
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("CKTDO", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("bszMs"));

});
parcelRegister("bszMs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $evZCX.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $evZCX.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $eqBPr.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $eqBPr.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $3WvWY.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $3WvWY.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $857e1081b5aa9262$var$_symbol.symbolsStroke;
    }
});

var $857e1081b5aa9262$var$_arc = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("8sWC8")));

var $857e1081b5aa9262$var$_area = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("cYK15")));

var $857e1081b5aa9262$var$_line = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("2gJml")));

var $857e1081b5aa9262$var$_pie = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fM93E")));

var $857e1081b5aa9262$var$_areaRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7s0ZM")));

var $857e1081b5aa9262$var$_lineRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7auFH")));

var $857e1081b5aa9262$var$_pointRadial = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5wAin")));

var $3WvWY = parcelRequire("3WvWY");

var $857e1081b5aa9262$var$_symbol = $857e1081b5aa9262$var$_interopRequireWildcard((parcelRequire("l3mP4")));

var $857e1081b5aa9262$var$_asterisk = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("hNi5e")));

var $857e1081b5aa9262$var$_circle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("80b5j")));

var $857e1081b5aa9262$var$_cross = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("34kQO")));

var $857e1081b5aa9262$var$_diamond = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aSxHZ")));

var $857e1081b5aa9262$var$_diamond2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3rBZo")));

var $857e1081b5aa9262$var$_plus = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l9ST9")));

var $857e1081b5aa9262$var$_square = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3oWT7")));

var $857e1081b5aa9262$var$_square2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("k3QGU")));

var $857e1081b5aa9262$var$_star = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1WZhf")));

var $857e1081b5aa9262$var$_triangle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("hQr8g")));

var $857e1081b5aa9262$var$_triangle2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("NGszi")));

var $857e1081b5aa9262$var$_wye = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7fYkN")));

var $857e1081b5aa9262$var$_x = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("3oXF4")));

var $857e1081b5aa9262$var$_basisClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("a65kp")));

var $857e1081b5aa9262$var$_basisOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aFwZp")));

var $857e1081b5aa9262$var$_basis = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4MmJ6")));

var $evZCX = parcelRequire("evZCX");

var $857e1081b5aa9262$var$_bundle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1uOPP")));

var $857e1081b5aa9262$var$_cardinalClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1RBVE")));

var $857e1081b5aa9262$var$_cardinalOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("88R3u")));

var $857e1081b5aa9262$var$_cardinal = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("8MEVA")));

var $857e1081b5aa9262$var$_catmullRomClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("63Rg9")));

var $857e1081b5aa9262$var$_catmullRomOpen = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4JV2s")));

var $857e1081b5aa9262$var$_catmullRom = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("jeCIz")));

var $857e1081b5aa9262$var$_linearClosed = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7HCNf")));

var $857e1081b5aa9262$var$_linear = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $eqBPr = parcelRequire("eqBPr");

var $857e1081b5aa9262$var$_natural = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("dY7QQ")));

var $857e1081b5aa9262$var$_step = $857e1081b5aa9262$var$_interopRequireWildcard((parcelRequire("llSQy")));

var $857e1081b5aa9262$var$_stack = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l6qno")));

var $857e1081b5aa9262$var$_expand = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fpjqO")));

var $857e1081b5aa9262$var$_diverging = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("l5EV1")));

var $857e1081b5aa9262$var$_none = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("7CMPN")));

var $857e1081b5aa9262$var$_silhouette = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4ViQy")));

var $857e1081b5aa9262$var$_wiggle = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("fIpqC")));

var $857e1081b5aa9262$var$_appearance = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5qWRn")));

var $857e1081b5aa9262$var$_ascending = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("klspr")));

var $857e1081b5aa9262$var$_descending = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("kwAJ5")));

var $857e1081b5aa9262$var$_insideOut = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("4fWJp")));

var $857e1081b5aa9262$var$_none2 = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("5Nf2s")));

var $857e1081b5aa9262$var$_reverse = $857e1081b5aa9262$var$_interopRequireDefault((parcelRequire("aFPqy")));
function $857e1081b5aa9262$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($857e1081b5aa9262$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $857e1081b5aa9262$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $857e1081b5aa9262$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $857e1081b5aa9262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("8sWC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $629e67c3e170e9e8$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $629e67c3e170e9e8$var$_constant = $629e67c3e170e9e8$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $8EE7R = parcelRequire("8EE7R");
function $629e67c3e170e9e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $629e67c3e170e9e8$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $629e67c3e170e9e8$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $629e67c3e170e9e8$var$arcStartAngle(d) {
    return d.startAngle;
}
function $629e67c3e170e9e8$var$arcEndAngle(d) {
    return d.endAngle;
}
function $629e67c3e170e9e8$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $629e67c3e170e9e8$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $8EE7R.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $629e67c3e170e9e8$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $8EE7R.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $8EE7R.sqrt)((0, $8EE7R.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $629e67c3e170e9e8$var$_default() {
    var innerRadius = $629e67c3e170e9e8$var$arcInnerRadius, outerRadius = $629e67c3e170e9e8$var$arcOuterRadius, cornerRadius = (0, $629e67c3e170e9e8$var$_constant.default)(0), padRadius = null, startAngle = $629e67c3e170e9e8$var$arcStartAngle, endAngle = $629e67c3e170e9e8$var$arcEndAngle, padAngle = $629e67c3e170e9e8$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $8EE7R.halfPi, a1 = endAngle.apply(this, arguments) - $8EE7R.halfPi, da = (0, $8EE7R.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $ahT4l.path)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > $8EE7R.epsilon)) context.moveTo(0, 0);
        else if (da > $8EE7R.tau - $8EE7R.epsilon) {
            context.moveTo(r1 * (0, $8EE7R.cos)(a0), r1 * (0, $8EE7R.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $8EE7R.epsilon) {
                context.moveTo(r0 * (0, $8EE7R.cos)(a1), r0 * (0, $8EE7R.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $8EE7R.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $8EE7R.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $8EE7R.min)((0, $8EE7R.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $8EE7R.epsilon) {
                var p0 = (0, $8EE7R.asin)(rp / r0 * (0, $8EE7R.sin)(ap)), p1 = (0, $8EE7R.asin)(rp / r1 * (0, $8EE7R.sin)(ap));
                if ((da0 -= p0 * 2) > $8EE7R.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $8EE7R.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $8EE7R.cos)(a01), y01 = r1 * (0, $8EE7R.sin)(a01), x10 = r0 * (0, $8EE7R.cos)(a10), y10 = r0 * (0, $8EE7R.sin)(a10);
            // Apply rounded corners?
            if (rc > $8EE7R.epsilon) {
                var x11 = r1 * (0, $8EE7R.cos)(a11), y11 = r1 * (0, $8EE7R.sin)(a11), x00 = r0 * (0, $8EE7R.cos)(a00), y00 = r0 * (0, $8EE7R.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < $8EE7R.pi && (oc = $629e67c3e170e9e8$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $8EE7R.sin)((0, $8EE7R.acos)((ax * bx + ay * by) / ((0, $8EE7R.sqrt)(ax * ax + ay * ay) * (0, $8EE7R.sqrt)(bx * bx + by * by))) / 2), lc = (0, $8EE7R.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $8EE7R.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $8EE7R.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > $8EE7R.epsilon)) context.moveTo(x01, y01);
            else if (rc1 > $8EE7R.epsilon) {
                t0 = $629e67c3e170e9e8$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $629e67c3e170e9e8$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $8EE7R.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8EE7R.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $8EE7R.atan2)(t1.y11, t1.x11), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $8EE7R.epsilon) || !(da0 > $8EE7R.epsilon)) context.lineTo(x10, y10);
            else if (rc0 > $8EE7R.epsilon) {
                t0 = $629e67c3e170e9e8$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $629e67c3e170e9e8$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $8EE7R.atan2)(t0.y01, t0.x01), (0, $8EE7R.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $8EE7R.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $8EE7R.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $8EE7R.atan2)(t1.y11, t1.x11), (0, $8EE7R.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $8EE7R.pi / 2;
        return [
            (0, $8EE7R.cos)(a) * r,
            (0, $8EE7R.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $629e67c3e170e9e8$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("ahT4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $77d6357a38850c18$var$_path.default;
    }
});

var $77d6357a38850c18$var$_path = $77d6357a38850c18$var$_interopRequireDefault((parcelRequire("le6pz")));
function $77d6357a38850c18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("le6pz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f73fe0f2b8713871$var$pi = Math.PI, $f73fe0f2b8713871$var$tau = 2 * $f73fe0f2b8713871$var$pi, $f73fe0f2b8713871$var$epsilon = 1e-6, $f73fe0f2b8713871$var$tauEpsilon = $f73fe0f2b8713871$var$tau - $f73fe0f2b8713871$var$epsilon;
function $f73fe0f2b8713871$var$Path() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $f73fe0f2b8713871$var$path() {
    return new $f73fe0f2b8713871$var$Path();
}
$f73fe0f2b8713871$var$Path.prototype = $f73fe0f2b8713871$var$path.prototype = {
    constructor: $f73fe0f2b8713871$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $f73fe0f2b8713871$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $f73fe0f2b8713871$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($f73fe0f2b8713871$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $f73fe0f2b8713871$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $f73fe0f2b8713871$var$epsilon || Math.abs(this._y1 - y0) > $f73fe0f2b8713871$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $f73fe0f2b8713871$var$tau + $f73fe0f2b8713871$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $f73fe0f2b8713871$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $f73fe0f2b8713871$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $f73fe0f2b8713871$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $f73fe0f2b8713871$var$_default = module.exports.default = $f73fe0f2b8713871$var$path;

});


parcelRegister("1SFIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15eb3195f18fef30$var$_default;
function $15eb3195f18fef30$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("8EE7R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $64d12f47b5cdfb44$var$acos;
module.exports.asin = $64d12f47b5cdfb44$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $64d12f47b5cdfb44$var$abs = module.exports.abs = Math.abs;
const $64d12f47b5cdfb44$var$atan2 = module.exports.atan2 = Math.atan2;
const $64d12f47b5cdfb44$var$cos = module.exports.cos = Math.cos;
const $64d12f47b5cdfb44$var$max = module.exports.max = Math.max;
const $64d12f47b5cdfb44$var$min = module.exports.min = Math.min;
const $64d12f47b5cdfb44$var$sin = module.exports.sin = Math.sin;
const $64d12f47b5cdfb44$var$sqrt = module.exports.sqrt = Math.sqrt;
const $64d12f47b5cdfb44$var$epsilon = module.exports.epsilon = 1e-12;
const $64d12f47b5cdfb44$var$pi = module.exports.pi = Math.PI;
const $64d12f47b5cdfb44$var$halfPi = module.exports.halfPi = $64d12f47b5cdfb44$var$pi / 2;
const $64d12f47b5cdfb44$var$tau = module.exports.tau = 2 * $64d12f47b5cdfb44$var$pi;
function $64d12f47b5cdfb44$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $64d12f47b5cdfb44$var$pi : Math.acos(x);
}
function $64d12f47b5cdfb44$var$asin(x) {
    return x >= 1 ? $64d12f47b5cdfb44$var$halfPi : x <= -1 ? -$64d12f47b5cdfb44$var$halfPi : Math.asin(x);
}

});


parcelRegister("cYK15", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $972ec88a4d5ed3c6$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $972ec88a4d5ed3c6$var$_array = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("72xzV")));

var $972ec88a4d5ed3c6$var$_constant = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $972ec88a4d5ed3c6$var$_linear = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $972ec88a4d5ed3c6$var$_line = $972ec88a4d5ed3c6$var$_interopRequireDefault((parcelRequire("2gJml")));

var $97E2D = parcelRequire("97E2D");
function $972ec88a4d5ed3c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $972ec88a4d5ed3c6$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $972ec88a4d5ed3c6$var$_constant.default)(true), context = null, curve = $972ec88a4d5ed3c6$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $97E2D.x : (0, $972ec88a4d5ed3c6$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $972ec88a4d5ed3c6$var$_constant.default)(0) : (0, $972ec88a4d5ed3c6$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $97E2D.y : (0, $972ec88a4d5ed3c6$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $972ec88a4d5ed3c6$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $972ec88a4d5ed3c6$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $972ec88a4d5ed3c6$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("72xzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5202c4444202b759$var$_default;
module.exports.slice = void 0;
var $5202c4444202b759$var$slice = module.exports.slice = Array.prototype.slice;
function $5202c4444202b759$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("1wm0G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11b9da5b73dc4d76$var$_default;
function $11b9da5b73dc4d76$var$Linear(context) {
    this._context = context;
}
$11b9da5b73dc4d76$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $11b9da5b73dc4d76$var$_default(context) {
    return new $11b9da5b73dc4d76$var$Linear(context);
}

});

parcelRegister("2gJml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a7042d356f33d45$var$_default;

var $ahT4l = parcelRequire("ahT4l");

var $1a7042d356f33d45$var$_array = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("72xzV")));

var $1a7042d356f33d45$var$_constant = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $1a7042d356f33d45$var$_linear = $1a7042d356f33d45$var$_interopRequireDefault((parcelRequire("1wm0G")));

var $97E2D = parcelRequire("97E2D");
function $1a7042d356f33d45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a7042d356f33d45$var$_default(x, y) {
    var defined = (0, $1a7042d356f33d45$var$_constant.default)(true), context = null, curve = $1a7042d356f33d45$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $97E2D.x : (0, $1a7042d356f33d45$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $97E2D.y : (0, $1a7042d356f33d45$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $1a7042d356f33d45$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $1a7042d356f33d45$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("97E2D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $6a43d3ea9922a71a$var$x;
module.exports.y = $6a43d3ea9922a71a$var$y;
function $6a43d3ea9922a71a$var$x(p) {
    return p[0];
}
function $6a43d3ea9922a71a$var$y(p) {
    return p[1];
}

});



parcelRegister("fM93E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7c25d6f0d698acb$var$_default;

var $b7c25d6f0d698acb$var$_array = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("72xzV")));

var $b7c25d6f0d698acb$var$_constant = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $b7c25d6f0d698acb$var$_descending = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("fI7FW")));

var $b7c25d6f0d698acb$var$_identity = $b7c25d6f0d698acb$var$_interopRequireDefault((parcelRequire("gi9bQ")));

var $8EE7R = parcelRequire("8EE7R");
function $b7c25d6f0d698acb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b7c25d6f0d698acb$var$_default() {
    var value = $b7c25d6f0d698acb$var$_identity.default, sortValues = $b7c25d6f0d698acb$var$_descending.default, sort = null, startAngle = (0, $b7c25d6f0d698acb$var$_constant.default)(0), endAngle = (0, $b7c25d6f0d698acb$var$_constant.default)($8EE7R.tau), padAngle = (0, $b7c25d6f0d698acb$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $b7c25d6f0d698acb$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($8EE7R.tau, Math.max(-$8EE7R.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $b7c25d6f0d698acb$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("fI7FW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b700eb49b0c7926d$var$_default;
function $b700eb49b0c7926d$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("gi9bQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdc574b68d16a31a$var$_default;
function $bdc574b68d16a31a$var$_default(d) {
    return d;
}

});


parcelRegister("7s0ZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56cbeb94d955b565$var$_default;

var $56cbeb94d955b565$var$_radial = $56cbeb94d955b565$var$_interopRequireWildcard((parcelRequire("dqrdl")));

var $56cbeb94d955b565$var$_area = $56cbeb94d955b565$var$_interopRequireDefault((parcelRequire("cYK15")));

var $7auFH = parcelRequire("7auFH");
function $56cbeb94d955b565$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $56cbeb94d955b565$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($56cbeb94d955b565$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $56cbeb94d955b565$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $56cbeb94d955b565$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $56cbeb94d955b565$var$_default() {
    var a = (0, $56cbeb94d955b565$var$_area.default)().curve($56cbeb94d955b565$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $7auFH.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $7auFH.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $7auFH.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $7auFH.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $56cbeb94d955b565$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("dqrdl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9c62d03c39ca9869$var$curveRadial;

var $9c62d03c39ca9869$var$_linear = $9c62d03c39ca9869$var$_interopRequireDefault((parcelRequire("1wm0G")));
function $9c62d03c39ca9869$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9c62d03c39ca9869$var$curveRadialLinear = module.exports.curveRadialLinear = $9c62d03c39ca9869$var$curveRadial($9c62d03c39ca9869$var$_linear.default);
function $9c62d03c39ca9869$var$Radial(curve) {
    this._curve = curve;
}
$9c62d03c39ca9869$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9c62d03c39ca9869$var$curveRadial(curve) {
    function radial(context) {
        return new $9c62d03c39ca9869$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("7auFH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5381424cea8627da$var$_default;
module.exports.lineRadial = $5381424cea8627da$var$lineRadial;

var $5381424cea8627da$var$_radial = $5381424cea8627da$var$_interopRequireWildcard((parcelRequire("dqrdl")));

var $5381424cea8627da$var$_line = $5381424cea8627da$var$_interopRequireDefault((parcelRequire("2gJml")));
function $5381424cea8627da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5381424cea8627da$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5381424cea8627da$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $5381424cea8627da$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $5381424cea8627da$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $5381424cea8627da$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $5381424cea8627da$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $5381424cea8627da$var$_default() {
    return $5381424cea8627da$var$lineRadial((0, $5381424cea8627da$var$_line.default)().curve($5381424cea8627da$var$_radial.curveRadialLinear));
}

});


parcelRegister("5wAin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $405c1869ebbc3c11$var$_default;
function $405c1869ebbc3c11$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("3WvWY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $2def9285c4745f69$var$link;
module.exports.linkHorizontal = $2def9285c4745f69$var$linkHorizontal;
module.exports.linkRadial = $2def9285c4745f69$var$linkRadial;
module.exports.linkVertical = $2def9285c4745f69$var$linkVertical;

var $ahT4l = parcelRequire("ahT4l");

var $72xzV = parcelRequire("72xzV");

var $2def9285c4745f69$var$_constant = $2def9285c4745f69$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $evZCX = parcelRequire("evZCX");

var $97E2D = parcelRequire("97E2D");
function $2def9285c4745f69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2def9285c4745f69$var$linkSource(d) {
    return d.source;
}
function $2def9285c4745f69$var$linkTarget(d) {
    return d.target;
}
function $2def9285c4745f69$var$link(curve) {
    let source = $2def9285c4745f69$var$linkSource;
    let target = $2def9285c4745f69$var$linkTarget;
    let x = $97E2D.x;
    let y = $97E2D.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $72xzV.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $ahT4l.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2def9285c4745f69$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2def9285c4745f69$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $2def9285c4745f69$var$linkHorizontal() {
    return $2def9285c4745f69$var$link($evZCX.bumpX);
}
function $2def9285c4745f69$var$linkVertical() {
    return $2def9285c4745f69$var$link($evZCX.bumpY);
}
function $2def9285c4745f69$var$linkRadial() {
    const l = $2def9285c4745f69$var$link($evZCX.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("evZCX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $a913c3def1aa11e0$var$bumpRadial;
module.exports.bumpX = $a913c3def1aa11e0$var$bumpX;
module.exports.bumpY = $a913c3def1aa11e0$var$bumpY;

var $a913c3def1aa11e0$var$_pointRadial = $a913c3def1aa11e0$var$_interopRequireDefault((parcelRequire("5wAin")));
function $a913c3def1aa11e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $a913c3def1aa11e0$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $a913c3def1aa11e0$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $a913c3def1aa11e0$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $a913c3def1aa11e0$var$bumpX(context) {
    return new $a913c3def1aa11e0$var$Bump(context, true);
}
function $a913c3def1aa11e0$var$bumpY(context) {
    return new $a913c3def1aa11e0$var$Bump(context, false);
}
function $a913c3def1aa11e0$var$bumpRadial(context) {
    return new $a913c3def1aa11e0$var$BumpRadial(context);
}

});


parcelRegister("l3mP4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f53b94ec46d9e16d$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $ahT4l = parcelRequire("ahT4l");

var $f53b94ec46d9e16d$var$_constant = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $f53b94ec46d9e16d$var$_asterisk = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("hNi5e")));

var $f53b94ec46d9e16d$var$_circle = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("80b5j")));

var $f53b94ec46d9e16d$var$_cross = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("34kQO")));

var $f53b94ec46d9e16d$var$_diamond = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("aSxHZ")));

var $f53b94ec46d9e16d$var$_diamond2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3rBZo")));

var $f53b94ec46d9e16d$var$_plus = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("l9ST9")));

var $f53b94ec46d9e16d$var$_square = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3oWT7")));

var $f53b94ec46d9e16d$var$_square2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("k3QGU")));

var $f53b94ec46d9e16d$var$_star = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("1WZhf")));

var $f53b94ec46d9e16d$var$_triangle = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("hQr8g")));

var $f53b94ec46d9e16d$var$_triangle2 = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("NGszi")));

var $f53b94ec46d9e16d$var$_wye = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("7fYkN")));

var $f53b94ec46d9e16d$var$_x = $f53b94ec46d9e16d$var$_interopRequireDefault((parcelRequire("3oXF4")));
function $f53b94ec46d9e16d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $f53b94ec46d9e16d$var$symbolsFill = module.exports.symbolsFill = [
    $f53b94ec46d9e16d$var$_circle.default,
    $f53b94ec46d9e16d$var$_cross.default,
    $f53b94ec46d9e16d$var$_diamond.default,
    $f53b94ec46d9e16d$var$_square.default,
    $f53b94ec46d9e16d$var$_star.default,
    $f53b94ec46d9e16d$var$_triangle.default,
    $f53b94ec46d9e16d$var$_wye.default
];
// These symbols are designed to be stroked (with a width of 1.5px and round caps).
const $f53b94ec46d9e16d$var$symbolsStroke = module.exports.symbolsStroke = [
    $f53b94ec46d9e16d$var$_circle.default,
    $f53b94ec46d9e16d$var$_plus.default,
    $f53b94ec46d9e16d$var$_x.default,
    $f53b94ec46d9e16d$var$_triangle2.default,
    $f53b94ec46d9e16d$var$_asterisk.default,
    $f53b94ec46d9e16d$var$_square2.default,
    $f53b94ec46d9e16d$var$_diamond2.default
];
function $f53b94ec46d9e16d$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $f53b94ec46d9e16d$var$_constant.default)(type || $f53b94ec46d9e16d$var$_circle.default);
    size = typeof size === "function" ? size : (0, $f53b94ec46d9e16d$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $ahT4l.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $f53b94ec46d9e16d$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $f53b94ec46d9e16d$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("hNi5e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $cf450a3c0731ada3$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $cf450a3c0731ada3$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size + (0, $8EE7R.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $cf450a3c0731ada3$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

});

parcelRegister("80b5j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $5d36ebfe49ab4f39$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / $8EE7R.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $8EE7R.tau);
    }
};

});

parcelRegister("34kQO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $23c1eb5d54df31fd$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("aSxHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $7eb9185183e161be$var$tan30 = (0, $8EE7R.sqrt)(1 / 3);
const $7eb9185183e161be$var$tan30_2 = $7eb9185183e161be$var$tan30 * 2;
var $7eb9185183e161be$var$_default = module.exports.default = {
    draw (context, size) {
        const y = (0, $8EE7R.sqrt)(size / $7eb9185183e161be$var$tan30_2);
        const x = y * $7eb9185183e161be$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("3rBZo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $28215c91c44f670d$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

});

parcelRegister("l9ST9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $f67503ef4c2b53b7$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size - (0, $8EE7R.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

});

parcelRegister("3oWT7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $27a14ae956ab4069$var$_default = module.exports.default = {
    draw (context, size) {
        const w = (0, $8EE7R.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("k3QGU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $e9acf5d321c8d9b2$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

});

parcelRegister("1WZhf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $16babd934cfaf5dd$var$ka = 0.89081309152928522810;
const $16babd934cfaf5dd$var$kr = (0, $8EE7R.sin)($8EE7R.pi / 10) / (0, $8EE7R.sin)(7 * $8EE7R.pi / 10);
const $16babd934cfaf5dd$var$kx = (0, $8EE7R.sin)($8EE7R.tau / 10) * $16babd934cfaf5dd$var$kr;
const $16babd934cfaf5dd$var$ky = -(0, $8EE7R.cos)($8EE7R.tau / 10) * $16babd934cfaf5dd$var$kr;
var $16babd934cfaf5dd$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size * $16babd934cfaf5dd$var$ka);
        const x = $16babd934cfaf5dd$var$kx * r;
        const y = $16babd934cfaf5dd$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $8EE7R.tau * i / 5;
            const c = (0, $8EE7R.cos)(a);
            const s = (0, $8EE7R.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("hQr8g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $cfdc56e10135b109$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $cfdc56e10135b109$var$_default = module.exports.default = {
    draw (context, size) {
        const y = -(0, $8EE7R.sqrt)(size / ($cfdc56e10135b109$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$cfdc56e10135b109$var$sqrt3 * y, -y);
        context.lineTo($cfdc56e10135b109$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("NGszi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $095583585e5011bc$var$sqrt3 = (0, $8EE7R.sqrt)(3);
var $095583585e5011bc$var$_default = module.exports.default = {
    draw (context, size) {
        const s = (0, $8EE7R.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $095583585e5011bc$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

});

parcelRegister("7fYkN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
const $5488bc434537f81a$var$c = -0.5;
const $5488bc434537f81a$var$s = (0, $8EE7R.sqrt)(3) / 2;
const $5488bc434537f81a$var$k = 1 / (0, $8EE7R.sqrt)(12);
const $5488bc434537f81a$var$a = ($5488bc434537f81a$var$k / 2 + 1) * 3;
var $5488bc434537f81a$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size / $5488bc434537f81a$var$a);
        const x0 = r / 2, y0 = r * $5488bc434537f81a$var$k;
        const x1 = x0, y1 = r * $5488bc434537f81a$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($5488bc434537f81a$var$c * x0 - $5488bc434537f81a$var$s * y0, $5488bc434537f81a$var$s * x0 + $5488bc434537f81a$var$c * y0);
        context.lineTo($5488bc434537f81a$var$c * x1 - $5488bc434537f81a$var$s * y1, $5488bc434537f81a$var$s * x1 + $5488bc434537f81a$var$c * y1);
        context.lineTo($5488bc434537f81a$var$c * x2 - $5488bc434537f81a$var$s * y2, $5488bc434537f81a$var$s * x2 + $5488bc434537f81a$var$c * y2);
        context.lineTo($5488bc434537f81a$var$c * x0 + $5488bc434537f81a$var$s * y0, $5488bc434537f81a$var$c * y0 - $5488bc434537f81a$var$s * x0);
        context.lineTo($5488bc434537f81a$var$c * x1 + $5488bc434537f81a$var$s * y1, $5488bc434537f81a$var$c * y1 - $5488bc434537f81a$var$s * x1);
        context.lineTo($5488bc434537f81a$var$c * x2 + $5488bc434537f81a$var$s * y2, $5488bc434537f81a$var$c * y2 - $5488bc434537f81a$var$s * x2);
        context.closePath();
    }
};

});

parcelRegister("3oXF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8EE7R = parcelRequire("8EE7R");
var $27a1e47f32a4af98$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $8EE7R.sqrt)(size - (0, $8EE7R.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

});


parcelRegister("a65kp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $759e98ff97b5ba2e$var$_default;

var $759e98ff97b5ba2e$var$_noop = $759e98ff97b5ba2e$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $4MmJ6 = parcelRequire("4MmJ6");
function $759e98ff97b5ba2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $759e98ff97b5ba2e$var$BasisClosed(context) {
    this._context = context;
}
$759e98ff97b5ba2e$var$BasisClosed.prototype = {
    areaStart: $759e98ff97b5ba2e$var$_noop.default,
    areaEnd: $759e98ff97b5ba2e$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $4MmJ6.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $759e98ff97b5ba2e$var$_default(context) {
    return new $759e98ff97b5ba2e$var$BasisClosed(context);
}

});
parcelRegister("9Id5q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71225fd811f521df$var$_default;
function $71225fd811f521df$var$_default() {}

});

parcelRegister("4MmJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $37ad461e07222a10$var$Basis;
module.exports.default = $37ad461e07222a10$var$_default;
module.exports.point = $37ad461e07222a10$var$point;
function $37ad461e07222a10$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $37ad461e07222a10$var$Basis(context) {
    this._context = context;
}
$37ad461e07222a10$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $37ad461e07222a10$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $37ad461e07222a10$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $37ad461e07222a10$var$_default(context) {
    return new $37ad461e07222a10$var$Basis(context);
}

});


parcelRegister("aFwZp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c4752bb83e8ecae$var$_default;

var $4MmJ6 = parcelRequire("4MmJ6");
function $7c4752bb83e8ecae$var$BasisOpen(context) {
    this._context = context;
}
$7c4752bb83e8ecae$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $4MmJ6.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7c4752bb83e8ecae$var$_default(context) {
    return new $7c4752bb83e8ecae$var$BasisOpen(context);
}

});

parcelRegister("1uOPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4MmJ6 = parcelRequire("4MmJ6");
function $117006928d6a0b46$var$Bundle(context, beta) {
    this._basis = new $4MmJ6.Basis(context);
    this._beta = beta;
}
$117006928d6a0b46$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $117006928d6a0b46$var$_default = module.exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $4MmJ6.Basis(context) : new $117006928d6a0b46$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("1RBVE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $15b8298ff61d0817$var$CardinalClosed;
module.exports.default = void 0;

var $15b8298ff61d0817$var$_noop = $15b8298ff61d0817$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $8MEVA = parcelRequire("8MEVA");
function $15b8298ff61d0817$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $15b8298ff61d0817$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$15b8298ff61d0817$var$CardinalClosed.prototype = {
    areaStart: $15b8298ff61d0817$var$_noop.default,
    areaEnd: $15b8298ff61d0817$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $8MEVA.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $15b8298ff61d0817$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $15b8298ff61d0817$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("8MEVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $66528dd5d1af4c7e$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $66528dd5d1af4c7e$var$point;
function $66528dd5d1af4c7e$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $66528dd5d1af4c7e$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$66528dd5d1af4c7e$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $66528dd5d1af4c7e$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $66528dd5d1af4c7e$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $66528dd5d1af4c7e$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $66528dd5d1af4c7e$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("88R3u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $5ed839c05fa37c42$var$CardinalOpen;
module.exports.default = void 0;

var $8MEVA = parcelRequire("8MEVA");
function $5ed839c05fa37c42$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$5ed839c05fa37c42$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $8MEVA.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5ed839c05fa37c42$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $5ed839c05fa37c42$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("63Rg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1RBVE = parcelRequire("1RBVE");

var $469c561ba2a63423$var$_noop = $469c561ba2a63423$var$_interopRequireDefault((parcelRequire("9Id5q")));

var $jeCIz = parcelRequire("jeCIz");
function $469c561ba2a63423$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $469c561ba2a63423$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$469c561ba2a63423$var$CatmullRomClosed.prototype = {
    areaStart: $469c561ba2a63423$var$_noop.default,
    areaEnd: $469c561ba2a63423$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $jeCIz.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $469c561ba2a63423$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $469c561ba2a63423$var$CatmullRomClosed(context, alpha) : new $1RBVE.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("jeCIz", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $8EE7R = parcelRequire("8EE7R");

var $8MEVA = parcelRequire("8MEVA");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $8EE7R.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $8EE7R.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $8MEVA.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("4JV2s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88R3u = parcelRequire("88R3u");

var $jeCIz = parcelRequire("jeCIz");
function $37379c0e81acd368$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$37379c0e81acd368$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $jeCIz.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $37379c0e81acd368$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $37379c0e81acd368$var$CatmullRomOpen(context, alpha) : new $88R3u.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("7HCNf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59baa41516fc43b4$var$_default;

var $59baa41516fc43b4$var$_noop = $59baa41516fc43b4$var$_interopRequireDefault((parcelRequire("9Id5q")));
function $59baa41516fc43b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $59baa41516fc43b4$var$LinearClosed(context) {
    this._context = context;
}
$59baa41516fc43b4$var$LinearClosed.prototype = {
    areaStart: $59baa41516fc43b4$var$_noop.default,
    areaEnd: $59baa41516fc43b4$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $59baa41516fc43b4$var$_default(context) {
    return new $59baa41516fc43b4$var$LinearClosed(context);
}

});

parcelRegister("eqBPr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $a810d6679ecb238b$var$monotoneX;
module.exports.monotoneY = $a810d6679ecb238b$var$monotoneY;
function $a810d6679ecb238b$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a810d6679ecb238b$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a810d6679ecb238b$var$sign(s0) + $a810d6679ecb238b$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $a810d6679ecb238b$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a810d6679ecb238b$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a810d6679ecb238b$var$MonotoneX(context) {
    this._context = context;
}
$a810d6679ecb238b$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a810d6679ecb238b$var$point(this, this._t0, $a810d6679ecb238b$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a810d6679ecb238b$var$point(this, $a810d6679ecb238b$var$slope2(this, t1 = $a810d6679ecb238b$var$slope3(this, x, y)), t1);
                break;
            default:
                $a810d6679ecb238b$var$point(this, this._t0, t1 = $a810d6679ecb238b$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a810d6679ecb238b$var$MonotoneY(context) {
    this._context = new $a810d6679ecb238b$var$ReflectContext(context);
}
($a810d6679ecb238b$var$MonotoneY.prototype = Object.create($a810d6679ecb238b$var$MonotoneX.prototype)).point = function(x, y) {
    $a810d6679ecb238b$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a810d6679ecb238b$var$ReflectContext(context) {
    this._context = context;
}
$a810d6679ecb238b$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a810d6679ecb238b$var$monotoneX(context) {
    return new $a810d6679ecb238b$var$MonotoneX(context);
}
function $a810d6679ecb238b$var$monotoneY(context) {
    return new $a810d6679ecb238b$var$MonotoneY(context);
}

});

parcelRegister("dY7QQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2b6f811606136fa$var$_default;
function $a2b6f811606136fa$var$Natural(context) {
    this._context = context;
}
$a2b6f811606136fa$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $a2b6f811606136fa$var$controlPoints(x), py = $a2b6f811606136fa$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $a2b6f811606136fa$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $a2b6f811606136fa$var$_default(context) {
    return new $a2b6f811606136fa$var$Natural(context);
}

});

parcelRegister("llSQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8b61a9052882a76$var$_default;
module.exports.stepAfter = $f8b61a9052882a76$var$stepAfter;
module.exports.stepBefore = $f8b61a9052882a76$var$stepBefore;
function $f8b61a9052882a76$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$f8b61a9052882a76$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $f8b61a9052882a76$var$_default(context) {
    return new $f8b61a9052882a76$var$Step(context, 0.5);
}
function $f8b61a9052882a76$var$stepBefore(context) {
    return new $f8b61a9052882a76$var$Step(context, 0);
}
function $f8b61a9052882a76$var$stepAfter(context) {
    return new $f8b61a9052882a76$var$Step(context, 1);
}

});

parcelRegister("l6qno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5ce9e484cf7993d$var$_default;

var $f5ce9e484cf7993d$var$_array = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("72xzV")));

var $f5ce9e484cf7993d$var$_constant = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("1SFIt")));

var $f5ce9e484cf7993d$var$_none = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("7CMPN")));

var $f5ce9e484cf7993d$var$_none2 = $f5ce9e484cf7993d$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $f5ce9e484cf7993d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5ce9e484cf7993d$var$stackValue(d, key) {
    return d[key];
}
function $f5ce9e484cf7993d$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $f5ce9e484cf7993d$var$_default() {
    var keys = (0, $f5ce9e484cf7993d$var$_constant.default)([]), order = $f5ce9e484cf7993d$var$_none2.default, offset = $f5ce9e484cf7993d$var$_none.default, value = $f5ce9e484cf7993d$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $f5ce9e484cf7993d$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $f5ce9e484cf7993d$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $f5ce9e484cf7993d$var$_none2.default : typeof _ === "function" ? _ : (0, $f5ce9e484cf7993d$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $f5ce9e484cf7993d$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("7CMPN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58d1f689330b7a76$var$_default;
function $58d1f689330b7a76$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("5Nf2s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $437d31b0a43c0970$var$_default;
function $437d31b0a43c0970$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("fpjqO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b378437dd6c974d0$var$_default;

var $b378437dd6c974d0$var$_none = $b378437dd6c974d0$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $b378437dd6c974d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b378437dd6c974d0$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $b378437dd6c974d0$var$_none.default)(series, order);
}

});

parcelRegister("l5EV1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5a9ce2ee69901dc$var$_default;
function $f5a9ce2ee69901dc$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("4ViQy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $395b1adc41e49f8c$var$_default;

var $395b1adc41e49f8c$var$_none = $395b1adc41e49f8c$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $395b1adc41e49f8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $395b1adc41e49f8c$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $395b1adc41e49f8c$var$_none.default)(series, order);
}

});

parcelRegister("fIpqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b70eb098f6aa193f$var$_default;

var $b70eb098f6aa193f$var$_none = $b70eb098f6aa193f$var$_interopRequireDefault((parcelRequire("7CMPN")));
function $b70eb098f6aa193f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b70eb098f6aa193f$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $b70eb098f6aa193f$var$_none.default)(series, order);
}

});

parcelRegister("5qWRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f4d09d5c255cbed$var$_default;

var $3f4d09d5c255cbed$var$_none = $3f4d09d5c255cbed$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $3f4d09d5c255cbed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f4d09d5c255cbed$var$_default(series) {
    var peaks = series.map($3f4d09d5c255cbed$var$peak);
    return (0, $3f4d09d5c255cbed$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $3f4d09d5c255cbed$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("klspr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ecfbce4dec6048ef$var$_default;
module.exports.sum = $ecfbce4dec6048ef$var$sum;

var $ecfbce4dec6048ef$var$_none = $ecfbce4dec6048ef$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $ecfbce4dec6048ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ecfbce4dec6048ef$var$_default(series) {
    var sums = series.map($ecfbce4dec6048ef$var$sum);
    return (0, $ecfbce4dec6048ef$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $ecfbce4dec6048ef$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("kwAJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef1348de13f9b72a$var$_default;

var $ef1348de13f9b72a$var$_ascending = $ef1348de13f9b72a$var$_interopRequireDefault((parcelRequire("klspr")));
function $ef1348de13f9b72a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef1348de13f9b72a$var$_default(series) {
    return (0, $ef1348de13f9b72a$var$_ascending.default)(series).reverse();
}

});

parcelRegister("4fWJp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31961efae4ac3cd9$var$_default;

var $31961efae4ac3cd9$var$_appearance = $31961efae4ac3cd9$var$_interopRequireDefault((parcelRequire("5qWRn")));

var $klspr = parcelRequire("klspr");
function $31961efae4ac3cd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31961efae4ac3cd9$var$_default(series) {
    var n = series.length, i, j, sums = series.map($klspr.sum), order = (0, $31961efae4ac3cd9$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("aFPqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c55a01e302bb624$var$_default;

var $7c55a01e302bb624$var$_none = $7c55a01e302bb624$var$_interopRequireDefault((parcelRequire("5Nf2s")));
function $7c55a01e302bb624$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c55a01e302bb624$var$_default(series) {
    return (0, $7c55a01e302bb624$var$_none.default)(series).reverse();
}

});



parcelRegister("HT3oM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9QEH5 = parcelRequire("9QEH5");

var $cvH4Z = parcelRequire("cvH4Z");

var $3jH0h = parcelRequire("3jH0h");

var $cwBsL = parcelRequire("cwBsL");
function $083eb8cede45851a$var$get(object, path, defaultValue) {
    if (object == null) return defaultValue;
    switch(typeof path){
        case 'string':
            {
                if ($9QEH5.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) {
                    if ($cvH4Z.isDeepKey(path)) return $083eb8cede45851a$var$get(object, $cwBsL.toPath(path), defaultValue);
                    else return defaultValue;
                }
                return result;
            }
        case 'number':
        case 'symbol':
            {
                if (typeof path === 'number') path = $3jH0h.toKey(path);
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
        default:
            {
                if (Array.isArray(path)) return $083eb8cede45851a$var$getWithPath(object, path, defaultValue);
                if (Object.is(path?.valueOf(), -0)) path = '-0';
                else path = String(path);
                if ($9QEH5.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
    }
}
function $083eb8cede45851a$var$getWithPath(object, path, defaultValue) {
    if (path.length === 0) return defaultValue;
    let current = object;
    for(let index = 0; index < path.length; index++){
        if (current == null) return defaultValue;
        if ($9QEH5.isUnsafeProperty(path[index])) return defaultValue;
        current = current[path[index]];
    }
    if (current === undefined) return defaultValue;
    return current;
}
module.exports.get = $083eb8cede45851a$var$get;

});
parcelRegister("9QEH5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $72b8895fb2fd87e5$var$isUnsafeProperty(key) {
    return key === '__proto__';
}
module.exports.isUnsafeProperty = $72b8895fb2fd87e5$var$isUnsafeProperty;

});

parcelRegister("cvH4Z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $91b9cbf83e1b22ea$var$isDeepKey(key) {
    switch(typeof key){
        case 'number':
        case 'symbol':
            return false;
        case 'string':
            return key.includes('.') || key.includes('[') || key.includes(']');
    }
}
module.exports.isDeepKey = $91b9cbf83e1b22ea$var$isDeepKey;

});

parcelRegister("3jH0h", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $26a4810f80293fb4$var$toKey(value) {
    if (typeof value === 'string' || typeof value === 'symbol') return value;
    if (Object.is(value?.valueOf?.(), -0)) return '-0';
    return String(value);
}
module.exports.toKey = $26a4810f80293fb4$var$toKey;

});

parcelRegister("cwBsL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a5N0a = parcelRequire("a5N0a");

var $3jH0h = parcelRequire("3jH0h");
function $91e58891b014f8b3$var$toPath(deepKey) {
    if (Array.isArray(deepKey)) return deepKey.map($3jH0h.toKey);
    if (typeof deepKey === 'symbol') return [
        deepKey
    ];
    deepKey = $a5N0a.toString(deepKey);
    const result = [];
    const length = deepKey.length;
    if (length === 0) return result;
    let index = 0;
    let key = '';
    let quoteChar = '';
    let bracket = false;
    if (deepKey.charCodeAt(0) === 46) {
        result.push('');
        index++;
    }
    while(index < length){
        const char = deepKey[index];
        if (quoteChar) {
            if (char === '\\' && index + 1 < length) {
                index++;
                key += deepKey[index];
            } else if (char === quoteChar) quoteChar = '';
            else key += char;
        } else if (bracket) {
            if (char === '"' || char === "'") quoteChar = char;
            else if (char === ']') {
                bracket = false;
                result.push(key);
                key = '';
            } else key += char;
        } else {
            if (char === '[') {
                bracket = true;
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else if (char === '.') {
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else key += char;
        }
        index++;
    }
    if (key) result.push(key);
    return result;
}
module.exports.toPath = $91e58891b014f8b3$var$toPath;

});
parcelRegister("a5N0a", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $759061b41f956d3b$var$toString(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map($759061b41f956d3b$var$toString).join(',');
    const result = String(value);
    if (result === '0' && Object.is(Number(value), -0)) return '-0';
    return result;
}
module.exports.toString = $759061b41f956d3b$var$toString;

});



parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});



parcelRegister("fwXTL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ln8tO = parcelRequire("ln8tO");

var $9z1JB = parcelRequire("9z1JB");

var $vYphW = parcelRequire("vYphW");
function $b4e84ebf8fd6b5af$var$sortBy(collection, ...criteria) {
    const length = criteria.length;
    if (length > 1 && $vYphW.isIterateeCall(collection, criteria[0], criteria[1])) criteria = [];
    else if (length > 2 && $vYphW.isIterateeCall(criteria[0], criteria[1], criteria[2])) criteria = [
        criteria[0]
    ];
    return $ln8tO.orderBy(collection, $9z1JB.flatten(criteria), [
        'asc'
    ]);
}
module.exports.sortBy = $b4e84ebf8fd6b5af$var$sortBy;

});
parcelRegister("ln8tO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4ZHPY = parcelRequire("4ZHPY");

var $bRMWM = parcelRequire("bRMWM");

var $cwBsL = parcelRequire("cwBsL");
function $f8f252e1aa7106d2$var$orderBy(collection, criteria, orders, guard) {
    if (collection == null) return [];
    orders = guard ? undefined : orders;
    if (!Array.isArray(collection)) collection = Object.values(collection);
    if (!Array.isArray(criteria)) criteria = criteria == null ? [
        null
    ] : [
        criteria
    ];
    if (criteria.length === 0) criteria = [
        null
    ];
    if (!Array.isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    orders = orders.map((order)=>String(order));
    const getValueByNestedPath = (object, path)=>{
        let target = object;
        for(let i = 0; i < path.length && target != null; ++i)target = target[path[i]];
        return target;
    };
    const getValueByCriterion = (criterion, object)=>{
        if (object == null || criterion == null) return object;
        if (typeof criterion === 'object' && 'key' in criterion) {
            if (Object.hasOwn(object, criterion.key)) return object[criterion.key];
            return getValueByNestedPath(object, criterion.path);
        }
        if (typeof criterion === 'function') return criterion(object);
        if (Array.isArray(criterion)) return getValueByNestedPath(object, criterion);
        if (typeof object === 'object') return object[criterion];
        return object;
    };
    const preparedCriteria = criteria.map((criterion)=>{
        if (Array.isArray(criterion) && criterion.length === 1) criterion = criterion[0];
        if (criterion == null || typeof criterion === 'function' || Array.isArray(criterion) || $bRMWM.isKey(criterion)) return criterion;
        return {
            key: criterion,
            path: $cwBsL.toPath(criterion)
        };
    });
    const preparedCollection = collection.map((item)=>({
            original: item,
            criteria: preparedCriteria.map((criterion)=>getValueByCriterion(criterion, item))
        }));
    return preparedCollection.slice().sort((a, b)=>{
        for(let i = 0; i < preparedCriteria.length; i++){
            const comparedResult = $4ZHPY.compareValues(a.criteria[i], b.criteria[i], orders[i]);
            if (comparedResult !== 0) return comparedResult;
        }
        return 0;
    }).map((item)=>item.original);
}
module.exports.orderBy = $f8f252e1aa7106d2$var$orderBy;

});
parcelRegister("4ZHPY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $3a2edd168db6a807$var$getPriority(a) {
    if (typeof a === 'symbol') return 1;
    if (a === null) return 2;
    if (a === undefined) return 3;
    if (a !== a) return 4;
    return 0;
}
const $3a2edd168db6a807$var$compareValues = (a, b, order)=>{
    if (a !== b) {
        const aPriority = $3a2edd168db6a807$var$getPriority(a);
        const bPriority = $3a2edd168db6a807$var$getPriority(b);
        if (aPriority === bPriority && aPriority === 0) {
            if (a < b) return order === 'desc' ? 1 : -1;
            if (a > b) return order === 'desc' ? -1 : 1;
        }
        return order === 'desc' ? bPriority - aPriority : aPriority - bPriority;
    }
    return 0;
};
module.exports.compareValues = $3a2edd168db6a807$var$compareValues;

});

parcelRegister("bRMWM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eA1Xn = parcelRequire("eA1Xn");
const $8a3a9cd13be1ad7f$var$regexIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const $8a3a9cd13be1ad7f$var$regexIsPlainProp = /^\w*$/;
function $8a3a9cd13be1ad7f$var$isKey(value, object) {
    if (Array.isArray(value)) return false;
    if (typeof value === 'number' || typeof value === 'boolean' || value == null || $eA1Xn.isSymbol(value)) return true;
    return typeof value === 'string' && ($8a3a9cd13be1ad7f$var$regexIsPlainProp.test(value) || !$8a3a9cd13be1ad7f$var$regexIsDeepProp.test(value)) || object != null && Object.hasOwn(object, value);
}
module.exports.isKey = $8a3a9cd13be1ad7f$var$isKey;

});
parcelRegister("eA1Xn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a9d5f203fd7bea0c$var$isSymbol(value) {
    return typeof value === 'symbol' || value instanceof Symbol;
}
module.exports.isSymbol = $a9d5f203fd7bea0c$var$isSymbol;

});



parcelRegister("9z1JB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6f68ba62eac5ea02$var$flatten(arr, depth = 1) {
    const result = [];
    const flooredDepth = Math.floor(depth);
    const recursive = (arr, currentDepth)=>{
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            if (Array.isArray(item) && currentDepth < flooredDepth) recursive(item, currentDepth + 1);
            else result.push(item);
        }
    };
    recursive(arr, 0);
    return result;
}
module.exports.flatten = $6f68ba62eac5ea02$var$flatten;

});

parcelRegister("vYphW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k8KlW = parcelRequire("k8KlW");

var $1kPBT = parcelRequire("1kPBT");

var $9rZjx = parcelRequire("9rZjx");

var $6fz3V = parcelRequire("6fz3V");
function $0601c0e98cf8a2dc$var$isIterateeCall(value, index, object) {
    if (!$9rZjx.isObject(object)) return false;
    if (typeof index === 'number' && $1kPBT.isArrayLike(object) && $k8KlW.isIndex(index) && index < object.length || typeof index === 'string' && index in object) return $6fz3V.isEqualsSameValueZero(object[index], value);
    return false;
}
module.exports.isIterateeCall = $0601c0e98cf8a2dc$var$isIterateeCall;

});
parcelRegister("k8KlW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ea9882b6a49268f2$var$IS_UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;
function $ea9882b6a49268f2$var$isIndex(value, length = Number.MAX_SAFE_INTEGER) {
    switch(typeof value){
        case 'number':
            return Number.isInteger(value) && value >= 0 && value < length;
        case 'symbol':
            return false;
        case 'string':
            return $ea9882b6a49268f2$var$IS_UNSIGNED_INTEGER.test(value);
    }
}
module.exports.isIndex = $ea9882b6a49268f2$var$isIndex;

});

parcelRegister("1kPBT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $qyXkB = parcelRequire("qyXkB");
function $0f8fb165028ab93c$var$isArrayLike(value) {
    return value != null && typeof value !== 'function' && $qyXkB.isLength(value.length);
}
module.exports.isArrayLike = $0f8fb165028ab93c$var$isArrayLike;

});
parcelRegister("qyXkB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $04fd8b58f8e6e303$var$isLength(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
module.exports.isLength = $04fd8b58f8e6e303$var$isLength;

});


parcelRegister("9rZjx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6e16325c2ab5c065$var$isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
}
module.exports.isObject = $6e16325c2ab5c065$var$isObject;

});

parcelRegister("6fz3V", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $48cf5773c9ca1dcf$var$isEqualsSameValueZero(value, other) {
    return value === other || Number.isNaN(value) && Number.isNaN(other);
}
module.exports.isEqualsSameValueZero = $48cf5773c9ca1dcf$var$isEqualsSameValueZero;

});



parcelRegister("2q7WT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $goIKG = parcelRequire("goIKG");
function $1c342cfb680ef1e9$var$throttle(func, throttleMs = 0, options = {}) {
    const { leading: leading = true, trailing: trailing = true } = options;
    return $goIKG.debounce(func, throttleMs, {
        leading: leading,
        maxWait: throttleMs,
        trailing: trailing
    });
}
module.exports.throttle = $1c342cfb680ef1e9$var$throttle;

});
parcelRegister("goIKG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8YPLc = parcelRequire("8YPLc");
function $bf019a09156804eb$var$debounce(func, debounceMs = 0, options = {}) {
    if (typeof options !== 'object') options = {};
    const { leading: leading = false, trailing: trailing = true, maxWait: maxWait } = options;
    const edges = Array(2);
    if (leading) edges[0] = 'leading';
    if (trailing) edges[1] = 'trailing';
    let result = undefined;
    let pendingAt = null;
    const _debounced = $8YPLc.debounce(function(...args) {
        result = func.apply(this, args);
        pendingAt = null;
    }, debounceMs, {
        edges: edges
    });
    const debounced = function(...args) {
        if (maxWait != null) {
            if (pendingAt === null) pendingAt = Date.now();
            if (Date.now() - pendingAt >= maxWait) {
                result = func.apply(this, args);
                pendingAt = Date.now();
                _debounced.cancel();
                _debounced.schedule();
                return result;
            }
        }
        _debounced.apply(this, args);
        return result;
    };
    const flush = ()=>{
        _debounced.flush();
        return result;
    };
    debounced.cancel = _debounced.cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $bf019a09156804eb$var$debounce;

});
parcelRegister("8YPLc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $689c13d82d3abfe7$var$debounce(func, debounceMs, { signal: signal, edges: edges } = {}) {
    let pendingThis = undefined;
    let pendingArgs = null;
    const leading = edges != null && edges.includes('leading');
    const trailing = edges == null || edges.includes('trailing');
    const invoke = ()=>{
        if (pendingArgs !== null) {
            func.apply(pendingThis, pendingArgs);
            pendingThis = undefined;
            pendingArgs = null;
        }
    };
    const onTimerEnd = ()=>{
        if (trailing) invoke();
        cancel();
    };
    let timeoutId = null;
    const schedule = ()=>{
        if (timeoutId != null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            onTimerEnd();
        }, debounceMs);
    };
    const cancelTimer = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    const cancel = ()=>{
        cancelTimer();
        pendingThis = undefined;
        pendingArgs = null;
    };
    const flush = ()=>{
        invoke();
    };
    const debounced = function(...args) {
        if (signal?.aborted) return;
        pendingThis = this;
        pendingArgs = args;
        const isFirstCall = timeoutId == null;
        schedule();
        if (leading && isFirstCall) invoke();
    };
    debounced.schedule = schedule;
    debounced.cancel = cancel;
    debounced.flush = flush;
    signal?.addEventListener('abort', cancel, {
        once: true
    });
    return debounced;
}
module.exports.debounce = $689c13d82d3abfe7$var$debounce;

});



parcelRegister("l55GX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fdFwK = parcelRequire("fdFwK");

var $ku82D = parcelRequire("ku82D");

var $1kPBT = parcelRequire("1kPBT");
function $f58e7ae42c83d124$var$last(array) {
    if (!$1kPBT.isArrayLike(array)) return undefined;
    return $fdFwK.last($ku82D.toArray(array));
}
module.exports.last = $f58e7ae42c83d124$var$last;

});
parcelRegister("fdFwK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b1484856759c00b5$var$last(arr) {
    return arr[arr.length - 1];
}
module.exports.last = $b1484856759c00b5$var$last;

});

parcelRegister("ku82D", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ee9cd8daee971935$var$toArray(value) {
    return Array.isArray(value) ? value : Array.from(value);
}
module.exports.toArray = $ee9cd8daee971935$var$toArray;

});


parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                    case $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});

parcelRegister("4DyUZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $vYphW = parcelRequire("vYphW");

var $048jc = parcelRequire("048jc");
function $3605e3fb1bfaa8da$var$range(start, end, step) {
    if (step && typeof step !== 'number' && $vYphW.isIterateeCall(start, end, step)) end = step = undefined;
    start = $048jc.toFinite(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = $048jc.toFinite(end);
    step = step === undefined ? start < end ? 1 : -1 : $048jc.toFinite(step);
    const length = Math.max(Math.ceil((end - start) / (step || 1)), 0);
    const result = new Array(length);
    for(let index = 0; index < length; index++){
        result[index] = start;
        start += step;
    }
    return result;
}
module.exports.range = $3605e3fb1bfaa8da$var$range;

});
parcelRegister("048jc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hkogZ = parcelRequire("hkogZ");
function $00c6d1bf8fe1d628$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $hkogZ.toNumber(value);
    if (value === Infinity || value === -Infinity) {
        const sign = value < 0 ? -1 : 1;
        return sign * Number.MAX_VALUE;
    }
    return value === value ? value : 0;
}
module.exports.toFinite = $00c6d1bf8fe1d628$var$toFinite;

});
parcelRegister("hkogZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eA1Xn = parcelRequire("eA1Xn");
function $c9d7220eebeb78de$var$toNumber(value) {
    if ($eA1Xn.isSymbol(value)) return NaN;
    return Number(value);
}
module.exports.toNumber = $c9d7220eebeb78de$var$toNumber;

});



parcelRegister("eTYpT", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("3adcp"));

});
parcelRegister("3adcp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $24dc8b55daa987f9$var$_tickFormat.default;
    }
});

var $24dc8b55daa987f9$var$_band = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("dlF1c")));

var $24dc8b55daa987f9$var$_identity = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("5Hf98")));

var $24dc8b55daa987f9$var$_linear = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("hvSDx")));

var $24dc8b55daa987f9$var$_log = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("aEI3x")));

var $24dc8b55daa987f9$var$_symlog = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("bzrFz")));

var $24dc8b55daa987f9$var$_ordinal = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("cndqj")));

var $24dc8b55daa987f9$var$_pow = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("cpAbf")));

var $24dc8b55daa987f9$var$_radial = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("5lxEG")));

var $24dc8b55daa987f9$var$_quantile = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("67PVh")));

var $24dc8b55daa987f9$var$_quantize = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("mgOAc")));

var $24dc8b55daa987f9$var$_threshold = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("g6ge9")));

var $24dc8b55daa987f9$var$_time = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("617BV")));

var $24dc8b55daa987f9$var$_utcTime = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("ne0st")));

var $24dc8b55daa987f9$var$_sequential = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("5pVeE")));

var $24dc8b55daa987f9$var$_sequentialQuantile = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("l4TSc")));

var $24dc8b55daa987f9$var$_diverging = $24dc8b55daa987f9$var$_interopRequireWildcard((parcelRequire("fMWTD")));

var $24dc8b55daa987f9$var$_tickFormat = $24dc8b55daa987f9$var$_interopRequireDefault((parcelRequire("3ZXxn")));
function $24dc8b55daa987f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24dc8b55daa987f9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24dc8b55daa987f9$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $24dc8b55daa987f9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $24dc8b55daa987f9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("dlF1c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b7d0de6b9b21ba7$var$band;
module.exports.point = $9b7d0de6b9b21ba7$var$point;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");

var $9b7d0de6b9b21ba7$var$_ordinal = $9b7d0de6b9b21ba7$var$_interopRequireDefault((parcelRequire("cndqj")));
function $9b7d0de6b9b21ba7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b7d0de6b9b21ba7$var$band() {
    var scale = (0, $9b7d0de6b9b21ba7$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $baM4h.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $9b7d0de6b9b21ba7$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $98nei.initRange.apply(rescale(), arguments);
}
function $9b7d0de6b9b21ba7$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $9b7d0de6b9b21ba7$var$pointish(copy());
    };
    return scale;
}
function $9b7d0de6b9b21ba7$var$point() {
    return $9b7d0de6b9b21ba7$var$pointish($9b7d0de6b9b21ba7$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("baM4h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $aRMXC.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $7sRhp.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $7sRhp.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $aRMXC.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $aRMXC.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $8225ea2cc440a857$var$_zip.default;
    }
});

var $8225ea2cc440a857$var$_bisect = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("eiUsc")));

var $8225ea2cc440a857$var$_ascending = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("42JXN")));

var $8225ea2cc440a857$var$_bisector = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7C7yR")));

var $8225ea2cc440a857$var$_count = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $8225ea2cc440a857$var$_cross = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("67S8D")));

var $8225ea2cc440a857$var$_cumsum = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hG40Y")));

var $8225ea2cc440a857$var$_descending = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("j54An")));

var $8225ea2cc440a857$var$_deviation = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7tsUa")));

var $8225ea2cc440a857$var$_extent = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lRRFR")));

var $aRMXC = parcelRequire("aRMXC");

var $8225ea2cc440a857$var$_group = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("c1jhN")));

var $8225ea2cc440a857$var$_groupSort = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("g9Xbd")));

var $8225ea2cc440a857$var$_bin = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("cLuus")));

var $8225ea2cc440a857$var$_freedmanDiaconis = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("d1BC7")));

var $8225ea2cc440a857$var$_scott = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6i8dH")));

var $8225ea2cc440a857$var$_sturges = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("i7tuN")));

var $8225ea2cc440a857$var$_max = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("kHUkZ")));

var $8225ea2cc440a857$var$_maxIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("draOj")));

var $8225ea2cc440a857$var$_mean = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6DBgh")));

var $8225ea2cc440a857$var$_median = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("4HwgR")));

var $8225ea2cc440a857$var$_merge = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("gnNvC")));

var $8225ea2cc440a857$var$_min = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("5raSG")));

var $8225ea2cc440a857$var$_minIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("5nboE")));

var $8225ea2cc440a857$var$_mode = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("asMhi")));

var $8225ea2cc440a857$var$_nice = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("7mFci")));

var $8225ea2cc440a857$var$_pairs = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ir717")));

var $8225ea2cc440a857$var$_permute = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("39H9X")));

var $8225ea2cc440a857$var$_quantile = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("26KnF")));

var $8225ea2cc440a857$var$_quickselect = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("3EDNm")));

var $8225ea2cc440a857$var$_range = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hxxuu")));

var $8225ea2cc440a857$var$_rank = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("2Koeh")));

var $8225ea2cc440a857$var$_least = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("8ITro")));

var $8225ea2cc440a857$var$_leastIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("akUwn")));

var $8225ea2cc440a857$var$_greatest = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("ldDLn")));

var $8225ea2cc440a857$var$_greatestIndex = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6g8Yn")));

var $8225ea2cc440a857$var$_scan = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lfHoP")));

var $8225ea2cc440a857$var$_shuffle = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("jL9vH")));

var $8225ea2cc440a857$var$_sum = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("2zFIX")));

var $8225ea2cc440a857$var$_ticks = $8225ea2cc440a857$var$_interopRequireWildcard((parcelRequire("5nk0u")));

var $8225ea2cc440a857$var$_transpose = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("lcJcg")));

var $8225ea2cc440a857$var$_variance = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("eUraa")));

var $8225ea2cc440a857$var$_zip = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("6s8G0")));

var $8225ea2cc440a857$var$_every = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("4tbza")));

var $8225ea2cc440a857$var$_some = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("1clrJ")));

var $8225ea2cc440a857$var$_filter = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("hR10Z")));

var $8225ea2cc440a857$var$_map = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("akUza")));

var $8225ea2cc440a857$var$_reduce = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("h6YjS")));

var $8225ea2cc440a857$var$_reverse = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("397w5")));

var $8225ea2cc440a857$var$_sort = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("c5SM0")));

var $8225ea2cc440a857$var$_difference = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("e1d1i")));

var $8225ea2cc440a857$var$_disjoint = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("fu4hi")));

var $8225ea2cc440a857$var$_intersection = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("YVzQY")));

var $8225ea2cc440a857$var$_subset = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("fg75q")));

var $8225ea2cc440a857$var$_superset = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("8D0Hg")));

var $8225ea2cc440a857$var$_union = $8225ea2cc440a857$var$_interopRequireDefault((parcelRequire("aIUy7")));

var $7sRhp = parcelRequire("7sRhp");
function $8225ea2cc440a857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8225ea2cc440a857$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8225ea2cc440a857$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $8225ea2cc440a857$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $8225ea2cc440a857$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("eiUsc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $a69e89b1b00926f6$var$_ascending = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("42JXN")));

var $a69e89b1b00926f6$var$_bisector = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("7C7yR")));

var $a69e89b1b00926f6$var$_number = $a69e89b1b00926f6$var$_interopRequireDefault((parcelRequire("gcfbT")));
function $a69e89b1b00926f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a69e89b1b00926f6$var$ascendingBisect = (0, $a69e89b1b00926f6$var$_bisector.default)($a69e89b1b00926f6$var$_ascending.default);
const $a69e89b1b00926f6$var$bisectRight = module.exports.bisectRight = $a69e89b1b00926f6$var$ascendingBisect.right;
const $a69e89b1b00926f6$var$bisectLeft = module.exports.bisectLeft = $a69e89b1b00926f6$var$ascendingBisect.left;
const $a69e89b1b00926f6$var$bisectCenter = module.exports.bisectCenter = (0, $a69e89b1b00926f6$var$_bisector.default)($a69e89b1b00926f6$var$_number.default).center;
var $a69e89b1b00926f6$var$_default = module.exports.default = $a69e89b1b00926f6$var$bisectRight;

});
parcelRegister("42JXN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f1b00b724dfee65$var$ascending;
function $2f1b00b724dfee65$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("7C7yR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58b1f287db5949a5$var$bisector;

var $58b1f287db5949a5$var$_ascending = $58b1f287db5949a5$var$_interopRequireDefault((parcelRequire("42JXN")));

var $58b1f287db5949a5$var$_descending = $58b1f287db5949a5$var$_interopRequireDefault((parcelRequire("j54An")));
function $58b1f287db5949a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $58b1f287db5949a5$var$bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $58b1f287db5949a5$var$_ascending.default;
        compare2 = (d, x)=>(0, $58b1f287db5949a5$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $58b1f287db5949a5$var$_ascending.default || f === $58b1f287db5949a5$var$_descending.default ? f : $58b1f287db5949a5$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $58b1f287db5949a5$var$zero() {
    return 0;
}

});
parcelRegister("j54An", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de420a943e5c0a77$var$descending;
function $de420a943e5c0a77$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("gcfbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bca98cef4eb74909$var$number;
module.exports.numbers = $bca98cef4eb74909$var$numbers;
function $bca98cef4eb74909$var$number(x) {
    return x === null ? NaN : +x;
}
function* $bca98cef4eb74909$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("ajdJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7816560ab8fc6739$var$count;
function $7816560ab8fc6739$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("67S8D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $475d643bc06ac38a$var$cross;
function $475d643bc06ac38a$var$length(array) {
    return array.length | 0;
}
function $475d643bc06ac38a$var$empty(length) {
    return !(length > 0);
}
function $475d643bc06ac38a$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $475d643bc06ac38a$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $475d643bc06ac38a$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $475d643bc06ac38a$var$reducer(values.pop());
    values = values.map($475d643bc06ac38a$var$arrayify);
    const lengths = values.map($475d643bc06ac38a$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($475d643bc06ac38a$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("hG40Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cde979221a8d2882$var$cumsum;
function $cde979221a8d2882$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("7tsUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5711a9c3c8056430$var$deviation;

var $5711a9c3c8056430$var$_variance = $5711a9c3c8056430$var$_interopRequireDefault((parcelRequire("eUraa")));
function $5711a9c3c8056430$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5711a9c3c8056430$var$deviation(values, valueof) {
    const v = (0, $5711a9c3c8056430$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("eUraa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adab5da989fb8953$var$variance;
function $adab5da989fb8953$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("lRRFR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feb82ec2fd27e17d$var$extent;
function $feb82ec2fd27e17d$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("aRMXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $7e94d527ee12243e$var$fcumsum;
module.exports.fsum = $7e94d527ee12243e$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $7e94d527ee12243e$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $7e94d527ee12243e$var$Adder;
function $7e94d527ee12243e$var$fsum(values, valueof) {
    const adder = new $7e94d527ee12243e$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $7e94d527ee12243e$var$fcumsum(values, valueof) {
    const adder = new $7e94d527ee12243e$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("c1jhN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c0489d5df4dc49a$var$group;
module.exports.flatGroup = $8c0489d5df4dc49a$var$flatGroup;
module.exports.flatRollup = $8c0489d5df4dc49a$var$flatRollup;
module.exports.groups = $8c0489d5df4dc49a$var$groups;
module.exports.index = $8c0489d5df4dc49a$var$index;
module.exports.indexes = $8c0489d5df4dc49a$var$indexes;
module.exports.rollup = $8c0489d5df4dc49a$var$rollup;
module.exports.rollups = $8c0489d5df4dc49a$var$rollups;

var $7sRhp = parcelRequire("7sRhp");

var $8c0489d5df4dc49a$var$_identity = $8c0489d5df4dc49a$var$_interopRequireDefault((parcelRequire("8zLyq")));
function $8c0489d5df4dc49a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c0489d5df4dc49a$var$group(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, $8c0489d5df4dc49a$var$_identity.default, keys);
}
function $8c0489d5df4dc49a$var$groups(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, $8c0489d5df4dc49a$var$_identity.default, keys);
}
function $8c0489d5df4dc49a$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $8c0489d5df4dc49a$var$flatGroup(values, ...keys) {
    return $8c0489d5df4dc49a$var$flatten($8c0489d5df4dc49a$var$groups(values, ...keys), keys);
}
function $8c0489d5df4dc49a$var$flatRollup(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$flatten($8c0489d5df4dc49a$var$rollups(values, reduce, ...keys), keys);
}
function $8c0489d5df4dc49a$var$rollup(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, reduce, keys);
}
function $8c0489d5df4dc49a$var$rollups(values, reduce, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, reduce, keys);
}
function $8c0489d5df4dc49a$var$index(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, $8c0489d5df4dc49a$var$_identity.default, $8c0489d5df4dc49a$var$unique, keys);
}
function $8c0489d5df4dc49a$var$indexes(values, ...keys) {
    return $8c0489d5df4dc49a$var$nest(values, Array.from, $8c0489d5df4dc49a$var$unique, keys);
}
function $8c0489d5df4dc49a$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $8c0489d5df4dc49a$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $7sRhp.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("7sRhp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $56f47a2ee37085db$var$InternMap extends Map {
    constructor(entries, key = $56f47a2ee37085db$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($56f47a2ee37085db$var$intern_get(this, key));
    }
    has(key) {
        return super.has($56f47a2ee37085db$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($56f47a2ee37085db$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($56f47a2ee37085db$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $56f47a2ee37085db$var$InternMap;
class $56f47a2ee37085db$var$InternSet extends Set {
    constructor(values, key = $56f47a2ee37085db$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($56f47a2ee37085db$var$intern_get(this, value));
    }
    add(value) {
        return super.add($56f47a2ee37085db$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($56f47a2ee37085db$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $56f47a2ee37085db$var$InternSet;
function $56f47a2ee37085db$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $56f47a2ee37085db$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $56f47a2ee37085db$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $56f47a2ee37085db$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("8zLyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63e67ae60b71c777$var$identity;
function $63e67ae60b71c777$var$identity(x) {
    return x;
}

});


parcelRegister("g9Xbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc3b647cce9788a6$var$groupSort;

var $bc3b647cce9788a6$var$_ascending = $bc3b647cce9788a6$var$_interopRequireDefault((parcelRequire("42JXN")));

var $bc3b647cce9788a6$var$_group = $bc3b647cce9788a6$var$_interopRequireWildcard((parcelRequire("c1jhN")));

var $bc3b647cce9788a6$var$_sort = $bc3b647cce9788a6$var$_interopRequireDefault((parcelRequire("c5SM0")));
function $bc3b647cce9788a6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bc3b647cce9788a6$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $bc3b647cce9788a6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $bc3b647cce9788a6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $bc3b647cce9788a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bc3b647cce9788a6$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $bc3b647cce9788a6$var$_sort.default)((0, $bc3b647cce9788a6$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $bc3b647cce9788a6$var$_ascending.default)(av, bv) || (0, $bc3b647cce9788a6$var$_ascending.default)(ak, bk)) : (0, $bc3b647cce9788a6$var$_sort.default)((0, $bc3b647cce9788a6$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $bc3b647cce9788a6$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("c5SM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $8ce0707f2a6c02b5$var$ascendingDefined;
module.exports.compareDefined = $8ce0707f2a6c02b5$var$compareDefined;
module.exports.default = $8ce0707f2a6c02b5$var$sort;

var $8ce0707f2a6c02b5$var$_ascending = $8ce0707f2a6c02b5$var$_interopRequireDefault((parcelRequire("42JXN")));

var $8ce0707f2a6c02b5$var$_permute = $8ce0707f2a6c02b5$var$_interopRequireDefault((parcelRequire("39H9X")));
function $8ce0707f2a6c02b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ce0707f2a6c02b5$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $8ce0707f2a6c02b5$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$8ce0707f2a6c02b5$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $8ce0707f2a6c02b5$var$_permute.default)(values, index);
    }
    return values.sort($8ce0707f2a6c02b5$var$compareDefined(f));
}
function $8ce0707f2a6c02b5$var$compareDefined(compare = $8ce0707f2a6c02b5$var$_ascending.default) {
    if (compare === $8ce0707f2a6c02b5$var$_ascending.default) return $8ce0707f2a6c02b5$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $8ce0707f2a6c02b5$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("39H9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24c3b0f3203412d9$var$permute;
function $24c3b0f3203412d9$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("cLuus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94b18691700bad11$var$bin;

var $8fPjY = parcelRequire("8fPjY");

var $94b18691700bad11$var$_bisect = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("eiUsc")));

var $94b18691700bad11$var$_constant = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("lWOD3")));

var $94b18691700bad11$var$_extent = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("lRRFR")));

var $94b18691700bad11$var$_identity = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("8zLyq")));

var $94b18691700bad11$var$_nice = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("7mFci")));

var $94b18691700bad11$var$_ticks = $94b18691700bad11$var$_interopRequireWildcard((parcelRequire("5nk0u")));

var $94b18691700bad11$var$_sturges = $94b18691700bad11$var$_interopRequireDefault((parcelRequire("i7tuN")));
function $94b18691700bad11$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($94b18691700bad11$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $94b18691700bad11$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $94b18691700bad11$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $94b18691700bad11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94b18691700bad11$var$bin() {
    var value = $94b18691700bad11$var$_identity.default, domain = $94b18691700bad11$var$_extent.default, threshold = $94b18691700bad11$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $94b18691700bad11$var$_extent.default) [x0, x1] = (0, $94b18691700bad11$var$_nice.default)(x0, x1, tn);
            tz = (0, $94b18691700bad11$var$_ticks.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $94b18691700bad11$var$_ticks.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $94b18691700bad11$var$_extent.default) {
                    const step = (0, $94b18691700bad11$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $94b18691700bad11$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $94b18691700bad11$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $94b18691700bad11$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $94b18691700bad11$var$_constant.default)($8fPjY.slice.call(_)) : (0, $94b18691700bad11$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("8fPjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $602788bdac406ac0$var$array = Array.prototype;
var $602788bdac406ac0$var$slice = module.exports.slice = $602788bdac406ac0$var$array.slice;
var $602788bdac406ac0$var$map = module.exports.map = $602788bdac406ac0$var$array.map;

});

parcelRegister("lWOD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffa649a02a5bb3a3$var$constant;
function $ffa649a02a5bb3a3$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("7mFci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55ca8b6e985ae2f5$var$nice;

var $5nk0u = parcelRequire("5nk0u");
function $55ca8b6e985ae2f5$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $5nk0u.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("5nk0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e9e9eb054d2a742$var$ticks;
module.exports.tickIncrement = $3e9e9eb054d2a742$var$tickIncrement;
module.exports.tickStep = $3e9e9eb054d2a742$var$tickStep;
var $3e9e9eb054d2a742$var$e10 = Math.sqrt(50), $3e9e9eb054d2a742$var$e5 = Math.sqrt(10), $3e9e9eb054d2a742$var$e2 = Math.sqrt(2);
function $3e9e9eb054d2a742$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $3e9e9eb054d2a742$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $3e9e9eb054d2a742$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $3e9e9eb054d2a742$var$e10 ? 10 : error >= $3e9e9eb054d2a742$var$e5 ? 5 : error >= $3e9e9eb054d2a742$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $3e9e9eb054d2a742$var$e10 ? 10 : error >= $3e9e9eb054d2a742$var$e5 ? 5 : error >= $3e9e9eb054d2a742$var$e2 ? 2 : 1);
}
function $3e9e9eb054d2a742$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $3e9e9eb054d2a742$var$e10) step1 *= 10;
    else if (error >= $3e9e9eb054d2a742$var$e5) step1 *= 5;
    else if (error >= $3e9e9eb054d2a742$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("i7tuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d30fc2ac2a08428f$var$thresholdSturges;

var $d30fc2ac2a08428f$var$_count = $d30fc2ac2a08428f$var$_interopRequireDefault((parcelRequire("ajdJT")));
function $d30fc2ac2a08428f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d30fc2ac2a08428f$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $d30fc2ac2a08428f$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("d1BC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97b88ba8a5b45d42$var$thresholdFreedmanDiaconis;

var $97b88ba8a5b45d42$var$_count = $97b88ba8a5b45d42$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $97b88ba8a5b45d42$var$_quantile = $97b88ba8a5b45d42$var$_interopRequireDefault((parcelRequire("26KnF")));
function $97b88ba8a5b45d42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97b88ba8a5b45d42$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $97b88ba8a5b45d42$var$_quantile.default)(values, 0.75) - (0, $97b88ba8a5b45d42$var$_quantile.default)(values, 0.25)) * Math.pow((0, $97b88ba8a5b45d42$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("26KnF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18901e8b3a4fd0ff$var$quantile;
module.exports.quantileSorted = $18901e8b3a4fd0ff$var$quantileSorted;

var $18901e8b3a4fd0ff$var$_max = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("kHUkZ")));

var $18901e8b3a4fd0ff$var$_min = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("5raSG")));

var $18901e8b3a4fd0ff$var$_quickselect = $18901e8b3a4fd0ff$var$_interopRequireDefault((parcelRequire("3EDNm")));

var $18901e8b3a4fd0ff$var$_number = $18901e8b3a4fd0ff$var$_interopRequireWildcard((parcelRequire("gcfbT")));
function $18901e8b3a4fd0ff$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($18901e8b3a4fd0ff$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $18901e8b3a4fd0ff$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $18901e8b3a4fd0ff$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $18901e8b3a4fd0ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $18901e8b3a4fd0ff$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $18901e8b3a4fd0ff$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $18901e8b3a4fd0ff$var$_min.default)(values);
    if (p >= 1) return (0, $18901e8b3a4fd0ff$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $18901e8b3a4fd0ff$var$_max.default)((0, $18901e8b3a4fd0ff$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $18901e8b3a4fd0ff$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $18901e8b3a4fd0ff$var$quantileSorted(values, p, valueof = $18901e8b3a4fd0ff$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("kHUkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1338644b4c67516$var$max;
function $f1338644b4c67516$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("5raSG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f57ea15fd4fa697$var$min;
function $3f57ea15fd4fa697$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("3EDNm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a93f9ffa4634b87$var$quickselect;

var $c5SM0 = parcelRequire("c5SM0");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $2a93f9ffa4634b87$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $c5SM0.ascendingDefined : (0, $c5SM0.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $2a93f9ffa4634b87$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $2a93f9ffa4634b87$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $2a93f9ffa4634b87$var$swap(array, left, right);
        while(i < j){
            $2a93f9ffa4634b87$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $2a93f9ffa4634b87$var$swap(array, left, j);
        else ++j, $2a93f9ffa4634b87$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $2a93f9ffa4634b87$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("6i8dH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $494acccde647e16c$var$thresholdScott;

var $494acccde647e16c$var$_count = $494acccde647e16c$var$_interopRequireDefault((parcelRequire("ajdJT")));

var $494acccde647e16c$var$_deviation = $494acccde647e16c$var$_interopRequireDefault((parcelRequire("7tsUa")));
function $494acccde647e16c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $494acccde647e16c$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $494acccde647e16c$var$_count.default)(values)) / (3.49 * (0, $494acccde647e16c$var$_deviation.default)(values)));
}

});

parcelRegister("draOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c862eb3e14f7f21$var$maxIndex;
function $9c862eb3e14f7f21$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("6DBgh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d5349f5a83ddf13$var$mean;
function $4d5349f5a83ddf13$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("4HwgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36c435e6cfd0c994$var$median;

var $36c435e6cfd0c994$var$_quantile = $36c435e6cfd0c994$var$_interopRequireDefault((parcelRequire("26KnF")));
function $36c435e6cfd0c994$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36c435e6cfd0c994$var$median(values, valueof) {
    return (0, $36c435e6cfd0c994$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("gnNvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bed532caf95c2cc1$var$merge;
function* $bed532caf95c2cc1$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $bed532caf95c2cc1$var$merge(arrays) {
    return Array.from($bed532caf95c2cc1$var$flatten(arrays));
}

});

parcelRegister("5nboE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e97f0d92d44cfb5$var$minIndex;
function $3e97f0d92d44cfb5$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("asMhi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79e1f7e990dab177$var$mode;

var $7sRhp = parcelRequire("7sRhp");
function $79e1f7e990dab177$var$mode(values, valueof) {
    const counts = new $7sRhp.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("ir717", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6c03112fa117caf$var$pairs;
module.exports.pair = $d6c03112fa117caf$var$pair;
function $d6c03112fa117caf$var$pairs(values, pairof = $d6c03112fa117caf$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $d6c03112fa117caf$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("hxxuu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc4f7f4c7cafdf17$var$range;
function $cc4f7f4c7cafdf17$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("2Koeh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2002ac11cfb6d638$var$rank;

var $2002ac11cfb6d638$var$_ascending = $2002ac11cfb6d638$var$_interopRequireDefault((parcelRequire("42JXN")));

var $c5SM0 = parcelRequire("c5SM0");
function $2002ac11cfb6d638$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2002ac11cfb6d638$var$rank(values, valueof = $2002ac11cfb6d638$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $2002ac11cfb6d638$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $2002ac11cfb6d638$var$_ascending.default ? (i, j)=>(0, $c5SM0.ascendingDefined)(V[i], V[j]) : (0, $c5SM0.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("8ITro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $659d7030edb20224$var$least;

var $659d7030edb20224$var$_ascending = $659d7030edb20224$var$_interopRequireDefault((parcelRequire("42JXN")));
function $659d7030edb20224$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $659d7030edb20224$var$least(values, compare = $659d7030edb20224$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $659d7030edb20224$var$_ascending.default)(value, minValue) < 0 : (0, $659d7030edb20224$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("akUwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78679d96d8a8dfa8$var$leastIndex;

var $78679d96d8a8dfa8$var$_ascending = $78679d96d8a8dfa8$var$_interopRequireDefault((parcelRequire("42JXN")));

var $78679d96d8a8dfa8$var$_minIndex = $78679d96d8a8dfa8$var$_interopRequireDefault((parcelRequire("5nboE")));
function $78679d96d8a8dfa8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78679d96d8a8dfa8$var$leastIndex(values, compare = $78679d96d8a8dfa8$var$_ascending.default) {
    if (compare.length === 1) return (0, $78679d96d8a8dfa8$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("ldDLn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f729a7fb558b06cf$var$greatest;

var $f729a7fb558b06cf$var$_ascending = $f729a7fb558b06cf$var$_interopRequireDefault((parcelRequire("42JXN")));
function $f729a7fb558b06cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f729a7fb558b06cf$var$greatest(values, compare = $f729a7fb558b06cf$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $f729a7fb558b06cf$var$_ascending.default)(value, maxValue) > 0 : (0, $f729a7fb558b06cf$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("6g8Yn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48eb32837203911a$var$greatestIndex;

var $48eb32837203911a$var$_ascending = $48eb32837203911a$var$_interopRequireDefault((parcelRequire("42JXN")));

var $48eb32837203911a$var$_maxIndex = $48eb32837203911a$var$_interopRequireDefault((parcelRequire("draOj")));
function $48eb32837203911a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $48eb32837203911a$var$greatestIndex(values, compare = $48eb32837203911a$var$_ascending.default) {
    if (compare.length === 1) return (0, $48eb32837203911a$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("lfHoP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78ca9ea19eaeee4$var$scan;

var $f78ca9ea19eaeee4$var$_leastIndex = $f78ca9ea19eaeee4$var$_interopRequireDefault((parcelRequire("akUwn")));
function $f78ca9ea19eaeee4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f78ca9ea19eaeee4$var$scan(values, compare) {
    const index = (0, $f78ca9ea19eaeee4$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("jL9vH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $e629c8a42e8bf302$var$shuffler;
var $e629c8a42e8bf302$var$_default = module.exports.default = $e629c8a42e8bf302$var$shuffler(Math.random);
function $e629c8a42e8bf302$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("2zFIX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1dff3733b9c4bd4d$var$sum;
function $1dff3733b9c4bd4d$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("lcJcg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6fdc71f51d85f9f$var$transpose;

var $f6fdc71f51d85f9f$var$_min = $f6fdc71f51d85f9f$var$_interopRequireDefault((parcelRequire("5raSG")));
function $f6fdc71f51d85f9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6fdc71f51d85f9f$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f6fdc71f51d85f9f$var$_min.default)(matrix, $f6fdc71f51d85f9f$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $f6fdc71f51d85f9f$var$length(d) {
    return d.length;
}

});

parcelRegister("6s8G0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b2c16983adf6c04$var$zip;

var $4b2c16983adf6c04$var$_transpose = $4b2c16983adf6c04$var$_interopRequireDefault((parcelRequire("lcJcg")));
function $4b2c16983adf6c04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b2c16983adf6c04$var$zip() {
    return (0, $4b2c16983adf6c04$var$_transpose.default)(arguments);
}

});

parcelRegister("4tbza", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3412d7ab2a2d2c83$var$every;
function $3412d7ab2a2d2c83$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("1clrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0df78c3c85287a4f$var$some;
function $0df78c3c85287a4f$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("hR10Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cff82c72a5b8b509$var$filter;
function $cff82c72a5b8b509$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("akUza", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7867a68277e09c2f$var$map;
function $7867a68277e09c2f$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("h6YjS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c751c9725add00ba$var$reduce;
function $c751c9725add00ba$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("397w5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24a80b0230cdfb4b$var$reverse;
function $24a80b0230cdfb4b$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("e1d1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a34b4226c9d69ac9$var$difference;

var $7sRhp = parcelRequire("7sRhp");
function $a34b4226c9d69ac9$var$difference(values, ...others) {
    values = new $7sRhp.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("fu4hi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b45cf9dd28454a0d$var$disjoint;

var $7sRhp = parcelRequire("7sRhp");
function $b45cf9dd28454a0d$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $7sRhp.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("YVzQY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b72445c1f450e7c$var$intersection;

var $7sRhp = parcelRequire("7sRhp");
function $0b72445c1f450e7c$var$intersection(values, ...others) {
    values = new $7sRhp.InternSet(values);
    others = others.map($0b72445c1f450e7c$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $0b72445c1f450e7c$var$set(values) {
    return values instanceof $7sRhp.InternSet ? values : new $7sRhp.InternSet(values);
}

});

parcelRegister("fg75q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1bdd8db4dd52b60$var$subset;

var $b1bdd8db4dd52b60$var$_superset = $b1bdd8db4dd52b60$var$_interopRequireDefault((parcelRequire("8D0Hg")));
function $b1bdd8db4dd52b60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1bdd8db4dd52b60$var$subset(values, other) {
    return (0, $b1bdd8db4dd52b60$var$_superset.default)(other, values);
}

});
parcelRegister("8D0Hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6482819a31cea494$var$superset;
function $6482819a31cea494$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $6482819a31cea494$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $6482819a31cea494$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $6482819a31cea494$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("aIUy7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ce9e0f4038492e4$var$union;

var $7sRhp = parcelRequire("7sRhp");
function $7ce9e0f4038492e4$var$union(...others) {
    const set = new $7sRhp.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("98nei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $6a66e152678b40cc$var$initInterpolator;
module.exports.initRange = $6a66e152678b40cc$var$initRange;
function $6a66e152678b40cc$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $6a66e152678b40cc$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("cndqj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90220b9f6d3aba30$var$ordinal;
module.exports.implicit = void 0;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
const $90220b9f6d3aba30$var$implicit = module.exports.implicit = Symbol("implicit");
function $90220b9f6d3aba30$var$ordinal() {
    var index = new $baM4h.InternMap(), domain = [], range = [], unknown = $90220b9f6d3aba30$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $90220b9f6d3aba30$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $baM4h.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $90220b9f6d3aba30$var$ordinal(domain, range).unknown(unknown);
    };
    $98nei.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("5Hf98", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $425cb7a96912c4d8$var$identity;

var $hvSDx = parcelRequire("hvSDx");

var $425cb7a96912c4d8$var$_number = $425cb7a96912c4d8$var$_interopRequireDefault((parcelRequire("jerFr")));
function $425cb7a96912c4d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $425cb7a96912c4d8$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $425cb7a96912c4d8$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $425cb7a96912c4d8$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $425cb7a96912c4d8$var$_number.default) : [
        0,
        1
    ];
    return (0, $hvSDx.linearish)(scale);
}

});
parcelRegister("hvSDx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbffb6a56efcbb3c$var$linear;
module.exports.linearish = $cbffb6a56efcbb3c$var$linearish;

var $baM4h = parcelRequire("baM4h");

var $cbffb6a56efcbb3c$var$_continuous = $cbffb6a56efcbb3c$var$_interopRequireWildcard((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $cbffb6a56efcbb3c$var$_tickFormat = $cbffb6a56efcbb3c$var$_interopRequireDefault((parcelRequire("3ZXxn")));
function $cbffb6a56efcbb3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbffb6a56efcbb3c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cbffb6a56efcbb3c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $cbffb6a56efcbb3c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $cbffb6a56efcbb3c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $cbffb6a56efcbb3c$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $baM4h.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $cbffb6a56efcbb3c$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $baM4h.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $cbffb6a56efcbb3c$var$linear() {
    var scale = (0, $cbffb6a56efcbb3c$var$_continuous.default)();
    scale.copy = function() {
        return (0, $cbffb6a56efcbb3c$var$_continuous.copy)(scale, $cbffb6a56efcbb3c$var$linear());
    };
    $98nei.initRange.apply(scale, arguments);
    return $cbffb6a56efcbb3c$var$linearish(scale);
}

});
parcelRegister("dTLbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $a1e5028e49e95242$var$copy;
module.exports.default = $a1e5028e49e95242$var$continuous;
module.exports.identity = $a1e5028e49e95242$var$identity;
module.exports.transformer = $a1e5028e49e95242$var$transformer;

var $baM4h = parcelRequire("baM4h");

var $665th = parcelRequire("665th");

var $a1e5028e49e95242$var$_constant = $a1e5028e49e95242$var$_interopRequireDefault((parcelRequire("jgTuH")));

var $a1e5028e49e95242$var$_number = $a1e5028e49e95242$var$_interopRequireDefault((parcelRequire("jerFr")));
function $a1e5028e49e95242$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a1e5028e49e95242$var$unit = [
    0,
    1
];
function $a1e5028e49e95242$var$identity(x) {
    return x;
}
function $a1e5028e49e95242$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $a1e5028e49e95242$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $a1e5028e49e95242$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $a1e5028e49e95242$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $a1e5028e49e95242$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $a1e5028e49e95242$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $a1e5028e49e95242$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $a1e5028e49e95242$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $baM4h.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $a1e5028e49e95242$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $a1e5028e49e95242$var$transformer() {
    var domain = $a1e5028e49e95242$var$unit, range = $a1e5028e49e95242$var$unit, interpolate = $665th.interpolate, transform, untransform, unknown, clamp = $a1e5028e49e95242$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $a1e5028e49e95242$var$identity) clamp = $a1e5028e49e95242$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $a1e5028e49e95242$var$polymap : $a1e5028e49e95242$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $665th.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $a1e5028e49e95242$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $665th.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $a1e5028e49e95242$var$identity, rescale()) : clamp !== $a1e5028e49e95242$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $a1e5028e49e95242$var$continuous() {
    return $a1e5028e49e95242$var$transformer()($a1e5028e49e95242$var$identity, $a1e5028e49e95242$var$identity);
}

});
parcelRegister("665th", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $O407u.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $O407u.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $47078c155d673c7c$var$_quantize.default;
    }
});

var $47078c155d673c7c$var$_value = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("k8gaa")));

var $47078c155d673c7c$var$_array = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("c2a7V")));

var $47078c155d673c7c$var$_basis = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("hurAB")));

var $47078c155d673c7c$var$_basisClosed = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("7JEhq")));

var $47078c155d673c7c$var$_date = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("ck059")));

var $47078c155d673c7c$var$_discrete = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("9bEkd")));

var $47078c155d673c7c$var$_hue = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("gPZC5")));

var $47078c155d673c7c$var$_number = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $47078c155d673c7c$var$_numberArray = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4Xtub")));

var $47078c155d673c7c$var$_object = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("eWQsD")));

var $47078c155d673c7c$var$_round = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("1qcvW")));

var $47078c155d673c7c$var$_string = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("aQhro")));

var $O407u = parcelRequire("O407u");

var $47078c155d673c7c$var$_zoom = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("4ymTx")));

var $47078c155d673c7c$var$_rgb = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("3CWNZ")));

var $47078c155d673c7c$var$_hsl = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("h8Xdb")));

var $47078c155d673c7c$var$_lab = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("6bPgS")));

var $47078c155d673c7c$var$_hcl = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("dWbd5")));

var $47078c155d673c7c$var$_cubehelix = $47078c155d673c7c$var$_interopRequireWildcard((parcelRequire("1chdf")));

var $47078c155d673c7c$var$_piecewise = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("1d2kq")));

var $47078c155d673c7c$var$_quantize = $47078c155d673c7c$var$_interopRequireDefault((parcelRequire("7rbIB")));
function $47078c155d673c7c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($47078c155d673c7c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $47078c155d673c7c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $47078c155d673c7c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $47078c155d673c7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("k8gaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea8117a067b5834a$var$_default;

var $4xVlj = parcelRequire("4xVlj");

var $ea8117a067b5834a$var$_rgb = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("3CWNZ")));

var $c2a7V = parcelRequire("c2a7V");

var $ea8117a067b5834a$var$_date = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("ck059")));

var $ea8117a067b5834a$var$_number = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $ea8117a067b5834a$var$_object = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("eWQsD")));

var $ea8117a067b5834a$var$_string = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("aQhro")));

var $ea8117a067b5834a$var$_constant = $ea8117a067b5834a$var$_interopRequireDefault((parcelRequire("iRCSk")));

var $ea8117a067b5834a$var$_numberArray = $ea8117a067b5834a$var$_interopRequireWildcard((parcelRequire("4Xtub")));
function $ea8117a067b5834a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ea8117a067b5834a$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $ea8117a067b5834a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $ea8117a067b5834a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $ea8117a067b5834a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea8117a067b5834a$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ea8117a067b5834a$var$_constant.default)(b) : (t === "number" ? $ea8117a067b5834a$var$_number.default : t === "string" ? (c = (0, $4xVlj.color)(b)) ? (b = c, $ea8117a067b5834a$var$_rgb.default) : $ea8117a067b5834a$var$_string.default : b instanceof $4xVlj.color ? $ea8117a067b5834a$var$_rgb.default : b instanceof Date ? $ea8117a067b5834a$var$_date.default : (0, $ea8117a067b5834a$var$_numberArray.isNumberArray)(b) ? $ea8117a067b5834a$var$_numberArray.default : Array.isArray(b) ? $c2a7V.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $ea8117a067b5834a$var$_object.default : $ea8117a067b5834a$var$_number.default)(a, b);
}

});
parcelRegister("4xVlj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $34f6b991f3373171$var$_color.rgb;
    }
});

var $34f6b991f3373171$var$_color = $34f6b991f3373171$var$_interopRequireWildcard((parcelRequire("hCN5L")));

var $34f6b991f3373171$var$_lab = $34f6b991f3373171$var$_interopRequireWildcard((parcelRequire("9xOfl")));

var $34f6b991f3373171$var$_cubehelix = $34f6b991f3373171$var$_interopRequireDefault((parcelRequire("45fUy")));
function $34f6b991f3373171$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34f6b991f3373171$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($34f6b991f3373171$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $34f6b991f3373171$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $34f6b991f3373171$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("hCN5L", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("4Ivzr")));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function Color() {}
var darker = exports.darker = 0.7;
var brighter = exports.brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("4Ivzr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36f3c2bb271333d6$var$_default;
module.exports.extend = $36f3c2bb271333d6$var$extend;
function $36f3c2bb271333d6$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $36f3c2bb271333d6$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("9xOfl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $6f2e2c04ae38a42e$var$Hcl;
module.exports.Lab = $6f2e2c04ae38a42e$var$Lab;
module.exports.default = $6f2e2c04ae38a42e$var$lab;
module.exports.gray = $6f2e2c04ae38a42e$var$gray;
module.exports.hcl = $6f2e2c04ae38a42e$var$hcl;
module.exports.lch = $6f2e2c04ae38a42e$var$lch;

var $6f2e2c04ae38a42e$var$_define = $6f2e2c04ae38a42e$var$_interopRequireWildcard((parcelRequire("4Ivzr")));

var $hCN5L = parcelRequire("hCN5L");

var $hPqOe = parcelRequire("hPqOe");
function $6f2e2c04ae38a42e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6f2e2c04ae38a42e$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6f2e2c04ae38a42e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6f2e2c04ae38a42e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $6f2e2c04ae38a42e$var$K = 18, $6f2e2c04ae38a42e$var$Xn = 0.96422, $6f2e2c04ae38a42e$var$Yn = 1, $6f2e2c04ae38a42e$var$Zn = 0.82521, $6f2e2c04ae38a42e$var$t0 = 4 / 29, $6f2e2c04ae38a42e$var$t1 = 6 / 29, $6f2e2c04ae38a42e$var$t2 = 3 * $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1, $6f2e2c04ae38a42e$var$t3 = $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1 * $6f2e2c04ae38a42e$var$t1;
function $6f2e2c04ae38a42e$var$labConvert(o) {
    if (o instanceof $6f2e2c04ae38a42e$var$Lab) return new $6f2e2c04ae38a42e$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $6f2e2c04ae38a42e$var$Hcl) return $6f2e2c04ae38a42e$var$hcl2lab(o);
    if (!(o instanceof $hCN5L.Rgb)) o = (0, $hCN5L.rgbConvert)(o);
    var r = $6f2e2c04ae38a42e$var$rgb2lrgb(o.r), g = $6f2e2c04ae38a42e$var$rgb2lrgb(o.g), b = $6f2e2c04ae38a42e$var$rgb2lrgb(o.b), y = $6f2e2c04ae38a42e$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $6f2e2c04ae38a42e$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $6f2e2c04ae38a42e$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $6f2e2c04ae38a42e$var$Xn);
        z = $6f2e2c04ae38a42e$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $6f2e2c04ae38a42e$var$Zn);
    }
    return new $6f2e2c04ae38a42e$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $6f2e2c04ae38a42e$var$gray(l, opacity) {
    return new $6f2e2c04ae38a42e$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$labConvert(l) : new $6f2e2c04ae38a42e$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $6f2e2c04ae38a42e$var$_define.default)($6f2e2c04ae38a42e$var$Lab, $6f2e2c04ae38a42e$var$lab, (0, $6f2e2c04ae38a42e$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        return new $6f2e2c04ae38a42e$var$Lab(this.l + $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $6f2e2c04ae38a42e$var$Lab(this.l - $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $6f2e2c04ae38a42e$var$Xn * $6f2e2c04ae38a42e$var$lab2xyz(x);
        y = $6f2e2c04ae38a42e$var$Yn * $6f2e2c04ae38a42e$var$lab2xyz(y);
        z = $6f2e2c04ae38a42e$var$Zn * $6f2e2c04ae38a42e$var$lab2xyz(z);
        return new $hCN5L.Rgb($6f2e2c04ae38a42e$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $6f2e2c04ae38a42e$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $6f2e2c04ae38a42e$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $6f2e2c04ae38a42e$var$xyz2lab(t) {
    return t > $6f2e2c04ae38a42e$var$t3 ? Math.pow(t, 1 / 3) : t / $6f2e2c04ae38a42e$var$t2 + $6f2e2c04ae38a42e$var$t0;
}
function $6f2e2c04ae38a42e$var$lab2xyz(t) {
    return t > $6f2e2c04ae38a42e$var$t1 ? t * t * t : $6f2e2c04ae38a42e$var$t2 * (t - $6f2e2c04ae38a42e$var$t0);
}
function $6f2e2c04ae38a42e$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $6f2e2c04ae38a42e$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $6f2e2c04ae38a42e$var$hclConvert(o) {
    if (o instanceof $6f2e2c04ae38a42e$var$Hcl) return new $6f2e2c04ae38a42e$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $6f2e2c04ae38a42e$var$Lab)) o = $6f2e2c04ae38a42e$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $6f2e2c04ae38a42e$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $hPqOe.degrees;
    return new $6f2e2c04ae38a42e$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $6f2e2c04ae38a42e$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$hclConvert(l) : new $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $6f2e2c04ae38a42e$var$hclConvert(h) : new $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $6f2e2c04ae38a42e$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $6f2e2c04ae38a42e$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $6f2e2c04ae38a42e$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $hPqOe.radians;
    return new $6f2e2c04ae38a42e$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $6f2e2c04ae38a42e$var$_define.default)($6f2e2c04ae38a42e$var$Hcl, $6f2e2c04ae38a42e$var$hcl, (0, $6f2e2c04ae38a42e$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        return new $6f2e2c04ae38a42e$var$Hcl(this.h, this.c, this.l + $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $6f2e2c04ae38a42e$var$Hcl(this.h, this.c, this.l - $6f2e2c04ae38a42e$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $6f2e2c04ae38a42e$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("hPqOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $cfabfed4d344b6c6$var$radians = module.exports.radians = Math.PI / 180;
const $cfabfed4d344b6c6$var$degrees = module.exports.degrees = 180 / Math.PI;

});


parcelRegister("45fUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $2f93f8ad649541d1$var$Cubehelix;
module.exports.default = $2f93f8ad649541d1$var$cubehelix;

var $2f93f8ad649541d1$var$_define = $2f93f8ad649541d1$var$_interopRequireWildcard((parcelRequire("4Ivzr")));

var $hCN5L = parcelRequire("hCN5L");

var $hPqOe = parcelRequire("hPqOe");
function $2f93f8ad649541d1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2f93f8ad649541d1$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $2f93f8ad649541d1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $2f93f8ad649541d1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $2f93f8ad649541d1$var$A = -0.14861, $2f93f8ad649541d1$var$B = 1.78277, $2f93f8ad649541d1$var$C = -0.29227, $2f93f8ad649541d1$var$D = -0.90649, $2f93f8ad649541d1$var$E = 1.97294, $2f93f8ad649541d1$var$ED = $2f93f8ad649541d1$var$E * $2f93f8ad649541d1$var$D, $2f93f8ad649541d1$var$EB = $2f93f8ad649541d1$var$E * $2f93f8ad649541d1$var$B, $2f93f8ad649541d1$var$BC_DA = $2f93f8ad649541d1$var$B * $2f93f8ad649541d1$var$C - $2f93f8ad649541d1$var$D * $2f93f8ad649541d1$var$A;
function $2f93f8ad649541d1$var$cubehelixConvert(o) {
    if (o instanceof $2f93f8ad649541d1$var$Cubehelix) return new $2f93f8ad649541d1$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $hCN5L.Rgb)) o = (0, $hCN5L.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($2f93f8ad649541d1$var$BC_DA * b + $2f93f8ad649541d1$var$ED * r - $2f93f8ad649541d1$var$EB * g) / ($2f93f8ad649541d1$var$BC_DA + $2f93f8ad649541d1$var$ED - $2f93f8ad649541d1$var$EB), bl = b - l, k = ($2f93f8ad649541d1$var$E * (g - l) - $2f93f8ad649541d1$var$C * bl) / $2f93f8ad649541d1$var$D, s = Math.sqrt(k * k + bl * bl) / ($2f93f8ad649541d1$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $hPqOe.degrees - 120 : NaN;
    return new $2f93f8ad649541d1$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $2f93f8ad649541d1$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $2f93f8ad649541d1$var$cubehelixConvert(h) : new $2f93f8ad649541d1$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $2f93f8ad649541d1$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $2f93f8ad649541d1$var$_define.default)($2f93f8ad649541d1$var$Cubehelix, $2f93f8ad649541d1$var$cubehelix, (0, $2f93f8ad649541d1$var$_define.extend)($hCN5L.Color, {
    brighter (k) {
        k = k == null ? $hCN5L.brighter : Math.pow($hCN5L.brighter, k);
        return new $2f93f8ad649541d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $hCN5L.darker : Math.pow($hCN5L.darker, k);
        return new $2f93f8ad649541d1$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $hPqOe.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $hCN5L.Rgb(255 * (l + a * ($2f93f8ad649541d1$var$A * cosh + $2f93f8ad649541d1$var$B * sinh)), 255 * (l + a * ($2f93f8ad649541d1$var$C * cosh + $2f93f8ad649541d1$var$D * sinh)), 255 * (l + a * ($2f93f8ad649541d1$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("3CWNZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $2a428938b73abdd0$var$_basis = $2a428938b73abdd0$var$_interopRequireDefault((parcelRequire("hurAB")));

var $2a428938b73abdd0$var$_basisClosed = $2a428938b73abdd0$var$_interopRequireDefault((parcelRequire("7JEhq")));

var $2a428938b73abdd0$var$_color = $2a428938b73abdd0$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $2a428938b73abdd0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2a428938b73abdd0$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $2a428938b73abdd0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $2a428938b73abdd0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $2a428938b73abdd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2a428938b73abdd0$var$_default = module.exports.default = function rgbGamma(y) {
    var color = (0, $2a428938b73abdd0$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $4xVlj.rgb)(start)).r, (end = (0, $4xVlj.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $2a428938b73abdd0$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $2a428938b73abdd0$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $4xVlj.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $2a428938b73abdd0$var$rgbBasis = module.exports.rgbBasis = $2a428938b73abdd0$var$rgbSpline($2a428938b73abdd0$var$_basis.default);
var $2a428938b73abdd0$var$rgbBasisClosed = module.exports.rgbBasisClosed = $2a428938b73abdd0$var$rgbSpline($2a428938b73abdd0$var$_basisClosed.default);

});
parcelRegister("hurAB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $cbbaa3aa677f5a3b$var$basis;
module.exports.default = $cbbaa3aa677f5a3b$var$_default;
function $cbbaa3aa677f5a3b$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $cbbaa3aa677f5a3b$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $cbbaa3aa677f5a3b$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("7JEhq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a1bfb292f547c5a$var$_default;

var $hurAB = parcelRequire("hurAB");
function $5a1bfb292f547c5a$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $hurAB.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("b3Scd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80da03bd38d34502$var$nogamma;
module.exports.gamma = $80da03bd38d34502$var$gamma;
module.exports.hue = $80da03bd38d34502$var$hue;

var $80da03bd38d34502$var$_constant = $80da03bd38d34502$var$_interopRequireDefault((parcelRequire("iRCSk")));
function $80da03bd38d34502$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80da03bd38d34502$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $80da03bd38d34502$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $80da03bd38d34502$var$hue(a, b) {
    var d = b - a;
    return d ? $80da03bd38d34502$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
}
function $80da03bd38d34502$var$gamma(y) {
    return (y = +y) === 1 ? $80da03bd38d34502$var$nogamma : function(a, b) {
        return b - a ? $80da03bd38d34502$var$exponential(a, b, y) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $80da03bd38d34502$var$nogamma(a, b) {
    var d = b - a;
    return d ? $80da03bd38d34502$var$linear(a, d) : (0, $80da03bd38d34502$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("iRCSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dbbb550bf3b8cf75$var$_default = (x)=>()=>x;
module.exports.default = $dbbb550bf3b8cf75$var$_default;

});



parcelRegister("c2a7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c2d86ed32487c0d$var$_default;
module.exports.genericArray = $8c2d86ed32487c0d$var$genericArray;

var $8c2d86ed32487c0d$var$_value = $8c2d86ed32487c0d$var$_interopRequireDefault((parcelRequire("k8gaa")));

var $8c2d86ed32487c0d$var$_numberArray = $8c2d86ed32487c0d$var$_interopRequireWildcard((parcelRequire("4Xtub")));
function $8c2d86ed32487c0d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8c2d86ed32487c0d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $8c2d86ed32487c0d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $8c2d86ed32487c0d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $8c2d86ed32487c0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c2d86ed32487c0d$var$_default(a, b) {
    return ((0, $8c2d86ed32487c0d$var$_numberArray.isNumberArray)(b) ? $8c2d86ed32487c0d$var$_numberArray.default : $8c2d86ed32487c0d$var$genericArray)(a, b);
}
function $8c2d86ed32487c0d$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8c2d86ed32487c0d$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("4Xtub", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39c38b6190d0c1f6$var$_default;
module.exports.isNumberArray = $39c38b6190d0c1f6$var$isNumberArray;
function $39c38b6190d0c1f6$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $39c38b6190d0c1f6$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("ck059", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f876a9bd8834a98$var$_default;
function $8f876a9bd8834a98$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("4TXx0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $391a7a2535dd71f8$var$_default;
function $391a7a2535dd71f8$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("eWQsD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae1f2d19cc5303ea$var$_default;

var $ae1f2d19cc5303ea$var$_value = $ae1f2d19cc5303ea$var$_interopRequireDefault((parcelRequire("k8gaa")));
function $ae1f2d19cc5303ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae1f2d19cc5303ea$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $ae1f2d19cc5303ea$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aQhro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e4c4a1e1697197c$var$_default;

var $7e4c4a1e1697197c$var$_number = $7e4c4a1e1697197c$var$_interopRequireDefault((parcelRequire("4TXx0")));
function $7e4c4a1e1697197c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7e4c4a1e1697197c$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $7e4c4a1e1697197c$var$reB = new RegExp($7e4c4a1e1697197c$var$reA.source, "g");
function $7e4c4a1e1697197c$var$zero(b) {
    return function() {
        return b;
    };
}
function $7e4c4a1e1697197c$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $7e4c4a1e1697197c$var$_default(a, b) {
    var bi = $7e4c4a1e1697197c$var$reA.lastIndex = $7e4c4a1e1697197c$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $7e4c4a1e1697197c$var$reA.exec(a)) && (bm = $7e4c4a1e1697197c$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $7e4c4a1e1697197c$var$_number.default)(am, bm)
            });
        }
        bi = $7e4c4a1e1697197c$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $7e4c4a1e1697197c$var$one(q[0].x) : $7e4c4a1e1697197c$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("9bEkd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b046bd8ca223f2b$var$_default;
function $6b046bd8ca223f2b$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("gPZC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c42133e20db58540$var$_default;

var $b3Scd = parcelRequire("b3Scd");
function $c42133e20db58540$var$_default(a, b) {
    var i = (0, $b3Scd.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("1qcvW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1091ed2fd6f93976$var$_default;
function $1091ed2fd6f93976$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("O407u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $0967c620c111940e$var$_number = $0967c620c111940e$var$_interopRequireDefault((parcelRequire("4TXx0")));

var $bJ37r = parcelRequire("bJ37r");
function $0967c620c111940e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0967c620c111940e$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $0967c620c111940e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $0967c620c111940e$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $0967c620c111940e$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $0967c620c111940e$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $0967c620c111940e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $0967c620c111940e$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $0967c620c111940e$var$interpolateTransformCss = module.exports.interpolateTransformCss = $0967c620c111940e$var$interpolateTransform($bJ37r.parseCss, "px, ", "px)", "deg)");
var $0967c620c111940e$var$interpolateTransformSvg = module.exports.interpolateTransformSvg = $0967c620c111940e$var$interpolateTransform($bJ37r.parseSvg, ", ", ")", ")");

});
parcelRegister("bJ37r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $8896510fbfd72d82$var$parseCss;
module.exports.parseSvg = $8896510fbfd72d82$var$parseSvg;

var $8896510fbfd72d82$var$_decompose = $8896510fbfd72d82$var$_interopRequireWildcard((parcelRequire("5pgbl")));
function $8896510fbfd72d82$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8896510fbfd72d82$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $8896510fbfd72d82$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $8896510fbfd72d82$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $8896510fbfd72d82$var$svgNode;
/* eslint-disable no-undef */ function $8896510fbfd72d82$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $8896510fbfd72d82$var$_decompose.identity : (0, $8896510fbfd72d82$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $8896510fbfd72d82$var$parseSvg(value) {
    if (value == null) return $8896510fbfd72d82$var$_decompose.identity;
    if (!$8896510fbfd72d82$var$svgNode) $8896510fbfd72d82$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $8896510fbfd72d82$var$svgNode.setAttribute("transform", value);
    if (!(value = $8896510fbfd72d82$var$svgNode.transform.baseVal.consolidate())) return $8896510fbfd72d82$var$_decompose.identity;
    value = value.matrix;
    return (0, $8896510fbfd72d82$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("5pgbl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3efbd6f206ca181f$var$_default;
module.exports.identity = void 0;
var $3efbd6f206ca181f$var$degrees = 180 / Math.PI;
var $3efbd6f206ca181f$var$identity = module.exports.identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $3efbd6f206ca181f$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $3efbd6f206ca181f$var$degrees,
        skewX: Math.atan(skewX) * $3efbd6f206ca181f$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("4ymTx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $350c18cead77b4c8$var$epsilon2 = 1e-12;
function $350c18cead77b4c8$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $350c18cead77b4c8$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $350c18cead77b4c8$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $350c18cead77b4c8$var$_default = module.exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $350c18cead77b4c8$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $350c18cead77b4c8$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $350c18cead77b4c8$var$tanh(rho * s + r0) - $350c18cead77b4c8$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $350c18cead77b4c8$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("h8Xdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $c7b11d37ff7aa7ad$var$_color = $c7b11d37ff7aa7ad$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $c7b11d37ff7aa7ad$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c7b11d37ff7aa7ad$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $c7b11d37ff7aa7ad$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $c7b11d37ff7aa7ad$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $c7b11d37ff7aa7ad$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4xVlj.hsl)(start)).h, (end = (0, $4xVlj.hsl)(end)).h), s = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.s, end.s), l = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.l, end.l), opacity = (0, $c7b11d37ff7aa7ad$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $c7b11d37ff7aa7ad$var$_default = module.exports.default = $c7b11d37ff7aa7ad$var$hsl($c7b11d37ff7aa7ad$var$_color.hue);
var $c7b11d37ff7aa7ad$var$hslLong = module.exports.hslLong = $c7b11d37ff7aa7ad$var$hsl($c7b11d37ff7aa7ad$var$_color.default);

});

parcelRegister("6bPgS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $481b8a88abe10bce$var$lab;

var $4xVlj = parcelRequire("4xVlj");

var $481b8a88abe10bce$var$_color = $481b8a88abe10bce$var$_interopRequireDefault((parcelRequire("b3Scd")));
function $481b8a88abe10bce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $481b8a88abe10bce$var$lab(start, end) {
    var l = (0, $481b8a88abe10bce$var$_color.default)((start = (0, $4xVlj.lab)(start)).l, (end = (0, $4xVlj.lab)(end)).l), a = (0, $481b8a88abe10bce$var$_color.default)(start.a, end.a), b = (0, $481b8a88abe10bce$var$_color.default)(start.b, end.b), opacity = (0, $481b8a88abe10bce$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("dWbd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $a259633f8ae92865$var$_color = $a259633f8ae92865$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $a259633f8ae92865$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a259633f8ae92865$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a259633f8ae92865$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a259633f8ae92865$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $a259633f8ae92865$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4xVlj.hcl)(start)).h, (end = (0, $4xVlj.hcl)(end)).h), c = (0, $a259633f8ae92865$var$_color.default)(start.c, end.c), l = (0, $a259633f8ae92865$var$_color.default)(start.l, end.l), opacity = (0, $a259633f8ae92865$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $a259633f8ae92865$var$_default = module.exports.default = $a259633f8ae92865$var$hcl($a259633f8ae92865$var$_color.hue);
var $a259633f8ae92865$var$hclLong = module.exports.hclLong = $a259633f8ae92865$var$hcl($a259633f8ae92865$var$_color.default);

});

parcelRegister("1chdf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $4xVlj = parcelRequire("4xVlj");

var $0df4438370b2da5e$var$_color = $0df4438370b2da5e$var$_interopRequireWildcard((parcelRequire("b3Scd")));
function $0df4438370b2da5e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0df4438370b2da5e$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $0df4438370b2da5e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $0df4438370b2da5e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $0df4438370b2da5e$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $4xVlj.cubehelix)(start)).h, (end = (0, $4xVlj.cubehelix)(end)).h), s = (0, $0df4438370b2da5e$var$_color.default)(start.s, end.s), l = (0, $0df4438370b2da5e$var$_color.default)(start.l, end.l), opacity = (0, $0df4438370b2da5e$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $0df4438370b2da5e$var$_default = module.exports.default = $0df4438370b2da5e$var$cubehelix($0df4438370b2da5e$var$_color.hue);
var $0df4438370b2da5e$var$cubehelixLong = module.exports.cubehelixLong = $0df4438370b2da5e$var$cubehelix($0df4438370b2da5e$var$_color.default);

});

parcelRegister("1d2kq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e18cfb4c16c4104$var$piecewise;

var $0e18cfb4c16c4104$var$_value = $0e18cfb4c16c4104$var$_interopRequireDefault((parcelRequire("k8gaa")));
function $0e18cfb4c16c4104$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e18cfb4c16c4104$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $0e18cfb4c16c4104$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("7rbIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56a425076c517cf9$var$_default;
function $56a425076c517cf9$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("jgTuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e07a8ef03a1474be$var$constants;
function $e07a8ef03a1474be$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("jerFr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e004c94f2a5276f3$var$number;
function $e004c94f2a5276f3$var$number(x) {
    return +x;
}

});


parcelRegister("3ZXxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e954078d0c875a8$var$tickFormat;

var $baM4h = parcelRequire("baM4h");

var $itzmc = parcelRequire("itzmc");
function $2e954078d0c875a8$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $baM4h.tickStep)(start, stop, count), precision;
    specifier = (0, $itzmc.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $itzmc.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $itzmc.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $itzmc.format)(specifier);
}

});
parcelRegister("itzmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $d7365c9f4c120e49$var$_precisionRound.default;
    }
});

var $d7365c9f4c120e49$var$_defaultLocale = $d7365c9f4c120e49$var$_interopRequireWildcard((parcelRequire("52crh")));

var $d7365c9f4c120e49$var$_locale = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("jdHNs")));

var $d7365c9f4c120e49$var$_formatSpecifier = $d7365c9f4c120e49$var$_interopRequireWildcard((parcelRequire("22nPw")));

var $d7365c9f4c120e49$var$_precisionFixed = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("lzwe8")));

var $d7365c9f4c120e49$var$_precisionPrefix = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("9ymIQ")));

var $d7365c9f4c120e49$var$_precisionRound = $d7365c9f4c120e49$var$_interopRequireDefault((parcelRequire("dK8tE")));
function $d7365c9f4c120e49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d7365c9f4c120e49$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d7365c9f4c120e49$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $d7365c9f4c120e49$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $d7365c9f4c120e49$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("52crh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3aa6c9ca8743f64c$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $3aa6c9ca8743f64c$var$_locale = $3aa6c9ca8743f64c$var$_interopRequireDefault((parcelRequire("jdHNs")));
function $3aa6c9ca8743f64c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3aa6c9ca8743f64c$var$locale;
var $3aa6c9ca8743f64c$var$format;
var $3aa6c9ca8743f64c$var$formatPrefix;
$3aa6c9ca8743f64c$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $3aa6c9ca8743f64c$var$defaultLocale(definition) {
    $3aa6c9ca8743f64c$var$locale = (0, $3aa6c9ca8743f64c$var$_locale.default)(definition);
    module.exports.format = $3aa6c9ca8743f64c$var$format = $3aa6c9ca8743f64c$var$locale.format;
    module.exports.formatPrefix = $3aa6c9ca8743f64c$var$formatPrefix = $3aa6c9ca8743f64c$var$locale.formatPrefix;
    return $3aa6c9ca8743f64c$var$locale;
}

});
parcelRegister("jdHNs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfe1345305b146cd$var$_default;

var $dfe1345305b146cd$var$_exponent = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("9WmdL")));

var $dfe1345305b146cd$var$_formatGroup = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("bR58D")));

var $dfe1345305b146cd$var$_formatNumerals = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("2gEYt")));

var $dfe1345305b146cd$var$_formatSpecifier = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("22nPw")));

var $dfe1345305b146cd$var$_formatTrim = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("sIRm4")));

var $dfe1345305b146cd$var$_formatTypes = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("9AK8c")));

var $csczD = parcelRequire("csczD");

var $dfe1345305b146cd$var$_identity = $dfe1345305b146cd$var$_interopRequireDefault((parcelRequire("jJFZc")));
function $dfe1345305b146cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dfe1345305b146cd$var$map = Array.prototype.map, $dfe1345305b146cd$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $dfe1345305b146cd$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $dfe1345305b146cd$var$_identity.default : (0, $dfe1345305b146cd$var$_formatGroup.default)($dfe1345305b146cd$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $dfe1345305b146cd$var$_identity.default : (0, $dfe1345305b146cd$var$_formatNumerals.default)($dfe1345305b146cd$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $dfe1345305b146cd$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!$dfe1345305b146cd$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $dfe1345305b146cd$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $dfe1345305b146cd$var$_formatTrim.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $dfe1345305b146cd$var$prefixes[8 + $csczD.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $dfe1345305b146cd$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $dfe1345305b146cd$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $dfe1345305b146cd$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("9WmdL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73cac4781972bb68$var$_default;

var $ek6ef = parcelRequire("ek6ef");
function $73cac4781972bb68$var$_default(x) {
    return x = (0, $ek6ef.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("ek6ef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6d7c3d6a68b9f55$var$_default;
module.exports.formatDecimalParts = $a6d7c3d6a68b9f55$var$formatDecimalParts;
function $a6d7c3d6a68b9f55$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $a6d7c3d6a68b9f55$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("bR58D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a18a14b4c6d5ad1$var$_default;
function $8a18a14b4c6d5ad1$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2gEYt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a6cdc0d667ac473$var$_default;
function $1a6cdc0d667ac473$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("22nPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $17be40d45524154b$var$FormatSpecifier;
module.exports.default = $17be40d45524154b$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $17be40d45524154b$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $17be40d45524154b$var$formatSpecifier(specifier) {
    if (!(match = $17be40d45524154b$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $17be40d45524154b$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$17be40d45524154b$var$formatSpecifier.prototype = $17be40d45524154b$var$FormatSpecifier.prototype; // instanceof
function $17be40d45524154b$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$17be40d45524154b$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("sIRm4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $056569d07d5aff33$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $056569d07d5aff33$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("9AK8c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fbb428c1ef09695$var$_formatDecimal = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("ek6ef")));

var $6fbb428c1ef09695$var$_formatPrefixAuto = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("csczD")));

var $6fbb428c1ef09695$var$_formatRounded = $6fbb428c1ef09695$var$_interopRequireDefault((parcelRequire("lNpva")));
function $6fbb428c1ef09695$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6fbb428c1ef09695$var$_default = module.exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $6fbb428c1ef09695$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $6fbb428c1ef09695$var$_formatRounded.default)(x * 100, p),
    "r": $6fbb428c1ef09695$var$_formatRounded.default,
    "s": $6fbb428c1ef09695$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("csczD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9111da6de56a44e7$var$_default;
module.exports.prefixExponent = void 0;

var $ek6ef = parcelRequire("ek6ef");
var $9111da6de56a44e7$var$prefixExponent;
function $9111da6de56a44e7$var$_default(x, p) {
    var d = (0, $ek6ef.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $9111da6de56a44e7$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $ek6ef.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("lNpva", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fde1f4b20b992562$var$_default;

var $ek6ef = parcelRequire("ek6ef");
function $fde1f4b20b992562$var$_default(x, p) {
    var d = (0, $ek6ef.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("jJFZc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5e2c9e09981bca9$var$_default;
function $e5e2c9e09981bca9$var$_default(x) {
    return x;
}

});



parcelRegister("lzwe8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb45dd7ad9d5b52f$var$_default;

var $fb45dd7ad9d5b52f$var$_exponent = $fb45dd7ad9d5b52f$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $fb45dd7ad9d5b52f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb45dd7ad9d5b52f$var$_default(step) {
    return Math.max(0, -(0, $fb45dd7ad9d5b52f$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("9ymIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f48ea33e817f9e5$var$_default;

var $6f48ea33e817f9e5$var$_exponent = $6f48ea33e817f9e5$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $6f48ea33e817f9e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f48ea33e817f9e5$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $6f48ea33e817f9e5$var$_exponent.default)(value) / 3))) * 3 - (0, $6f48ea33e817f9e5$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("dK8tE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a01625a8f580c632$var$_default;

var $a01625a8f580c632$var$_exponent = $a01625a8f580c632$var$_interopRequireDefault((parcelRequire("9WmdL")));
function $a01625a8f580c632$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a01625a8f580c632$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $a01625a8f580c632$var$_exponent.default)(max) - (0, $a01625a8f580c632$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("aEI3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c1fd0730f0c3a86$var$log;
module.exports.loggish = $7c1fd0730f0c3a86$var$loggish;

var $baM4h = parcelRequire("baM4h");

var $itzmc = parcelRequire("itzmc");

var $7c1fd0730f0c3a86$var$_nice = $7c1fd0730f0c3a86$var$_interopRequireDefault((parcelRequire("3CPJt")));

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $7c1fd0730f0c3a86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c1fd0730f0c3a86$var$transformLog(x) {
    return Math.log(x);
}
function $7c1fd0730f0c3a86$var$transformExp(x) {
    return Math.exp(x);
}
function $7c1fd0730f0c3a86$var$transformLogn(x) {
    return -Math.log(-x);
}
function $7c1fd0730f0c3a86$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $7c1fd0730f0c3a86$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $7c1fd0730f0c3a86$var$powp(base) {
    return base === 10 ? $7c1fd0730f0c3a86$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $7c1fd0730f0c3a86$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $7c1fd0730f0c3a86$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $7c1fd0730f0c3a86$var$loggish(transform) {
    const scale = transform($7c1fd0730f0c3a86$var$transformLog, $7c1fd0730f0c3a86$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $7c1fd0730f0c3a86$var$logp(base), pows = $7c1fd0730f0c3a86$var$powp(base);
        if (domain()[0] < 0) {
            logs = $7c1fd0730f0c3a86$var$reflect(logs), pows = $7c1fd0730f0c3a86$var$reflect(pows);
            transform($7c1fd0730f0c3a86$var$transformLogn, $7c1fd0730f0c3a86$var$transformExpn);
        } else transform($7c1fd0730f0c3a86$var$transformLog, $7c1fd0730f0c3a86$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $baM4h.ticks)(u, v, n);
        } else z = (0, $baM4h.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $itzmc.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $itzmc.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $7c1fd0730f0c3a86$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $7c1fd0730f0c3a86$var$log() {
    const scale = $7c1fd0730f0c3a86$var$loggish((0, $dTLbh.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $dTLbh.copy)(scale, $7c1fd0730f0c3a86$var$log()).base(scale.base());
    $98nei.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("3CPJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a3d0cb2bab01a48$var$nice;
function $2a3d0cb2bab01a48$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("bzrFz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86c86d2b217611f5$var$symlog;
module.exports.symlogish = $86c86d2b217611f5$var$symlogish;

var $hvSDx = parcelRequire("hvSDx");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $86c86d2b217611f5$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $86c86d2b217611f5$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $86c86d2b217611f5$var$symlogish(transform) {
    var c = 1, scale = transform($86c86d2b217611f5$var$transformSymlog(c), $86c86d2b217611f5$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($86c86d2b217611f5$var$transformSymlog(c = +_), $86c86d2b217611f5$var$transformSymexp(c)) : c;
    };
    return (0, $hvSDx.linearish)(scale);
}
function $86c86d2b217611f5$var$symlog() {
    var scale = $86c86d2b217611f5$var$symlogish((0, $dTLbh.transformer)());
    scale.copy = function() {
        return (0, $dTLbh.copy)(scale, $86c86d2b217611f5$var$symlog()).constant(scale.constant());
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("cpAbf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9093e282c6b6bc7f$var$pow;
module.exports.powish = $9093e282c6b6bc7f$var$powish;
module.exports.sqrt = $9093e282c6b6bc7f$var$sqrt;

var $hvSDx = parcelRequire("hvSDx");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $9093e282c6b6bc7f$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $9093e282c6b6bc7f$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $9093e282c6b6bc7f$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $9093e282c6b6bc7f$var$powish(transform) {
    var scale = transform($dTLbh.identity, $dTLbh.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($dTLbh.identity, $dTLbh.identity) : exponent === 0.5 ? transform($9093e282c6b6bc7f$var$transformSqrt, $9093e282c6b6bc7f$var$transformSquare) : transform($9093e282c6b6bc7f$var$transformPow(exponent), $9093e282c6b6bc7f$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $hvSDx.linearish)(scale);
}
function $9093e282c6b6bc7f$var$pow() {
    var scale = $9093e282c6b6bc7f$var$powish((0, $dTLbh.transformer)());
    scale.copy = function() {
        return (0, $dTLbh.copy)(scale, $9093e282c6b6bc7f$var$pow()).exponent(scale.exponent());
    };
    $98nei.initRange.apply(scale, arguments);
    return scale;
}
function $9093e282c6b6bc7f$var$sqrt() {
    return $9093e282c6b6bc7f$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("5lxEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e4905273b67de17$var$radial;

var $3e4905273b67de17$var$_continuous = $3e4905273b67de17$var$_interopRequireDefault((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $3e4905273b67de17$var$_number = $3e4905273b67de17$var$_interopRequireDefault((parcelRequire("jerFr")));
function $3e4905273b67de17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e4905273b67de17$var$square(x) {
    return Math.sign(x) * x * x;
}
function $3e4905273b67de17$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $3e4905273b67de17$var$radial() {
    var squared = (0, $3e4905273b67de17$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $3e4905273b67de17$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($3e4905273b67de17$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $3e4905273b67de17$var$_number.default)).map($3e4905273b67de17$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3e4905273b67de17$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $98nei.initRange.apply(scale, arguments);
    return (0, $hvSDx.linearish)(scale);
}

});

parcelRegister("67PVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $475bac569bb46018$var$quantile;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
function $475bac569bb46018$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $baM4h.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $baM4h.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($baM4h.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $475bac569bb46018$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("mgOAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $042f19449e73ffae$var$quantize;

var $baM4h = parcelRequire("baM4h");

var $hvSDx = parcelRequire("hvSDx");

var $98nei = parcelRequire("98nei");
function $042f19449e73ffae$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $baM4h.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $042f19449e73ffae$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply((0, $hvSDx.linearish)(scale), arguments);
}

});

parcelRegister("g6ge9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bb89cb437536b92a$var$threshold;

var $baM4h = parcelRequire("baM4h");

var $98nei = parcelRequire("98nei");
function $bb89cb437536b92a$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $baM4h.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $bb89cb437536b92a$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $98nei.initRange.apply(scale, arguments);
}

});

parcelRegister("617BV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $4618bd65b703261b$var$calendar;
module.exports.default = $4618bd65b703261b$var$time;

var $kym6t = parcelRequire("kym6t");

var $2qXVT = parcelRequire("2qXVT");

var $4618bd65b703261b$var$_continuous = $4618bd65b703261b$var$_interopRequireWildcard((parcelRequire("dTLbh")));

var $98nei = parcelRequire("98nei");

var $4618bd65b703261b$var$_nice = $4618bd65b703261b$var$_interopRequireDefault((parcelRequire("3CPJt")));
function $4618bd65b703261b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4618bd65b703261b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4618bd65b703261b$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $4618bd65b703261b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $4618bd65b703261b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $4618bd65b703261b$var$date(t) {
    return new Date(t);
}
function $4618bd65b703261b$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $4618bd65b703261b$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $4618bd65b703261b$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $4618bd65b703261b$var$number)) : domain().map($4618bd65b703261b$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $4618bd65b703261b$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $4618bd65b703261b$var$_continuous.copy)(scale, $4618bd65b703261b$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $4618bd65b703261b$var$time() {
    return $98nei.initRange.apply($4618bd65b703261b$var$calendar($kym6t.timeTicks, $kym6t.timeTickInterval, $kym6t.timeYear, $kym6t.timeMonth, $kym6t.timeWeek, $kym6t.timeDay, $kym6t.timeHour, $kym6t.timeMinute, $kym6t.timeSecond, $2qXVT.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("kym6t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $exwcm.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $exwcm.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $exwcm.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $exwcm.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $exwcm.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $exwcm.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $exwcm.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $exwcm.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $exwcm.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $exwcm.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $c02Yy.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $c02Yy.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $exwcm.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $exwcm.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $exwcm.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $exwcm.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $exwcm.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $exwcm.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $c02Yy.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $c02Yy.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $kSPvm.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $ef6820ebdc1f168f$var$_utcYear.utcYears;
    }
});

var $ef6820ebdc1f168f$var$_interval = $ef6820ebdc1f168f$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $ef6820ebdc1f168f$var$_millisecond = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("hRCmg")));

var $ef6820ebdc1f168f$var$_second = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("jFJeY")));

var $ef6820ebdc1f168f$var$_minute = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("izQ7P")));

var $ef6820ebdc1f168f$var$_hour = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4kq4i")));

var $ef6820ebdc1f168f$var$_day = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("kSMPp")));

var $exwcm = parcelRequire("exwcm");

var $ef6820ebdc1f168f$var$_month = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4YFnz")));

var $ef6820ebdc1f168f$var$_year = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("lzVRI")));

var $ef6820ebdc1f168f$var$_utcMinute = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("9FVE8")));

var $ef6820ebdc1f168f$var$_utcHour = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4wGkR")));

var $ef6820ebdc1f168f$var$_utcDay = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("i3XOj")));

var $kSPvm = parcelRequire("kSPvm");

var $ef6820ebdc1f168f$var$_utcMonth = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("9ILJ1")));

var $ef6820ebdc1f168f$var$_utcYear = $ef6820ebdc1f168f$var$_interopRequireWildcard((parcelRequire("4hSHL")));

var $c02Yy = parcelRequire("c02Yy");
function $ef6820ebdc1f168f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ef6820ebdc1f168f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $ef6820ebdc1f168f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $ef6820ebdc1f168f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $ef6820ebdc1f168f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("bSxHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a5ee026fcfc7249$var$newInterval;
var $8a5ee026fcfc7249$var$t0 = new Date(), $8a5ee026fcfc7249$var$t1 = new Date();
function $8a5ee026fcfc7249$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $8a5ee026fcfc7249$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $8a5ee026fcfc7249$var$t0.setTime(+start), $8a5ee026fcfc7249$var$t1.setTime(+end);
            floori($8a5ee026fcfc7249$var$t0), floori($8a5ee026fcfc7249$var$t1);
            return Math.floor(count($8a5ee026fcfc7249$var$t0, $8a5ee026fcfc7249$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("hRCmg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $d0152406c3f5521e$var$_interval = $d0152406c3f5521e$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $d0152406c3f5521e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d0152406c3f5521e$var$millisecond = (0, $d0152406c3f5521e$var$_interval.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$d0152406c3f5521e$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $d0152406c3f5521e$var$millisecond;
    return (0, $d0152406c3f5521e$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $d0152406c3f5521e$var$_default = module.exports.default = $d0152406c3f5521e$var$millisecond;
var $d0152406c3f5521e$var$milliseconds = module.exports.milliseconds = $d0152406c3f5521e$var$millisecond.range;

});

parcelRegister("jFJeY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $e524f07ae6002e66$var$_interval = $e524f07ae6002e66$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $e524f07ae6002e66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e524f07ae6002e66$var$second = (0, $e524f07ae6002e66$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationSecond);
}, function(start, end) {
    return (end - start) / $188mN.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $e524f07ae6002e66$var$_default = module.exports.default = $e524f07ae6002e66$var$second;
var $e524f07ae6002e66$var$seconds = module.exports.seconds = $e524f07ae6002e66$var$second.range;

});
parcelRegister("188mN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $0d2d073c443f27b5$var$durationSecond = module.exports.durationSecond = 1000;
const $0d2d073c443f27b5$var$durationMinute = module.exports.durationMinute = $0d2d073c443f27b5$var$durationSecond * 60;
const $0d2d073c443f27b5$var$durationHour = module.exports.durationHour = $0d2d073c443f27b5$var$durationMinute * 60;
const $0d2d073c443f27b5$var$durationDay = module.exports.durationDay = $0d2d073c443f27b5$var$durationHour * 24;
const $0d2d073c443f27b5$var$durationWeek = module.exports.durationWeek = $0d2d073c443f27b5$var$durationDay * 7;
const $0d2d073c443f27b5$var$durationMonth = module.exports.durationMonth = $0d2d073c443f27b5$var$durationDay * 30;
const $0d2d073c443f27b5$var$durationYear = module.exports.durationYear = $0d2d073c443f27b5$var$durationDay * 365;

});


parcelRegister("izQ7P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $d863eddd69e079ff$var$_interval = $d863eddd69e079ff$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $d863eddd69e079ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d863eddd69e079ff$var$minute = (0, $d863eddd69e079ff$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $188mN.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationMinute);
}, function(start, end) {
    return (end - start) / $188mN.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $d863eddd69e079ff$var$_default = module.exports.default = $d863eddd69e079ff$var$minute;
var $d863eddd69e079ff$var$minutes = module.exports.minutes = $d863eddd69e079ff$var$minute.range;

});

parcelRegister("4kq4i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $326d404cf7731152$var$_interval = $326d404cf7731152$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $326d404cf7731152$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $326d404cf7731152$var$hour = (0, $326d404cf7731152$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $188mN.durationSecond - date.getMinutes() * $188mN.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationHour);
}, function(start, end) {
    return (end - start) / $188mN.durationHour;
}, function(date) {
    return date.getHours();
});
var $326d404cf7731152$var$_default = module.exports.default = $326d404cf7731152$var$hour;
var $326d404cf7731152$var$hours = module.exports.hours = $326d404cf7731152$var$hour.range;

});

parcelRegister("kSMPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $f33eba0c8fefd714$var$_interval = $f33eba0c8fefd714$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $f33eba0c8fefd714$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f33eba0c8fefd714$var$day = (0, $f33eba0c8fefd714$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $188mN.durationMinute) / $188mN.durationDay, (date)=>date.getDate() - 1);
var $f33eba0c8fefd714$var$_default = module.exports.default = $f33eba0c8fefd714$var$day;
var $f33eba0c8fefd714$var$days = module.exports.days = $f33eba0c8fefd714$var$day.range;

});

parcelRegister("exwcm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $a95d1fb36d555b21$var$_interval = $a95d1fb36d555b21$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $a95d1fb36d555b21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a95d1fb36d555b21$var$weekday(i) {
    return (0, $a95d1fb36d555b21$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $188mN.durationMinute) / $188mN.durationWeek;
    });
}
var $a95d1fb36d555b21$var$sunday = module.exports.sunday = $a95d1fb36d555b21$var$weekday(0);
var $a95d1fb36d555b21$var$monday = module.exports.monday = $a95d1fb36d555b21$var$weekday(1);
var $a95d1fb36d555b21$var$tuesday = module.exports.tuesday = $a95d1fb36d555b21$var$weekday(2);
var $a95d1fb36d555b21$var$wednesday = module.exports.wednesday = $a95d1fb36d555b21$var$weekday(3);
var $a95d1fb36d555b21$var$thursday = module.exports.thursday = $a95d1fb36d555b21$var$weekday(4);
var $a95d1fb36d555b21$var$friday = module.exports.friday = $a95d1fb36d555b21$var$weekday(5);
var $a95d1fb36d555b21$var$saturday = module.exports.saturday = $a95d1fb36d555b21$var$weekday(6);
var $a95d1fb36d555b21$var$sundays = module.exports.sundays = $a95d1fb36d555b21$var$sunday.range;
var $a95d1fb36d555b21$var$mondays = module.exports.mondays = $a95d1fb36d555b21$var$monday.range;
var $a95d1fb36d555b21$var$tuesdays = module.exports.tuesdays = $a95d1fb36d555b21$var$tuesday.range;
var $a95d1fb36d555b21$var$wednesdays = module.exports.wednesdays = $a95d1fb36d555b21$var$wednesday.range;
var $a95d1fb36d555b21$var$thursdays = module.exports.thursdays = $a95d1fb36d555b21$var$thursday.range;
var $a95d1fb36d555b21$var$fridays = module.exports.fridays = $a95d1fb36d555b21$var$friday.range;
var $a95d1fb36d555b21$var$saturdays = module.exports.saturdays = $a95d1fb36d555b21$var$saturday.range;

});

parcelRegister("4YFnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $39fcdd0c8c747959$var$_interval = $39fcdd0c8c747959$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $39fcdd0c8c747959$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $39fcdd0c8c747959$var$month = (0, $39fcdd0c8c747959$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $39fcdd0c8c747959$var$_default = module.exports.default = $39fcdd0c8c747959$var$month;
var $39fcdd0c8c747959$var$months = module.exports.months = $39fcdd0c8c747959$var$month.range;

});

parcelRegister("lzVRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $fb59c0bdd551f11c$var$_interval = $fb59c0bdd551f11c$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $fb59c0bdd551f11c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fb59c0bdd551f11c$var$year = (0, $fb59c0bdd551f11c$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$fb59c0bdd551f11c$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $fb59c0bdd551f11c$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $fb59c0bdd551f11c$var$_default = module.exports.default = $fb59c0bdd551f11c$var$year;
var $fb59c0bdd551f11c$var$years = module.exports.years = $fb59c0bdd551f11c$var$year.range;

});

parcelRegister("9FVE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $70b4a8c4dc5c94df$var$_interval = $70b4a8c4dc5c94df$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $70b4a8c4dc5c94df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $70b4a8c4dc5c94df$var$utcMinute = (0, $70b4a8c4dc5c94df$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationMinute);
}, function(start, end) {
    return (end - start) / $188mN.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $70b4a8c4dc5c94df$var$_default = module.exports.default = $70b4a8c4dc5c94df$var$utcMinute;
var $70b4a8c4dc5c94df$var$utcMinutes = module.exports.utcMinutes = $70b4a8c4dc5c94df$var$utcMinute.range;

});

parcelRegister("4wGkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $34bafd84c6844820$var$_interval = $34bafd84c6844820$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $34bafd84c6844820$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $34bafd84c6844820$var$utcHour = (0, $34bafd84c6844820$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $188mN.durationHour);
}, function(start, end) {
    return (end - start) / $188mN.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $34bafd84c6844820$var$_default = module.exports.default = $34bafd84c6844820$var$utcHour;
var $34bafd84c6844820$var$utcHours = module.exports.utcHours = $34bafd84c6844820$var$utcHour.range;

});

parcelRegister("i3XOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $d266e6f0c540d430$var$_interval = $d266e6f0c540d430$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $d266e6f0c540d430$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d266e6f0c540d430$var$utcDay = (0, $d266e6f0c540d430$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $188mN.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $d266e6f0c540d430$var$_default = module.exports.default = $d266e6f0c540d430$var$utcDay;
var $d266e6f0c540d430$var$utcDays = module.exports.utcDays = $d266e6f0c540d430$var$utcDay.range;

});

parcelRegister("kSPvm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $f340cd979f69f122$var$_interval = $f340cd979f69f122$var$_interopRequireDefault((parcelRequire("bSxHc")));

var $188mN = parcelRequire("188mN");
function $f340cd979f69f122$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f340cd979f69f122$var$utcWeekday(i) {
    return (0, $f340cd979f69f122$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $188mN.durationWeek;
    });
}
var $f340cd979f69f122$var$utcSunday = module.exports.utcSunday = $f340cd979f69f122$var$utcWeekday(0);
var $f340cd979f69f122$var$utcMonday = module.exports.utcMonday = $f340cd979f69f122$var$utcWeekday(1);
var $f340cd979f69f122$var$utcTuesday = module.exports.utcTuesday = $f340cd979f69f122$var$utcWeekday(2);
var $f340cd979f69f122$var$utcWednesday = module.exports.utcWednesday = $f340cd979f69f122$var$utcWeekday(3);
var $f340cd979f69f122$var$utcThursday = module.exports.utcThursday = $f340cd979f69f122$var$utcWeekday(4);
var $f340cd979f69f122$var$utcFriday = module.exports.utcFriday = $f340cd979f69f122$var$utcWeekday(5);
var $f340cd979f69f122$var$utcSaturday = module.exports.utcSaturday = $f340cd979f69f122$var$utcWeekday(6);
var $f340cd979f69f122$var$utcSundays = module.exports.utcSundays = $f340cd979f69f122$var$utcSunday.range;
var $f340cd979f69f122$var$utcMondays = module.exports.utcMondays = $f340cd979f69f122$var$utcMonday.range;
var $f340cd979f69f122$var$utcTuesdays = module.exports.utcTuesdays = $f340cd979f69f122$var$utcTuesday.range;
var $f340cd979f69f122$var$utcWednesdays = module.exports.utcWednesdays = $f340cd979f69f122$var$utcWednesday.range;
var $f340cd979f69f122$var$utcThursdays = module.exports.utcThursdays = $f340cd979f69f122$var$utcThursday.range;
var $f340cd979f69f122$var$utcFridays = module.exports.utcFridays = $f340cd979f69f122$var$utcFriday.range;
var $f340cd979f69f122$var$utcSaturdays = module.exports.utcSaturdays = $f340cd979f69f122$var$utcSaturday.range;

});

parcelRegister("9ILJ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $01d391858e0bc807$var$_interval = $01d391858e0bc807$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $01d391858e0bc807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $01d391858e0bc807$var$utcMonth = (0, $01d391858e0bc807$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $01d391858e0bc807$var$_default = module.exports.default = $01d391858e0bc807$var$utcMonth;
var $01d391858e0bc807$var$utcMonths = module.exports.utcMonths = $01d391858e0bc807$var$utcMonth.range;

});

parcelRegister("4hSHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $31f32f2daf3ec1ad$var$_interval = $31f32f2daf3ec1ad$var$_interopRequireDefault((parcelRequire("bSxHc")));
function $31f32f2daf3ec1ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31f32f2daf3ec1ad$var$utcYear = (0, $31f32f2daf3ec1ad$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$31f32f2daf3ec1ad$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $31f32f2daf3ec1ad$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $31f32f2daf3ec1ad$var$_default = module.exports.default = $31f32f2daf3ec1ad$var$utcYear;
var $31f32f2daf3ec1ad$var$utcYears = module.exports.utcYears = $31f32f2daf3ec1ad$var$utcYear.range;

});

parcelRegister("c02Yy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $baM4h = parcelRequire("baM4h");

var $188mN = parcelRequire("188mN");

var $8bc7cb069ddd56a7$var$_millisecond = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("hRCmg")));

var $8bc7cb069ddd56a7$var$_second = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("jFJeY")));

var $8bc7cb069ddd56a7$var$_minute = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("izQ7P")));

var $8bc7cb069ddd56a7$var$_hour = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4kq4i")));

var $8bc7cb069ddd56a7$var$_day = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("kSMPp")));

var $exwcm = parcelRequire("exwcm");

var $8bc7cb069ddd56a7$var$_month = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4YFnz")));

var $8bc7cb069ddd56a7$var$_year = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("lzVRI")));

var $8bc7cb069ddd56a7$var$_utcMinute = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("9FVE8")));

var $8bc7cb069ddd56a7$var$_utcHour = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4wGkR")));

var $8bc7cb069ddd56a7$var$_utcDay = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("i3XOj")));

var $kSPvm = parcelRequire("kSPvm");

var $8bc7cb069ddd56a7$var$_utcMonth = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("9ILJ1")));

var $8bc7cb069ddd56a7$var$_utcYear = $8bc7cb069ddd56a7$var$_interopRequireDefault((parcelRequire("4hSHL")));
function $8bc7cb069ddd56a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bc7cb069ddd56a7$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $8bc7cb069ddd56a7$var$_second.default,
            1,
            $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            5,
            5 * $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            15,
            15 * $188mN.durationSecond
        ],
        [
            $8bc7cb069ddd56a7$var$_second.default,
            30,
            30 * $188mN.durationSecond
        ],
        [
            minute,
            1,
            $188mN.durationMinute
        ],
        [
            minute,
            5,
            5 * $188mN.durationMinute
        ],
        [
            minute,
            15,
            15 * $188mN.durationMinute
        ],
        [
            minute,
            30,
            30 * $188mN.durationMinute
        ],
        [
            hour,
            1,
            $188mN.durationHour
        ],
        [
            hour,
            3,
            3 * $188mN.durationHour
        ],
        [
            hour,
            6,
            6 * $188mN.durationHour
        ],
        [
            hour,
            12,
            12 * $188mN.durationHour
        ],
        [
            day,
            1,
            $188mN.durationDay
        ],
        [
            day,
            2,
            2 * $188mN.durationDay
        ],
        [
            week,
            1,
            $188mN.durationWeek
        ],
        [
            month,
            1,
            $188mN.durationMonth
        ],
        [
            month,
            3,
            3 * $188mN.durationMonth
        ],
        [
            year,
            1,
            $188mN.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $baM4h.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $baM4h.tickStep)(start / $188mN.durationYear, stop / $188mN.durationYear, count));
        if (i === 0) return $8bc7cb069ddd56a7$var$_millisecond.default.every(Math.max((0, $baM4h.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$8bc7cb069ddd56a7$var$utcTicks, $8bc7cb069ddd56a7$var$utcTickInterval] = $8bc7cb069ddd56a7$var$ticker($8bc7cb069ddd56a7$var$_utcYear.default, $8bc7cb069ddd56a7$var$_utcMonth.default, $kSPvm.utcSunday, $8bc7cb069ddd56a7$var$_utcDay.default, $8bc7cb069ddd56a7$var$_utcHour.default, $8bc7cb069ddd56a7$var$_utcMinute.default);
module.exports.utcTickInterval = $8bc7cb069ddd56a7$var$utcTickInterval;
module.exports.utcTicks = $8bc7cb069ddd56a7$var$utcTicks;
const [$8bc7cb069ddd56a7$var$timeTicks, $8bc7cb069ddd56a7$var$timeTickInterval] = $8bc7cb069ddd56a7$var$ticker($8bc7cb069ddd56a7$var$_year.default, $8bc7cb069ddd56a7$var$_month.default, $exwcm.sunday, $8bc7cb069ddd56a7$var$_day.default, $8bc7cb069ddd56a7$var$_hour.default, $8bc7cb069ddd56a7$var$_minute.default);
module.exports.timeTickInterval = $8bc7cb069ddd56a7$var$timeTickInterval;
module.exports.timeTicks = $8bc7cb069ddd56a7$var$timeTicks;

});


parcelRegister("2qXVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $1c5c7fdd0d9de9a3$var$_defaultLocale.utcParse;
    }
});

var $1c5c7fdd0d9de9a3$var$_defaultLocale = $1c5c7fdd0d9de9a3$var$_interopRequireWildcard((parcelRequire("UhGoU")));

var $1c5c7fdd0d9de9a3$var$_locale = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("h1gUO")));

var $1c5c7fdd0d9de9a3$var$_isoFormat = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("k4LLC")));

var $1c5c7fdd0d9de9a3$var$_isoParse = $1c5c7fdd0d9de9a3$var$_interopRequireDefault((parcelRequire("ipWNh")));
function $1c5c7fdd0d9de9a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c5c7fdd0d9de9a3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1c5c7fdd0d9de9a3$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $1c5c7fdd0d9de9a3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $1c5c7fdd0d9de9a3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("UhGoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a92f287880e1421$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $0a92f287880e1421$var$_locale = $0a92f287880e1421$var$_interopRequireDefault((parcelRequire("h1gUO")));
function $0a92f287880e1421$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a92f287880e1421$var$locale;
var $0a92f287880e1421$var$timeFormat;
var $0a92f287880e1421$var$timeParse;
var $0a92f287880e1421$var$utcFormat;
var $0a92f287880e1421$var$utcParse;
$0a92f287880e1421$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a92f287880e1421$var$defaultLocale(definition) {
    $0a92f287880e1421$var$locale = (0, $0a92f287880e1421$var$_locale.default)(definition);
    module.exports.timeFormat = $0a92f287880e1421$var$timeFormat = $0a92f287880e1421$var$locale.format;
    module.exports.timeParse = $0a92f287880e1421$var$timeParse = $0a92f287880e1421$var$locale.parse;
    module.exports.utcFormat = $0a92f287880e1421$var$utcFormat = $0a92f287880e1421$var$locale.utcFormat;
    module.exports.utcParse = $0a92f287880e1421$var$utcParse = $0a92f287880e1421$var$locale.utcParse;
    return $0a92f287880e1421$var$locale;
}

});
parcelRegister("h1gUO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c63fa6af19e13ce4$var$formatLocale;

var $kym6t = parcelRequire("kym6t");
function $c63fa6af19e13ce4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $c63fa6af19e13ce4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $c63fa6af19e13ce4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $c63fa6af19e13ce4$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $c63fa6af19e13ce4$var$formatRe(locale_periods), periodLookup = $c63fa6af19e13ce4$var$formatLookup(locale_periods), weekdayRe = $c63fa6af19e13ce4$var$formatRe(locale_weekdays), weekdayLookup = $c63fa6af19e13ce4$var$formatLookup(locale_weekdays), shortWeekdayRe = $c63fa6af19e13ce4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $c63fa6af19e13ce4$var$formatLookup(locale_shortWeekdays), monthRe = $c63fa6af19e13ce4$var$formatRe(locale_months), monthLookup = $c63fa6af19e13ce4$var$formatLookup(locale_months), shortMonthRe = $c63fa6af19e13ce4$var$formatRe(locale_shortMonths), shortMonthLookup = $c63fa6af19e13ce4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $c63fa6af19e13ce4$var$formatDayOfMonth,
        "e": $c63fa6af19e13ce4$var$formatDayOfMonth,
        "f": $c63fa6af19e13ce4$var$formatMicroseconds,
        "g": $c63fa6af19e13ce4$var$formatYearISO,
        "G": $c63fa6af19e13ce4$var$formatFullYearISO,
        "H": $c63fa6af19e13ce4$var$formatHour24,
        "I": $c63fa6af19e13ce4$var$formatHour12,
        "j": $c63fa6af19e13ce4$var$formatDayOfYear,
        "L": $c63fa6af19e13ce4$var$formatMilliseconds,
        "m": $c63fa6af19e13ce4$var$formatMonthNumber,
        "M": $c63fa6af19e13ce4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $c63fa6af19e13ce4$var$formatUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$formatUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$formatSeconds,
        "u": $c63fa6af19e13ce4$var$formatWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$formatWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$formatWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$formatWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c63fa6af19e13ce4$var$formatYear,
        "Y": $c63fa6af19e13ce4$var$formatFullYear,
        "Z": $c63fa6af19e13ce4$var$formatZone,
        "%": $c63fa6af19e13ce4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $c63fa6af19e13ce4$var$formatUTCDayOfMonth,
        "e": $c63fa6af19e13ce4$var$formatUTCDayOfMonth,
        "f": $c63fa6af19e13ce4$var$formatUTCMicroseconds,
        "g": $c63fa6af19e13ce4$var$formatUTCYearISO,
        "G": $c63fa6af19e13ce4$var$formatUTCFullYearISO,
        "H": $c63fa6af19e13ce4$var$formatUTCHour24,
        "I": $c63fa6af19e13ce4$var$formatUTCHour12,
        "j": $c63fa6af19e13ce4$var$formatUTCDayOfYear,
        "L": $c63fa6af19e13ce4$var$formatUTCMilliseconds,
        "m": $c63fa6af19e13ce4$var$formatUTCMonthNumber,
        "M": $c63fa6af19e13ce4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $c63fa6af19e13ce4$var$formatUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$formatUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$formatUTCSeconds,
        "u": $c63fa6af19e13ce4$var$formatUTCWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$formatUTCWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$formatUTCWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$formatUTCWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c63fa6af19e13ce4$var$formatUTCYear,
        "Y": $c63fa6af19e13ce4$var$formatUTCFullYear,
        "Z": $c63fa6af19e13ce4$var$formatUTCZone,
        "%": $c63fa6af19e13ce4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $c63fa6af19e13ce4$var$parseDayOfMonth,
        "e": $c63fa6af19e13ce4$var$parseDayOfMonth,
        "f": $c63fa6af19e13ce4$var$parseMicroseconds,
        "g": $c63fa6af19e13ce4$var$parseYear,
        "G": $c63fa6af19e13ce4$var$parseFullYear,
        "H": $c63fa6af19e13ce4$var$parseHour24,
        "I": $c63fa6af19e13ce4$var$parseHour24,
        "j": $c63fa6af19e13ce4$var$parseDayOfYear,
        "L": $c63fa6af19e13ce4$var$parseMilliseconds,
        "m": $c63fa6af19e13ce4$var$parseMonthNumber,
        "M": $c63fa6af19e13ce4$var$parseMinutes,
        "p": parsePeriod,
        "q": $c63fa6af19e13ce4$var$parseQuarter,
        "Q": $c63fa6af19e13ce4$var$parseUnixTimestamp,
        "s": $c63fa6af19e13ce4$var$parseUnixTimestampSeconds,
        "S": $c63fa6af19e13ce4$var$parseSeconds,
        "u": $c63fa6af19e13ce4$var$parseWeekdayNumberMonday,
        "U": $c63fa6af19e13ce4$var$parseWeekNumberSunday,
        "V": $c63fa6af19e13ce4$var$parseWeekNumberISO,
        "w": $c63fa6af19e13ce4$var$parseWeekdayNumberSunday,
        "W": $c63fa6af19e13ce4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $c63fa6af19e13ce4$var$parseYear,
        "Y": $c63fa6af19e13ce4$var$parseFullYear,
        "Z": $c63fa6af19e13ce4$var$parseZone,
        "%": $c63fa6af19e13ce4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $c63fa6af19e13ce4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $c63fa6af19e13ce4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $c63fa6af19e13ce4$var$utcDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $kym6t.utcMonday.ceil(week) : (0, $kym6t.utcMonday)(week);
                    week = $kym6t.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $c63fa6af19e13ce4$var$localDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $kym6t.timeMonday.ceil(week) : (0, $kym6t.timeMonday)(week);
                    week = $kym6t.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $c63fa6af19e13ce4$var$utcDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)).getUTCDay() : $c63fa6af19e13ce4$var$localDate($c63fa6af19e13ce4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $c63fa6af19e13ce4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $c63fa6af19e13ce4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $c63fa6af19e13ce4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $c63fa6af19e13ce4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $c63fa6af19e13ce4$var$numberRe = /^\s*\d+/, // note: ignores next directive
$c63fa6af19e13ce4$var$percentRe = /^%/, $c63fa6af19e13ce4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $c63fa6af19e13ce4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $c63fa6af19e13ce4$var$requote(s) {
    return s.replace($c63fa6af19e13ce4$var$requoteRe, "\\$&");
}
function $c63fa6af19e13ce4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($c63fa6af19e13ce4$var$requote).join("|") + ")", "i");
}
function $c63fa6af19e13ce4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $c63fa6af19e13ce4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberSunday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberISO(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseWeekNumberMonday(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseFullYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseQuarter(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMonthNumber(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseDayOfMonth(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseDayOfYear(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseHour24(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMinutes(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseSeconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMilliseconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseMicroseconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseLiteralPercent(d, string, i) {
    var n = $c63fa6af19e13ce4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $c63fa6af19e13ce4$var$parseUnixTimestamp(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $c63fa6af19e13ce4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $c63fa6af19e13ce4$var$formatDayOfMonth(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getDate(), p, 2);
}
function $c63fa6af19e13ce4$var$formatHour24(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getHours(), p, 2);
}
function $c63fa6af19e13ce4$var$formatHour12(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $c63fa6af19e13ce4$var$formatDayOfYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(1 + $kym6t.timeDay.count((0, $kym6t.timeYear)(d), d), p, 3);
}
function $c63fa6af19e13ce4$var$formatMilliseconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMilliseconds(), p, 3);
}
function $c63fa6af19e13ce4$var$formatMicroseconds(d, p) {
    return $c63fa6af19e13ce4$var$formatMilliseconds(d, p) + "000";
}
function $c63fa6af19e13ce4$var$formatMonthNumber(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMonth() + 1, p, 2);
}
function $c63fa6af19e13ce4$var$formatMinutes(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getMinutes(), p, 2);
}
function $c63fa6af19e13ce4$var$formatSeconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getSeconds(), p, 2);
}
function $c63fa6af19e13ce4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $c63fa6af19e13ce4$var$formatWeekNumberSunday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.timeSunday.count((0, $kym6t.timeYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $kym6t.timeThursday)(d) : $kym6t.timeThursday.ceil(d);
}
function $c63fa6af19e13ce4$var$formatWeekNumberISO(d, p) {
    d = $c63fa6af19e13ce4$var$dISO(d);
    return $c63fa6af19e13ce4$var$pad($kym6t.timeThursday.count((0, $kym6t.timeYear)(d), d) + ((0, $kym6t.timeYear)(d).getDay() === 4), p, 2);
}
function $c63fa6af19e13ce4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $c63fa6af19e13ce4$var$formatWeekNumberMonday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.timeMonday.count((0, $kym6t.timeYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$formatYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatYearISO(d, p) {
    d = $c63fa6af19e13ce4$var$dISO(d);
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatFullYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $kym6t.timeThursday)(d) : $kym6t.timeThursday.ceil(d);
    return $c63fa6af19e13ce4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $c63fa6af19e13ce4$var$pad(z / 60 | 0, "0", 2) + $c63fa6af19e13ce4$var$pad(z % 60, "0", 2);
}
function $c63fa6af19e13ce4$var$formatUTCDayOfMonth(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCDate(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCHour24(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCHours(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCHour12(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCDayOfYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(1 + $kym6t.utcDay.count((0, $kym6t.utcYear)(d), d), p, 3);
}
function $c63fa6af19e13ce4$var$formatUTCMilliseconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $c63fa6af19e13ce4$var$formatUTCMicroseconds(d, p) {
    return $c63fa6af19e13ce4$var$formatUTCMilliseconds(d, p) + "000";
}
function $c63fa6af19e13ce4$var$formatUTCMonthNumber(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCMinutes(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCMinutes(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCSeconds(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCSeconds(), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberSunday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.utcSunday.count((0, $kym6t.utcYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $kym6t.utcThursday)(d) : $kym6t.utcThursday.ceil(d);
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberISO(d, p) {
    d = $c63fa6af19e13ce4$var$UTCdISO(d);
    return $c63fa6af19e13ce4$var$pad($kym6t.utcThursday.count((0, $kym6t.utcYear)(d), d) + ((0, $kym6t.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $c63fa6af19e13ce4$var$formatUTCWeekNumberMonday(d, p) {
    return $c63fa6af19e13ce4$var$pad($kym6t.utcMonday.count((0, $kym6t.utcYear)(d) - 1, d), p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCYearISO(d, p) {
    d = $c63fa6af19e13ce4$var$UTCdISO(d);
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c63fa6af19e13ce4$var$formatUTCFullYear(d, p) {
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $kym6t.utcThursday)(d) : $kym6t.utcThursday.ceil(d);
    return $c63fa6af19e13ce4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c63fa6af19e13ce4$var$formatUTCZone() {
    return "+0000";
}
function $c63fa6af19e13ce4$var$formatLiteralPercent() {
    return "%";
}
function $c63fa6af19e13ce4$var$formatUnixTimestamp(d) {
    return +d;
}
function $c63fa6af19e13ce4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("k4LLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $UhGoU = parcelRequire("UhGoU");
var $e9d93beb7b18b592$var$isoSpecifier = module.exports.isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function $e9d93beb7b18b592$var$formatIsoNative(date) {
    return date.toISOString();
}
var $e9d93beb7b18b592$var$formatIso = Date.prototype.toISOString ? $e9d93beb7b18b592$var$formatIsoNative : (0, $UhGoU.utcFormat)($e9d93beb7b18b592$var$isoSpecifier);
var $e9d93beb7b18b592$var$_default = module.exports.default = $e9d93beb7b18b592$var$formatIso;

});

parcelRegister("ipWNh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $k4LLC = parcelRequire("k4LLC");

var $UhGoU = parcelRequire("UhGoU");
function $d6882b05ea79e09e$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $d6882b05ea79e09e$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $d6882b05ea79e09e$var$parseIsoNative : (0, $UhGoU.utcParse)($k4LLC.isoSpecifier);
var $d6882b05ea79e09e$var$_default = module.exports.default = $d6882b05ea79e09e$var$parseIso;

});



parcelRegister("ne0st", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $045d0379864c58f8$var$utcTime;

var $kym6t = parcelRequire("kym6t");

var $2qXVT = parcelRequire("2qXVT");

var $617BV = parcelRequire("617BV");

var $98nei = parcelRequire("98nei");
function $045d0379864c58f8$var$utcTime() {
    return $98nei.initRange.apply((0, $617BV.calendar)($kym6t.utcTicks, $kym6t.utcTickInterval, $kym6t.utcYear, $kym6t.utcMonth, $kym6t.utcWeek, $kym6t.utcDay, $kym6t.utcHour, $kym6t.utcMinute, $kym6t.utcSecond, $2qXVT.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("5pVeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $3f1baf43dc1248ab$var$copy;
module.exports.default = $3f1baf43dc1248ab$var$sequential;
module.exports.sequentialLog = $3f1baf43dc1248ab$var$sequentialLog;
module.exports.sequentialPow = $3f1baf43dc1248ab$var$sequentialPow;
module.exports.sequentialSqrt = $3f1baf43dc1248ab$var$sequentialSqrt;
module.exports.sequentialSymlog = $3f1baf43dc1248ab$var$sequentialSymlog;

var $665th = parcelRequire("665th");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $aEI3x = parcelRequire("aEI3x");

var $bzrFz = parcelRequire("bzrFz");

var $cpAbf = parcelRequire("cpAbf");
function $3f1baf43dc1248ab$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $dTLbh.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($665th.interpolate);
    scale.rangeRound = range($665th.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $3f1baf43dc1248ab$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $3f1baf43dc1248ab$var$sequential() {
    var scale = (0, $hvSDx.linearish)($3f1baf43dc1248ab$var$transformer()($dTLbh.identity));
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequential());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialLog() {
    var scale = (0, $aEI3x.loggish)($3f1baf43dc1248ab$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialLog()).base(scale.base());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialSymlog() {
    var scale = (0, $bzrFz.symlogish)($3f1baf43dc1248ab$var$transformer());
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialSymlog()).constant(scale.constant());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialPow() {
    var scale = (0, $cpAbf.powish)($3f1baf43dc1248ab$var$transformer());
    scale.copy = function() {
        return $3f1baf43dc1248ab$var$copy(scale, $3f1baf43dc1248ab$var$sequentialPow()).exponent(scale.exponent());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $3f1baf43dc1248ab$var$sequentialSqrt() {
    return $3f1baf43dc1248ab$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("l4TSc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5854ff20784e77c$var$sequentialQuantile;

var $baM4h = parcelRequire("baM4h");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");
function $f5854ff20784e77c$var$sequentialQuantile() {
    var domain = [], interpolator = $dTLbh.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $baM4h.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($baM4h.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $baM4h.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $f5854ff20784e77c$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("fMWTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7e906464bbf9363$var$diverging;
module.exports.divergingLog = $b7e906464bbf9363$var$divergingLog;
module.exports.divergingPow = $b7e906464bbf9363$var$divergingPow;
module.exports.divergingSqrt = $b7e906464bbf9363$var$divergingSqrt;
module.exports.divergingSymlog = $b7e906464bbf9363$var$divergingSymlog;

var $665th = parcelRequire("665th");

var $dTLbh = parcelRequire("dTLbh");

var $98nei = parcelRequire("98nei");

var $hvSDx = parcelRequire("hvSDx");

var $aEI3x = parcelRequire("aEI3x");

var $5pVeE = parcelRequire("5pVeE");

var $bzrFz = parcelRequire("bzrFz");

var $cpAbf = parcelRequire("cpAbf");
function $b7e906464bbf9363$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $dTLbh.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $665th.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($665th.interpolate);
    scale.rangeRound = range($665th.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $b7e906464bbf9363$var$diverging() {
    var scale = (0, $hvSDx.linearish)($b7e906464bbf9363$var$transformer()($dTLbh.identity));
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$diverging());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingLog() {
    var scale = (0, $aEI3x.loggish)($b7e906464bbf9363$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingLog()).base(scale.base());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingSymlog() {
    var scale = (0, $bzrFz.symlogish)($b7e906464bbf9363$var$transformer());
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingSymlog()).constant(scale.constant());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingPow() {
    var scale = (0, $cpAbf.powish)($b7e906464bbf9363$var$transformer());
    scale.copy = function() {
        return (0, $5pVeE.copy)(scale, $b7e906464bbf9363$var$divergingPow()).exponent(scale.exponent());
    };
    return $98nei.initInterpolator.apply(scale, arguments);
}
function $b7e906464bbf9363$var$divergingSqrt() {
    return $b7e906464bbf9363$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("hm1Vt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ca25fc37378f3959$var$isPlainObject(object) {
    if (typeof object !== 'object') return false;
    if (object == null) return false;
    if (Object.getPrototypeOf(object) === null) return true;
    if (Object.prototype.toString.call(object) !== '[object Object]') {
        const tag = object[Symbol.toStringTag];
        if (tag == null) return false;
        const isTagReadonly = !Object.getOwnPropertyDescriptor(object, Symbol.toStringTag)?.writable;
        if (isTagReadonly) return false;
        return object.toString() === `[object ${tag}]`;
    }
    let proto = object;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(object) === proto;
}
module.exports.isPlainObject = $ca25fc37378f3959$var$isPlainObject;

});

parcelRegister("k3IAw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f94E9 = parcelRequire("f94E9");

var $2BtLz = parcelRequire("2BtLz");

var $goOlg = parcelRequire("goOlg");

var $4LEjk = parcelRequire("4LEjk");

var $1Aacb = parcelRequire("1Aacb");
function $e9a6acb8d2f55cc9$var$uniqBy(array, iteratee$1 = $goOlg.identity) {
    if (!$4LEjk.isArrayLikeObject(array)) return [];
    return $f94E9.uniqBy(Array.from(array), $2BtLz.ary($1Aacb.iteratee(iteratee$1), 1));
}
module.exports.uniqBy = $e9a6acb8d2f55cc9$var$uniqBy;

});
parcelRegister("f94E9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b06b4cf98e3889aa$var$uniqBy(arr, mapper) {
    const map = new Map();
    for(let i = 0; i < arr.length; i++){
        const item = arr[i];
        const key = mapper(item, i, arr);
        if (!map.has(key)) map.set(key, item);
    }
    return Array.from(map.values());
}
module.exports.uniqBy = $b06b4cf98e3889aa$var$uniqBy;

});

parcelRegister("2BtLz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $1e562068f7af8c19$var$ary(func, n) {
    return function(...args) {
        return func.apply(this, args.slice(0, n));
    };
}
module.exports.ary = $1e562068f7af8c19$var$ary;

});

parcelRegister("goOlg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $bf05f01982b96157$var$identity(x) {
    return x;
}
module.exports.identity = $bf05f01982b96157$var$identity;

});

parcelRegister("4LEjk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1kPBT = parcelRequire("1kPBT");

var $5DHsF = parcelRequire("5DHsF");
function $378ad21667f41d8f$var$isArrayLikeObject(value) {
    return $5DHsF.isObjectLike(value) && $1kPBT.isArrayLike(value);
}
module.exports.isArrayLikeObject = $378ad21667f41d8f$var$isArrayLikeObject;

});
parcelRegister("5DHsF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $41b24ecff6d22aa9$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
module.exports.isObjectLike = $41b24ecff6d22aa9$var$isObjectLike;

});


parcelRegister("1Aacb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $goOlg = parcelRequire("goOlg");

var $iM8Vg = parcelRequire("iM8Vg");

var $3zeZN = parcelRequire("3zeZN");

var $hHu3L = parcelRequire("hHu3L");
function $12710fdc2c1f8c3d$var$iteratee(value) {
    if (value == null) return $goOlg.identity;
    switch(typeof value){
        case 'function':
            return value;
        case 'object':
            if (Array.isArray(value) && value.length === 2) return $hHu3L.matchesProperty(value[0], value[1]);
            return $3zeZN.matches(value);
        case 'string':
        case 'symbol':
        case 'number':
            return $iM8Vg.property(value);
    }
}
module.exports.iteratee = $12710fdc2c1f8c3d$var$iteratee;

});
parcelRegister("iM8Vg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $HT3oM = parcelRequire("HT3oM");
function $dab3a18958c2fe97$var$property(path) {
    return function(object) {
        return $HT3oM.get(object, path);
    };
}
module.exports.property = $dab3a18958c2fe97$var$property;

});

parcelRegister("3zeZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWirn = parcelRequire("cWirn");

var $gaUX2 = parcelRequire("gaUX2");
function $299045d4ae3f7f94$var$matches(source) {
    source = $gaUX2.cloneDeep(source);
    return (target)=>{
        return $cWirn.isMatch(target, source);
    };
}
module.exports.matches = $299045d4ae3f7f94$var$matches;

});
parcelRegister("cWirn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g90rL = parcelRequire("g90rL");
function $96b934bd931b6383$var$isMatch(target, source) {
    return $g90rL.isMatchWith(target, source, ()=>undefined);
}
module.exports.isMatch = $96b934bd931b6383$var$isMatch;

});
parcelRegister("g90rL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9rZjx = parcelRequire("9rZjx");

var $9EwSx = parcelRequire("9EwSx");

var $6fz3V = parcelRequire("6fz3V");
function $bc0dd54e8ad52ae8$var$isMatchWith(target, source, compare) {
    if (typeof compare !== 'function') return $bc0dd54e8ad52ae8$var$isMatchWith(target, source, ()=>undefined);
    return $bc0dd54e8ad52ae8$var$isMatchWithInternal(target, source, function doesMatch(objValue, srcValue, key, object, source, stack) {
        const isEqual = compare(objValue, srcValue, key, object, source, stack);
        if (isEqual !== undefined) return Boolean(isEqual);
        return $bc0dd54e8ad52ae8$var$isMatchWithInternal(objValue, srcValue, doesMatch, stack);
    }, new Map());
}
function $bc0dd54e8ad52ae8$var$isMatchWithInternal(target, source, compare, stack) {
    if (source === target) return true;
    switch(typeof source){
        case 'object':
            return $bc0dd54e8ad52ae8$var$isObjectMatch(target, source, compare, stack);
        case 'function':
            {
                const sourceKeys = Object.keys(source);
                if (sourceKeys.length > 0) return $bc0dd54e8ad52ae8$var$isMatchWithInternal(target, {
                    ...source
                }, compare, stack);
                return $6fz3V.isEqualsSameValueZero(target, source);
            }
        default:
            if (!$9rZjx.isObject(target)) return $6fz3V.isEqualsSameValueZero(target, source);
            if (typeof source === 'string') return source === '';
            return true;
    }
}
function $bc0dd54e8ad52ae8$var$isObjectMatch(target, source, compare, stack) {
    if (source == null) return true;
    if (Array.isArray(source)) return $bc0dd54e8ad52ae8$var$isArrayMatch(target, source, compare, stack);
    if (source instanceof Map) return $bc0dd54e8ad52ae8$var$isMapMatch(target, source, compare, stack);
    if (source instanceof Set) return $bc0dd54e8ad52ae8$var$isSetMatch(target, source, compare, stack);
    const keys = Object.keys(source);
    if (target == null || $9EwSx.isPrimitive(target)) return keys.length === 0;
    if (keys.length === 0) return true;
    if (stack?.has(source)) return stack.get(source) === target;
    stack?.set(source, target);
    try {
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!$9EwSx.isPrimitive(target) && !(key in target)) return false;
            if (source[key] === undefined && target[key] !== undefined) return false;
            if (source[key] === null && target[key] !== null) return false;
            const isEqual = compare(target[key], source[key], key, target, source, stack);
            if (!isEqual) return false;
        }
        return true;
    } finally{
        stack?.delete(source);
    }
}
function $bc0dd54e8ad52ae8$var$isMapMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Map)) return false;
    for (const [key, sourceValue] of source.entries()){
        const targetValue = target.get(key);
        const isEqual = compare(targetValue, sourceValue, key, target, source, stack);
        if (isEqual === false) return false;
    }
    return true;
}
function $bc0dd54e8ad52ae8$var$isArrayMatch(target, source, compare, stack) {
    if (source.length === 0) return true;
    if (!Array.isArray(target)) return false;
    const countedIndex = new Set();
    for(let i = 0; i < source.length; i++){
        const sourceItem = source[i];
        let found = false;
        for(let j = 0; j < target.length; j++){
            if (countedIndex.has(j)) continue;
            const targetItem = target[j];
            let matches = false;
            const isEqual = compare(targetItem, sourceItem, i, target, source, stack);
            if (isEqual) matches = true;
            if (matches) {
                countedIndex.add(j);
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    return true;
}
function $bc0dd54e8ad52ae8$var$isSetMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Set)) return false;
    return $bc0dd54e8ad52ae8$var$isArrayMatch([
        ...target
    ], [
        ...source
    ], compare, stack);
}
module.exports.isMatchWith = $bc0dd54e8ad52ae8$var$isMatchWith;
module.exports.isSetMatch = $bc0dd54e8ad52ae8$var$isSetMatch;

});
parcelRegister("9EwSx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $70715a7ff11b637b$var$isPrimitive(value) {
    return value == null || typeof value !== 'object' && typeof value !== 'function';
}
module.exports.isPrimitive = $70715a7ff11b637b$var$isPrimitive;

});



parcelRegister("gaUX2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jmEdf = parcelRequire("jmEdf");
function $bc69c1d2c832f60a$var$cloneDeep(obj) {
    return $jmEdf.cloneDeepWithImpl(obj, undefined, obj, new Map(), undefined);
}
module.exports.cloneDeep = $bc69c1d2c832f60a$var$cloneDeep;

});
parcelRegister("jmEdf", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e18f43cafdd451c9$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XBpk = parcelRequire("1XBpk");

var $7iCDH = parcelRequire("7iCDH");

var $1acfL = parcelRequire("1acfL");

var $9EwSx = parcelRequire("9EwSx");

var $8SFHp = parcelRequire("8SFHp");
function $e18f43cafdd451c9$var$cloneDeepWith(obj, cloneValue) {
    return $e18f43cafdd451c9$var$cloneDeepWithImpl(obj, undefined, obj, new Map(), cloneValue);
}
function $e18f43cafdd451c9$var$cloneDeepWithImpl(valueToClone, keyToClone, objectToClone, stack = new Map(), cloneValue) {
    const cloned = cloneValue?.(valueToClone, keyToClone, objectToClone, stack);
    if (cloned !== undefined) return cloned;
    if ($9EwSx.isPrimitive(valueToClone)) return valueToClone;
    if (stack.has(valueToClone)) return stack.get(valueToClone);
    if (Array.isArray(valueToClone)) {
        const result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $e18f43cafdd451c9$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        if (Object.hasOwn(valueToClone, 'index')) result.index = valueToClone.index;
        if (Object.hasOwn(valueToClone, 'input')) result.input = valueToClone.input;
        return result;
    }
    if (valueToClone instanceof Date) return new Date(valueToClone.getTime());
    if (valueToClone instanceof RegExp) {
        const result = new RegExp(valueToClone.source, valueToClone.flags);
        result.lastIndex = valueToClone.lastIndex;
        return result;
    }
    if (valueToClone instanceof Map) {
        const result = new Map();
        stack.set(valueToClone, result);
        for (const [key, value] of valueToClone)result.set(key, $e18f43cafdd451c9$var$cloneDeepWithImpl(value, key, objectToClone, stack, cloneValue));
        return result;
    }
    if (valueToClone instanceof Set) {
        const result = new Set();
        stack.set(valueToClone, result);
        for (const value of valueToClone)result.add($e18f43cafdd451c9$var$cloneDeepWithImpl(value, undefined, objectToClone, stack, cloneValue));
        return result;
    }
    if (typeof $e18f43cafdd451c9$require$Buffer !== 'undefined' && $e18f43cafdd451c9$require$Buffer.isBuffer(valueToClone)) return valueToClone.subarray();
    if ($8SFHp.isTypedArray(valueToClone)) {
        const result = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $e18f43cafdd451c9$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && valueToClone instanceof SharedArrayBuffer) return valueToClone.slice(0);
    if (valueToClone instanceof DataView) {
        const result = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result);
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof File !== 'undefined' && valueToClone instanceof File) {
        const result = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof Blob !== 'undefined' && valueToClone instanceof Blob) {
        const result = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Error) {
        const result = new valueToClone.constructor();
        stack.set(valueToClone, result);
        result.message = valueToClone.message;
        result.name = valueToClone.name;
        result.stack = valueToClone.stack;
        result.cause = valueToClone.cause;
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Boolean) {
        const result = new Boolean(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Number) {
        const result = new Number(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof String) {
        const result = new String(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof valueToClone === 'object' && $e18f43cafdd451c9$var$isCloneableObject(valueToClone)) {
        const result = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result);
        $e18f43cafdd451c9$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    return valueToClone;
}
function $e18f43cafdd451c9$var$copyProperties(target, source, objectToClone = target, stack, cloneValue) {
    const keys = [
        ...Object.keys(source),
        ...$1XBpk.getSymbols(source)
    ];
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) target[key] = $e18f43cafdd451c9$var$cloneDeepWithImpl(source[key], key, objectToClone, stack, cloneValue);
    }
}
function $e18f43cafdd451c9$var$isCloneableObject(object) {
    switch($7iCDH.getTag(object)){
        case $1acfL.argumentsTag:
        case $1acfL.arrayTag:
        case $1acfL.arrayBufferTag:
        case $1acfL.dataViewTag:
        case $1acfL.booleanTag:
        case $1acfL.dateTag:
        case $1acfL.float32ArrayTag:
        case $1acfL.float64ArrayTag:
        case $1acfL.int8ArrayTag:
        case $1acfL.int16ArrayTag:
        case $1acfL.int32ArrayTag:
        case $1acfL.mapTag:
        case $1acfL.numberTag:
        case $1acfL.objectTag:
        case $1acfL.regexpTag:
        case $1acfL.setTag:
        case $1acfL.stringTag:
        case $1acfL.symbolTag:
        case $1acfL.uint8ArrayTag:
        case $1acfL.uint8ClampedArrayTag:
        case $1acfL.uint16ArrayTag:
        case $1acfL.uint32ArrayTag:
            return true;
        default:
            return false;
    }
}
module.exports.cloneDeepWith = $e18f43cafdd451c9$var$cloneDeepWith;
module.exports.cloneDeepWithImpl = $e18f43cafdd451c9$var$cloneDeepWithImpl;
module.exports.copyProperties = $e18f43cafdd451c9$var$copyProperties;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("1XBpk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $16d8517f17d9607c$var$getSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter((symbol)=>Object.prototype.propertyIsEnumerable.call(object, symbol));
}
module.exports.getSymbols = $16d8517f17d9607c$var$getSymbols;

});

parcelRegister("7iCDH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $55082fc9d2bbc02a$var$getTag(value) {
    if (value == null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
module.exports.getTag = $55082fc9d2bbc02a$var$getTag;

});

parcelRegister("1acfL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0d903ad90da5380f$var$regexpTag = '[object RegExp]';
const $0d903ad90da5380f$var$stringTag = '[object String]';
const $0d903ad90da5380f$var$numberTag = '[object Number]';
const $0d903ad90da5380f$var$booleanTag = '[object Boolean]';
const $0d903ad90da5380f$var$argumentsTag = '[object Arguments]';
const $0d903ad90da5380f$var$symbolTag = '[object Symbol]';
const $0d903ad90da5380f$var$dateTag = '[object Date]';
const $0d903ad90da5380f$var$mapTag = '[object Map]';
const $0d903ad90da5380f$var$setTag = '[object Set]';
const $0d903ad90da5380f$var$arrayTag = '[object Array]';
const $0d903ad90da5380f$var$functionTag = '[object Function]';
const $0d903ad90da5380f$var$arrayBufferTag = '[object ArrayBuffer]';
const $0d903ad90da5380f$var$objectTag = '[object Object]';
const $0d903ad90da5380f$var$errorTag = '[object Error]';
const $0d903ad90da5380f$var$dataViewTag = '[object DataView]';
const $0d903ad90da5380f$var$uint8ArrayTag = '[object Uint8Array]';
const $0d903ad90da5380f$var$uint8ClampedArrayTag = '[object Uint8ClampedArray]';
const $0d903ad90da5380f$var$uint16ArrayTag = '[object Uint16Array]';
const $0d903ad90da5380f$var$uint32ArrayTag = '[object Uint32Array]';
const $0d903ad90da5380f$var$bigUint64ArrayTag = '[object BigUint64Array]';
const $0d903ad90da5380f$var$int8ArrayTag = '[object Int8Array]';
const $0d903ad90da5380f$var$int16ArrayTag = '[object Int16Array]';
const $0d903ad90da5380f$var$int32ArrayTag = '[object Int32Array]';
const $0d903ad90da5380f$var$bigInt64ArrayTag = '[object BigInt64Array]';
const $0d903ad90da5380f$var$float32ArrayTag = '[object Float32Array]';
const $0d903ad90da5380f$var$float64ArrayTag = '[object Float64Array]';
module.exports.argumentsTag = $0d903ad90da5380f$var$argumentsTag;
module.exports.arrayBufferTag = $0d903ad90da5380f$var$arrayBufferTag;
module.exports.arrayTag = $0d903ad90da5380f$var$arrayTag;
module.exports.bigInt64ArrayTag = $0d903ad90da5380f$var$bigInt64ArrayTag;
module.exports.bigUint64ArrayTag = $0d903ad90da5380f$var$bigUint64ArrayTag;
module.exports.booleanTag = $0d903ad90da5380f$var$booleanTag;
module.exports.dataViewTag = $0d903ad90da5380f$var$dataViewTag;
module.exports.dateTag = $0d903ad90da5380f$var$dateTag;
module.exports.errorTag = $0d903ad90da5380f$var$errorTag;
module.exports.float32ArrayTag = $0d903ad90da5380f$var$float32ArrayTag;
module.exports.float64ArrayTag = $0d903ad90da5380f$var$float64ArrayTag;
module.exports.functionTag = $0d903ad90da5380f$var$functionTag;
module.exports.int16ArrayTag = $0d903ad90da5380f$var$int16ArrayTag;
module.exports.int32ArrayTag = $0d903ad90da5380f$var$int32ArrayTag;
module.exports.int8ArrayTag = $0d903ad90da5380f$var$int8ArrayTag;
module.exports.mapTag = $0d903ad90da5380f$var$mapTag;
module.exports.numberTag = $0d903ad90da5380f$var$numberTag;
module.exports.objectTag = $0d903ad90da5380f$var$objectTag;
module.exports.regexpTag = $0d903ad90da5380f$var$regexpTag;
module.exports.setTag = $0d903ad90da5380f$var$setTag;
module.exports.stringTag = $0d903ad90da5380f$var$stringTag;
module.exports.symbolTag = $0d903ad90da5380f$var$symbolTag;
module.exports.uint16ArrayTag = $0d903ad90da5380f$var$uint16ArrayTag;
module.exports.uint32ArrayTag = $0d903ad90da5380f$var$uint32ArrayTag;
module.exports.uint8ArrayTag = $0d903ad90da5380f$var$uint8ArrayTag;
module.exports.uint8ClampedArrayTag = $0d903ad90da5380f$var$uint8ClampedArrayTag;

});

parcelRegister("8SFHp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6773b673248308d7$var$isTypedArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
module.exports.isTypedArray = $6773b673248308d7$var$isTypedArray;

});




parcelRegister("hHu3L", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cWirn = parcelRequire("cWirn");

var $3jH0h = parcelRequire("3jH0h");

var $caUfz = parcelRequire("caUfz");

var $HT3oM = parcelRequire("HT3oM");

var $2JAEE = parcelRequire("2JAEE");
function $ce2dc50c590c04cd$var$matchesProperty(property, source) {
    switch(typeof property){
        case 'object':
            if (Object.is(property?.valueOf(), -0)) property = '-0';
            break;
        case 'number':
            property = $3jH0h.toKey(property);
            break;
    }
    source = $caUfz.cloneDeep(source);
    return function(target) {
        const result = $HT3oM.get(target, property);
        if (result === undefined) return $2JAEE.has(target, property);
        if (source === undefined) return result === undefined;
        return $cWirn.isMatch(result, source);
    };
}
module.exports.matchesProperty = $ce2dc50c590c04cd$var$matchesProperty;

});
parcelRegister("caUfz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7UoEI = parcelRequire("7UoEI");
function $8dd20d4c63feb3e1$var$cloneDeep(obj) {
    return $7UoEI.cloneDeepWith(obj);
}
module.exports.cloneDeep = $8dd20d4c63feb3e1$var$cloneDeep;

});
parcelRegister("7UoEI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jmEdf = parcelRequire("jmEdf");

var $7iCDH = parcelRequire("7iCDH");

var $1acfL = parcelRequire("1acfL");
function $5c20e3776952cd7a$var$cloneDeepWith(obj, customizer) {
    return $jmEdf.cloneDeepWith(obj, (value, key, object, stack)=>{
        const cloned = customizer?.(value, key, object, stack);
        if (cloned !== undefined) return cloned;
        if (typeof obj !== 'object') return undefined;
        if ($7iCDH.getTag(obj) === $1acfL.objectTag && typeof obj.constructor !== 'function') {
            const result = {};
            stack.set(obj, result);
            $jmEdf.copyProperties(result, obj, object, stack);
            return result;
        }
        switch(Object.prototype.toString.call(obj)){
            case $1acfL.numberTag:
            case $1acfL.stringTag:
            case $1acfL.booleanTag:
                {
                    const result = new obj.constructor(obj?.valueOf());
                    $jmEdf.copyProperties(result, obj);
                    return result;
                }
            case $1acfL.argumentsTag:
                {
                    const result = {};
                    $jmEdf.copyProperties(result, obj);
                    result.length = obj.length;
                    result[Symbol.iterator] = obj[Symbol.iterator];
                    return result;
                }
            default:
                return undefined;
        }
    });
}
module.exports.cloneDeepWith = $5c20e3776952cd7a$var$cloneDeepWith;

});


parcelRegister("2JAEE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cvH4Z = parcelRequire("cvH4Z");

var $k8KlW = parcelRequire("k8KlW");

var $gobWK = parcelRequire("gobWK");

var $cwBsL = parcelRequire("cwBsL");
function $1fdc379a733ba5cf$var$has(object, path) {
    let resolvedPath;
    if (Array.isArray(path)) resolvedPath = path;
    else if (typeof path === 'string' && $cvH4Z.isDeepKey(path) && object?.[path] == null) resolvedPath = $cwBsL.toPath(path);
    else resolvedPath = [
        path
    ];
    if (resolvedPath.length === 0) return false;
    let current = object;
    for(let i = 0; i < resolvedPath.length; i++){
        const key = resolvedPath[i];
        if (current == null || !Object.hasOwn(current, key)) {
            const isSparseIndex = (Array.isArray(current) || $gobWK.isArguments(current)) && $k8KlW.isIndex(key) && key < current.length;
            if (!isSparseIndex) return false;
        }
        current = current[key];
    }
    return true;
}
module.exports.has = $1fdc379a733ba5cf$var$has;

});
parcelRegister("gobWK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7iCDH = parcelRequire("7iCDH");
function $bee82794000dbdf6$var$isArguments(value) {
    return value !== null && typeof value === 'object' && $7iCDH.getTag(value) === '[object Arguments]';
}
module.exports.isArguments = $bee82794000dbdf6$var$isArguments;

});





var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");
var $9b23116271105198$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$9b23116271105198$exports = (parcelRequire("CKTDO"));




var $acw62 = parcelRequire("acw62");
var $186e804a234e7960$var$EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
function $186e804a234e7960$export$7d045284457d8577(key) {
    if (typeof key !== 'string') return false;
    var allowedEventKeys = $186e804a234e7960$var$EventKeys;
    return allowedEventKeys.includes(key);
}


var $909d5f835f4e917b$export$b8cdb4ab1d25db49 = (c)=>{
    return 'radius' in c && 'startAngle' in c && 'endAngle' in c;
};
var $909d5f835f4e917b$export$7c4c290a4a9c1b1e = (props, newHandler)=>{
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(props)) inputProps = props.props;
    if (typeof inputProps !== 'object' && typeof inputProps !== 'function') return null;
    var out = {};
    Object.keys(inputProps).forEach((key)=>{
        if ((0, $186e804a234e7960$export$7d045284457d8577)(key)) out[key] = newHandler || ((e)=>inputProps[key](inputProps, e));
    });
    return out;
};
var $909d5f835f4e917b$var$getEventHandlerOfChild = (originalHandler, data, index)=>(e)=>{
        originalHandler(data, index, e);
        return null;
    };
var $909d5f835f4e917b$export$ca62be0d67a3158c = (props, data, index)=>{
    if (props === null || typeof props !== 'object' && typeof props !== 'function') return null;
    var out = null;
    Object.keys(props).forEach((key)=>{
        var item = props[key];
        if ((0, $186e804a234e7960$export$7d045284457d8577)(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $909d5f835f4e917b$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};
var $909d5f835f4e917b$export$d307f5934e447d0e = (arr)=>{
    return Array.isArray(arr) && arr.length > 0;
};


var $7bb38c04d3b378db$exports = {};

$7bb38c04d3b378db$exports = (parcelRequire("HT3oM")).get;


// if you go lower than 3, wild wild things happen during rendering
var $a838779be6c997fd$var$defaultRoundPrecision = 4;
function $a838779be6c997fd$export$2077e0241d6afd3c(num) {
    var roundPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a838779be6c997fd$var$defaultRoundPrecision;
    var factor = 10 ** roundPrecision;
    var rounded = Math.round(num * factor) / factor;
    if (Object.is(rounded, -0)) return 0;
    return rounded;
}
function $a838779be6c997fd$export$f8a24ecc3d6c26c3(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    return strings.reduce((result, string, i)=>{
        var value = values[i - 1];
        if (typeof value === 'string') return result + value + string;
        if (value !== undefined) return result + $a838779be6c997fd$export$2077e0241d6afd3c(value) + string;
        return result + string;
    }, '');
}


var $2ab3a7e25c8aba74$export$9d334328eb75e624 = (value)=>{
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $2ab3a7e25c8aba74$export$e426a261f3212d7d = (value)=>{
    // eslint-disable-next-line eqeqeq
    return typeof value == 'number' && value != +value;
};
var $2ab3a7e25c8aba74$export$e50269385c77c348 = (value)=>typeof value === 'string' && value.indexOf('%') === value.length - 1;
var $2ab3a7e25c8aba74$export$7e4aa119212bc614 = (value)=>(typeof value === 'number' || value instanceof Number) && !$2ab3a7e25c8aba74$export$e426a261f3212d7d(value);
var $2ab3a7e25c8aba74$export$402a499e1ea44294 = (value)=>$2ab3a7e25c8aba74$export$7e4aa119212bc614(value) || typeof value === 'string';
var $2ab3a7e25c8aba74$var$idCounter = 0;
var $2ab3a7e25c8aba74$export$8b15d37bc3f197d4 = (prefix)=>{
    var id = ++$2ab3a7e25c8aba74$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $2ab3a7e25c8aba74$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$2ab3a7e25c8aba74$export$7e4aa119212bc614(percent) && typeof percent !== 'string') return defaultValue;
    var value;
    if ($2ab3a7e25c8aba74$export$e50269385c77c348(percent)) {
        if (totalValue == null) return defaultValue;
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ($2ab3a7e25c8aba74$export$e426a261f3212d7d(value)) value = defaultValue;
    if (validate && totalValue != null && value > totalValue) value = totalValue;
    return value;
};
var $2ab3a7e25c8aba74$export$732baf6a98f122 = (ary)=>{
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[String(ary[i])]) cache[String(ary[i])] = true;
        else return true;
    }
    return false;
};
function $2ab3a7e25c8aba74$export$89e29e4ab65e70a9(start, end, t) {
    if ($2ab3a7e25c8aba74$export$7e4aa119212bc614(start) && $2ab3a7e25c8aba74$export$7e4aa119212bc614(end)) return (0, $a838779be6c997fd$export$2077e0241d6afd3c)(start + t * (end - start));
    return end;
}
function $2ab3a7e25c8aba74$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return undefined;
    return ary.find((entry)=>entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($7bb38c04d3b378db$exports)))(entry, specifiedKey)) === specifiedValue);
}
var $2ab3a7e25c8aba74$export$484982720961754e = (data)=>{
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        var _data$i, _data$i2;
        xcurrent = ((_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.cx) || 0;
        ycurrent = ((_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.cy) || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $2ab3a7e25c8aba74$export$b931b78cbb3caf86 = (value)=>{
    return value === null || typeof value === 'undefined';
};
var $2ab3a7e25c8aba74$export$3061f22cd819074d = (value)=>{
    if ($2ab3a7e25c8aba74$export$b931b78cbb3caf86(value)) return value;
    return "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
};
function $2ab3a7e25c8aba74$export$7e515ab5fbd92bef(value) {
    return value != null;
}
function $2ab3a7e25c8aba74$export$8793edee2d425525() {}


function $dabee322b52312f4$export$f8a8fc612ced9bb0(n) {
    return Number.isFinite(n);
}
function $dabee322b52312f4$export$5374bb854d0e41c8(n) {
    return typeof n === 'number' && n > 0 && Number.isFinite(n);
}



var $acw62 = parcelRequire("acw62");
var $37a0b0a95f0e25bf$var$SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it, and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $37a0b0a95f0e25bf$var$SVGElementPropKeySet = new Set($37a0b0a95f0e25bf$var$SVGElementPropKeys);
function $37a0b0a95f0e25bf$export$b73d29c2a6d3ff97(key) {
    if (typeof key !== 'string') return false;
    return $37a0b0a95f0e25bf$var$SVGElementPropKeySet.has(key);
}
function $37a0b0a95f0e25bf$export$904e03d0a8b085df(key) {
    return typeof key === 'string' && key.startsWith('data-');
}
function $37a0b0a95f0e25bf$export$8b56257912140094(obj) {
    if (typeof obj !== 'object' || obj === null) return {};
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ($37a0b0a95f0e25bf$export$b73d29c2a6d3ff97(key) || $37a0b0a95f0e25bf$export$904e03d0a8b085df(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $37a0b0a95f0e25bf$export$6d5921c09aa671a9(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(input) && typeof input.props === 'object' && input.props !== null) {
        var p = input.props;
        return $37a0b0a95f0e25bf$export$8b56257912140094(p);
    }
    if (typeof input === 'object' && !Array.isArray(input)) return $37a0b0a95f0e25bf$export$8b56257912140094(input);
    return null;
}



var $acw62 = parcelRequire("acw62");
var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("i5mAx"));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4546adee7e5b0920$export$876ef70bc88b13cb = /*#__PURE__*/ (0, $acw62.createContext)(null);


var $8512ea9be24774fb$var$noopDispatch = (a)=>a;
var $8512ea9be24774fb$export$f51d452c10d5b956 = ()=>{
    var context = (0, $acw62.useContext)((0, $4546adee7e5b0920$export$876ef70bc88b13cb));
    if (context) return context.store.dispatch;
    return $8512ea9be24774fb$var$noopDispatch;
};
var $8512ea9be24774fb$var$noop = ()=>{};
var $8512ea9be24774fb$var$addNestedSubNoop = ()=>$8512ea9be24774fb$var$noop;
var $8512ea9be24774fb$var$refEquality = (a, b)=>a === b;
function $8512ea9be24774fb$export$a7347740d65f620b(selector) {
    var context = (0, $acw62.useContext)((0, $4546adee7e5b0920$export$876ef70bc88b13cb));
    var outOfContextSelector = (0, $acw62.useMemo)(()=>{
        if (!context) return $8512ea9be24774fb$var$noop;
        return (state)=>{
            if (state == null) return undefined;
            return selector(state);
        };
    }, [
        context,
        selector
    ]);
    return (0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector)(context ? context.subscription.addNestedSub : $8512ea9be24774fb$var$addNestedSubNoop, context ? context.store.getState : $8512ea9be24774fb$var$noop, context ? context.store.getState : $8512ea9be24774fb$var$noop, outOfContextSelector, $8512ea9be24774fb$var$refEquality);
}


// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $b9146244dc19043a$var$__defProp = Object.defineProperty;
var $b9146244dc19043a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b9146244dc19043a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b9146244dc19043a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b9146244dc19043a$var$__defNormalProp = (obj, key, value)=>key in obj ? $b9146244dc19043a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b9146244dc19043a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b9146244dc19043a$var$__hasOwnProp.call(b, prop)) $b9146244dc19043a$var$__defNormalProp(a, prop, b[prop]);
    if ($b9146244dc19043a$var$__getOwnPropSymbols) {
        for (var prop of $b9146244dc19043a$var$__getOwnPropSymbols(b))if ($b9146244dc19043a$var$__propIsEnum.call(b, prop)) $b9146244dc19043a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $b9146244dc19043a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $b9146244dc19043a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $b9146244dc19043a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $b9146244dc19043a$var$errors = [];
function $b9146244dc19043a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $b9146244dc19043a$var$O = Object;
var $b9146244dc19043a$var$getPrototypeOf = $b9146244dc19043a$var$O.getPrototypeOf;
var $b9146244dc19043a$var$CONSTRUCTOR = "constructor";
var $b9146244dc19043a$var$PROTOTYPE = "prototype";
var $b9146244dc19043a$var$CONFIGURABLE = "configurable";
var $b9146244dc19043a$var$ENUMERABLE = "enumerable";
var $b9146244dc19043a$var$WRITABLE = "writable";
var $b9146244dc19043a$var$VALUE = "value";
var $b9146244dc19043a$export$541ac630993a4c84 = (value)=>!!value && !!value[$b9146244dc19043a$var$DRAFT_STATE];
function $b9146244dc19043a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $b9146244dc19043a$var$isPlainObject(value) || $b9146244dc19043a$var$isArray(value) || !!value[$b9146244dc19043a$export$6ee2082928bcb0ee] || !!((_a = value[$b9146244dc19043a$var$CONSTRUCTOR]) == null ? void 0 : _a[$b9146244dc19043a$export$6ee2082928bcb0ee]) || $b9146244dc19043a$var$isMap(value) || $b9146244dc19043a$var$isSet(value);
}
var $b9146244dc19043a$var$objectCtorString = $b9146244dc19043a$var$O[$b9146244dc19043a$var$PROTOTYPE][$b9146244dc19043a$var$CONSTRUCTOR].toString();
var $b9146244dc19043a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $b9146244dc19043a$var$isPlainObject(value) {
    if (!value || !$b9146244dc19043a$var$isObjectish(value)) return false;
    const proto = $b9146244dc19043a$var$getPrototypeOf(value);
    if (proto === null || proto === $b9146244dc19043a$var$O[$b9146244dc19043a$var$PROTOTYPE]) return true;
    const Ctor = $b9146244dc19043a$var$O.hasOwnProperty.call(proto, $b9146244dc19043a$var$CONSTRUCTOR) && proto[$b9146244dc19043a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$b9146244dc19043a$var$isFunction(Ctor)) return false;
    let ctorString = $b9146244dc19043a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $b9146244dc19043a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $b9146244dc19043a$var$objectCtorString;
}
function $b9146244dc19043a$export$22e8af3f75a010e3(value) {
    if (!$b9146244dc19043a$export$541ac630993a4c84(value)) $b9146244dc19043a$var$die(15, value);
    return value[$b9146244dc19043a$var$DRAFT_STATE].base_;
}
function $b9146244dc19043a$var$each(obj, iter, strict = true) {
    if ($b9146244dc19043a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $b9146244dc19043a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $b9146244dc19043a$var$getArchtype(thing) {
    const state = thing[$b9146244dc19043a$var$DRAFT_STATE];
    return state ? state.type_ : $b9146244dc19043a$var$isArray(thing) ? 1 /* Array */  : $b9146244dc19043a$var$isMap(thing) ? 2 /* Map */  : $b9146244dc19043a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $b9146244dc19043a$var$has = (thing, prop, type = $b9146244dc19043a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $b9146244dc19043a$var$O[$b9146244dc19043a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $b9146244dc19043a$var$get = (thing, prop, type = $b9146244dc19043a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $b9146244dc19043a$var$set = (thing, propOrOldValue, value, type = $b9146244dc19043a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $b9146244dc19043a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $b9146244dc19043a$var$isArray = Array.isArray;
var $b9146244dc19043a$var$isMap = (target)=>target instanceof Map;
var $b9146244dc19043a$var$isSet = (target)=>target instanceof Set;
var $b9146244dc19043a$var$isObjectish = (target)=>typeof target === "object";
var $b9146244dc19043a$var$isFunction = (target)=>typeof target === "function";
var $b9146244dc19043a$var$isBoolean = (target)=>typeof target === "boolean";
function $b9146244dc19043a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $b9146244dc19043a$var$getProxyDraft = (value)=>{
    if (!$b9146244dc19043a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$b9146244dc19043a$var$DRAFT_STATE];
};
var $b9146244dc19043a$var$latest = (state)=>state.copy_ || state.base_;
var $b9146244dc19043a$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $b9146244dc19043a$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $b9146244dc19043a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $b9146244dc19043a$var$shallowCopy(base, strict) {
    if ($b9146244dc19043a$var$isMap(base)) return new Map(base);
    if ($b9146244dc19043a$var$isSet(base)) return new Set(base);
    if ($b9146244dc19043a$var$isArray(base)) return Array[$b9146244dc19043a$var$PROTOTYPE].slice.call(base);
    const isPlain = $b9146244dc19043a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $b9146244dc19043a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$b9146244dc19043a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$b9146244dc19043a$var$WRITABLE] === false) {
                desc[$b9146244dc19043a$var$WRITABLE] = true;
                desc[$b9146244dc19043a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$b9146244dc19043a$var$CONFIGURABLE]: true,
                [$b9146244dc19043a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$b9146244dc19043a$var$ENUMERABLE]: desc[$b9146244dc19043a$var$ENUMERABLE],
                [$b9146244dc19043a$var$VALUE]: base[key]
            };
        }
        return $b9146244dc19043a$var$O.create($b9146244dc19043a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $b9146244dc19043a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $b9146244dc19043a$var$__spreadValues({}, base);
        const obj = $b9146244dc19043a$var$O.create(proto);
        return $b9146244dc19043a$var$O.assign(obj, base);
    }
}
function $b9146244dc19043a$export$792f3d81ea979f55(obj, deep = false) {
    if ($b9146244dc19043a$var$isFrozen(obj) || $b9146244dc19043a$export$541ac630993a4c84(obj) || !$b9146244dc19043a$export$16e3aed3edb85946(obj)) return obj;
    if ($b9146244dc19043a$var$getArchtype(obj) > 1) $b9146244dc19043a$var$O.defineProperties(obj, {
        set: $b9146244dc19043a$var$dontMutateMethodOverride,
        add: $b9146244dc19043a$var$dontMutateMethodOverride,
        clear: $b9146244dc19043a$var$dontMutateMethodOverride,
        delete: $b9146244dc19043a$var$dontMutateMethodOverride
    });
    $b9146244dc19043a$var$O.freeze(obj);
    if (deep) $b9146244dc19043a$var$each(obj, (_key, value)=>{
        $b9146244dc19043a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $b9146244dc19043a$var$dontMutateFrozenCollections() {
    $b9146244dc19043a$var$die(2);
}
var $b9146244dc19043a$var$dontMutateMethodOverride = {
    [$b9146244dc19043a$var$VALUE]: $b9146244dc19043a$var$dontMutateFrozenCollections
};
function $b9146244dc19043a$var$isFrozen(obj) {
    if (obj === null || !$b9146244dc19043a$var$isObjectish(obj)) return true;
    return $b9146244dc19043a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $b9146244dc19043a$var$PluginMapSet = "MapSet";
var $b9146244dc19043a$var$PluginPatches = "Patches";
var $b9146244dc19043a$var$PluginArrayMethods = "ArrayMethods";
var $b9146244dc19043a$var$plugins = {};
function $b9146244dc19043a$var$getPlugin(pluginKey) {
    const plugin = $b9146244dc19043a$var$plugins[pluginKey];
    if (!plugin) $b9146244dc19043a$var$die(0, pluginKey);
    return plugin;
}
var $b9146244dc19043a$var$isPluginLoaded = (pluginKey)=>!!$b9146244dc19043a$var$plugins[pluginKey];
function $b9146244dc19043a$var$loadPlugin(pluginKey, implementation) {
    if (!$b9146244dc19043a$var$plugins[pluginKey]) $b9146244dc19043a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $b9146244dc19043a$var$currentScope;
var $b9146244dc19043a$var$getCurrentScope = ()=>$b9146244dc19043a$var$currentScope;
var $b9146244dc19043a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $b9146244dc19043a$var$isPluginLoaded($b9146244dc19043a$var$PluginMapSet) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $b9146244dc19043a$var$isPluginLoaded($b9146244dc19043a$var$PluginArrayMethods) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginArrayMethods) : void 0
    });
function $b9146244dc19043a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $b9146244dc19043a$var$revokeScope(scope) {
    $b9146244dc19043a$var$leaveScope(scope);
    scope.drafts_.forEach($b9146244dc19043a$var$revokeDraft);
    scope.drafts_ = null;
}
function $b9146244dc19043a$var$leaveScope(scope) {
    if (scope === $b9146244dc19043a$var$currentScope) $b9146244dc19043a$var$currentScope = scope.parent_;
}
var $b9146244dc19043a$var$enterScope = (immer2)=>$b9146244dc19043a$var$currentScope = $b9146244dc19043a$var$createScope($b9146244dc19043a$var$currentScope, immer2);
function $b9146244dc19043a$var$revokeDraft(draft) {
    const state = draft[$b9146244dc19043a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $b9146244dc19043a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$b9146244dc19043a$var$DRAFT_STATE].modified_) {
            $b9146244dc19043a$var$revokeScope(scope);
            $b9146244dc19043a$var$die(4);
        }
        if ($b9146244dc19043a$export$16e3aed3edb85946(result)) result = $b9146244dc19043a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$b9146244dc19043a$var$DRAFT_STATE].base_, result, scope);
    } else result = $b9146244dc19043a$var$finalize(scope, baseDraft);
    $b9146244dc19043a$var$maybeFreeze(scope, result, true);
    $b9146244dc19043a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $b9146244dc19043a$export$45b790e32b2810ee ? result : void 0;
}
function $b9146244dc19043a$var$finalize(rootScope, value) {
    if ($b9146244dc19043a$var$isFrozen(value)) return value;
    const state = value[$b9146244dc19043a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $b9146244dc19043a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$b9146244dc19043a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $b9146244dc19043a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $b9146244dc19043a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $b9146244dc19043a$export$792f3d81ea979f55(value, deep);
}
function $b9146244dc19043a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $b9146244dc19043a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $b9146244dc19043a$var$EMPTY_LOCATIONS_RESULT = [];
function $b9146244dc19043a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $b9146244dc19043a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $b9146244dc19043a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $b9146244dc19043a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $b9146244dc19043a$var$each(parentCopy, (key, value)=>{
            if ($b9146244dc19043a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $b9146244dc19043a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$b9146244dc19043a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $b9146244dc19043a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$b9146244dc19043a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $b9146244dc19043a$var$getFinalValue(state);
        $b9146244dc19043a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $b9146244dc19043a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $b9146244dc19043a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $b9146244dc19043a$var$markStateFinalized(state);
    }
}
function $b9146244dc19043a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($b9146244dc19043a$export$541ac630993a4c84(value)) {
        const state = value[$b9146244dc19043a$var$DRAFT_STATE];
        if ($b9146244dc19043a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $b9146244dc19043a$var$prepareCopy(target);
            const finalizedValue = $b9146244dc19043a$var$getFinalValue(state);
            $b9146244dc19043a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($b9146244dc19043a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $b9146244dc19043a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $b9146244dc19043a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($b9146244dc19043a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $b9146244dc19043a$var$handleValue($b9146244dc19043a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $b9146244dc19043a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($b9146244dc19043a$export$541ac630993a4c84(target) || handledSet.has(target) || !$b9146244dc19043a$export$16e3aed3edb85946(target) || $b9146244dc19043a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $b9146244dc19043a$var$each(target, (key, value)=>{
        if ($b9146244dc19043a$export$541ac630993a4c84(value)) {
            const state = value[$b9146244dc19043a$var$DRAFT_STATE];
            if ($b9146244dc19043a$var$isSameScope(state, rootScope)) {
                const updatedValue = $b9146244dc19043a$var$getFinalValue(state);
                $b9146244dc19043a$var$set(target, key, updatedValue, target.type_);
                $b9146244dc19043a$var$markStateFinalized(state);
            }
        } else if ($b9146244dc19043a$export$16e3aed3edb85946(value)) $b9146244dc19043a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $b9146244dc19043a$var$createProxyProxy(base, parent) {
    const baseIsArray = $b9146244dc19043a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $b9146244dc19043a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $b9146244dc19043a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $b9146244dc19043a$var$objectTraps = {
    get (state, prop) {
        if (prop === $b9146244dc19043a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $b9146244dc19043a$var$latest(state);
        if (!$b9146244dc19043a$var$has(source, prop, state.type_)) return $b9146244dc19043a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$b9146244dc19043a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $b9146244dc19043a$var$isArrayIndex(prop)) return value;
        if (value === $b9146244dc19043a$var$peek(state.base_, prop)) {
            $b9146244dc19043a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $b9146244dc19043a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $b9146244dc19043a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($b9146244dc19043a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $b9146244dc19043a$var$getDescriptorFromProto($b9146244dc19043a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $b9146244dc19043a$var$peek($b9146244dc19043a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$b9146244dc19043a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($b9146244dc19043a$var$is(value, current2) && (value !== void 0 || $b9146244dc19043a$var$has(state.base_, prop, state.type_))) return true;
            $b9146244dc19043a$var$prepareCopy(state);
            $b9146244dc19043a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $b9146244dc19043a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $b9146244dc19043a$var$prepareCopy(state);
        if ($b9146244dc19043a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $b9146244dc19043a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $b9146244dc19043a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$b9146244dc19043a$var$WRITABLE]: true,
            [$b9146244dc19043a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$b9146244dc19043a$var$ENUMERABLE]: desc[$b9146244dc19043a$var$ENUMERABLE],
            [$b9146244dc19043a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $b9146244dc19043a$var$die(11);
    },
    getPrototypeOf (state) {
        return $b9146244dc19043a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $b9146244dc19043a$var$die(12);
    }
};
var $b9146244dc19043a$var$arrayTraps = {};
for(let key in $b9146244dc19043a$var$objectTraps){
    let fn = $b9146244dc19043a$var$objectTraps[key];
    $b9146244dc19043a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$b9146244dc19043a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $b9146244dc19043a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$b9146244dc19043a$var$arrayTraps.set = function(state, prop, value) {
    return $b9146244dc19043a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $b9146244dc19043a$var$peek(draft, prop) {
    const state = draft[$b9146244dc19043a$var$DRAFT_STATE];
    const source = state ? $b9146244dc19043a$var$latest(state) : draft;
    return source[prop];
}
function $b9146244dc19043a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $b9146244dc19043a$var$getDescriptorFromProto(source, prop);
    return desc ? $b9146244dc19043a$var$VALUE in desc ? desc[$b9146244dc19043a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $b9146244dc19043a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $b9146244dc19043a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $b9146244dc19043a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $b9146244dc19043a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $b9146244dc19043a$var$markChanged(state.parent_);
    }
}
function $b9146244dc19043a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $b9146244dc19043a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $b9146244dc19043a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($b9146244dc19043a$var$isFunction(base) && !$b9146244dc19043a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$b9146244dc19043a$var$isFunction(recipe)) $b9146244dc19043a$var$die(6);
            if (patchListener !== void 0 && !$b9146244dc19043a$var$isFunction(patchListener)) $b9146244dc19043a$var$die(7);
            let result;
            if ($b9146244dc19043a$export$16e3aed3edb85946(base)) {
                const scope = $b9146244dc19043a$var$enterScope(this);
                const proxy = $b9146244dc19043a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $b9146244dc19043a$var$revokeScope(scope);
                    else $b9146244dc19043a$var$leaveScope(scope);
                }
                $b9146244dc19043a$var$usePatchesInScope(scope, patchListener);
                return $b9146244dc19043a$var$processResult(result, scope);
            } else if (!base || !$b9146244dc19043a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $b9146244dc19043a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $b9146244dc19043a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $b9146244dc19043a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($b9146244dc19043a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($b9146244dc19043a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($b9146244dc19043a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($b9146244dc19043a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$b9146244dc19043a$export$16e3aed3edb85946(base)) $b9146244dc19043a$var$die(8);
        if ($b9146244dc19043a$export$541ac630993a4c84(base)) base = $b9146244dc19043a$export$97aac956da55dae9(base);
        const scope = $b9146244dc19043a$var$enterScope(this);
        const proxy = $b9146244dc19043a$var$createProxy(scope, base, void 0);
        proxy[$b9146244dc19043a$var$DRAFT_STATE].isManual_ = true;
        $b9146244dc19043a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$b9146244dc19043a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $b9146244dc19043a$var$die(9);
        const { scope_: scope } = state;
        $b9146244dc19043a$var$usePatchesInScope(scope, patchListener);
        return $b9146244dc19043a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginPatches).applyPatches_;
        if ($b9146244dc19043a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $b9146244dc19043a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $b9146244dc19043a$var$isMap(value) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginMapSet).proxyMap_(value, parent) : $b9146244dc19043a$var$isSet(value) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginMapSet).proxySet_(value, parent) : $b9146244dc19043a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $b9146244dc19043a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $b9146244dc19043a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $b9146244dc19043a$export$97aac956da55dae9(value) {
    if (!$b9146244dc19043a$export$541ac630993a4c84(value)) $b9146244dc19043a$var$die(10, value);
    return $b9146244dc19043a$var$currentImpl(value);
}
function $b9146244dc19043a$var$currentImpl(value) {
    if (!$b9146244dc19043a$export$16e3aed3edb85946(value) || $b9146244dc19043a$var$isFrozen(value)) return value;
    const state = value[$b9146244dc19043a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $b9146244dc19043a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $b9146244dc19043a$var$shallowCopy(value, true);
    $b9146244dc19043a$var$each(copy, (key, childValue)=>{
        $b9146244dc19043a$var$set(copy, key, $b9146244dc19043a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $b9146244dc19043a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $b9146244dc19043a$var$getProxyDraft($b9146244dc19043a$var$get(parentCopy, state.key_));
            const valueAtKey = $b9146244dc19043a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $b9146244dc19043a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $b9146244dc19043a$var$get(current2, key);
            if (!$b9146244dc19043a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$b9146244dc19043a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $b9146244dc19043a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $b9146244dc19043a$var$get(base_, key, type_);
            const value = $b9146244dc19043a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $b9146244dc19043a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $b9146244dc19043a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $b9146244dc19043a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $b9146244dc19043a$var$CONSTRUCTOR)) $b9146244dc19043a$var$die(errorOffset + 3);
                if ($b9146244dc19043a$var$isFunction(base) && p === $b9146244dc19043a$var$PROTOTYPE) $b9146244dc19043a$var$die(errorOffset + 3);
                base = $b9146244dc19043a$var$get(base, p);
                if (!$b9146244dc19043a$var$isObjectish(base)) $b9146244dc19043a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $b9146244dc19043a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $b9146244dc19043a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $b9146244dc19043a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$b9146244dc19043a$export$16e3aed3edb85946(obj)) return obj;
        if ($b9146244dc19043a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($b9146244dc19043a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($b9146244dc19043a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($b9146244dc19043a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($b9146244dc19043a$var$has(obj, $b9146244dc19043a$export$6ee2082928bcb0ee)) cloned[$b9146244dc19043a$export$6ee2082928bcb0ee] = obj[$b9146244dc19043a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($b9146244dc19043a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $b9146244dc19043a$var$loadPlugin($b9146244dc19043a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $b9146244dc19043a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$b9146244dc19043a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$b9146244dc19043a$var$latest(state).has(key) || $b9146244dc19043a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $b9146244dc19043a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $b9146244dc19043a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b9146244dc19043a$var$latest(state).size) {
                prepareMapCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $b9146244dc19043a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            $b9146244dc19043a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $b9146244dc19043a$var$latest(state).get(key);
            if (state.finalized_ || !$b9146244dc19043a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $b9146244dc19043a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($b9146244dc19043a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$b9146244dc19043a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$b9146244dc19043a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.copy_.add(value);
                $b9146244dc19043a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $b9146244dc19043a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b9146244dc19043a$var$latest(state).size) {
                prepareSetCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($b9146244dc19043a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$b9146244dc19043a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($b9146244dc19043a$export$16e3aed3edb85946(value)) {
                    const draft = $b9146244dc19043a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $b9146244dc19043a$var$die(3, JSON.stringify($b9146244dc19043a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($b9146244dc19043a$var$getValue(value));
            });
        }
    }
    $b9146244dc19043a$var$loadPlugin($b9146244dc19043a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $b9146244dc19043a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $b9146244dc19043a$var$prepareCopy(state);
        const result = operation();
        $b9146244dc19043a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $b9146244dc19043a$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $b9146244dc19043a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $b9146244dc19043a$var$loadPlugin($b9146244dc19043a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $b9146244dc19043a$var$immer = new $b9146244dc19043a$export$aaadc6ff0f822719();
var $b9146244dc19043a$export$b46cabe22e78bc00 = $b9146244dc19043a$var$immer.produce;
var $b9146244dc19043a$export$4da66d41c9492c78 = /* @__PURE__ */ $b9146244dc19043a$var$immer.produceWithPatches.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$573f26f60825c493 = /* @__PURE__ */ $b9146244dc19043a$var$immer.setAutoFreeze.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$333ce65961cbe047 = /* @__PURE__ */ $b9146244dc19043a$var$immer.setUseStrictShallowCopy.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$1045b3be3904c489 = /* @__PURE__ */ $b9146244dc19043a$var$immer.setUseStrictIteration.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $b9146244dc19043a$var$immer.applyPatches.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$3c3214997190395f = /* @__PURE__ */ $b9146244dc19043a$var$immer.createDraft.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$c60f5e69c521b528 = /* @__PURE__ */ $b9146244dc19043a$var$immer.finishDraft.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$c05b21e3257751e5 = (value)=>value;
var $b9146244dc19043a$export$20f911b3f8cf0b74 = (value)=>value;


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $b9146244dc19043a$export$541ac630993a4c84)(value) ? (0, $b9146244dc19043a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $b9146244dc19043a$export$16e3aed3edb85946)(val) ? (0, $b9146244dc19043a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $b9146244dc19043a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $b9146244dc19043a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $b9146244dc19043a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $d91034f47eb948f2$var$isDraftTyped = (0, $b9146244dc19043a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $b9146244dc19043a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $b9146244dc19043a$export$541ac630993a4c84)(value) ? (0, $b9146244dc19043a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$emptyObject = {};
var $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $2c79e8f39a8896b6$var$initialState = {
    layoutType: 'horizontal',
    width: 0,
    height: 0,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    scale: 1
};
var $2c79e8f39a8896b6$var$chartLayoutSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'chartLayout',
    initialState: $2c79e8f39a8896b6$var$initialState,
    reducers: {
        setLayout (state, action) {
            state.layoutType = action.payload;
        },
        setChartSize (state, action) {
            state.width = action.payload.width;
            state.height = action.payload.height;
        },
        setMargin (state, action) {
            var _action$payload$top, _action$payload$right, _action$payload$botto, _action$payload$left;
            state.margin.top = (_action$payload$top = action.payload.top) !== null && _action$payload$top !== void 0 ? _action$payload$top : 0;
            state.margin.right = (_action$payload$right = action.payload.right) !== null && _action$payload$right !== void 0 ? _action$payload$right : 0;
            state.margin.bottom = (_action$payload$botto = action.payload.bottom) !== null && _action$payload$botto !== void 0 ? _action$payload$botto : 0;
            state.margin.left = (_action$payload$left = action.payload.left) !== null && _action$payload$left !== void 0 ? _action$payload$left : 0;
        },
        setScale (state, action) {
            state.scale = action.payload;
        }
    }
});
var { setMargin: $2c79e8f39a8896b6$export$3f8f25b83912855f, setLayout: $2c79e8f39a8896b6$export$e8437af1f2483b8e, setChartSize: $2c79e8f39a8896b6$export$136b7feefeae481a, setScale: $2c79e8f39a8896b6$export$4dc523f7f9b3edd6 } = $2c79e8f39a8896b6$var$chartLayoutSlice.actions;
var $2c79e8f39a8896b6$export$701395c4acfabc85 = $2c79e8f39a8896b6$var$chartLayoutSlice.reducer;




var $f89f7c674aff322e$exports = {};

$f89f7c674aff322e$exports = (parcelRequire("fwXTL")).sortBy;


var $a3c7059a0e295f7c$export$1d27a9e667f67593 = (state)=>state.legend.settings;
var $a3c7059a0e295f7c$export$c9c2b00a34f852e5 = (state)=>state.legend.size;
var $a3c7059a0e295f7c$var$selectAllLegendPayload2DArray = (state)=>state.legend.payload;
var $a3c7059a0e295f7c$export$9a6de64b691a7304 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $a3c7059a0e295f7c$var$selectAllLegendPayload2DArray,
    $a3c7059a0e295f7c$export$1d27a9e667f67593
], (payloads, _ref)=>{
    var { itemSorter: itemSorter } = _ref;
    var flat = payloads.flat(1);
    return itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($f89f7c674aff322e$exports)))(flat, itemSorter) : flat;
});






function $c1b90a42ae6f9682$export$238176e5211cdc1a(arr, startIndex, endIndex) {
    if (!Array.isArray(arr)) return arr;
    if (arr && startIndex + endIndex !== 0) return arr.slice(startIndex, endIndex + 1);
    return arr;
}



function $cd015374923bb5c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd015374923bb5c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd015374923bb5c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd015374923bb5c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd015374923bb5c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd015374923bb5c7$var$_defineProperty(e, r, t) {
    return (r = $cd015374923bb5c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cd015374923bb5c7$var$_toPropertyKey(t) {
    var i = $cd015374923bb5c7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cd015374923bb5c7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cd015374923bb5c7$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(obj) || (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(dataKey)) return defaultValue;
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($7bb38c04d3b378db$exports)))(obj, dataKey, defaultValue);
    if (typeof dataKey === 'function') return dataKey(obj);
    return defaultValue;
}
var $cd015374923bb5c7$export$3a657a8c9f789617 = (offset, legendSettings, legendSize)=>{
    if (legendSettings && legendSize) {
        var { width: boxWidth, height: boxHeight } = legendSize;
        var { align: align, verticalAlign: verticalAlign, layout: layout } = legendSettings;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(offset[align])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
            [align]: offset[align] + (boxWidth || 0)
        });
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(offset[verticalAlign])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
            [verticalAlign]: offset[verticalAlign] + (boxHeight || 0)
        });
    }
    return offset;
};
var $cd015374923bb5c7$export$9fc1baaa6c6368b = (layout, axisType)=>layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
var $cd015374923bb5c7$export$846dc5ac5fecff74 = (ticks, minValue, maxValue, syncWithTicks)=>{
    if (syncWithTicks) return ticks.map((entry)=>entry.coordinate);
    var hasMin, hasMax;
    var values = ticks.map((entry)=>{
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $cd015374923bb5c7$export$c829ee42daf7f66d = (axis, isGrid, isAll)=>{
    if (!axis) return null;
    var { duplicateDomain: duplicateDomain, type: type, range: range, scale: scale, realScaleType: realScaleType, isCategorical: isCategorical, categoricalDomain: categoricalDomain, tickCount: tickCount, ticks: ticks, niceTicks: niceTicks, axisType: axisType } = axis;
    if (!scale) return null;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range && range.length >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (ticks || niceTicks)) {
        var result = (ticks || niceTicks || []).map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            var scaled = scale.map(scaleContent);
            if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scaled + offset,
                value: entry,
                offset: offset,
                index: index
            };
        }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
        return result;
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    if (scale.ticks && !isAll && tickCount != null) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as an index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
};
var $cd015374923bb5c7$export$c7ec0fa96d0c462e = (value, domain)=>{
    if (!domain || domain.length !== 2 || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domain[0]) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $cd015374923bb5c7$export$3104c513558164c1 = (series)=>{
    var _series$;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$ = series[0]) === null || _series$ === void 0 ? void 0 : _series$.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var series1 = col[1];
            var series0 = col[0];
            var value = (0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(series1) ? series0 : series1;
            if (value >= 0) {
                col[0] = positive;
                positive += value;
                col[1] = positive;
            } else {
                col[0] = negative;
                negative += value;
                col[1] = negative;
            }
        }
    }
};
var $cd015374923bb5c7$export$9f2c6ead70935022 = (series)=>{
    var _series$2;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$2 = series[0]) === null || _series$2 === void 0 ? void 0 : _series$2.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var value = (0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(col[1]) ? col[0] : col[1];
            if (value >= 0) {
                col[0] = positive;
                positive += value;
                col[1] = positive;
            } else {
                col[0] = 0;
                col[1] = 0;
            }
        }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $cd015374923bb5c7$var$STACK_OFFSET_MAP = {
    sign: $cd015374923bb5c7$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $9b23116271105198$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $9b23116271105198$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $9b23116271105198$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $9b23116271105198$exports.stackOffsetWiggle),
    positive: $cd015374923bb5c7$export$9f2c6ead70935022
};
var $cd015374923bb5c7$export$c2170542cfc0177c = (data, dataKeys, offsetType)=>{
    var _STACK_OFFSET_MAP$off;
    var offsetAccessor = (_STACK_OFFSET_MAP$off = $cd015374923bb5c7$var$STACK_OFFSET_MAP[offsetType]) !== null && _STACK_OFFSET_MAP$off !== void 0 ? _STACK_OFFSET_MAP$off : (0, $9b23116271105198$exports.stackOffsetNone);
    var stack = (0, $9b23116271105198$exports.stack)().keys(dataKeys).value((d, key)=>Number($cd015374923bb5c7$export$f97fc4a450f29a(d, key, 0))).order((0, $9b23116271105198$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    var result = stack(data);
    // Post-process ranged data: if value is an array of two numbers, use them directly without stacking
    result.forEach((series, seriesIndex)=>{
        series.forEach((point, pointIndex)=>{
            var value = $cd015374923bb5c7$export$f97fc4a450f29a(data[pointIndex], dataKeys[seriesIndex], 0);
            if (Array.isArray(value) && value.length === 2 && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[0]) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value[1])) {
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[0] = value[0];
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[1] = value[1];
            }
        });
    });
    return result;
};
function $cd015374923bb5c7$export$f0871da41ca7fc82(publicStackId) {
    return publicStackId == null ? undefined : String(publicStackId);
}
function $cd015374923bb5c7$export$6e87f3defb83c3f(_ref) {
    var { axis: axis, ticks: ticks, bandSize: bandSize, entry: entry, index: index, dataKey: dataKey } = _ref;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks !== null && ticks !== void 0 && ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, !(0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(dataKey) ? dataKey : axis.dataKey);
    var scaled = axis.scale.map(value);
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(scaled)) return null;
    return scaled;
}
var $cd015374923bb5c7$export$8abb9e87422f3a0c = (_ref2)=>{
    var { axis: axis, ticks: ticks, offset: offset, bandSize: bandSize, entry: entry, index: index } = _ref2;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    // @ts-expect-error getValueByDataKey does not validate the output type
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, axis.dataKey, axis.scale.domain()[index]);
    if ((0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(value)) return null;
    var scaled = axis.scale.map(value);
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(scaled)) return null;
    return scaled - bandSize / 2 + offset;
};
var $cd015374923bb5c7$export$54f3200dd4a8a235 = (_ref3)=>{
    var { numericAxis: numericAxis } = _ref3;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var minValue = Math.min(domain[0], domain[1]);
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $cd015374923bb5c7$var$getDomainOfSingle = (data)=>{
    var flat = data.flat(2).filter((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614));
    return [
        Math.min(...flat),
        Math.max(...flat)
    ];
};
var $cd015374923bb5c7$var$makeDomainFinite = (domain)=>{
    return [
        domain[0] === Infinity ? 0 : domain[0],
        domain[1] === -Infinity ? 0 : domain[1]
    ];
};
var $cd015374923bb5c7$export$26522b779eb5497c = (stackGroups, startIndex, endIndex)=>{
    if (stackGroups == null) return undefined;
    return $cd015374923bb5c7$var$makeDomainFinite(Object.keys(stackGroups).reduce((result, stackId)=>{
        var group = stackGroups[stackId];
        if (!group) return result;
        var { stackedData: stackedData } = group;
        var domain = stackedData.reduce((res, entry)=>{
            var sliced = (0, $c1b90a42ae6f9682$export$238176e5211cdc1a)(entry, startIndex, endIndex);
            var s = $cd015374923bb5c7$var$getDomainOfSingle(sliced);
            if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(s[0]) || !(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(s[1])) return res;
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]));
};
var $cd015374923bb5c7$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$212ec45c42fe68a7 = (axis, ticks, isBar)=>{
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($f89f7c674aff322e$exports)))(ticks, (o)=>o.coordinate);
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min(((cur === null || cur === void 0 ? void 0 : cur.coordinate) || 0) - ((prev === null || prev === void 0 ? void 0 : prev.coordinate) || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
function $cd015374923bb5c7$export$3c1b390368bb3561(_ref4) {
    var { tooltipEntrySettings: tooltipEntrySettings, dataKey: dataKey, payload: payload, value: value, name: name } = _ref4;
    return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, tooltipEntrySettings), {}, {
        dataKey: dataKey,
        payload: payload,
        value: value,
        name: name
    });
}
function $cd015374923bb5c7$export$d3207de44081d2b3(nameFromItem, dataKey) {
    if (nameFromItem) return String(nameFromItem);
    if (typeof dataKey === 'string') return dataKey;
    return undefined;
}
var $cd015374923bb5c7$export$f29fac779ccd75bc = (coordinate, layout)=>{
    if (layout === 'horizontal') return coordinate.chartX;
    if (layout === 'vertical') return coordinate.chartY;
    return undefined;
};
var $cd015374923bb5c7$export$fb2b0f76aa25d837 = (rangeObj, layout)=>{
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};


var $0ab9657931cbbb24$export$771ef0ac044f724d = (state)=>state.layout.width;
var $0ab9657931cbbb24$export$5856a7d94c109505 = (state)=>state.layout.height;
var $0ab9657931cbbb24$export$317b55dda5fb5617 = (state)=>state.layout.scale;
var $0ab9657931cbbb24$export$aa3aa1fbf76377f0 = (state)=>state.layout.margin;



var $601e2713d7fc7a32$export$bd320344232f30af = (0, $375276bea32f9eda$export$595d22ed68ca2841)((state)=>state.cartesianAxis.xAxis, (xAxisMap)=>{
    return Object.values(xAxisMap);
});
var $601e2713d7fc7a32$export$e22adabb0128cf25 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((state)=>state.cartesianAxis.yAxis, (yAxisMap)=>{
    return Object.values(yAxisMap);
});


var $f6fce23ac63eec53$export$db34c3e22d611955 = [
    '#1890FF',
    '#66B5FF',
    '#41D9C7',
    '#2FC25B',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#223273',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#13C2C2',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9'
];
var $f6fce23ac63eec53$export$c0f3d78d63b3e065 = 'data-recharts-item-index';
var $f6fce23ac63eec53$export$5c80c48c1d137460 = 'data-recharts-item-id';
var $f6fce23ac63eec53$export$fb6ee82c8ee2faf8 = 60;


function $f90bc049d1e95f26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f90bc049d1e95f26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f90bc049d1e95f26$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f90bc049d1e95f26$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f90bc049d1e95f26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f90bc049d1e95f26$var$_defineProperty(e, r, t) {
    return (r = $f90bc049d1e95f26$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f90bc049d1e95f26$var$_toPropertyKey(t) {
    var i = $f90bc049d1e95f26$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f90bc049d1e95f26$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f90bc049d1e95f26$export$2d0a7adecb2afc9c = (state)=>state.brush.height;
function $f90bc049d1e95f26$var$selectLeftAxesOffset(state) {
    var yAxes = (0, $601e2713d7fc7a32$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'left' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $f6fce23ac63eec53$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $f90bc049d1e95f26$var$selectRightAxesOffset(state) {
    var yAxes = (0, $601e2713d7fc7a32$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'right' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $f6fce23ac63eec53$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $f90bc049d1e95f26$var$selectTopAxesOffset(state) {
    var xAxes = (0, $601e2713d7fc7a32$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'top' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
function $f90bc049d1e95f26$var$selectBottomAxesOffset(state) {
    var xAxes = (0, $601e2713d7fc7a32$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'bottom' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
var $f90bc049d1e95f26$export$1e34c8efb0bc9b3b = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $0ab9657931cbbb24$export$771ef0ac044f724d),
    (0, $0ab9657931cbbb24$export$5856a7d94c109505),
    (0, $0ab9657931cbbb24$export$aa3aa1fbf76377f0),
    $f90bc049d1e95f26$export$2d0a7adecb2afc9c,
    $f90bc049d1e95f26$var$selectLeftAxesOffset,
    $f90bc049d1e95f26$var$selectRightAxesOffset,
    $f90bc049d1e95f26$var$selectTopAxesOffset,
    $f90bc049d1e95f26$var$selectBottomAxesOffset,
    (0, $a3c7059a0e295f7c$export$1d27a9e667f67593),
    (0, $a3c7059a0e295f7c$export$c9c2b00a34f852e5)
], (chartWidth, chartHeight, margin, brushHeight, leftAxesOffset, rightAxesOffset, topAxesOffset, bottomAxesOffset, legendSettings, legendSize)=>{
    var offsetH = {
        left: (margin.left || 0) + leftAxesOffset,
        right: (margin.right || 0) + rightAxesOffset
    };
    var offsetV = {
        top: (margin.top || 0) + topAxesOffset,
        bottom: (margin.bottom || 0) + bottomAxesOffset
    };
    var offset = $f90bc049d1e95f26$var$_objectSpread($f90bc049d1e95f26$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    offset.bottom += brushHeight;
    offset = (0, $cd015374923bb5c7$export$3a657a8c9f789617)(offset, legendSettings, legendSize);
    var offsetWidth = chartWidth - offset.left - offset.right;
    var offsetHeight = chartHeight - offset.top - offset.bottom;
    return $f90bc049d1e95f26$var$_objectSpread($f90bc049d1e95f26$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
});
var $f90bc049d1e95f26$export$fb5e3eb7f8167ce7 = (0, $375276bea32f9eda$export$595d22ed68ca2841)($f90bc049d1e95f26$export$1e34c8efb0bc9b3b, (offset)=>({
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    }));
var $f90bc049d1e95f26$export$32c8e778bac69ce4 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $0ab9657931cbbb24$export$771ef0ac044f724d), (0, $0ab9657931cbbb24$export$5856a7d94c109505), (width, height)=>({
        x: 0,
        y: 0,
        width: width,
        height: height
    }));




var $acw62 = parcelRequire("acw62");
var $2e0e14143329e31b$var$PanoramaContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $2e0e14143329e31b$export$4b0c59f8845ba920 = ()=>(0, $acw62.useContext)($2e0e14143329e31b$var$PanoramaContext) != null;
var $2e0e14143329e31b$export$415fcedf1e191db0 = (_ref)=>{
    var { children: children } = _ref;
    return /*#__PURE__*/ $acw62.createElement($2e0e14143329e31b$var$PanoramaContext.Provider, {
        value: true
    }, children);
};






var $2779731b2b31d554$export$5ba94b496f8dc52e = (state)=>state.brush;
var $2779731b2b31d554$export$3b81e97eae001823 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $2779731b2b31d554$export$5ba94b496f8dc52e,
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    (0, $0ab9657931cbbb24$export$aa3aa1fbf76377f0)
], (brushSettings, offset, margin)=>({
        height: brushSettings.height,
        x: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(brushSettings.x) ? brushSettings.x : offset.left,
        y: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(brushSettings.y) ? brushSettings.y : offset.top + offset.height + offset.brushBottom - ((margin === null || margin === void 0 ? void 0 : margin.bottom) || 0),
        width: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(brushSettings.width) ? brushSettings.width : offset.width
    }));




var $acw62 = parcelRequire("acw62");
var $51b3fbea00189217$exports = {};

$51b3fbea00189217$exports = (parcelRequire("2q7WT")).throttle;



/* eslint no-console: 0 */ var $0c26188443d0bc67$var$isDev = true;
var $0c26188443d0bc67$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($0c26188443d0bc67$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, ()=>args[argIndex++]));
            }
        }
    }
};



var $39e759c44f5dbc32$export$5beeeca5506dd945 = {
    width: '100%',
    height: '100%',
    debounce: 0,
    minWidth: 0,
    initialDimension: {
        width: -1,
        height: -1
    }
};
var $39e759c44f5dbc32$export$83d33ab1950e2a9 = (containerWidth, containerHeight, props)=>{
    var { width: width = $39e759c44f5dbc32$export$5beeeca5506dd945.width, height: height = $39e759c44f5dbc32$export$5beeeca5506dd945.height, aspect: aspect, maxHeight: maxHeight } = props;
    /*
   * The containerWidth and containerHeight are already percentage based because it's set as that percentage in CSS.
   * Means we don't have to calculate percentages here.
   */ var calculatedWidth = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(width) ? containerWidth : Number(width);
    var calculatedHeight = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(height) ? containerHeight : Number(height);
    if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        else if (calculatedHeight) // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight != null && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
    }
    return {
        calculatedWidth: calculatedWidth,
        calculatedHeight: calculatedHeight
    };
};
var $39e759c44f5dbc32$var$bothOverflow = {
    width: 0,
    height: 0,
    overflow: 'visible'
};
var $39e759c44f5dbc32$var$overflowX = {
    width: 0,
    overflowX: 'visible'
};
var $39e759c44f5dbc32$var$overflowY = {
    height: 0,
    overflowY: 'visible'
};
var $39e759c44f5dbc32$var$noStyle = {};
var $39e759c44f5dbc32$export$d36bc8432d8d3f9d = (props)=>{
    var { width: width, height: height } = props;
    var isWidthPercent = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(width);
    var isHeightPercent = (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(height);
    if (isWidthPercent && isHeightPercent) return $39e759c44f5dbc32$var$bothOverflow;
    if (isWidthPercent) return $39e759c44f5dbc32$var$overflowX;
    if (isHeightPercent) return $39e759c44f5dbc32$var$overflowY;
    return $39e759c44f5dbc32$var$noStyle;
};
function $39e759c44f5dbc32$export$f717eb32fd8d3af5(_ref) {
    var { width: width, height: height, aspect: aspect } = _ref;
    var calculatedWidth = width;
    var calculatedHeight = height;
    if (calculatedWidth === undefined && calculatedHeight === undefined) {
        calculatedWidth = $39e759c44f5dbc32$export$5beeeca5506dd945.width;
        calculatedHeight = $39e759c44f5dbc32$export$5beeeca5506dd945.height;
    } else if (calculatedWidth === undefined) calculatedWidth = aspect && aspect > 0 ? undefined : $39e759c44f5dbc32$export$5beeeca5506dd945.width;
    else if (calculatedHeight === undefined) calculatedHeight = aspect && aspect > 0 ? undefined : $39e759c44f5dbc32$export$5beeeca5506dd945.height;
    return {
        width: calculatedWidth,
        height: calculatedHeight
    };
}



function $0431397098acacbe$var$_extends() {
    return $0431397098acacbe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0431397098acacbe$var$_extends.apply(null, arguments);
}
function $0431397098acacbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0431397098acacbe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0431397098acacbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0431397098acacbe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0431397098acacbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0431397098acacbe$var$_defineProperty(e, r, t) {
    return (r = $0431397098acacbe$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0431397098acacbe$var$_toPropertyKey(t) {
    var i = $0431397098acacbe$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0431397098acacbe$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0431397098acacbe$var$ResponsiveContainerContext = /*#__PURE__*/ (0, $acw62.createContext)((0, $39e759c44f5dbc32$export$5beeeca5506dd945).initialDimension);
function $0431397098acacbe$var$isAcceptableSize(size) {
    return (0, $dabee322b52312f4$export$5374bb854d0e41c8)(size.width) && (0, $dabee322b52312f4$export$5374bb854d0e41c8)(size.height);
}
function $0431397098acacbe$var$ResponsiveContainerContextProvider(_ref) {
    var { children: children, width: width, height: height } = _ref;
    var size = (0, $acw62.useMemo)(()=>({
            width: width,
            height: height
        }), [
        width,
        height
    ]);
    if (!$0431397098acacbe$var$isAcceptableSize(size)) /*
     * Don't render the container if width or height is non-positive because
     * in that case the chart will not be rendered properly anyway.
     * We will instead wait for the next resize event to provide the correct dimensions.
     */ return null;
    return /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$ResponsiveContainerContext.Provider, {
        value: size
    }, children);
}
var $0431397098acacbe$export$4ec9972d4f677af6 = ()=>(0, $acw62.useContext)($0431397098acacbe$var$ResponsiveContainerContext);
var $0431397098acacbe$var$SizeDetectorContainer = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref2, ref)=>{
    var { aspect: aspect, initialDimension: initialDimension = (0, $39e759c44f5dbc32$export$5beeeca5506dd945).initialDimension, width: width, height: height, minWidth: /*
     * default min-width to 0 if not specified - 'auto' causes issues with flexbox
     * https://github.com/recharts/recharts/issues/172
     */ minWidth = (0, $39e759c44f5dbc32$export$5beeeca5506dd945).minWidth, minHeight: minHeight, maxHeight: maxHeight, children: children, debounce: debounce = (0, $39e759c44f5dbc32$export$5beeeca5506dd945).debounce, id: id, className: className, onResize: onResize, style: style = {} } = _ref2;
    var containerRef = (0, $acw62.useRef)(null);
    /*
   * We are using a ref to avoid re-creating the ResizeObserver when the onResize function changes.
   * The ref is updated on every render, so the latest onResize function is always available in the effect.
   */ var onResizeRef = (0, $acw62.useRef)();
    onResizeRef.current = onResize;
    (0, $acw62.useImperativeHandle)(ref, ()=>containerRef.current);
    var [sizes, setSizes] = (0, $acw62.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    });
    var setContainerSize = (0, $acw62.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (containerRef.current == null || typeof ResizeObserver === 'undefined') return 0, $2ab3a7e25c8aba74$export$8793edee2d425525;
        var callback = (entries)=>{
            var _onResizeRef$current;
            var entry = entries[0];
            if (entry == null) return;
            var { width: containerWidth, height: containerHeight } = entry.contentRect;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($51b3fbea00189217$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var { width: containerWidth, height: containerHeight } = containerRef.current.getBoundingClientRect();
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var { containerWidth: containerWidth, containerHeight: containerHeight } = sizes;
    (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $39e759c44f5dbc32$export$83d33ab1950e2a9)(containerWidth, containerHeight, {
        width: width,
        height: height,
        aspect: aspect,
        maxHeight: maxHeight
    });
    (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(calculatedWidth != null && calculatedWidth > 0 || calculatedHeight != null && calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-responsive-container', className),
        style: $0431397098acacbe$var$_objectSpread($0431397098acacbe$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, /*#__PURE__*/ $acw62.createElement("div", {
        style: (0, $39e759c44f5dbc32$export$d36bc8432d8d3f9d)({
            width: width,
            height: height
        })
    }, /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, children)));
});
var $0431397098acacbe$export$e60a4704009a0009 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var responsiveContainerContext = $0431397098acacbe$export$4ec9972d4f677af6();
    if ((0, $dabee322b52312f4$export$5374bb854d0e41c8)(responsiveContainerContext.width) && (0, $dabee322b52312f4$export$5374bb854d0e41c8)(responsiveContainerContext.height)) /*
     * If we detect that we are already inside another ResponsiveContainer,
     * we do not attempt to add another layer of responsiveness.
     */ return props.children;
    var { width: width, height: height } = (0, $39e759c44f5dbc32$export$f717eb32fd8d3af5)({
        width: props.width,
        height: props.height,
        aspect: props.aspect
    });
    /*
   * Let's try to get the calculated dimensions without having the div container set up.
   * Sometimes this does produce fixed, positive dimensions. If so, we can skip rendering the div and monitoring its size.
   */ var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $39e759c44f5dbc32$export$83d33ab1950e2a9)(undefined, undefined, {
        width: width,
        height: height,
        aspect: props.aspect,
        maxHeight: props.maxHeight
    });
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(calculatedWidth) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(calculatedHeight)) /*
     * If it just so happens that the combination of width, height, and aspect ratio
     * results in fixed dimensions, then we don't need to monitor the container's size.
     * We can just provide these fixed dimensions to the context.
     *
     * Note that here we are not checking for positive numbers;
     * if the user provides a zero or negative width/height, we will just pass that along
     * as whatever size we detect won't be helping anyway.
     */ return /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, props.children);
    /*
   * Static analysis did not produce fixed dimensions,
   * so we need to render a special div and monitor its size.
   */ return /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$SizeDetectorContainer, $0431397098acacbe$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
});



function $e573f10901a87cfb$export$94a03fc5d61f2504(box) {
    if (!box) return undefined;
    return {
        x: box.x,
        y: box.y,
        upperWidth: 'upperWidth' in box ? box.upperWidth : box.width,
        lowerWidth: 'lowerWidth' in box ? box.lowerWidth : box.width,
        width: box.width,
        height: box.height
    };
}
var $e573f10901a87cfb$export$76b29bb074e0c45a = ()=>{
    var _useAppSelector;
    var panorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var rootViewBox = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $f90bc049d1e95f26$export$fb5e3eb7f8167ce7));
    var brushDimensions = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $2779731b2b31d554$export$3b81e97eae001823));
    var brushPadding = (_useAppSelector = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $2779731b2b31d554$export$5ba94b496f8dc52e))) === null || _useAppSelector === void 0 ? void 0 : _useAppSelector.padding;
    if (!panorama || !brushDimensions || !brushPadding) return rootViewBox;
    return {
        width: brushDimensions.width - brushPadding.left - brushPadding.right,
        height: brushDimensions.height - brushPadding.top - brushPadding.bottom,
        x: brushPadding.left,
        y: brushPadding.top
    };
};
var $e573f10901a87cfb$var$manyComponentsThrowErrorsIfOffsetIsUndefined = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
    brushBottom: 0
};
var $e573f10901a87cfb$export$10605f61bef2858a = ()=>{
    var _useAppSelector2;
    return (_useAppSelector2 = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b))) !== null && _useAppSelector2 !== void 0 ? _useAppSelector2 : $e573f10901a87cfb$var$manyComponentsThrowErrorsIfOffsetIsUndefined;
};
var $e573f10901a87cfb$export$8854f7ece606854b = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $0ab9657931cbbb24$export$771ef0ac044f724d));
};
var $e573f10901a87cfb$export$369ae257969c6f9f = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $0ab9657931cbbb24$export$5856a7d94c109505));
};
var $e573f10901a87cfb$export$58ac794108fd8ca = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>state.layout.margin);
};
var $e573f10901a87cfb$export$8426b6d9af801dee = (state)=>state.layout.layoutType;
var $e573f10901a87cfb$export$970c79ecc7081cc = ()=>(0, $8512ea9be24774fb$export$a7347740d65f620b)($e573f10901a87cfb$export$8426b6d9af801dee);
var $e573f10901a87cfb$export$c9942bdfc7f2781c = ()=>{
    var layout = $e573f10901a87cfb$export$970c79ecc7081cc();
    if (layout === 'horizontal' || layout === 'vertical') return layout;
    return undefined;
};
var $e573f10901a87cfb$export$d7a0004f3c7f5ca0 = (state)=>{
    var layout = state.layout.layoutType;
    if (layout === 'centric' || layout === 'radial') return layout;
    return undefined;
};
var $e573f10901a87cfb$export$a5f9dd11254d5e7e = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)($e573f10901a87cfb$export$d7a0004f3c7f5ca0);
};
var $e573f10901a87cfb$export$a3faf3c7b8f19073 = ()=>{
    /*
   * All charts provide a layout type in the chart context.
   * If we have a layout type, we are in a chart context.
   */ var layout = $e573f10901a87cfb$export$970c79ecc7081cc();
    return layout !== undefined;
};
var $e573f10901a87cfb$export$80ea82e77fb424e1 = (props)=>{
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var { width: widthFromProps, height: heightFromProps } = props;
    var responsiveContainerCalculations = (0, $0431397098acacbe$export$4ec9972d4f677af6)();
    var width = widthFromProps;
    var height = heightFromProps;
    if (responsiveContainerCalculations) {
        /*
     * In case we receive width and height from ResponsiveContainer,
     * we will always prefer those.
     * Only in case ResponsiveContainer does not provide width or height,
     * we will fall back to the explicitly provided width and height.
     *
     * This to me feels backwards - we should allow override by the more specific props on individual charts, right?
     * But this is 3.x behaviour, so let's keep it for backwards compatibility.
     *
     * We can change this in 4.x if we want to.
     */ width = responsiveContainerCalculations.width > 0 ? responsiveContainerCalculations.width : widthFromProps;
        height = responsiveContainerCalculations.height > 0 ? responsiveContainerCalculations.height : heightFromProps;
    }
    (0, $acw62.useEffect)(()=>{
        if (!isPanorama && (0, $dabee322b52312f4$export$5374bb854d0e41c8)(width) && (0, $dabee322b52312f4$export$5374bb854d0e41c8)(height)) dispatch((0, $2c79e8f39a8896b6$export$136b7feefeae481a)({
            width: width,
            height: height
        }));
    }, [
        dispatch,
        isPanorama,
        width,
        height
    ]);
    return null;
};
var $e573f10901a87cfb$export$19a41f515e2a12ff = (_ref)=>{
    var { margin: margin } = _ref;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $2c79e8f39a8896b6$export$3f8f25b83912855f)(margin));
    }, [
        dispatch,
        margin
    ]);
    return null;
};


function $af2055905739b7f2$var$_extends() {
    return $af2055905739b7f2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af2055905739b7f2$var$_extends.apply(null, arguments);
}
function $af2055905739b7f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af2055905739b7f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af2055905739b7f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $af2055905739b7f2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af2055905739b7f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $af2055905739b7f2$var$_defineProperty(e, r, t) {
    return (r = $af2055905739b7f2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $af2055905739b7f2$var$_toPropertyKey(t) {
    var i = $af2055905739b7f2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $af2055905739b7f2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $af2055905739b7f2$var$CURVE_FACTORIES = {
    curveBasisClosed: $9b23116271105198$exports.curveBasisClosed,
    curveBasisOpen: $9b23116271105198$exports.curveBasisOpen,
    curveBasis: $9b23116271105198$exports.curveBasis,
    curveBumpX: $9b23116271105198$exports.curveBumpX,
    curveBumpY: $9b23116271105198$exports.curveBumpY,
    curveLinearClosed: $9b23116271105198$exports.curveLinearClosed,
    curveLinear: $9b23116271105198$exports.curveLinear,
    curveMonotoneX: $9b23116271105198$exports.curveMonotoneX,
    curveMonotoneY: $9b23116271105198$exports.curveMonotoneY,
    curveNatural: $9b23116271105198$exports.curveNatural,
    curveStep: $9b23116271105198$exports.curveStep,
    curveStepAfter: $9b23116271105198$exports.curveStepAfter,
    curveStepBefore: $9b23116271105198$exports.curveStepBefore
};
/**
 * @inline
 */ var $af2055905739b7f2$var$defined = (p)=>(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(p.x) && (0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(p.y);
var $af2055905739b7f2$var$areaDefined = (d)=>d.base != null && $af2055905739b7f2$var$defined(d.base) && $af2055905739b7f2$var$defined(d);
var $af2055905739b7f2$var$getX = (p)=>p.x;
var $af2055905739b7f2$var$getY = (p)=>p.y;
var $af2055905739b7f2$var$getCurveFactory = (type, layout)=>{
    if (typeof type === 'function') return type;
    var name = "curve".concat((0, $2ab3a7e25c8aba74$export$3061f22cd819074d)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) {
        var factory = $af2055905739b7f2$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
        if (factory) return factory;
    }
    return $af2055905739b7f2$var$CURVE_FACTORIES[name] || (0, $9b23116271105198$exports.curveLinear);
};
var $af2055905739b7f2$export$4ad7f9093e086ed7 = {
    connectNulls: false,
    type: 'linear'
};
var $af2055905739b7f2$export$2aa3fd96c49a84a8 = (_ref)=>{
    var { type: type = $af2055905739b7f2$export$4ad7f9093e086ed7.type, points: points = [], baseLine: baseLine, layout: layout, connectNulls: connectNulls = $af2055905739b7f2$export$4ad7f9093e086ed7.connectNulls } = _ref;
    var curveFactory = $af2055905739b7f2$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter($af2055905739b7f2$var$defined) : points;
    // When dealing with an area chart (where `baseLine` is an array),
    // we need to pair points with their corresponding `baseLine` points first.
    // This is to ensure that we filter points and their baseline counterparts together,
    // preventing errors from mismatched array lengths and ensuring `defined` checks both.
    if (Array.isArray(baseLine)) {
        var _lineFunction;
        var areaPoints = points.map((entry, index)=>$af2055905739b7f2$var$_objectSpread($af2055905739b7f2$var$_objectSpread({}, entry), {}, {
                base: baseLine[index]
            }));
        if (layout === 'vertical') _lineFunction = (0, $9b23116271105198$exports.area)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0((d)=>d.base.x);
        else _lineFunction = (0, $9b23116271105198$exports.area)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0((d)=>d.base.y);
        /*
     * What happens here is that the `.defined()` call will make it so that this function can accept
     * nullable points, and internally it will filter them out and skip when generating the path.
     * So on the input it accepts NullableCoordinate, but it never calls getX/getY on null points because of the defined() filter.
     *
     * The d3 type definition has only one generic so it doesn't allow to describe this properly.
     * However. d3 types are mutable, but we can pretend that they are not, and we can pretend
     * that calling defined() returns a new function with a different generic type.
     */ // @ts-expect-error the defined call changes the generic type internally but d3 types don't reflect that
        var _nullableLineFunction = _lineFunction.defined($af2055905739b7f2$var$areaDefined).curve(curveFactory);
        var finalPoints = connectNulls ? areaPoints.filter($af2055905739b7f2$var$areaDefined) : areaPoints;
        return _nullableLineFunction(finalPoints);
    }
    var lineFunction;
    if (layout === 'vertical' && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $9b23116271105198$exports.area)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0(baseLine);
    else if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $9b23116271105198$exports.area)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0(baseLine);
    else lineFunction = (0, $9b23116271105198$exports.line)().x($af2055905739b7f2$var$getX).y($af2055905739b7f2$var$getY);
    // @ts-expect-error the defined call changes the generic type internally but d3 types don't reflect that
    var nullableLineFunction = lineFunction.defined($af2055905739b7f2$var$defined).curve(curveFactory);
    return nullableLineFunction(formatPoints);
};
var $af2055905739b7f2$export$b0e83c3ef8d2db1 = (props)=>{
    var { className: className, points: points, path: path, pathRef: pathRef } = props;
    var layout = (0, $e573f10901a87cfb$export$970c79ecc7081cc)();
    if ((!points || !points.length) && !path) return null;
    var getPathInput = {
        type: props.type,
        points: props.points,
        baseLine: props.baseLine,
        layout: props.layout || layout,
        connectNulls: props.connectNulls
    };
    var realPath = points && points.length ? $af2055905739b7f2$export$2aa3fd96c49a84a8(getPathInput) : path;
    return /*#__PURE__*/ $acw62.createElement("path", $af2055905739b7f2$var$_extends({}, (0, $37a0b0a95f0e25bf$export$8b56257912140094)(props), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-curve', className),
        d: realPath === null ? undefined : realPath,
        ref: pathRef
    }));
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


function $fefe4263beb558e0$export$67f8fc03e57e2747(obj) {
    var result = {};
    // for ... in loop is 10x faster than Object.entries + filter + Object.fromEntries in Chrome
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ((0, $37a0b0a95f0e25bf$export$b73d29c2a6d3ff97)(key) || (0, $37a0b0a95f0e25bf$export$904e03d0a8b085df)(key) || (0, $186e804a234e7960$export$7d045284457d8577)(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $fefe4263beb558e0$export$87ef3d7bc7cd0706(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(input)) // @ts-expect-error we can't type this better because input can be any React element
    return $fefe4263beb558e0$export$67f8fc03e57e2747(input.props);
    if (typeof input === 'object' && !Array.isArray(input)) return $fefe4263beb558e0$export$67f8fc03e57e2747(input);
    return null;
}


var $04149ae279e74c50$var$_excluded = [
    "children",
    "className"
];
function $04149ae279e74c50$var$_extends() {
    return $04149ae279e74c50$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $04149ae279e74c50$var$_extends.apply(null, arguments);
}
function $04149ae279e74c50$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $04149ae279e74c50$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $04149ae279e74c50$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $04149ae279e74c50$export$936d0764594b6eb3 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var { children: children, className: className } = props, others = $04149ae279e74c50$var$_objectWithoutProperties(props, $04149ae279e74c50$var$_excluded);
    var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-layer', className);
    return /*#__PURE__*/ $acw62.createElement("g", $04149ae279e74c50$var$_extends({
        className: layerClass
    }, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(others), {
        ref: ref
    }), children);
});



var $acw62 = parcelRequire("acw62");
var $43142099cd566622$exports = {};

$43142099cd566622$exports = (parcelRequire("l55GX")).last;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $795299547b24e258$var$parseIsSsrByDefault = ()=>!(typeof window !== 'undefined' && window.document && Boolean(window.document.createElement) && window.setTimeout);
var $795299547b24e258$export$98f03c5d19621d70 = {
    devToolsEnabled: true,
    isSsr: $795299547b24e258$var$parseIsSsrByDefault()
};



function $246fb5b10438d867$var$_defineProperty(e, r, t) {
    return (r = $246fb5b10438d867$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $246fb5b10438d867$var$_toPropertyKey(t) {
    var i = $246fb5b10438d867$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $246fb5b10438d867$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $246fb5b10438d867$export$182500e6725aad9a {
    constructor(maxSize){
        $246fb5b10438d867$var$_defineProperty(this, "cache", new Map());
        this.maxSize = maxSize;
    }
    get(key) {
        var value = this.cache.get(key);
        if (value !== undefined) {
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            var firstKey = this.cache.keys().next().value;
            if (firstKey != null) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
    size() {
        return this.cache.size;
    }
}


function $41867cca6cb93873$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41867cca6cb93873$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41867cca6cb93873$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41867cca6cb93873$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41867cca6cb93873$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41867cca6cb93873$var$_defineProperty(e, r, t) {
    return (r = $41867cca6cb93873$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $41867cca6cb93873$var$_toPropertyKey(t) {
    var i = $41867cca6cb93873$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $41867cca6cb93873$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $41867cca6cb93873$var$defaultConfig = {
    cacheSize: 2000,
    enableCache: true
};
var $41867cca6cb93873$var$currentConfig = $41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$defaultConfig);
var $41867cca6cb93873$var$stringCache = new (0, $246fb5b10438d867$export$182500e6725aad9a)($41867cca6cb93873$var$currentConfig.cacheSize);
var $41867cca6cb93873$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $41867cca6cb93873$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $41867cca6cb93873$var$createCacheKey(text, style) {
    // Simple string concatenation for better performance than JSON.stringify
    var fontSize = style.fontSize || '';
    var fontFamily = style.fontFamily || '';
    var fontWeight = style.fontWeight || '';
    var fontStyle = style.fontStyle || '';
    var letterSpacing = style.letterSpacing || '';
    var textTransform = style.textTransform || '';
    return "".concat(text, "|").concat(fontSize, "|").concat(fontFamily, "|").concat(fontWeight, "|").concat(fontStyle, "|").concat(letterSpacing, "|").concat(textTransform);
}
/**
 * Measure text using DOM (accurate but slower)
 * @param text - The text to measure
 * @param style - CSS style properties to apply
 * @returns The size of the text
 */ var $41867cca6cb93873$var$measureTextWithDOM = (text, style)=>{
    try {
        var measurementSpan = document.getElementById($41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Apply styles directly without unnecessary object creation
        Object.assign(measurementSpan.style, $41867cca6cb93873$var$SPAN_STYLE, style);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height
        };
    } catch (_unused) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $41867cca6cb93873$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $795299547b24e258$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    // If caching is disabled, measure directly
    if (!$41867cca6cb93873$var$currentConfig.enableCache) return $41867cca6cb93873$var$measureTextWithDOM(text, style);
    var cacheKey = $41867cca6cb93873$var$createCacheKey(text, style);
    var cachedResult = $41867cca6cb93873$var$stringCache.get(cacheKey);
    if (cachedResult) return cachedResult;
    // Measure using DOM
    var result = $41867cca6cb93873$var$measureTextWithDOM(text, style);
    // Store in LRU cache
    $41867cca6cb93873$var$stringCache.set(cacheKey, result);
    return result;
};
var $41867cca6cb93873$export$24830ea431eb8e34 = (config)=>{
    var newConfig = $41867cca6cb93873$var$_objectSpread($41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$currentConfig), config);
    if (newConfig.cacheSize !== $41867cca6cb93873$var$currentConfig.cacheSize) $41867cca6cb93873$var$stringCache = new (0, $246fb5b10438d867$export$182500e6725aad9a)(newConfig.cacheSize);
    $41867cca6cb93873$var$currentConfig = newConfig;
};
var $41867cca6cb93873$export$1340d8ffb2cb9b2 = ()=>$41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$currentConfig);
var $41867cca6cb93873$export$dbfda59986504510 = ()=>{
    $41867cca6cb93873$var$stringCache.clear();
};
var $41867cca6cb93873$export$5941b2b80425c12f = ()=>({
        size: $41867cca6cb93873$var$stringCache.size(),
        maxSize: $41867cca6cb93873$var$currentConfig.cacheSize
    });



var $59d4ad4b8fae5b14$var$_DecimalCSS;
function $59d4ad4b8fae5b14$var$_defineProperty(e, r, t) {
    return (r = $59d4ad4b8fae5b14$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $59d4ad4b8fae5b14$var$_toPropertyKey(t) {
    var i = $59d4ad4b8fae5b14$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $59d4ad4b8fae5b14$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $59d4ad4b8fae5b14$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    in: 96,
    Q: 96 / 101.6,
    px: 1
};
var $59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS = [
    'cm',
    'mm',
    'pt',
    'pc',
    'in',
    'Q',
    'px'
];
function $59d4ad4b8fae5b14$var$isSupportedUnit(unit) {
    return $59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS.includes(unit);
}
var $59d4ad4b8fae5b14$var$STR_NAN = 'NaN';
function $59d4ad4b8fae5b14$var$convertToPx(value, unit) {
    return value * $59d4ad4b8fae5b14$var$CONVERSION_RATES[unit];
}
class $59d4ad4b8fae5b14$var$DecimalCSS {
    static parse(str) {
        var _NUM_SPLIT_REGEX$exec;
        var [, numStr, unit] = (_NUM_SPLIT_REGEX$exec = $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [];
        if (numStr == null) return $59d4ad4b8fae5b14$var$DecimalCSS.NaN;
        return new $59d4ad4b8fae5b14$var$DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
    }
    constructor(num, unit){
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if ((0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(num)) this.unit = '';
        if (unit !== '' && !$59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($59d4ad4b8fae5b14$var$isSupportedUnit(unit)) {
            this.num = $59d4ad4b8fae5b14$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    add(other) {
        if (this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num + other.num, this.unit);
    }
    subtract(other) {
        if (this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num - other.num, this.unit);
    }
    multiply(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num * other.num, this.unit || other.unit);
    }
    divide(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num / other.num, this.unit || other.unit);
    }
    toString() {
        return "".concat(this.num).concat(this.unit);
    }
    isNaN() {
        return (0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(this.num);
    }
}
$59d4ad4b8fae5b14$var$_DecimalCSS = $59d4ad4b8fae5b14$var$DecimalCSS;
$59d4ad4b8fae5b14$var$_defineProperty($59d4ad4b8fae5b14$var$DecimalCSS, "NaN", new $59d4ad4b8fae5b14$var$_DecimalCSS(NaN, ''));
function $59d4ad4b8fae5b14$var$calculateArithmetic(expr) {
    if (expr == null || expr.includes($59d4ad4b8fae5b14$var$STR_NAN)) return $59d4ad4b8fae5b14$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var [, leftOperand, operator, rightOperand] = (_MULTIPLY_OR_DIVIDE_R = $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [];
        var lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var [, _leftOperand, _operator, _rightOperand] = (_ADD_OR_SUBTRACT_REGE = $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [];
        var _lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $59d4ad4b8fae5b14$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $59d4ad4b8fae5b14$var$calculateParentheses(expr) {
    var newExpr = expr;
    var match;
    // eslint-disable-next-line no-cond-assign
    while((match = $59d4ad4b8fae5b14$var$PARENTHESES_REGEX.exec(newExpr)) != null){
        var [, parentheticalExpression] = match;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$PARENTHESES_REGEX, $59d4ad4b8fae5b14$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $59d4ad4b8fae5b14$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $59d4ad4b8fae5b14$var$calculateParentheses(newExpr);
    newExpr = $59d4ad4b8fae5b14$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression) {
    try {
        return $59d4ad4b8fae5b14$var$evaluateExpression(expression);
    } catch (_unused) {
        return $59d4ad4b8fae5b14$var$STR_NAN;
    }
}
function $59d4ad4b8fae5b14$export$254eac204f89fd7d(expression) {
    var result = $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $59d4ad4b8fae5b14$var$STR_NAN) return '';
    return result;
}



function $8e3e05537b79f9d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e3e05537b79f9d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e3e05537b79f9d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e3e05537b79f9d5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e3e05537b79f9d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e3e05537b79f9d5$var$_defineProperty(e, r, t) {
    return (r = $8e3e05537b79f9d5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e3e05537b79f9d5$var$_toPropertyKey(t) {
    var i = $8e3e05537b79f9d5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8e3e05537b79f9d5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e3e05537b79f9d5$export$45004cc70a390ee8(realProps, defaultProps) {
    /*
   * To avoid mutating the original `realProps` object passed to the function, create a shallow copy of it.
   * `resolvedProps` will be modified directly with the defaults.
   */ var resolvedProps = $8e3e05537b79f9d5$var$_objectSpread({}, realProps);
    /*
   * Since the function guarantees `D extends Partial<T>`, this assignment is safe.
   * It allows TypeScript to work with the well-defined `Partial<T>` type inside the loop,
   * making subsequent type inference (especially for `dp[key]`) much more straightforward for the compiler.
   * This is a key step to improve type safety *without* value assertions later.
   */ var dp = defaultProps;
    /*
   * `Object.keys` doesn't preserve strong key types - it always returns Array<string>.
   * However, due to the `D extends Partial<T>` constraint,
   * we know these keys *must* also be valid keys of `T`.
   * This assertion informs TypeScript of this relationship, avoiding type errors when using `key` to index `acc` (type T).
   *
   * Type assertions are not sound but in this case it's necessary
   * as `Object.keys` does not do what we want it to do.
   */ var keys = Object.keys(defaultProps);
    var withDefaults = keys.reduce((acc, key)=>{
        if (acc[key] === undefined && dp[key] !== undefined) acc[key] = dp[key];
        return acc;
    }, resolvedProps);
    /*
   * And again type assertions are not safe but here we have done the runtime work
   * so let's bypass the lack of static type safety and tell the compiler what happened.
   */ return withDefaults;
} /**
 * Helper type to extract the keys of T that are required.
 * It iterates through each key K in T. If Pick<T, K> cannot be assigned an empty object {},
 * it means K is required, so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to extract the keys of T that are optional.
 * It iterates through each key K in T. If Pick<T, K> can be assigned an empty object {},
 * it means K is optional (or potentially missing), so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to ensure keys of D exist in T.
 * For each key K in D, if K is also a key of T, keep the type D[K].
 * If K is NOT a key of T, map it to type `never`.
 * An object cannot have a property of type `never`, effectively disallowing extra keys.
 */  /**
 * This type will take a source type `Props` and a default type `Defaults` and will return a new type
 * where all properties that are optional in `Props` but required in `Defaults` are made required in the result.
 * Properties that are required in `Props` and optional in `Defaults` will remain required.
 * Properties that are optional in both `Props` and `Defaults` will remain optional.
 *
 * This is useful for creating a type that represents the resolved props of a component with default props.
 */ 



var $964be52cc11879b4$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "fill",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor"
], $964be52cc11879b4$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $964be52cc11879b4$var$_extends() {
    return $964be52cc11879b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $964be52cc11879b4$var$_extends.apply(null, arguments);
}
function $964be52cc11879b4$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $964be52cc11879b4$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $964be52cc11879b4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $964be52cc11879b4$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $964be52cc11879b4$var$calculateWordWidths = (_ref)=>{
    var { children: children, breakAll: breakAll, style: style } = _ref;
    try {
        var words = [];
        if (!(0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($964be52cc11879b4$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map((word)=>({
                word: word,
                width: (0, $41867cca6cb93873$export$e5560531f057ad5d)(word, style).width
            }));
        var spaceWidth = breakAll ? 0 : (0, $41867cca6cb93873$export$e5560531f057ad5d)('\u00A0', style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (_unused) {
        return null;
    }
};
function $964be52cc11879b4$export$ae5e6c08954aa63c(value) {
    return value === 'start' || value === 'middle' || value === 'end' || value === 'inherit';
}
/**
 * @inline
 */ /**
 * @inline
 */ var $964be52cc11879b4$var$calculate = (words, lineWidth, spaceWidth, scaleToFit)=>words.reduce((result, _ref2)=>{
        var { word: word, width: width } = _ref2;
        var currentLine = result[result.length - 1];
        if (currentLine && width != null && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
            // Word can be added to an existing line
            currentLine.words.push(word);
            currentLine.width += width + spaceWidth;
        } else {
            // Add first word to line or word is too long to scaleToFit on existing line
            var newLine = {
                words: [
                    word
                ],
                width: width
            };
            result.push(newLine);
        }
        return result;
    }, []);
var $964be52cc11879b4$var$findLongestLine = (words)=>words.reduce((a, b)=>a.width > b.width ? a : b);
var $964be52cc11879b4$var$suffix = "\u2026";
var $964be52cc11879b4$var$checkOverflow = (text, index, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit)=>{
    var tempText = text.slice(0, index);
    var words = $964be52cc11879b4$var$calculateWordWidths({
        breakAll: breakAll,
        style: style,
        children: tempText + $964be52cc11879b4$var$suffix
    });
    if (!words) return [
        false,
        []
    ];
    var result = $964be52cc11879b4$var$calculate(words.wordsWithComputedWidth, lineWidth, spaceWidth, scaleToFit);
    var doesOverflow = result.length > maxLines || $964be52cc11879b4$var$findLongestLine(result).width > Number(lineWidth);
    return [
        doesOverflow,
        result
    ];
};
var $964be52cc11879b4$var$calculateWordsByLines = (_ref3, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit)=>{
    var { maxLines: maxLines, children: children, style: style, breakAll: breakAll } = _ref3;
    var shouldLimitLines = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(maxLines);
    var text = String(children);
    var originalResult = $964be52cc11879b4$var$calculate(initialWordsWithComputedWith, lineWidth, spaceWidth, scaleToFit);
    if (!shouldLimitLines || scaleToFit) return originalResult;
    var overflows = originalResult.length > maxLines || $964be52cc11879b4$var$findLongestLine(originalResult).width > Number(lineWidth);
    if (!overflows) return originalResult;
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var [doesPrevOverflow, result] = $964be52cc11879b4$var$checkOverflow(text, prev, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        var [doesMiddleOverflow] = $964be52cc11879b4$var$checkOverflow(text, middle, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $964be52cc11879b4$var$getWordsWithoutCalculate = (children)=>{
    var words = !(0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(children) ? children.toString().split($964be52cc11879b4$var$BREAKING_SPACES) : [];
    return [
        {
            words: words,
            width: undefined
        }
    ];
};
var $964be52cc11879b4$export$86ba3bfd091ebe4f = (_ref4)=>{
    var { width: width, scaleToFit: scaleToFit, children: children, style: style, breakAll: breakAll, maxLines: maxLines } = _ref4;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $964be52cc11879b4$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var { wordsWithComputedWidth: wcw, spaceWidth: sw } = wordWidths;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
        return $964be52cc11879b4$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, Boolean(scaleToFit));
    }
    return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
};
var $964be52cc11879b4$var$DEFAULT_FILL = '#808080';
var $964be52cc11879b4$export$beb103ac5cf1498b = {
    angle: 0,
    breakAll: false,
    // Magic number from d3
    capHeight: '0.71em',
    fill: $964be52cc11879b4$var$DEFAULT_FILL,
    lineHeight: '1em',
    scaleToFit: false,
    textAnchor: 'start',
    // Maintain compat with existing charts / default SVG behavior
    verticalAnchor: 'end',
    x: 0,
    y: 0
};
var $964be52cc11879b4$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $acw62.forwardRef)((outsideProps, ref)=>{
    var _resolveDefaultProps = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $964be52cc11879b4$export$beb103ac5cf1498b), { x: propsX, y: propsY, lineHeight: lineHeight, capHeight: capHeight, fill: fill, scaleToFit: scaleToFit, textAnchor: textAnchor, verticalAnchor: verticalAnchor } = _resolveDefaultProps, props = $964be52cc11879b4$var$_objectWithoutProperties(_resolveDefaultProps, $964be52cc11879b4$var$_excluded);
    var wordsByLines = (0, $acw62.useMemo)(()=>{
        return $964be52cc11879b4$export$86ba3bfd091ebe4f({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var { dx: dx, dy: dy, angle: angle, className: className, breakAll: breakAll } = props, textProps = $964be52cc11879b4$var$_objectWithoutProperties(props, $964be52cc11879b4$var$_excluded2);
    if (!(0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(propsX) || !(0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(propsY) || wordsByLines.length === 0) return null;
    var x = Number(propsX) + ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = Number(propsY) + ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(dy) ? dy : 0);
    if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(x) || !(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(y)) return null;
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $59d4ad4b8fae5b14$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    var firstLine = wordsByLines[0];
    if (scaleToFit && firstLine != null) {
        var lineWidth = firstLine.width;
        var { width: width } = props;
        transforms.push("scale(".concat((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(lineWidth) ? width / lineWidth : 1, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ $acw62.createElement("text", $964be52cc11879b4$var$_extends({}, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(textProps), {
        ref: ref,
        x: x,
        y: y,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $964be52cc11879b4$var$DEFAULT_FILL : fill
    }), wordsByLines.map((line, index)=>{
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys which is why we add the array index here
        $acw62.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
});
$964be52cc11879b4$export$5f1af8db9871e1d6.displayName = 'Text';



function $0f9bc5dd76ad1109$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f9bc5dd76ad1109$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f9bc5dd76ad1109$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0f9bc5dd76ad1109$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f9bc5dd76ad1109$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0f9bc5dd76ad1109$var$_defineProperty(e, r, t) {
    return (r = $0f9bc5dd76ad1109$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0f9bc5dd76ad1109$var$_toPropertyKey(t) {
    var i = $0f9bc5dd76ad1109$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0f9bc5dd76ad1109$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $0f9bc5dd76ad1109$export$4f2c4f194778dcbb = (angle)=>angle * Math.PI / 180;
var $0f9bc5dd76ad1109$export$1c20e104e3e29a0a = (angleInRadian)=>angleInRadian * 180 / Math.PI;
var $0f9bc5dd76ad1109$export$5c9a959bb3fc7749 = (cx, cy, radius, angle)=>({
        x: cx + Math.cos(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius
    });
var $0f9bc5dd76ad1109$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        brushBottom: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $0f9bc5dd76ad1109$var$distanceBetweenPoints = (point, anotherPoint)=>{
    var { x: x1, y: y1 } = point;
    var { x: x2, y: y2 } = anotherPoint;
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
};
var $0f9bc5dd76ad1109$var$getAngleOfPoint = (_ref, _ref2)=>{
    var { x: x, y: y } = _ref;
    var { cx: cx, cy: cy } = _ref2;
    var radius = $0f9bc5dd76ad1109$var$distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius,
        angle: 0
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $0f9bc5dd76ad1109$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $0f9bc5dd76ad1109$var$formatAngleOfSector = (_ref3)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref3;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $0f9bc5dd76ad1109$var$reverseFormatAngleOfSector = (angle, _ref4)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref4;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $0f9bc5dd76ad1109$export$e85a2bf8cd31c504 = (_ref5, viewBox)=>{
    var { chartX: x, chartY: y } = _ref5;
    var { radius: radius, angle: angle } = $0f9bc5dd76ad1109$var$getAngleOfPoint({
        x: x,
        y: y
    }, viewBox);
    var { innerRadius: innerRadius, outerRadius: outerRadius } = viewBox;
    if (radius < innerRadius || radius > outerRadius) return null;
    if (radius === 0) return null;
    var { startAngle: startAngle, endAngle: endAngle } = $0f9bc5dd76ad1109$var$formatAngleOfSector(viewBox);
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, viewBox), {}, {
        radius: radius,
        angle: $0f9bc5dd76ad1109$var$reverseFormatAngleOfSector(formatAngle, viewBox)
    });
    return null;
};









/**
 * A collection of all default zIndex values used by Recharts.
 *
 * You can reuse these, or you can define your own.
 */ var $c327287477e919da$export$96df16b28aa32702 = {
    /**
   * CartesianGrid and PolarGrid
   */ grid: -100,
    /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */ barBackground: -50,
    /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */ /**
   * Area, Pie, Radar, and ReferenceArea
   */ area: 100,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */ cursorRectangle: 200,
    /**
   * Bar and RadialBar
   */ bar: 300,
    /**
   * Line and ReferenceLine, and ErrorBor
   */ line: 400,
    /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */ axis: 500,
    /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */ scatter: 600,
    /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */ activeBar: 1000,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */ cursorLine: 1100,
    /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */ activeDot: 1200,
    /**
   * LabelList and Label, including Axis labels
   */ label: 2000
};


var $25d580895de704c0$export$969183d9e860c26e = {
    allowDecimals: false,
    allowDuplicatedCategory: true,
    // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
    allowDataOverflow: false,
    angle: 0,
    angleAxisId: 0,
    axisLine: true,
    axisLineType: 'polygon',
    cx: 0,
    cy: 0,
    hide: false,
    includeHidden: false,
    label: false,
    orientation: 'outer',
    reversed: false,
    scale: 'auto',
    tick: true,
    tickLine: true,
    tickSize: 8,
    type: 'auto',
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).axis
};



var $5811ea86e36cf7be$export$1a08e61551a7e57d = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: true,
    angle: 0,
    axisLine: true,
    includeHidden: false,
    hide: false,
    label: false,
    orientation: 'right',
    radiusAxisId: 0,
    reversed: false,
    scale: 'auto',
    stroke: '#ccc',
    tick: true,
    tickCount: 5,
    tickLine: true,
    type: 'auto',
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).axis
};


var $1dbac917d7459aa2$export$3f7e30291950e694 = (axisSettings, axisRange)=>{
    if (!axisSettings || !axisRange) return undefined;
    if (axisSettings !== null && axisSettings !== void 0 && axisSettings.reversed) return [
        axisRange[1],
        axisRange[0]
    ];
    return axisRange;
};




function $ec27de6f1bfb1a1f$export$c71ab14baba33626(layout, axisType, axisDomainType) {
    if (axisDomainType !== 'auto') return axisDomainType;
    if (layout == null) return undefined;
    return (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType) ? 'category' : 'number';
}


function $53bcbd5d17089da8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53bcbd5d17089da8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53bcbd5d17089da8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $53bcbd5d17089da8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53bcbd5d17089da8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $53bcbd5d17089da8$var$_defineProperty(e, r, t) {
    return (r = $53bcbd5d17089da8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $53bcbd5d17089da8$var$_toPropertyKey(t) {
    var i = $53bcbd5d17089da8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $53bcbd5d17089da8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $53bcbd5d17089da8$export$7489bacc62c76b42 = {
    allowDataOverflow: (0, $25d580895de704c0$export$969183d9e860c26e).allowDataOverflow,
    allowDecimals: (0, $25d580895de704c0$export$969183d9e860c26e).allowDecimals,
    allowDuplicatedCategory: false,
    // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
    dataKey: undefined,
    domain: undefined,
    id: (0, $25d580895de704c0$export$969183d9e860c26e).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: (0, $25d580895de704c0$export$969183d9e860c26e).reversed,
    scale: (0, $25d580895de704c0$export$969183d9e860c26e).scale,
    tick: (0, $25d580895de704c0$export$969183d9e860c26e).tick,
    tickCount: undefined,
    ticks: undefined,
    type: (0, $25d580895de704c0$export$969183d9e860c26e).type,
    unit: undefined
};
var $53bcbd5d17089da8$export$31037ebc9a4d24a3 = {
    allowDataOverflow: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).allowDataOverflow,
    allowDecimals: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).allowDecimals,
    allowDuplicatedCategory: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).radiusAxisId,
    includeHidden: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).includeHidden,
    name: undefined,
    reversed: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).reversed,
    scale: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).scale,
    tick: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).tick,
    tickCount: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).tickCount,
    ticks: undefined,
    type: (0, $5811ea86e36cf7be$export$1a08e61551a7e57d).type,
    unit: undefined
};
var $53bcbd5d17089da8$var$selectAngleAxisNoDefaults = (state, angleAxisId)=>{
    if (angleAxisId == null) return undefined;
    return state.polarAxis.angleAxis[angleAxisId];
};
var $53bcbd5d17089da8$export$2d9ff7eb66def0da = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$var$selectAngleAxisNoDefaults,
    (0, $e573f10901a87cfb$export$d7a0004f3c7f5ca0)
], (angleAxisSettings, layout)=>{
    var _getAxisTypeBasedOnLa;
    if (angleAxisSettings != null) return angleAxisSettings;
    var evaluatedType = (_getAxisTypeBasedOnLa = (0, $ec27de6f1bfb1a1f$export$c71ab14baba33626)(layout, 'angleAxis', $53bcbd5d17089da8$export$7489bacc62c76b42.type)) !== null && _getAxisTypeBasedOnLa !== void 0 ? _getAxisTypeBasedOnLa : 'category';
    return $53bcbd5d17089da8$var$_objectSpread($53bcbd5d17089da8$var$_objectSpread({}, $53bcbd5d17089da8$export$7489bacc62c76b42), {}, {
        type: evaluatedType
    });
});
var $53bcbd5d17089da8$var$selectRadiusAxisNoDefaults = (state, radiusAxisId)=>{
    return state.polarAxis.radiusAxis[radiusAxisId];
};
var $53bcbd5d17089da8$export$74b0499accddabe1 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$var$selectRadiusAxisNoDefaults,
    (0, $e573f10901a87cfb$export$d7a0004f3c7f5ca0)
], (radiusAxisSettings, layout)=>{
    var _getAxisTypeBasedOnLa2;
    if (radiusAxisSettings != null) return radiusAxisSettings;
    var evaluatedType = (_getAxisTypeBasedOnLa2 = (0, $ec27de6f1bfb1a1f$export$c71ab14baba33626)(layout, 'radiusAxis', $53bcbd5d17089da8$export$31037ebc9a4d24a3.type)) !== null && _getAxisTypeBasedOnLa2 !== void 0 ? _getAxisTypeBasedOnLa2 : 'category';
    return $53bcbd5d17089da8$var$_objectSpread($53bcbd5d17089da8$var$_objectSpread({}, $53bcbd5d17089da8$export$31037ebc9a4d24a3), {}, {
        type: evaluatedType
    });
});
var $53bcbd5d17089da8$export$a743f010244424e8 = (state)=>state.polarOptions;
var $53bcbd5d17089da8$export$53b653c1c5d6829b = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $0ab9657931cbbb24$export$771ef0ac044f724d),
    (0, $0ab9657931cbbb24$export$5856a7d94c109505),
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b)
], (0, $0f9bc5dd76ad1109$export$ad5c48602371adfa));
var $53bcbd5d17089da8$var$selectInnerRadius = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$export$a743f010244424e8,
    $53bcbd5d17089da8$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(polarChartOptions.innerRadius, maxRadius, 0);
});
var $53bcbd5d17089da8$export$32a1ec2f6eaad494 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$export$a743f010244424e8,
    $53bcbd5d17089da8$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(polarChartOptions.outerRadius, maxRadius, maxRadius * 0.8);
});
var $53bcbd5d17089da8$var$combineAngleAxisRange = (polarOptions)=>{
    if (polarOptions == null) return [
        0,
        0
    ];
    var { startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return [
        startAngle,
        endAngle
    ];
};
var $53bcbd5d17089da8$export$d00c8e94622c940 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$export$a743f010244424e8
], $53bcbd5d17089da8$var$combineAngleAxisRange);
var $53bcbd5d17089da8$export$15ccd32b0dd865d2 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$export$2d9ff7eb66def0da,
    $53bcbd5d17089da8$export$d00c8e94622c940
], (0, $1dbac917d7459aa2$export$3f7e30291950e694));
var $53bcbd5d17089da8$export$e13d847e4d4f833f = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$export$53b653c1c5d6829b,
    $53bcbd5d17089da8$var$selectInnerRadius,
    $53bcbd5d17089da8$export$32a1ec2f6eaad494
], (maxRadius, innerRadius, outerRadius)=>{
    if (maxRadius == null || innerRadius == null || outerRadius == null) return undefined;
    return [
        innerRadius,
        outerRadius
    ];
});
var $53bcbd5d17089da8$export$2b324c38f06972bb = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $53bcbd5d17089da8$export$74b0499accddabe1,
    $53bcbd5d17089da8$export$e13d847e4d4f833f
], (0, $1dbac917d7459aa2$export$3f7e30291950e694));
var $53bcbd5d17089da8$export$57f4101c1e20bd95 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $53bcbd5d17089da8$export$a743f010244424e8,
    $53bcbd5d17089da8$var$selectInnerRadius,
    $53bcbd5d17089da8$export$32a1ec2f6eaad494,
    (0, $0ab9657931cbbb24$export$771ef0ac044f724d),
    (0, $0ab9657931cbbb24$export$5856a7d94c109505)
], (layout, polarOptions, innerRadius, outerRadius, width, height)=>{
    if (layout !== 'centric' && layout !== 'radial' || polarOptions == null || innerRadius == null || outerRadius == null) return undefined;
    var { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return {
        cx: (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(cx, width, width / 2),
        cy: (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(cy, height, height / 2),
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        clockWise: false // this property look useful, why not use it?
    };
});





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



/**
 * Checks if two arrays are equal, treating empty arrays as equal regardless of reference.
 * If both arrays are non-empty, it checks for reference equality.
 * @param a
 * @param b
 */ function $0499b9ab63ed35d4$export$dcc34c4213e7f4c(a, b) {
    if (Array.isArray(a) && Array.isArray(b) && a.length === 0 && b.length === 0) // empty arrays are always equal, regardless of reference
    return true;
    return a === b;
}
function $0499b9ab63ed35d4$export$4f42c64323a69d96(a, b) {
    if (a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}



var $5f08f563d5a1ffa5$export$30b3c9504f8bc181 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (_, zIndex)=>zIndex, (_, _zIndex, isPanorama)=>isPanorama, (zIndexMap, zIndex, isPanorama)=>{
    if (zIndex == null) return undefined;
    var entry = zIndexMap[zIndex];
    if (entry == null) return undefined;
    if (isPanorama) return entry.panoramaElement;
    return entry.element;
});
var $5f08f563d5a1ffa5$export$7967bffce127e19c = (0, $375276bea32f9eda$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (zIndexMap)=>{
    var allNumbers = Object.keys(zIndexMap).map((zIndexStr)=>parseInt(zIndexStr, 10)).concat(Object.values((0, $c327287477e919da$export$96df16b28aa32702)));
    var uniqueNumbers = Array.from(new Set(allNumbers));
    return uniqueNumbers.sort((a, b)=>a - b);
}, {
    memoizeOptions: {
        resultEqualityCheck: (0, $0499b9ab63ed35d4$export$4f42c64323a69d96)
    }
});



var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$getPrototypeOf = Object.getPrototypeOf;
function $5f9e38360d79f95a$export$541ac630993a4c84(value) {
    return !!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
}
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || Array.isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = Object.prototype.constructor.toString();
var $5f9e38360d79f95a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null || proto === Object.prototype) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    if (typeof Ctor !== "function") return false;
    let ctorString = $5f9e38360d79f95a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $5f9e38360d79f95a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter, strict = true) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5f9e38360d79f95a$var$has(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5f9e38360d79f95a$var$get(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5f9e38360d79f95a$var$set(thing, propOrOldValue, value) {
    const t = $5f9e38360d79f95a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5f9e38360d79f95a$var$isMap(target) {
    return target instanceof Map;
}
function $5f9e38360d79f95a$var$isSet(target) {
    return target instanceof Set;
}
function $5f9e38360d79f95a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) Object.defineProperties(obj, {
        set: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        add: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        clear: $5f9e38360d79f95a$var$dontMutateMethodOverride,
        delete: $5f9e38360d79f95a$var$dontMutateMethodOverride
    });
    Object.freeze(obj);
    if (deep) Object.values(obj).forEach((value)=>$5f9e38360d79f95a$export$792f3d81ea979f55(value, true));
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
var $5f9e38360d79f95a$var$dontMutateMethodOverride = {
    value: $5f9e38360d79f95a$var$dontMutateFrozenCollections
};
function $5f9e38360d79f95a$var$isFrozen(obj) {
    if (obj === null || typeof obj !== "object") return true;
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
function $5f9e38360d79f95a$var$getCurrentScope() {
    return $5f9e38360d79f95a$var$currentScope;
}
function $5f9e38360d79f95a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5f9e38360d79f95a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
function $5f9e38360d79f95a$var$enterScope(immer2) {
    return $5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
}
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) {
            result = $5f9e38360d79f95a$var$finalize(scope, result);
            if (!scope.parent_) $5f9e38360d79f95a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft, []);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value, path) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        $5f9e38360d79f95a$var$each(value, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, value, key, childValue, path), useStrictIteration);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5f9e38360d79f95a$var$each(resultEach, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2), useStrictIteration);
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (childValue == null) return;
    if (typeof childValue !== "object" && !targetIsSet) return;
    const childIsFrozen = $5f9e38360d79f95a$var$isFrozen(childValue);
    if (childIsFrozen && !targetIsSet) return;
    if ($5f9e38360d79f95a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5f9e38360d79f95a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5f9e38360d79f95a$var$finalize(rootScope, childValue, path);
        $5f9e38360d79f95a$var$set(targetObject, prop, res);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5f9e38360d79f95a$export$16e3aed3edb85946(childValue) && !childIsFrozen) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) return;
        $5f9e38360d79f95a$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && ($5f9e38360d79f95a$var$isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop))) $5f9e38360d79f95a$var$maybeFreeze(rootScope, childValue);
    }
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            return state.copy_[prop] = $5f9e38360d79f95a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
$5f9e38360d79f95a$var$each($5f9e38360d79f95a$var$objectTraps, (key, fn)=>{
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = true;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (typeof (config == null ? void 0 : config.useStrictIteration) === "boolean") this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin("Patches").applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(value, parent) {
    const draft = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key);
            const value = $5f9e38360d79f95a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (typeof base !== "object") $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    $5f9e38360d79f95a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$1045b3be3904c489 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.setUseStrictIteration.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = /* @__PURE__ */ $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
function $5f9e38360d79f95a$export$c05b21e3257751e5(value) {
    return value;
}
function $5f9e38360d79f95a$export$20f911b3f8cf0b74(value) {
    return value;
}



function $2e81d63b6460b61d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e81d63b6460b61d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e81d63b6460b61d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2e81d63b6460b61d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e81d63b6460b61d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e81d63b6460b61d$var$_defineProperty(e, r, t) {
    return (r = $2e81d63b6460b61d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2e81d63b6460b61d$var$_toPropertyKey(t) {
    var i = $2e81d63b6460b61d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2e81d63b6460b61d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2e81d63b6460b61d$var$seed = {};
var $2e81d63b6460b61d$var$initialState = {
    zIndexMap: Object.values((0, $c327287477e919da$export$96df16b28aa32702)).reduce((acc, current)=>$2e81d63b6460b61d$var$_objectSpread($2e81d63b6460b61d$var$_objectSpread({}, acc), {}, {
            [current]: {
                element: undefined,
                panoramaElement: undefined,
                consumers: 0
            }
        }), $2e81d63b6460b61d$var$seed)
};
var $2e81d63b6460b61d$var$defaultZIndexSet = new Set(Object.values((0, $c327287477e919da$export$96df16b28aa32702)));
function $2e81d63b6460b61d$var$isDefaultZIndex(zIndex) {
    return $2e81d63b6460b61d$var$defaultZIndexSet.has(zIndex);
}
var $2e81d63b6460b61d$var$zIndexSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'zIndex',
    initialState: $2e81d63b6460b61d$var$initialState,
    reducers: {
        registerZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) state.zIndexMap[zIndex].consumers += 1;
                else state.zIndexMap[zIndex] = {
                    consumers: 1,
                    element: undefined,
                    panoramaElement: undefined
                };
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    state.zIndexMap[zIndex].consumers -= 1;
                    /*
           * Garbage collect unused z-index entries, except for default z-indexes.
           * Default z-indexes are always rendered, regardless of whether there are consumers or not.
           * And because of that, even if we delete this entry, the ZIndexPortal provider will still be rendered
           * and React is not going to re-create it, and it won't re-register the element ID.
           * So let's not delete default z-index entries.
           */ if (state.zIndexMap[zIndex].consumers <= 0 && !$2e81d63b6460b61d$var$isDefaultZIndex(zIndex)) delete state.zIndexMap[zIndex];
                }
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        registerZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex: zIndex, element: element, isPanorama: isPanorama } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (isPanorama) state.zIndexMap[zIndex].panoramaElement = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(element);
                    else state.zIndexMap[zIndex].element = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(element);
                } else state.zIndexMap[zIndex] = {
                    consumers: 0,
                    element: isPanorama ? undefined : (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(element),
                    panoramaElement: isPanorama ? (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(element) : undefined
                };
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (action.payload.isPanorama) state.zIndexMap[zIndex].panoramaElement = undefined;
                    else state.zIndexMap[zIndex].element = undefined;
                }
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        }
    }
});
var { registerZIndexPortal: $2e81d63b6460b61d$export$8fe155db96cddace, unregisterZIndexPortal: $2e81d63b6460b61d$export$230718bd38635ccb, registerZIndexPortalElement: $2e81d63b6460b61d$export$2e6026208075bd4f, unregisterZIndexPortalElement: $2e81d63b6460b61d$export$b735943939e8125 } = $2e81d63b6460b61d$var$zIndexSlice.actions;
var $2e81d63b6460b61d$export$a34096cdea3a022a = $2e81d63b6460b61d$var$zIndexSlice.reducer;




function $8de5347dd9805c3d$export$b37befaf92aba9f1(_ref) {
    var { zIndex: zIndex, children: children } = _ref;
    /*
   * If we are outside of chart, then we can't rely on the zIndex portal state,
   * so we just render normally.
   */ var isInChartContext = (0, $e573f10901a87cfb$export$a3faf3c7b8f19073)();
    /*
   * If zIndex is undefined then we render normally without portals.
   * Also, if zIndex is 0, we render normally without portals,
   * because 0 is the default layer that does not need a portal.
   */ var shouldRenderInPortal = isInChartContext && zIndex !== undefined && zIndex !== 0;
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useLayoutEffect)(()=>{
        if (!shouldRenderInPortal) // Nothing to do. We have to call the hook because of the rules of hooks.
        return 0, $2ab3a7e25c8aba74$export$8793edee2d425525;
        /*
     * Because zIndexes are dynamic (meaning, we're not working with a predefined set of layers,
     * but we allow users to define any zIndex at any time), we need to register
     * the requested zIndex in the global store. This way, the ZIndexPortals component
     * can render the corresponding portals and only the requested ones.
     */ dispatch((0, $2e81d63b6460b61d$export$8fe155db96cddace)({
            zIndex: zIndex
        }));
        return ()=>{
            dispatch((0, $2e81d63b6460b61d$export$230718bd38635ccb)({
                zIndex: zIndex
            }));
        };
    }, [
        dispatch,
        zIndex,
        shouldRenderInPortal
    ]);
    var portalElement = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $5f08f563d5a1ffa5$export$30b3c9504f8bc181)(state, zIndex, isPanorama));
    if (!shouldRenderInPortal) // If no zIndex is provided or zIndex is 0, render normally without portals
    return children;
    if (!portalElement) /*
     * If we don't have a portal element yet, this means that the registration
     * has not been processed yet by the ZIndexPortals component.
     * So here we render null and wait for the next render cycle.
     */ return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, portalElement);
}





function $d3c49d2682758394$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3c49d2682758394$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3c49d2682758394$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d3c49d2682758394$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3c49d2682758394$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d3c49d2682758394$var$_defineProperty(e, r, t) {
    return (r = $d3c49d2682758394$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d3c49d2682758394$var$_toPropertyKey(t) {
    var i = $d3c49d2682758394$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d3c49d2682758394$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d3c49d2682758394$export$524d3fb4d123c796 = (options)=>{
    var { viewBox: viewBox, position: position, offset: offset = 0, parentViewBox: parentViewBoxFromOptions, clamp: clamp } = options;
    var { x: x, y: y, height: height, upperWidth: upperWidth, lowerWidth: lowerWidth } = (0, $e573f10901a87cfb$export$94a03fc5d61f2504)(viewBox);
    // Funnel.tsx provides a viewBox where `x` is the top-left of the trapezoid shape.
    var upperX = x;
    // The trapezoid is centered, so we can calculate the other corners from the top-left.
    var lowerX = x + (upperWidth - lowerWidth) / 2;
    // middleX is the x-coordinate of the left edge at the vertical midpoint of the trapezoid.
    var middleX = (upperX + lowerX) / 2;
    // The width of the trapezoid at its vertical midpoint.
    var midHeightWidth = (upperWidth + lowerWidth) / 2;
    // The center x-coordinate is constant for the entire height of the trapezoid.
    var centerX = upperX + upperWidth / 2;
    // Define vertical offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative height.
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative width.
    var horizontalSign = upperWidth >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    // We assume parentViewBox is generic if provided.
    // The user has asserted that parentViewBox will be CartesianViewBoxRequired if present.
    var parentViewBox = parentViewBoxFromOptions;
    if (position === 'top') {
        var result = {
            x: upperX + upperWidth / 2,
            y: y - verticalOffset,
            horizontalAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        if (clamp && parentViewBox) {
            result.height = Math.max(y - parentViewBox.y, 0);
            result.width = upperWidth;
        }
        return result;
    }
    if (position === 'bottom') {
        var _result = {
            x: lowerX + lowerWidth / 2,
            y: y + height + verticalOffset,
            horizontalAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        if (clamp && parentViewBox) {
            _result.height = Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0);
            _result.width = lowerWidth;
        }
        return _result;
    }
    if (position === 'left') {
        var _result2 = {
            x: middleX - horizontalOffset,
            y: y + height / 2,
            horizontalAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        if (clamp && parentViewBox) {
            _result2.width = Math.max(_result2.x - parentViewBox.x, 0);
            _result2.height = height;
        }
        return _result2;
    }
    if (position === 'right') {
        var _result3 = {
            x: middleX + midHeightWidth + horizontalOffset,
            y: y + height / 2,
            horizontalAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        if (clamp && parentViewBox) {
            _result3.width = Math.max(parentViewBox.x + parentViewBox.width - _result3.x, 0);
            _result3.height = height;
        }
        return _result3;
    }
    var sizeAttrs = clamp && parentViewBox ? {
        width: midHeightWidth,
        height: height
    } : {};
    if (position === 'insideLeft') return $d3c49d2682758394$var$_objectSpread({
        x: middleX + horizontalOffset,
        y: y + height / 2,
        horizontalAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $d3c49d2682758394$var$_objectSpread({
        x: middleX + midHeightWidth - horizontalOffset,
        y: y + height / 2,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $d3c49d2682758394$var$_objectSpread({
        x: upperX + upperWidth / 2,
        y: y + verticalOffset,
        horizontalAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $d3c49d2682758394$var$_objectSpread({
        x: lowerX + lowerWidth / 2,
        y: y + height - verticalOffset,
        horizontalAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $d3c49d2682758394$var$_objectSpread({
        x: upperX + horizontalOffset,
        y: y + verticalOffset,
        horizontalAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $d3c49d2682758394$var$_objectSpread({
        x: upperX + upperWidth - horizontalOffset,
        y: y + verticalOffset,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $d3c49d2682758394$var$_objectSpread({
        x: lowerX + horizontalOffset,
        y: y + height - verticalOffset,
        horizontalAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $d3c49d2682758394$var$_objectSpread({
        x: lowerX + lowerWidth - horizontalOffset,
        y: y + height - verticalOffset,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (!!position && typeof position === 'object' && ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position.x) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(position.x)) && ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position.y) || (0, $2ab3a7e25c8aba74$export$e50269385c77c348)(position.y))) // TODO: This is not quite right. The width of the trapezoid changes with y.
    // A percentage-based x should be relative to the width at that y.
    // For now, we use the mid-height width as a reasonable approximation.
    return $d3c49d2682758394$var$_objectSpread({
        x: x + (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(position.x, midHeightWidth),
        y: y + (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(position.y, height),
        horizontalAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $d3c49d2682758394$var$_objectSpread({
        x: centerX,
        y: y + height / 2,
        horizontalAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};


var $77be8884b5ec622c$var$_excluded = [
    "labelRef"
], $77be8884b5ec622c$var$_excluded2 = [
    "content"
];
function $77be8884b5ec622c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $77be8884b5ec622c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77be8884b5ec622c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77be8884b5ec622c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77be8884b5ec622c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77be8884b5ec622c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77be8884b5ec622c$var$_defineProperty(e, r, t) {
    return (r = $77be8884b5ec622c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $77be8884b5ec622c$var$_toPropertyKey(t) {
    var i = $77be8884b5ec622c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $77be8884b5ec622c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $77be8884b5ec622c$var$_extends() {
    return $77be8884b5ec622c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $77be8884b5ec622c$var$_extends.apply(null, arguments);
}
/**
 * @inline
 */ /**
 * @inline
 */ /**
 * @inline
 */ var $77be8884b5ec622c$var$CartesianLabelContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $77be8884b5ec622c$export$3b4df77eaec10b03 = (_ref)=>{
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, width: width, height: height, children: children } = _ref;
    var viewBox = (0, $acw62.useMemo)(()=>({
            x: x,
            y: y,
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            width: width,
            height: height
        }), [
        x,
        y,
        upperWidth,
        lowerWidth,
        width,
        height
    ]);
    return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$var$CartesianLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $77be8884b5ec622c$var$useCartesianLabelContext = ()=>{
    var labelChildContext = (0, $acw62.useContext)($77be8884b5ec622c$var$CartesianLabelContext);
    var chartContext = (0, $e573f10901a87cfb$export$76b29bb074e0c45a)();
    return labelChildContext || (chartContext ? (0, $e573f10901a87cfb$export$94a03fc5d61f2504)(chartContext) : undefined);
};
var $77be8884b5ec622c$var$PolarLabelContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $77be8884b5ec622c$export$cd0d7ffccbd95e6d = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise, children: children } = _ref2;
    var viewBox = (0, $acw62.useMemo)(()=>({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            clockWise: clockWise
        }), [
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        clockWise
    ]);
    return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$var$PolarLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $77be8884b5ec622c$export$6f334acae8be4776 = ()=>{
    var labelChildContext = (0, $acw62.useContext)($77be8884b5ec622c$var$PolarLabelContext);
    var chartContext = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $53bcbd5d17089da8$export$57f4101c1e20bd95));
    return labelChildContext || chartContext;
};
var $77be8884b5ec622c$var$getLabel = (props)=>{
    var { value: value, formatter: formatter } = props;
    var label = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(props.children) ? value : props.children;
    if (typeof formatter === 'function') return formatter(label);
    return label;
};
var $77be8884b5ec622c$export$96a48941c06f377f = (content)=>{
    return content != null && typeof content === 'function';
};
var $77be8884b5ec622c$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $77be8884b5ec622c$var$renderRadialLabel = (labelProps, position, label, attrs, viewBox)=>{
    var { offset: offset, className: className } = labelProps;
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise } = viewBox;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $77be8884b5ec622c$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    switch(position){
        case 'insideStart':
            labelAngle = startAngle + sign * offset;
            direction = clockWise;
            break;
        case 'insideEnd':
            labelAngle = endAngle - sign * offset;
            direction = !clockWise;
            break;
        case 'end':
            labelAngle = endAngle + sign * offset;
            direction = clockWise;
            break;
        default:
            throw new Error("Unsupported position ".concat(position));
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(labelProps.id) ? (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ $acw62.createElement("text", $77be8884b5ec622c$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ $acw62.createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $77be8884b5ec622c$var$getAttrsOfPolarLabel = (viewBox, offset, position)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = viewBox;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var { x: _x, y: _y } = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle);
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var { x: x, y: y } = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, r, midAngle);
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $77be8884b5ec622c$var$isPolar = (viewBox)=>viewBox != null && 'cx' in viewBox && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(viewBox.cx);
var $77be8884b5ec622c$export$b1c389a57ef19225 = {
    angle: 0,
    offset: 5,
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).label,
    position: 'middle',
    textBreakAll: false
};
function $77be8884b5ec622c$var$polarViewBoxToTrapezoid(viewBox) {
    if (!$77be8884b5ec622c$var$isPolar(viewBox)) return viewBox;
    var { cx: cx, cy: cy, outerRadius: outerRadius } = viewBox;
    var diameter = outerRadius * 2;
    return {
        x: cx - outerRadius,
        y: cy - outerRadius,
        width: diameter,
        upperWidth: diameter,
        lowerWidth: diameter,
        height: diameter
    };
}
function $77be8884b5ec622c$export$b04be29aa201d4f5(outerProps) {
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outerProps, $77be8884b5ec622c$export$b1c389a57ef19225);
    var { viewBox: viewBoxFromProps, parentViewBox: parentViewBox, position: position, value: value, children: children, content: content, className: className = '', textBreakAll: textBreakAll, labelRef: labelRef } = props;
    var polarViewBox = $77be8884b5ec622c$export$6f334acae8be4776();
    var cartesianViewBox = $77be8884b5ec622c$var$useCartesianLabelContext();
    /*
   * I am not proud about this solution, but it's a quick fix for https://github.com/recharts/recharts/issues/6030#issuecomment-3155352460.
   * What we should really do is split Label into two components: CartesianLabel and PolarLabel and then handle their respective viewBoxes separately.
   * Also other components should set its own viewBox in a context so that we can fix https://github.com/recharts/recharts/issues/6156
   */ var resolvedViewBox = position === 'center' ? cartesianViewBox : polarViewBox !== null && polarViewBox !== void 0 ? polarViewBox : cartesianViewBox;
    var viewBox, label, positionAttrs;
    if (viewBoxFromProps == null) viewBox = resolvedViewBox;
    else if ($77be8884b5ec622c$var$isPolar(viewBoxFromProps)) viewBox = viewBoxFromProps;
    else viewBox = (0, $e573f10901a87cfb$export$94a03fc5d61f2504)(viewBoxFromProps);
    var cartesianBox = $77be8884b5ec622c$var$polarViewBoxToTrapezoid(viewBox);
    if (!viewBox || (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(value) && (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(children) && !/*#__PURE__*/ (0, $acw62.isValidElement)(content) && typeof content !== 'function') return null;
    var propsWithViewBox = $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, props), {}, {
        viewBox: viewBox
    });
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(content)) {
        var { labelRef: _ } = propsWithViewBox, propsWithoutLabelRef = $77be8884b5ec622c$var$_objectWithoutProperties(propsWithViewBox, $77be8884b5ec622c$var$_excluded);
        return /*#__PURE__*/ (0, $acw62.cloneElement)(content, propsWithoutLabelRef);
    }
    if (typeof content === 'function') {
        var { content: _2 } = propsWithViewBox, propsForContent = $77be8884b5ec622c$var$_objectWithoutProperties(propsWithViewBox, $77be8884b5ec622c$var$_excluded2);
        // @ts-expect-error we're not checking if the content component returns something that Text is able to render
        label = /*#__PURE__*/ (0, $acw62.createElement)(content, propsForContent);
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) return label;
    } else label = $77be8884b5ec622c$var$getLabel(props);
    var attrs = (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(props);
    if ($77be8884b5ec622c$var$isPolar(viewBox)) {
        // TODO: Generic Polar Hook
        if (position === 'insideStart' || position === 'insideEnd' || position === 'end') return $77be8884b5ec622c$var$renderRadialLabel(props, position, label, attrs, viewBox);
        positionAttrs = $77be8884b5ec622c$var$getAttrsOfPolarLabel(viewBox, props.offset, props.position);
    } else {
        if (!cartesianBox) return null;
        var cartesianResult = (0, $d3c49d2682758394$export$524d3fb4d123c796)({
            viewBox: cartesianBox,
            position: position,
            offset: props.offset,
            parentViewBox: $77be8884b5ec622c$var$isPolar(parentViewBox) ? undefined : parentViewBox,
            clamp: true
        });
        positionAttrs = $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({
            x: cartesianResult.x,
            y: cartesianResult.y,
            textAnchor: cartesianResult.horizontalAnchor,
            verticalAnchor: cartesianResult.verticalAnchor
        }, cartesianResult.width !== undefined ? {
            width: cartesianResult.width
        } : {}), cartesianResult.height !== undefined ? {
            height: cartesianResult.height
        } : {});
    }
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $77be8884b5ec622c$var$_extends({
        ref: labelRef,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-label', className)
    }, attrs, positionAttrs, {
        /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */ textAnchor: (0, $964be52cc11879b4$export$ae5e6c08954aa63c)(attrs.textAnchor) ? attrs.textAnchor : positionAttrs.textAnchor,
        breakAll: textBreakAll
    }), label));
}
$77be8884b5ec622c$export$b04be29aa201d4f5.displayName = 'Label';
var $77be8884b5ec622c$var$parseLabel = (label, viewBox, labelRef)=>{
    if (!label) return null;
    var commonProps = {
        viewBox: viewBox,
        labelRef: labelRef
    };
    if (label === true) return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        key: "label-implicit"
    }, commonProps));
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(label)) return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        key: "label-implicit",
        value: label
    }, commonProps));
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) {
        if (label.type === $77be8884b5ec622c$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $acw62.cloneElement)(label, $77be8884b5ec622c$var$_objectSpread({
            key: 'label-implicit'
        }, commonProps));
        return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
            key: "label-implicit",
            content: label
        }, commonProps));
    }
    if ($77be8884b5ec622c$export$96a48941c06f377f(label)) return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        key: "label-implicit",
        content: label
    }, commonProps));
    if (label && typeof label === 'object') return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({}, label, {
        key: "label-implicit"
    }, commonProps));
    return null;
};
function $77be8884b5ec622c$export$3c82c3a3704539d8(_ref3) {
    var { label: label, labelRef: labelRef } = _ref3;
    var viewBox = $77be8884b5ec622c$var$useCartesianLabelContext();
    return $77be8884b5ec622c$var$parseLabel(label, viewBox, labelRef) || null;
}
function $77be8884b5ec622c$export$24b42d9a68417c83(_ref4) {
    var { label: label } = _ref4;
    var viewBox = $77be8884b5ec622c$export$6f334acae8be4776();
    return $77be8884b5ec622c$var$parseLabel(label, viewBox) || null;
}








var $88ab0dba0fc78576$var$_excluded = [
    "valueAccessor"
], $88ab0dba0fc78576$var$_excluded2 = [
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll",
    "zIndex"
];
function $88ab0dba0fc78576$var$_extends() {
    return $88ab0dba0fc78576$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $88ab0dba0fc78576$var$_extends.apply(null, arguments);
}
function $88ab0dba0fc78576$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * This is public API because we expose it as the valueAccessor parameter.
 *
 * The properties of "viewBox" are repeated as the root props of the entry object.
 * So it doesn't matter if you read entry.x or entry.viewBox.x, they are the same.
 *
 * It's not necessary to pass redundant data, but we keep it for backward compatibility.
 */ /**
 * LabelList props do not allow refs because the same props are reused in multiple elements so we don't have a good single place to ref to.
 */ /**
 * This is the type accepted for the `label` prop on various graphical items.
 * It accepts:
 *
 * boolean:
 *    true = labels show,
 *    false = labels don't show
 * React element:
 *    will be cloned with extra props
 * function:
 *    is used as <Label content={function} />, so this will be called once for each individual label (so typically once for each data point)
 * object:
 *    the props to be passed to a LabelList component
 *
 * @inline
 */ var $88ab0dba0fc78576$var$defaultAccessor = (entry)=>Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($43142099cd566622$exports)))(entry.value) : entry.value;
var $88ab0dba0fc78576$var$CartesianLabelListContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $88ab0dba0fc78576$export$64e384eac5db53f7 = $88ab0dba0fc78576$var$CartesianLabelListContext.Provider;
var $88ab0dba0fc78576$var$PolarLabelListContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $88ab0dba0fc78576$export$38a852d7976af0fe = $88ab0dba0fc78576$var$PolarLabelListContext.Provider;
function $88ab0dba0fc78576$var$useCartesianLabelListContext() {
    return (0, $acw62.useContext)($88ab0dba0fc78576$var$CartesianLabelListContext);
}
function $88ab0dba0fc78576$var$usePolarLabelListContext() {
    return (0, $acw62.useContext)($88ab0dba0fc78576$var$PolarLabelListContext);
}
function $88ab0dba0fc78576$export$835fcf23ab7bf88(_ref) {
    var { valueAccessor: valueAccessor = $88ab0dba0fc78576$var$defaultAccessor } = _ref, restProps = $88ab0dba0fc78576$var$_objectWithoutProperties(_ref, $88ab0dba0fc78576$var$_excluded);
    var { dataKey: dataKey, clockWise: clockWise, id: id, textBreakAll: textBreakAll, zIndex: zIndex } = restProps, others = $88ab0dba0fc78576$var$_objectWithoutProperties(restProps, $88ab0dba0fc78576$var$_excluded2);
    var cartesianData = $88ab0dba0fc78576$var$useCartesianLabelListContext();
    var polarData = $88ab0dba0fc78576$var$usePolarLabelListContext();
    var data = cartesianData || polarData;
    if (!data || !data.length) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : (0, $c327287477e919da$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map((entry, index)=>{
        var _restProps$fill;
        var value = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(dataKey) ? valueAccessor(entry, index) : (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry.payload, dataKey);
        var idProps = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ $acw62.createElement((0, $77be8884b5ec622c$export$b04be29aa201d4f5), $88ab0dba0fc78576$var$_extends({
            key: "label-".concat(index)
        }, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(entry), others, idProps, {
            /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */ fill: (_restProps$fill = restProps.fill) !== null && _restProps$fill !== void 0 ? _restProps$fill : entry.fill,
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: entry.viewBox,
            index: index,
            zIndex: 0
        }));
    })));
}
$88ab0dba0fc78576$export$835fcf23ab7bf88.displayName = 'LabelList';
function $88ab0dba0fc78576$export$9a402bc8de2b410e(_ref2) {
    var { label: label } = _ref2;
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ $acw62.createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit"
    });
    if (/*#__PURE__*/ $acw62.isValidElement(label) || (0, $77be8884b5ec622c$export$96a48941c06f377f)(label)) return /*#__PURE__*/ $acw62.createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        content: label
    });
    if (typeof label === 'object') return /*#__PURE__*/ $acw62.createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, $88ab0dba0fc78576$var$_extends({
        key: "labelList-implicit"
    }, label, {
        type: String(label.type)
    }));
    return null;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




function $1ab98349969d46e2$var$_extends() {
    return $1ab98349969d46e2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1ab98349969d46e2$var$_extends.apply(null, arguments);
}
var $1ab98349969d46e2$export$d046b3c4a416f60d = (props)=>{
    var { cx: cx, cy: cy, r: r, className: className } = props;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-dot', className);
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cx) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cy) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(r)) return /*#__PURE__*/ $acw62.createElement("circle", $1ab98349969d46e2$var$_extends({}, (0, $37a0b0a95f0e25bf$export$8b56257912140094)(props), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("8ZGCM"));



var $008f02516c156322$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $008f02516c156322$export$be63e0664592e141 = (Comp)=>{
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $008f02516c156322$var$lastChildren = null;
var $008f02516c156322$var$lastResult = null;
var $008f02516c156322$export$45b10814cc054894 = (children)=>{
    if (children === $008f02516c156322$var$lastChildren && Array.isArray($008f02516c156322$var$lastResult)) return $008f02516c156322$var$lastResult;
    var result = [];
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(child)) return;
        if ((0, $3251146683c5d714$exports.isFragment)(child)) result = result.concat($008f02516c156322$export$45b10814cc054894(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $008f02516c156322$var$lastResult = result;
    $008f02516c156322$var$lastChildren = children;
    return result;
};
function $008f02516c156322$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map((t)=>$008f02516c156322$export$be63e0664592e141(t));
    else types = [
        $008f02516c156322$export$be63e0664592e141(type)
    ];
    $008f02516c156322$export$45b10814cc054894(children).forEach((child)=>{
        // @ts-expect-error toArray and lodash.get are not compatible. Let's get rid of the whole findAllByType function
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($7bb38c04d3b378db$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($7bb38c04d3b378db$exports)))(child, 'type.name');
        if (childType && types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
var $008f02516c156322$export$28c0c718114c1a2e = (dot)=>{
    if (dot && typeof dot === 'object' && 'clipDot' in dot) return Boolean(dot.clipDot);
    return true;
};





var $6dcd61e97c26c79c$var$_excluded = [
    "points"
];
function $6dcd61e97c26c79c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6dcd61e97c26c79c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6dcd61e97c26c79c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6dcd61e97c26c79c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6dcd61e97c26c79c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6dcd61e97c26c79c$var$_defineProperty(e, r, t) {
    return (r = $6dcd61e97c26c79c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6dcd61e97c26c79c$var$_toPropertyKey(t) {
    var i = $6dcd61e97c26c79c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6dcd61e97c26c79c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6dcd61e97c26c79c$var$_extends() {
    return $6dcd61e97c26c79c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6dcd61e97c26c79c$var$_extends.apply(null, arguments);
}
function $6dcd61e97c26c79c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6dcd61e97c26c79c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $6dcd61e97c26c79c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $6dcd61e97c26c79c$var$DotItem(_ref) {
    var { option: option, dotProps: dotProps, className: className } = _ref;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) // @ts-expect-error we can't type check element cloning properly
    return /*#__PURE__*/ (0, $acw62.cloneElement)(option, dotProps);
    if (typeof option === 'function') return option(dotProps);
    var finalClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, typeof option !== 'boolean' ? option.className : '');
    var _ref2 = dotProps !== null && dotProps !== void 0 ? dotProps : {}, { points: points } = _ref2, props = $6dcd61e97c26c79c$var$_objectWithoutProperties(_ref2, $6dcd61e97c26c79c$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), $6dcd61e97c26c79c$var$_extends({}, props, {
        className: finalClassName
    }));
}
function $6dcd61e97c26c79c$var$shouldRenderDots(points, dot) {
    if (points == null) return false;
    if (dot) return true;
    return points.length === 1;
}
function $6dcd61e97c26c79c$export$8da50d3722682be0(_ref3) {
    var { points: points, dot: dot, className: className, dotClassName: dotClassName, dataKey: dataKey, baseProps: baseProps, needClip: needClip, clipPathId: clipPathId, zIndex: zIndex = (0, $c327287477e919da$export$96df16b28aa32702).scatter } = _ref3;
    if (!$6dcd61e97c26c79c$var$shouldRenderDots(points, dot)) return null;
    var clipDot = (0, $008f02516c156322$export$28c0c718114c1a2e)(dot);
    var customDotProps = (0, $fefe4263beb558e0$export$87ef3d7bc7cd0706)(dot);
    var dots = points.map((entry, i)=>{
        var _entry$x, _entry$y;
        var dotProps = $6dcd61e97c26c79c$var$_objectSpread($6dcd61e97c26c79c$var$_objectSpread($6dcd61e97c26c79c$var$_objectSpread({
            r: 3
        }, baseProps), customDotProps), {}, {
            index: i,
            cx: (_entry$x = entry.x) !== null && _entry$x !== void 0 ? _entry$x : undefined,
            cy: (_entry$y = entry.y) !== null && _entry$y !== void 0 ? _entry$y : undefined,
            dataKey: dataKey,
            value: entry.value,
            payload: entry.payload,
            points: points
        });
        return /*#__PURE__*/ $acw62.createElement($6dcd61e97c26c79c$var$DotItem, {
            key: "dot-".concat(i),
            option: dot,
            dotProps: dotProps,
            className: dotClassName
        });
    });
    var layerProps = {};
    if (needClip && clipPathId != null) layerProps.clipPath = "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")");
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: zIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $6dcd61e97c26c79c$var$_extends({
        className: className
    }, layerProps), dots));
}







var $acw62 = parcelRequire("acw62");






var $38ed130fff70c422$exports = {};

$38ed130fff70c422$exports = (parcelRequire("4DyUZ")).range;


var $d8f008d3b0c1a5c3$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$d8f008d3b0c1a5c3$exports = (parcelRequire("eTYpT"));





var $d235e165ed12974e$export$519edd692222520 = (state)=>state.chartData;
var $d235e165ed12974e$export$3b10e41b7db2c36 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $d235e165ed12974e$export$519edd692222520
], (dataState)=>{
    var dataEndIndex = dataState.chartData != null ? dataState.chartData.length - 1 : 0;
    return {
        chartData: dataState.chartData,
        computedData: dataState.computedData,
        dataEndIndex: dataEndIndex,
        dataStartIndex: 0
    };
});
var $d235e165ed12974e$export$fe05134c2701d897 = (state, _unused1, _unused2, isPanorama)=>{
    if (isPanorama) return $d235e165ed12974e$export$3b10e41b7db2c36(state);
    return $d235e165ed12974e$export$519edd692222520(state);
};
var $d235e165ed12974e$export$46bf9459876c0e0c = (state, _unused1, isPanorama)=>{
    if (isPanorama) return $d235e165ed12974e$export$3b10e41b7db2c36(state);
    return $d235e165ed12974e$export$519edd692222520(state);
};





function $77a63a99eb6fec8b$export$ba29b24e2a92eb58(v) {
    if (Array.isArray(v) && v.length === 2) {
        var [min, max] = v;
        if ((0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(min) && (0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(max)) return true;
    }
    return false;
}
function $77a63a99eb6fec8b$export$15a9d37c57dafeb9(providedDomain, boundaryDomain, allowDataOverflow) {
    if (allowDataOverflow) // If the data are allowed to overflow - we're fine with whatever user provided
    return providedDomain;
    /*
   * If the data are not allowed to overflow - we need to extend the domain.
   * Means that effectively the user is allowed to make the domain larger
   * but not smaller.
   */ return [
        Math.min(providedDomain[0], boundaryDomain[0]),
        Math.max(providedDomain[1], boundaryDomain[1])
    ];
}
function $77a63a99eb6fec8b$export$fcbf88d4627b24df(userDomain, allowDataOverflow) {
    if (!allowDataOverflow) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function') // The user function expects the data to be provided as an argument
    return undefined;
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if ((0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        if ((0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($77a63a99eb6fec8b$export$ba29b24e2a92eb58(candidate)) return candidate;
    }
    return undefined;
}
function $77a63a99eb6fec8b$export$3f87aa7a53437a70(userDomain, dataDomain, allowDataOverflow) {
    if (!allowDataOverflow && dataDomain == null) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function' && dataDomain != null) try {
        var result = userDomain(dataDomain, allowDataOverflow);
        if ($77a63a99eb6fec8b$export$ba29b24e2a92eb58(result)) return $77a63a99eb6fec8b$export$15a9d37c57dafeb9(result, dataDomain, allowDataOverflow);
    } catch (_unused) {
    /* ignore the exception and compute domain from data later */ }
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if (providedMin === 'auto') {
            if (dataDomain != null) finalMin = Math.min(...dataDomain);
        } else if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') try {
            if (dataDomain != null) finalMin = providedMin(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0]);
        } catch (_unused2) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMin === 'string' && (0, $cd015374923bb5c7$export$75a7b23ff266dfa1).test(providedMin)) {
            var match = (0, $cd015374923bb5c7$export$75a7b23ff266dfa1).exec(providedMin);
            if (match == null || match[1] == null || dataDomain == null) finalMin = undefined;
            else {
                var value = +match[1];
                finalMin = dataDomain[0] - value;
            }
        } else finalMin = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0];
        if (providedMax === 'auto') {
            if (dataDomain != null) finalMax = Math.max(...dataDomain);
        } else if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') try {
            if (dataDomain != null) finalMax = providedMax(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1]);
        } catch (_unused3) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMax === 'string' && (0, $cd015374923bb5c7$export$19c111ec8ad6c644).test(providedMax)) {
            var _match = (0, $cd015374923bb5c7$export$19c111ec8ad6c644).exec(providedMax);
            if (_match == null || _match[1] == null || dataDomain == null) finalMax = undefined;
            else {
                var _value = +_match[1];
                finalMax = dataDomain[1] + _value;
            }
        } else finalMax = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1];
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($77a63a99eb6fec8b$export$ba29b24e2a92eb58(candidate)) {
            if (dataDomain == null) return candidate;
            return $77a63a99eb6fec8b$export$15a9d37c57dafeb9(candidate, dataDomain, allowDataOverflow);
        }
    }
    return undefined;
}




/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var $150bb5f05cbd0a1e$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($150bb5f05cbd0a1e$exports) $150bb5f05cbd0a1e$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($150bb5f05cbd0a1e$exports);


/**
 * @fileOverview Some common arithmetic methods
 * @author xile611
 * @date 2015-09-17
 */ 
/**
 * Get the digit count of a number.
 * If the absolute value is in the interval [0.1, 1), the result is 0.
 * If the absolute value is in the interval [0.01, 0.1), the digit count is -1.
 * If the absolute value is in the interval [0.001, 0.01), the digit count is -2.
 *
 * @param  {Number} value The number
 * @return {Integer}      Digit count
 */ function $9ab95d9069174a61$export$c21fa0a8c666ce01(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * Get the data in the interval [start, end) with a fixed step.
 * Also handles JS calculation precision issues.
 *
 * @param  {Decimal} start Start point
 * @param  {Decimal} end   End point, not included
 * @param  {Decimal} step  Step size
 * @return {Array}         Array of numbers
 */ function $9ab95d9069174a61$export$85207d4610782ccb(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(start);
    var i = 0;
    var result = [];
    // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}


var $7355e2f233c5e6b9$export$9fcf9e98b0fc6c13 = (_ref)=>{
    var [min, max] = _ref;
    var [validMin, validMax] = [
        min,
        max
    ];
    // exchange
    if (min > max) [validMin, validMax] = [
        max,
        min
    ];
    return [
        validMin,
        validMax
    ];
};
var $7355e2f233c5e6b9$export$bda2c289544cdcde = (roughStep, allowDecimals, correctionFactor)=>{
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0);
    var digitCount = (0, $9ab95d9069174a61$export$c21fa0a8c666ce01)(roughStep.toNumber());
    // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue);
    // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(formatStep.toNumber()) : new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.ceil(formatStep.toNumber()));
};
var $7355e2f233c5e6b9$export$8913aec4ff751b4d = (value, tickCount, allowDecimals)=>{
    var step = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(1);
    // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(10).pow((0, $9ab95d9069174a61$export$c21fa0a8c666ce01)(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var ticks = [];
    for(var i = 0; i < tickCount; i++)ticks.push(middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(i - middleIndex).mul(step)).toNumber());
    return ticks;
};
/**
 * Calculate the step
 *
 * @param  min              The minimum value of an interval
 * @param  max              The maximum value of an interval
 * @param  tickCount        The count of ticks
 * @param  allowDecimals    Allow the ticks to be decimals or not
 * @param  correctionFactor A correction factor
 * @return The step, minimum value of ticks, maximum value of ticks
 */ var $7355e2f233c5e6b9$export$ca78fcd978995194 = function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0)
    };
    // The step which is easy to understand between two ticks
    var step = $7355e2f233c5e6b9$export$bda2c289544cdcde(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor);
    // A medial value of ticks
    var middle;
    // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(min).add(max).div(2);
        // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $7355e2f233c5e6b9$export$ca78fcd978995194(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(upCount).mul(step))
    };
};
var $7355e2f233c5e6b9$export$b84e75ccbfe6a612 = function getNiceTickValues(_ref2) {
    var [min, max] = _ref2;
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var [cormin, cormax] = $7355e2f233c5e6b9$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin,
            ...Array(tickCount - 1).fill(Infinity)
        ] : [
            ...Array(tickCount - 1).fill(-Infinity),
            cormax
        ];
        return min > max ? _values.reverse() : _values;
    }
    if (cormin === cormax) return $7355e2f233c5e6b9$export$8913aec4ff751b4d(cormin, tickCount, allowDecimals);
    // Get the step between two ticks
    var { step: step, tickMin: tickMin, tickMax: tickMax } = $7355e2f233c5e6b9$export$ca78fcd978995194(cormin, cormax, count, allowDecimals, 0);
    var values = (0, $9ab95d9069174a61$export$85207d4610782ccb)(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(0.1).mul(step)), step);
    return min > max ? values.reverse() : values;
};
var $7355e2f233c5e6b9$export$e9d28da780436e98 = function getTickValuesFixedDomain(_ref3, tickCount) {
    var [min, max] = _ref3;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var [cormin, cormax] = $7355e2f233c5e6b9$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $7355e2f233c5e6b9$export$bda2c289544cdcde(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [
        ...(0, $9ab95d9069174a61$export$85207d4610782ccb)(new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($150bb5f05cbd0a1e$exports)))(cormax), step),
        cormax
    ];
    if (allowDecimals === false) /*
     * allowDecimals is false means that we want to have integer ticks.
     * The step is guaranteed to be an integer in the code above which is great start
     * but when the first step is not an integer, it will start stepping from a decimal value anyway.
     * So we need to round all the values to integers after the fact.
     */ values = values.map((value)=>Math.round(value));
    return min > max ? values.reverse() : values;
};






var $dcfc24e85ad2aefd$export$db43f3089e0ec1e9 = (state)=>state.rootProps.maxBarSize;
var $dcfc24e85ad2aefd$export$9b8e3d53e72fb7a8 = (state)=>state.rootProps.barGap;
var $dcfc24e85ad2aefd$export$a73f9d39b015942a = (state)=>state.rootProps.barCategoryGap;
var $dcfc24e85ad2aefd$export$be00206a4a82272f = (state)=>state.rootProps.barSize;
var $dcfc24e85ad2aefd$export$73aff39176364def = (state)=>state.rootProps.stackOffset;
var $dcfc24e85ad2aefd$export$ec830dc49707c6da = (state)=>state.rootProps.reverseStackOrder;
var $dcfc24e85ad2aefd$export$3247769c9dbde559 = (state)=>state.options.chartName;
var $dcfc24e85ad2aefd$export$d3b88e5c88540018 = (state)=>state.rootProps.syncId;
var $dcfc24e85ad2aefd$export$f3cbf53653105e96 = (state)=>state.rootProps.syncMethod;
var $dcfc24e85ad2aefd$export$b89defd58e84e980 = (state)=>state.options.eventEmitter;
var $dcfc24e85ad2aefd$export$a1ad1f48be8d5def = (state)=>state.rootProps.baseValue;



var $b940f2b84cdec1f7$export$8a7d579879340d98 = (_state, axisType)=>axisType;


var $680eada126f0aa15$export$6a2efa106dc9c8f6 = (_state, _axisType, axisId)=>axisId;




/**
 * Returns identifier for stack series which is one individual graphical item in the stack.
 * @param graphicalItem - The graphical item representing the series in the stack.
 * @return The identifier for the series in the stack
 */ function $c86621286e2c8ba6$export$58b095b87bc46727(graphicalItem) {
    return graphicalItem === null || graphicalItem === void 0 ? void 0 : graphicalItem.id;
}




function $3bf52c7ae65ae57f$export$ae6c77e7720cddf9(stackedGraphicalItems, _ref, tooltipAxisSettings) {
    var { chartData: chartData = [] } = _ref;
    var { allowDuplicatedCategory: allowDuplicatedCategory, dataKey: tooltipDataKey } = tooltipAxisSettings;
    // A map of tooltip data keys to the stacked data points
    var knownItemsByDataKey = new Map();
    stackedGraphicalItems.forEach((item)=>{
        var _item$data;
        // If there is no data on the individual item then we use the root chart data
        var resolvedData = (_item$data = item.data) !== null && _item$data !== void 0 ? _item$data : chartData;
        if (resolvedData == null || resolvedData.length === 0) // if that doesn't work then we skip this item
        return;
        var stackIdentifier = (0, $c86621286e2c8ba6$export$58b095b87bc46727)(item);
        resolvedData.forEach((entry, index)=>{
            var tooltipValue = tooltipDataKey == null || allowDuplicatedCategory ? index : String((0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, tooltipDataKey, null));
            var numericValue = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, item.dataKey, 0);
            var curr;
            if (knownItemsByDataKey.has(tooltipValue)) curr = knownItemsByDataKey.get(tooltipValue);
            else curr = {};
            Object.assign(curr, {
                [stackIdentifier]: numericValue
            });
            knownItemsByDataKey.set(tooltipValue, curr);
        });
    });
    return Array.from(knownItemsByDataKey.values());
}


/**
 * Some graphical items allow data stacking. The stacks are optional,
 * so all props here are optional too.
 */ /**
 * Some graphical items allow data stacking.
 * This interface is used to represent the items that are stacked
 * because the user has provided the stackId and dataKey properties.
 */ function $6bd3f90b40714619$export$2335dd91cc88053e(graphicalItem) {
    return 'stackId' in graphicalItem && graphicalItem.stackId != null && graphicalItem.dataKey != null;
}


var $192fdd139bcf9f78$export$45c01007b107f1a6 = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null) return false;
    return a[0] === b[0] && a[1] === b[1];
};




var $37e5cc0fa883575c$export$898d3dfd98fb482 = (state)=>{
    var layout = (0, $e573f10901a87cfb$export$8426b6d9af801dee)(state);
    if (layout === 'horizontal') return 'xAxis';
    if (layout === 'vertical') return 'yAxis';
    if (layout === 'centric') return 'angleAxis';
    return 'radiusAxis';
};


var $c92d1f706423a70a$export$eeffdb10daff095d = (state)=>state.tooltip.settings.axisId;




/**
 * This is internal representation of scale used in Recharts.
 * Users will provide CustomScaleDefinition or a string, which we will parse into RechartsScale.
 * Most importantly, RechartsScale is fully immutable - there are no setters that mutate the scale in place.
 * This is important for React integration - if the scale changes, we want to trigger re-renders.
 * Mutating the scale in place would not trigger re-renders, leading to stale UI.
 */ /**
 * Position within a band for banded scales.
 * In scales that are not banded, this parameter is ignored.
 *
 * @inline
 */ function $aa187d4cf30aa84e$var$getD3ScaleFromType(realScaleType) {
    if (realScaleType in $d8f008d3b0c1a5c3$exports) // @ts-expect-error we should do better type verification here
    return $d8f008d3b0c1a5c3$exports[realScaleType]();
    var name = "scale".concat((0, $2ab3a7e25c8aba74$export$3061f22cd819074d)(realScaleType));
    if (name in $d8f008d3b0c1a5c3$exports) // @ts-expect-error we should do better type verification here
    return $d8f008d3b0c1a5c3$exports[name]();
    return undefined;
}
function $aa187d4cf30aa84e$export$b562996c2b716fff(d3Scale) {
    var ticksFn = d3Scale.ticks;
    var bandwidthFn = d3Scale.bandwidth;
    var d3Range = d3Scale.range();
    var range = [
        Math.min(...d3Range),
        Math.max(...d3Range)
    ];
    return {
        domain: ()=>d3Scale.domain(),
        range: function(_range) {
            function range() {
                return _range.apply(this, arguments);
            }
            range.toString = function() {
                return _range.toString();
            };
            return range;
        }(()=>range),
        rangeMin: ()=>range[0],
        rangeMax: ()=>range[1],
        isInRange (value) {
            var first = range[0];
            var last = range[1];
            return first <= last ? value >= first && value <= last : value >= last && value <= first;
        },
        bandwidth: bandwidthFn ? ()=>bandwidthFn.call(d3Scale) : undefined,
        ticks: ticksFn ? (count)=>ticksFn.call(d3Scale, count) : undefined,
        map: (input, options)=>{
            var baseValue = d3Scale(input);
            if (baseValue == null) return undefined;
            if (d3Scale.bandwidth && options !== null && options !== void 0 && options.position) {
                var bandWidth = d3Scale.bandwidth();
                switch(options.position){
                    case 'middle':
                        baseValue += bandWidth / 2;
                        break;
                    case 'end':
                        baseValue += bandWidth;
                        break;
                    default:
                        break;
                }
            }
            return baseValue;
        }
    };
}
function $aa187d4cf30aa84e$export$5501a52df751e5ca(scale, axisDomain, axisRange) {
    if (typeof scale === 'function') return $aa187d4cf30aa84e$export$b562996c2b716fff(scale.copy().domain(axisDomain).range(axisRange));
    if (scale == null) return undefined;
    var d3ScaleFunction = $aa187d4cf30aa84e$var$getD3ScaleFromType(scale);
    if (d3ScaleFunction == null) return undefined;
    d3ScaleFunction.domain(axisDomain).range(axisRange);
    return $aa187d4cf30aa84e$export$b562996c2b716fff(d3ScaleFunction);
}




var $6c21bf4d095d2d4f$export$cd6ce636c480934e = (realScaleType, axisDomain)=>{
    if (axisDomain == null) return undefined;
    switch(realScaleType){
        case 'linear':
            /*
         * linear scale only reads the first two numbers in the domain, and ignores everything else.
         * So if it happens that someone somehow gave us a bigger domain,
         * let's pick the min and max from it.
         */ if (!(0, $77a63a99eb6fec8b$export$ba29b24e2a92eb58)(axisDomain)) {
                var min, max;
                for(var i = 0; i < axisDomain.length; i++){
                    var value = axisDomain[i];
                    if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(value)) continue;
                    if (min === undefined || value < min) min = value;
                    if (max === undefined || value > max) max = value;
                }
                if (min !== undefined && max !== undefined) return [
                    min,
                    max
                ];
                return undefined;
            }
            return axisDomain;
        default:
            return axisDomain;
    }
};


function $6aac8fe27ae10a7b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6aac8fe27ae10a7b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6aac8fe27ae10a7b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6aac8fe27ae10a7b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6aac8fe27ae10a7b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6aac8fe27ae10a7b$var$_defineProperty(e, r, t) {
    return (r = $6aac8fe27ae10a7b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6aac8fe27ae10a7b$var$_toPropertyKey(t) {
    var i = $6aac8fe27ae10a7b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6aac8fe27ae10a7b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6aac8fe27ae10a7b$export$a012a4dce80491c2 = [
    0,
    'auto'
];
var $6aac8fe27ae10a7b$export$21aec091b6ac8422 = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: undefined,
    height: 30,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'bottom',
    padding: {
        left: 0,
        right: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'category',
    unit: undefined
};
var $6aac8fe27ae10a7b$export$8079b33b4a6a2ac5 = (state, axisId)=>{
    return state.cartesianAxis.xAxis[axisId];
};
var $6aac8fe27ae10a7b$export$d6895d8ddb4cee5 = (state, axisId)=>{
    var axis = $6aac8fe27ae10a7b$export$8079b33b4a6a2ac5(state, axisId);
    if (axis == null) return $6aac8fe27ae10a7b$export$21aec091b6ac8422;
    return axis;
};
var $6aac8fe27ae10a7b$export$397148de2ecdec3c = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: $6aac8fe27ae10a7b$export$a012a4dce80491c2,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'left',
    padding: {
        top: 0,
        bottom: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined,
    width: (0, $f6fce23ac63eec53$export$fb6ee82c8ee2faf8)
};
var $6aac8fe27ae10a7b$export$d0970661da76c14c = (state, axisId)=>{
    return state.cartesianAxis.yAxis[axisId];
};
var $6aac8fe27ae10a7b$export$1f472705a332f1c9 = (state, axisId)=>{
    var axis = $6aac8fe27ae10a7b$export$d0970661da76c14c(state, axisId);
    if (axis == null) return $6aac8fe27ae10a7b$export$397148de2ecdec3c;
    return axis;
};
var $6aac8fe27ae10a7b$export$73a439a535d82503 = {
    domain: [
        0,
        'auto'
    ],
    includeHidden: false,
    reversed: false,
    allowDataOverflow: false,
    allowDuplicatedCategory: false,
    dataKey: undefined,
    id: 0,
    name: '',
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number',
    unit: ''
};
var $6aac8fe27ae10a7b$export$26eadf639b453d0f = (state, axisId)=>{
    var axis = state.cartesianAxis.zAxis[axisId];
    if (axis == null) return $6aac8fe27ae10a7b$export$73a439a535d82503;
    return axis;
};
var $6aac8fe27ae10a7b$export$fc14c3706e09c50c = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
        case 'zAxis':
            return $6aac8fe27ae10a7b$export$26eadf639b453d0f(state, axisId);
        case 'angleAxis':
            return (0, $53bcbd5d17089da8$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $53bcbd5d17089da8$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $6aac8fe27ae10a7b$var$selectCartesianAxisSettings = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $6aac8fe27ae10a7b$export$f5176fa96b596697 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
        case 'angleAxis':
            return (0, $53bcbd5d17089da8$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $53bcbd5d17089da8$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $6aac8fe27ae10a7b$export$1c7798b82c8010cd = (state)=>state.graphicalItems.cartesianItems.some((item)=>item.type === 'bar') || state.graphicalItems.polarItems.some((item)=>item.type === 'radialBar');
function $6aac8fe27ae10a7b$export$a3923f321c6572c3(axisType, axisId) {
    return (item)=>{
        switch(axisType){
            case 'xAxis':
                // This is sensitive to the data type, as 0 !== '0'. I wonder if we should be more flexible. How does 2.x branch behave? TODO write test for that
                return 'xAxisId' in item && item.xAxisId === axisId;
            case 'yAxis':
                return 'yAxisId' in item && item.yAxisId === axisId;
            case 'zAxis':
                return 'zAxisId' in item && item.zAxisId === axisId;
            case 'angleAxis':
                return 'angleAxisId' in item && item.angleAxisId === axisId;
            case 'radiusAxis':
                return 'radiusAxisId' in item && item.radiusAxisId === axisId;
            default:
                return false;
        }
    };
}
var $6aac8fe27ae10a7b$export$f67c737adf41a3af = (state)=>state.graphicalItems.cartesianItems;
var $6aac8fe27ae10a7b$var$selectAxisPredicate = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98),
    (0, $680eada126f0aa15$export$6a2efa106dc9c8f6)
], $6aac8fe27ae10a7b$export$a3923f321c6572c3);
var $6aac8fe27ae10a7b$export$ad35679ce4582010 = (graphicalItems, axisSettings, axisPredicate)=>graphicalItems.filter(axisPredicate).filter((item)=>{
        if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.includeHidden) === true) return true;
        return !item.hide;
    });
var $6aac8fe27ae10a7b$export$533d13f911334c9d = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$f67c737adf41a3af,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$var$selectAxisPredicate
], $6aac8fe27ae10a7b$export$ad35679ce4582010, {
    memoizeOptions: {
        resultEqualityCheck: (0, $0499b9ab63ed35d4$export$dcc34c4213e7f4c)
    }
});
var $6aac8fe27ae10a7b$export$58ad06f71246a0da = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], (cartesianItems)=>{
    return cartesianItems.filter((item)=>item.type === 'area' || item.type === 'bar').filter((0, $6bd3f90b40714619$export$2335dd91cc88053e));
});
var $6aac8fe27ae10a7b$export$a61da86823382adc = (cartesianItems)=>cartesianItems.filter((item)=>!('stackId' in item) || item.stackId === undefined);
var $6aac8fe27ae10a7b$var$selectCartesianItemsSettingsExceptStacked = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], $6aac8fe27ae10a7b$export$a61da86823382adc);
var $6aac8fe27ae10a7b$export$d945cee965d266f0 = (cartesianItems)=>cartesianItems.map((item)=>item.data).filter(Boolean).flat(1);
var $6aac8fe27ae10a7b$export$f2151bebfd9ae457 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], $6aac8fe27ae10a7b$export$d945cee965d266f0, {
    memoizeOptions: {
        resultEqualityCheck: (0, $0499b9ab63ed35d4$export$dcc34c4213e7f4c)
    }
});
var $6aac8fe27ae10a7b$export$c2c6d012cffe2c75 = (graphicalItemsData, _ref)=>{
    var { chartData: chartData = [], dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (graphicalItemsData.length > 0) /*
     * There is no slicing when data is defined on graphical items. Why?
     * Because Brush ignores data defined on graphical items,
     * and does not render.
     * So Brush will never show up in a Scatter chart for example.
     * This is something we will need to fix.
     *
     * Now, when the root chart data is not defined, the dataEndIndex is 0,
     * which means the itemsData will be sliced to an empty array anyway.
     * But that's an implementation detail, and we can fix that too.
     *
     * Also, in absence of Axis dataKey, we use the dataKey from each item, respectively.
     * This is the usual pattern for numerical axis, that is the one where bars go up:
     * users don't specify any dataKey by default and expect the axis to "just match the data".
     */ return graphicalItemsData;
    return chartData.slice(dataStartIndex, dataEndIndex + 1);
};
var $6aac8fe27ae10a7b$export$6099ba314905f0c4 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$f2151bebfd9ae457,
    (0, $d235e165ed12974e$export$fe05134c2701d897)
], $6aac8fe27ae10a7b$export$c2c6d012cffe2c75);
var $6aac8fe27ae10a7b$export$3051da2013ba9cfe = (data, axisSettings, items)=>{
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(item, axisSettings.dataKey)
        }));
    if (items.length > 0) return items.map((item)=>item.dataKey).flatMap((dataKey)=>data.map((entry)=>({
                value: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey)
            })));
    return data.map((entry)=>({
            value: entry
        }));
};
var $6aac8fe27ae10a7b$export$9cea618b690f07b7 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$6099ba314905f0c4,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], $6aac8fe27ae10a7b$export$3051da2013ba9cfe);
function $6aac8fe27ae10a7b$export$8b0eb5a8c39b724f(axisType, errorBar) {
    switch(axisType){
        case 'xAxis':
            return errorBar.direction === 'x';
        case 'yAxis':
            return errorBar.direction === 'y';
        default:
            return false;
    }
}
function $6aac8fe27ae10a7b$var$makeNumber(val) {
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(val) || val instanceof Date) {
        var n = Number(val);
        if ((0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(n)) return n;
    }
    return undefined;
}
function $6aac8fe27ae10a7b$var$makeDomain(val) {
    if (Array.isArray(val)) {
        var attempt = [
            $6aac8fe27ae10a7b$var$makeNumber(val[0]),
            $6aac8fe27ae10a7b$var$makeNumber(val[1])
        ];
        if ((0, $77a63a99eb6fec8b$export$ba29b24e2a92eb58)(attempt)) return attempt;
        return undefined;
    }
    var n = $6aac8fe27ae10a7b$var$makeNumber(val);
    if (n == null) return undefined;
    return [
        n,
        n
    ];
}
function $6aac8fe27ae10a7b$var$onlyAllowNumbers(data) {
    return data.map($6aac8fe27ae10a7b$var$makeNumber).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
}
function $6aac8fe27ae10a7b$export$25971beae035f58a(entry, appliedValue, relevantErrorBars) {
    if (!relevantErrorBars || typeof appliedValue !== 'number' || (0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(appliedValue)) return [];
    if (!relevantErrorBars.length) return [];
    return $6aac8fe27ae10a7b$var$onlyAllowNumbers(relevantErrorBars.flatMap((eb)=>{
        var errorValue = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, eb.dataKey);
        var lowBound, highBound;
        if (Array.isArray(errorValue)) [lowBound, highBound] = errorValue;
        else lowBound = highBound = errorValue;
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(lowBound) || !(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(highBound)) return undefined;
        return [
            appliedValue - lowBound,
            appliedValue + highBound
        ];
    }));
}
var $6aac8fe27ae10a7b$export$27d9004292294cd7 = (state)=>{
    var axisType = (0, $37e5cc0fa883575c$export$898d3dfd98fb482)(state);
    var axisId = (0, $c92d1f706423a70a$export$eeffdb10daff095d)(state);
    return $6aac8fe27ae10a7b$export$f5176fa96b596697(state, axisType, axisId);
};
var $6aac8fe27ae10a7b$export$bf8397fefbaa3617 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$27d9004292294cd7
], (axis)=>axis === null || axis === void 0 ? void 0 : axis.dataKey);
var $6aac8fe27ae10a7b$export$b329ef9482661e60 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$58ad06f71246a0da,
    (0, $d235e165ed12974e$export$fe05134c2701d897),
    $6aac8fe27ae10a7b$export$27d9004292294cd7
], (0, $3bf52c7ae65ae57f$export$ae6c77e7720cddf9));
var $6aac8fe27ae10a7b$export$9312914d13496409 = (displayedData, items, stackOffsetType, reverseStackOrder)=>{
    var initialItemsGroups = {};
    var itemsGroup = items.reduce((acc, item)=>{
        if (item.stackId == null) return acc;
        var stack = acc[item.stackId];
        if (stack == null) stack = [];
        stack.push(item);
        acc[item.stackId] = stack;
        return acc;
    }, initialItemsGroups);
    return Object.fromEntries(Object.entries(itemsGroup).map((_ref2)=>{
        var [stackId, graphicalItems] = _ref2;
        var orderedGraphicalItems = reverseStackOrder ? [
            ...graphicalItems
        ].reverse() : graphicalItems;
        var dataKeys = orderedGraphicalItems.map((0, $c86621286e2c8ba6$export$58b095b87bc46727));
        return [
            stackId,
            {
                // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
                stackedData: (0, $cd015374923bb5c7$export$c2170542cfc0177c)(displayedData, dataKeys, stackOffsetType),
                graphicalItems: orderedGraphicalItems
            }
        ];
    }));
};
var $6aac8fe27ae10a7b$export$af2278e5e47fc440 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$b329ef9482661e60,
    $6aac8fe27ae10a7b$export$58ad06f71246a0da,
    (0, $dcfc24e85ad2aefd$export$73aff39176364def),
    (0, $dcfc24e85ad2aefd$export$ec830dc49707c6da)
], $6aac8fe27ae10a7b$export$9312914d13496409);
var $6aac8fe27ae10a7b$export$3286b8ea6ff06720 = (stackGroups, _ref3, axisType, domainFromUserPreference)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref3;
    if (domainFromUserPreference != null) // User has specified a domain, so we respect that and we can skip computing anything else
    return undefined;
    if (axisType === 'zAxis') // ZAxis ignores stacks
    return undefined;
    var domainOfStackGroups = (0, $cd015374923bb5c7$export$26522b779eb5497c)(stackGroups, dataStartIndex, dataEndIndex);
    if (domainOfStackGroups != null && domainOfStackGroups[0] === 0 && domainOfStackGroups[1] === 0) return undefined;
    return domainOfStackGroups;
};
var $6aac8fe27ae10a7b$var$selectAllowsDataOverflow = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c
], (axisSettings)=>axisSettings.allowDataOverflow);
var $6aac8fe27ae10a7b$export$2e6262b6c952ab02 = (axisSettings)=>{
    var _axisSettings$domain;
    if (axisSettings == null || !('domain' in axisSettings)) return $6aac8fe27ae10a7b$export$a012a4dce80491c2;
    if (axisSettings.domain != null) return axisSettings.domain;
    if ('ticks' in axisSettings && axisSettings.ticks != null) {
        if (axisSettings.type === 'number') {
            var allValues = $6aac8fe27ae10a7b$var$onlyAllowNumbers(axisSettings.ticks);
            return [
                Math.min(...allValues),
                Math.max(...allValues)
            ];
        }
        if (axisSettings.type === 'category') return axisSettings.ticks.map(String);
    }
    return (_axisSettings$domain = axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.domain) !== null && _axisSettings$domain !== void 0 ? _axisSettings$domain : $6aac8fe27ae10a7b$export$a012a4dce80491c2;
};
var $6aac8fe27ae10a7b$export$5d46410c3f089eb2 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c
], $6aac8fe27ae10a7b$export$2e6262b6c952ab02);
var $6aac8fe27ae10a7b$export$c21dc69ecce61f8a = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$5d46410c3f089eb2,
    $6aac8fe27ae10a7b$var$selectAllowsDataOverflow
], (0, $77a63a99eb6fec8b$export$fcbf88d4627b24df));
var $6aac8fe27ae10a7b$export$969bc8d84122c036 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$af2278e5e47fc440,
    (0, $d235e165ed12974e$export$519edd692222520),
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98),
    $6aac8fe27ae10a7b$export$c21dc69ecce61f8a
], $6aac8fe27ae10a7b$export$3286b8ea6ff06720, {
    memoizeOptions: {
        resultEqualityCheck: (0, $192fdd139bcf9f78$export$45c01007b107f1a6)
    }
});
var $6aac8fe27ae10a7b$export$9429ab4550237b6d = (state)=>state.errorBars;
var $6aac8fe27ae10a7b$var$combineRelevantErrorBarSettings = (cartesianItemsSettings, allErrorBarSettings, axisType)=>{
    return cartesianItemsSettings.flatMap((item)=>{
        return allErrorBarSettings[item.id];
    }).filter(Boolean).filter((e)=>{
        return $6aac8fe27ae10a7b$export$8b0eb5a8c39b724f(axisType, e);
    });
};
var $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d = function mergeDomains() {
    for(var _len = arguments.length, domains = new Array(_len), _key = 0; _key < _len; _key++)domains[_key] = arguments[_key];
    var allDomains = domains.filter(Boolean);
    if (allDomains.length === 0) return undefined;
    var allValues = allDomains.flat();
    var min = Math.min(...allValues);
    var max = Math.max(...allValues);
    return [
        min,
        max
    ];
};
var $6aac8fe27ae10a7b$export$df56c8e9a3e45e65 = (data, axisSettings, items, errorBars, axisType)=>{
    var lowerEnd, upperEnd;
    if (items.length > 0) data.forEach((entry)=>{
        items.forEach((item)=>{
            var _errorBars$item$id, _axisSettings$dataKey;
            var relevantErrorBars = (_errorBars$item$id = errorBars[item.id]) === null || _errorBars$item$id === void 0 ? void 0 : _errorBars$item$id.filter((errorBar)=>$6aac8fe27ae10a7b$export$8b0eb5a8c39b724f(axisType, errorBar));
            var valueByDataKey = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            var errorDomain = $6aac8fe27ae10a7b$export$25971beae035f58a(entry, valueByDataKey, relevantErrorBars);
            if (errorDomain.length >= 2) {
                var localLower = Math.min(...errorDomain);
                var localUpper = Math.max(...errorDomain);
                if (lowerEnd == null || localLower < lowerEnd) lowerEnd = localLower;
                if (upperEnd == null || localUpper > upperEnd) upperEnd = localUpper;
            }
            var dataValueDomain = $6aac8fe27ae10a7b$var$makeDomain(valueByDataKey);
            if (dataValueDomain != null) {
                lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
                upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
            }
        });
    });
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) data.forEach((item)=>{
        var dataValueDomain = $6aac8fe27ae10a7b$var$makeDomain((0, $cd015374923bb5c7$export$f97fc4a450f29a)(item, axisSettings.dataKey));
        if (dataValueDomain != null) {
            lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
            upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
        }
    });
    if ((0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(lowerEnd) && (0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(upperEnd)) return [
        lowerEnd,
        upperEnd
    ];
    return undefined;
};
var $6aac8fe27ae10a7b$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$6099ba314905f0c4,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$var$selectCartesianItemsSettingsExceptStacked,
    $6aac8fe27ae10a7b$export$9429ab4550237b6d,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$df56c8e9a3e45e65, {
    memoizeOptions: {
        resultEqualityCheck: (0, $192fdd139bcf9f78$export$45c01007b107f1a6)
    }
});
function $6aac8fe27ae10a7b$var$onlyAllowNumbersAndStringsAndDates(item) {
    var { value: value } = item;
    if ((0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(value) || value instanceof Date) return value;
    return undefined;
}
var $6aac8fe27ae10a7b$var$computeDomainOfTypeCategory = (allDataSquished, axisSettings, isCategorical)=>{
    var categoricalDomain = allDataSquished.map($6aac8fe27ae10a7b$var$onlyAllowNumbersAndStringsAndDates).filter((v)=>v != null);
    if (isCategorical && (axisSettings.dataKey == null || axisSettings.allowDuplicatedCategory && (0, $2ab3a7e25c8aba74$export$732baf6a98f122)(categoricalDomain))) /*
     * 1. In an absence of dataKey, Recharts will use array indexes as its categorical domain
     * 2. When category axis has duplicated text, serial numbers are used to generate scale
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($38ed130fff70c422$exports)))(0, allDataSquished.length);
    if (axisSettings.allowDuplicatedCategory) return categoricalDomain;
    return Array.from(new Set(categoricalDomain));
};
var $6aac8fe27ae10a7b$export$71580de5ed38161a = (state)=>state.referenceElements.dots;
var $6aac8fe27ae10a7b$export$2829d12117d2002f = (elements, axisType, axisId)=>{
    return elements.filter((el)=>el.ifOverflow === 'extendDomain').filter((el)=>{
        if (axisType === 'xAxis') return el.xAxisId === axisId;
        return el.yAxisId === axisId;
    });
};
var $6aac8fe27ae10a7b$export$dc267b7b9026caca = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$71580de5ed38161a,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98),
    (0, $680eada126f0aa15$export$6a2efa106dc9c8f6)
], $6aac8fe27ae10a7b$export$2829d12117d2002f);
var $6aac8fe27ae10a7b$export$c7e152cb7f10c1a6 = (state)=>state.referenceElements.areas;
var $6aac8fe27ae10a7b$export$699de899b7bc81a9 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$c7e152cb7f10c1a6,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98),
    (0, $680eada126f0aa15$export$6a2efa106dc9c8f6)
], $6aac8fe27ae10a7b$export$2829d12117d2002f);
var $6aac8fe27ae10a7b$export$8fe2a49ce63c5348 = (state)=>state.referenceElements.lines;
var $6aac8fe27ae10a7b$export$29b80feb73eec2b3 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$8fe2a49ce63c5348,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98),
    (0, $680eada126f0aa15$export$6a2efa106dc9c8f6)
], $6aac8fe27ae10a7b$export$2829d12117d2002f);
var $6aac8fe27ae10a7b$export$5da0b79fd816ec4b = (dots, axisType)=>{
    if (dots == null) return undefined;
    var allCoords = $6aac8fe27ae10a7b$var$onlyAllowNumbers(dots.map((dot)=>axisType === 'xAxis' ? dot.x : dot.y));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $6aac8fe27ae10a7b$var$selectReferenceDotsDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)($6aac8fe27ae10a7b$export$dc267b7b9026caca, (0, $b940f2b84cdec1f7$export$8a7d579879340d98), $6aac8fe27ae10a7b$export$5da0b79fd816ec4b);
var $6aac8fe27ae10a7b$export$7b27918cf5e1fc19 = (areas, axisType)=>{
    if (areas == null) return undefined;
    var allCoords = $6aac8fe27ae10a7b$var$onlyAllowNumbers(areas.flatMap((area)=>[
            axisType === 'xAxis' ? area.x1 : area.y1,
            axisType === 'xAxis' ? area.x2 : area.y2
        ]));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $6aac8fe27ae10a7b$var$selectReferenceAreasDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$699de899b7bc81a9,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$7b27918cf5e1fc19);
function $6aac8fe27ae10a7b$var$extractXCoordinates(line) {
    var _line$segment;
    if (line.x != null) return $6aac8fe27ae10a7b$var$onlyAllowNumbers([
        line.x
    ]);
    var segmentCoordinates = (_line$segment = line.segment) === null || _line$segment === void 0 ? void 0 : _line$segment.map((s)=>s.x);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $6aac8fe27ae10a7b$var$onlyAllowNumbers(segmentCoordinates);
}
function $6aac8fe27ae10a7b$var$extractYCoordinates(line) {
    var _line$segment2;
    if (line.y != null) return $6aac8fe27ae10a7b$var$onlyAllowNumbers([
        line.y
    ]);
    var segmentCoordinates = (_line$segment2 = line.segment) === null || _line$segment2 === void 0 ? void 0 : _line$segment2.map((s)=>s.y);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $6aac8fe27ae10a7b$var$onlyAllowNumbers(segmentCoordinates);
}
var $6aac8fe27ae10a7b$export$f1d17aebd11953eb = (lines, axisType)=>{
    if (lines == null) return undefined;
    var allCoords = lines.flatMap((line)=>axisType === 'xAxis' ? $6aac8fe27ae10a7b$var$extractXCoordinates(line) : $6aac8fe27ae10a7b$var$extractYCoordinates(line));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $6aac8fe27ae10a7b$var$selectReferenceLinesDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$29b80feb73eec2b3,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$f1d17aebd11953eb);
var $6aac8fe27ae10a7b$var$selectReferenceElementsDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)($6aac8fe27ae10a7b$var$selectReferenceDotsDomain, $6aac8fe27ae10a7b$var$selectReferenceLinesDomain, $6aac8fe27ae10a7b$var$selectReferenceAreasDomain, (dotsDomain, linesDomain, areasDomain)=>{
    return $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d(dotsDomain, areasDomain, linesDomain);
});
var $6aac8fe27ae10a7b$export$b9eca0fd568f66a4 = (axisSettings, domainDefinition, domainFromUserPreference, domainOfStackGroups, dataAndErrorBarsDomain, referenceElementsDomain, layout, axisType)=>{
    if (domainFromUserPreference != null) // We're done! No need to compute anything else.
    return domainFromUserPreference;
    var shouldIncludeDomainOfStackGroups = layout === 'vertical' && axisType === 'xAxis' || layout === 'horizontal' && axisType === 'yAxis';
    var mergedDomains = shouldIncludeDomainOfStackGroups ? $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d(domainOfStackGroups, referenceElementsDomain, dataAndErrorBarsDomain) : $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d(referenceElementsDomain, dataAndErrorBarsDomain);
    return (0, $77a63a99eb6fec8b$export$3f87aa7a53437a70)(domainDefinition, mergedDomains, axisSettings.allowDataOverflow);
};
var $6aac8fe27ae10a7b$export$2a64502fccb4dfa6 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$5d46410c3f089eb2,
    $6aac8fe27ae10a7b$export$c21dc69ecce61f8a,
    $6aac8fe27ae10a7b$export$969bc8d84122c036,
    $6aac8fe27ae10a7b$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $6aac8fe27ae10a7b$var$selectReferenceElementsDomain,
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$b9eca0fd568f66a4, {
    memoizeOptions: {
        resultEqualityCheck: (0, $192fdd139bcf9f78$export$45c01007b107f1a6)
    }
});
/**
 * Expand by design maps everything between 0 and 1,
 * there is nothing to compute.
 * See https://d3js.org/d3-shape/stack#stack-offsets
 */ var $6aac8fe27ae10a7b$var$expandDomain = [
    0,
    1
];
var $6aac8fe27ae10a7b$export$70e6ef68424edf74 = (axisSettings, layout, displayedData, allAppliedValues, stackOffsetType, axisType, numericalDomain)=>{
    if ((axisSettings == null || displayedData == null || displayedData.length === 0) && numericalDomain === undefined) return undefined;
    var { dataKey: dataKey, type: type } = axisSettings;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && dataKey == null) {
        var _displayedData$length;
        return (0, (/*@__PURE__*/$parcel$interopDefault($38ed130fff70c422$exports)))(0, (_displayedData$length = displayedData === null || displayedData === void 0 ? void 0 : displayedData.length) !== null && _displayedData$length !== void 0 ? _displayedData$length : 0);
    }
    if (type === 'category') return $6aac8fe27ae10a7b$var$computeDomainOfTypeCategory(allAppliedValues, axisSettings, isCategorical);
    if (stackOffsetType === 'expand') return $6aac8fe27ae10a7b$var$expandDomain;
    return numericalDomain;
};
var $6aac8fe27ae10a7b$export$4fc5ecb5227dd744 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $6aac8fe27ae10a7b$export$6099ba314905f0c4,
    $6aac8fe27ae10a7b$export$9cea618b690f07b7,
    (0, $dcfc24e85ad2aefd$export$73aff39176364def),
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98),
    $6aac8fe27ae10a7b$export$2a64502fccb4dfa6
], $6aac8fe27ae10a7b$export$70e6ef68424edf74);
function $6aac8fe27ae10a7b$var$isSupportedScaleName(name) {
    return name in $d8f008d3b0c1a5c3$exports;
}
var $6aac8fe27ae10a7b$export$bebec32544750591 = (axisConfig, hasBar, chartType)=>{
    if (axisConfig == null) return undefined;
    var { scale: scale, type: type } = axisConfig;
    if (scale === 'auto') {
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return 'point';
        if (type === 'category') return 'band';
        return 'linear';
    }
    if (typeof scale === 'string') {
        var name = "scale".concat((0, $2ab3a7e25c8aba74$export$3061f22cd819074d)(scale));
        return $6aac8fe27ae10a7b$var$isSupportedScaleName(name) ? name : 'point';
    }
    return undefined;
};
var $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$1c7798b82c8010cd,
    (0, $dcfc24e85ad2aefd$export$3247769c9dbde559)
], $6aac8fe27ae10a7b$export$bebec32544750591);
function $6aac8fe27ae10a7b$export$e2fe61793fcf6495(axis, realScaleType, axisDomain, axisRange) {
    if (axisDomain == null || axisRange == null) return undefined;
    if (typeof axis.scale === 'function') return (0, $aa187d4cf30aa84e$export$5501a52df751e5ca)(axis.scale, axisDomain, axisRange);
    return (0, $aa187d4cf30aa84e$export$5501a52df751e5ca)(realScaleType, axisDomain, axisRange);
}
var $6aac8fe27ae10a7b$export$aa1ef6c8f610e48c = (axisDomain, axisSettings, realScaleType)=>{
    var domainDefinition = $6aac8fe27ae10a7b$export$2e6262b6c952ab02(axisSettings);
    if (realScaleType !== 'auto' && realScaleType !== 'linear') return undefined;
    if (axisSettings != null && axisSettings.tickCount && Array.isArray(domainDefinition) && (domainDefinition[0] === 'auto' || domainDefinition[1] === 'auto') && (0, $77a63a99eb6fec8b$export$ba29b24e2a92eb58)(axisDomain)) return (0, $7355e2f233c5e6b9$export$b84e75ccbfe6a612)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    if (axisSettings != null && axisSettings.tickCount && axisSettings.type === 'number' && (0, $77a63a99eb6fec8b$export$ba29b24e2a92eb58)(axisDomain)) return (0, $7355e2f233c5e6b9$export$e9d28da780436e98)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    return undefined;
};
var $6aac8fe27ae10a7b$export$2efb9b5d95659d33 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$4fc5ecb5227dd744,
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7
], $6aac8fe27ae10a7b$export$aa1ef6c8f610e48c);
var $6aac8fe27ae10a7b$export$3a4530026b1860ff = (axisSettings, domain, niceTicks, axisType)=>{
    if (/*
   * Angle axis for some reason uses nice ticks when rendering axis tick labels,
   * but doesn't use nice ticks for extending domain like all the other axes do.
   * Not really sure why? Is there a good reason,
   * or is it just because someone added support for nice ticks to the other axes and forgot this one?
   */ axisType !== 'angleAxis' && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.type) === 'number' && (0, $77a63a99eb6fec8b$export$ba29b24e2a92eb58)(domain) && Array.isArray(niceTicks) && niceTicks.length > 0) {
        var _niceTicks$, _niceTicks;
        var minFromDomain = domain[0];
        var minFromTicks = (_niceTicks$ = niceTicks[0]) !== null && _niceTicks$ !== void 0 ? _niceTicks$ : 0;
        var maxFromDomain = domain[1];
        var maxFromTicks = (_niceTicks = niceTicks[niceTicks.length - 1]) !== null && _niceTicks !== void 0 ? _niceTicks : 0;
        return [
            Math.min(minFromDomain, minFromTicks),
            Math.max(maxFromDomain, maxFromTicks)
        ];
    }
    return domain;
};
var $6aac8fe27ae10a7b$export$af7761c6ea30fae4 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$4fc5ecb5227dd744,
    $6aac8fe27ae10a7b$export$2efb9b5d95659d33,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$3a4530026b1860ff);
var $6aac8fe27ae10a7b$export$a1013ea99dfe6af9 = (0, $375276bea32f9eda$export$595d22ed68ca2841)($6aac8fe27ae10a7b$export$9cea618b690f07b7, $6aac8fe27ae10a7b$export$fc14c3706e09c50c, (allDataSquished, axisSettings)=>{
    if (!axisSettings || axisSettings.type !== 'number') return undefined;
    var smallestDistanceBetweenValues = Infinity;
    var sortedValues = Array.from($6aac8fe27ae10a7b$var$onlyAllowNumbers(allDataSquished.map((d)=>d.value))).sort((a, b)=>a - b);
    var first = sortedValues[0];
    var last = sortedValues[sortedValues.length - 1];
    if (first == null || last == null) return Infinity;
    var diff = last - first;
    if (diff === 0) return Infinity;
    // Only do n - 1 distance calculations because there's only n - 1 distances between n values.
    for(var i = 0; i < sortedValues.length - 1; i++){
        var curr = sortedValues[i];
        var next = sortedValues[i + 1];
        if (curr == null || next == null) continue;
        var distance = next - curr;
        smallestDistanceBetweenValues = Math.min(smallestDistanceBetweenValues, distance);
    }
    return smallestDistanceBetweenValues / diff;
});
var $6aac8fe27ae10a7b$var$selectCalculatedPadding = (0, $375276bea32f9eda$export$595d22ed68ca2841)($6aac8fe27ae10a7b$export$a1013ea99dfe6af9, (0, $e573f10901a87cfb$export$8426b6d9af801dee), (0, $dcfc24e85ad2aefd$export$a73f9d39b015942a), (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b), (_1, _2, _3, _4, padding)=>padding, (smallestDistanceInPercent, layout, barCategoryGap, offset, padding)=>{
    if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(smallestDistanceInPercent)) return 0;
    var rangeWidth = layout === 'vertical' ? offset.height : offset.width;
    if (padding === 'gap') return smallestDistanceInPercent * rangeWidth / 2;
    if (padding === 'no-gap') {
        var gap = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = smallestDistanceInPercent * rangeWidth / 2;
        return halfBand - gap - (halfBand - gap) / rangeWidth * gap;
    }
    return 0;
});
var $6aac8fe27ae10a7b$export$29cb35c3432eef0e = (state, axisId, isPanorama)=>{
    var xAxisSettings = $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
    if (xAxisSettings == null || typeof xAxisSettings.padding !== 'string') return 0;
    return $6aac8fe27ae10a7b$var$selectCalculatedPadding(state, 'xAxis', axisId, isPanorama, xAxisSettings.padding);
};
var $6aac8fe27ae10a7b$export$689bf02345b2d857 = (state, axisId, isPanorama)=>{
    var yAxisSettings = $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
    if (yAxisSettings == null || typeof yAxisSettings.padding !== 'string') return 0;
    return $6aac8fe27ae10a7b$var$selectCalculatedPadding(state, 'yAxis', axisId, isPanorama, yAxisSettings.padding);
};
var $6aac8fe27ae10a7b$var$selectXAxisPadding = (0, $375276bea32f9eda$export$595d22ed68ca2841)($6aac8fe27ae10a7b$export$d6895d8ddb4cee5, $6aac8fe27ae10a7b$export$29cb35c3432eef0e, (xAxisSettings, calculated)=>{
    var _padding$left, _padding$right;
    if (xAxisSettings == null) return {
        left: 0,
        right: 0
    };
    var { padding: padding } = xAxisSettings;
    if (typeof padding === 'string') return {
        left: calculated,
        right: calculated
    };
    return {
        left: ((_padding$left = padding.left) !== null && _padding$left !== void 0 ? _padding$left : 0) + calculated,
        right: ((_padding$right = padding.right) !== null && _padding$right !== void 0 ? _padding$right : 0) + calculated
    };
});
var $6aac8fe27ae10a7b$var$selectYAxisPadding = (0, $375276bea32f9eda$export$595d22ed68ca2841)($6aac8fe27ae10a7b$export$1f472705a332f1c9, $6aac8fe27ae10a7b$export$689bf02345b2d857, (yAxisSettings, calculated)=>{
    var _padding$top, _padding$bottom;
    if (yAxisSettings == null) return {
        top: 0,
        bottom: 0
    };
    var { padding: padding } = yAxisSettings;
    if (typeof padding === 'string') return {
        top: calculated,
        bottom: calculated
    };
    return {
        top: ((_padding$top = padding.top) !== null && _padding$top !== void 0 ? _padding$top : 0) + calculated,
        bottom: ((_padding$bottom = padding.bottom) !== null && _padding$bottom !== void 0 ? _padding$bottom : 0) + calculated
    };
});
var $6aac8fe27ae10a7b$export$f90f75eaf1068eb1 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    $6aac8fe27ae10a7b$var$selectXAxisPadding,
    (0, $2779731b2b31d554$export$3b81e97eae001823),
    (0, $2779731b2b31d554$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, padding, brushDimensions, _ref4, isPanorama)=>{
    var { padding: brushPadding } = _ref4;
    if (isPanorama) return [
        brushPadding.left,
        brushDimensions.width - brushPadding.right
    ];
    return [
        offset.left + padding.left,
        offset.left + offset.width - padding.right
    ];
});
var $6aac8fe27ae10a7b$export$90c620fc44f45640 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $6aac8fe27ae10a7b$var$selectYAxisPadding,
    (0, $2779731b2b31d554$export$3b81e97eae001823),
    (0, $2779731b2b31d554$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, layout, padding, brushDimensions, _ref5, isPanorama)=>{
    var { padding: brushPadding } = _ref5;
    if (isPanorama) return [
        brushDimensions.height - brushPadding.bottom,
        brushPadding.top
    ];
    if (layout === 'horizontal') return [
        offset.top + offset.height - padding.bottom,
        offset.top + padding.top
    ];
    return [
        offset.top + padding.top,
        offset.top + offset.height - padding.bottom
    ];
});
var $6aac8fe27ae10a7b$export$3506ed461810cc8f = (state, axisType, axisId, isPanorama)=>{
    var _selectZAxisSettings;
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$f90f75eaf1068eb1(state, axisId, isPanorama);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$90c620fc44f45640(state, axisId, isPanorama);
        case 'zAxis':
            return (_selectZAxisSettings = $6aac8fe27ae10a7b$export$26eadf639b453d0f(state, axisId)) === null || _selectZAxisSettings === void 0 ? void 0 : _selectZAxisSettings.range;
        case 'angleAxis':
            return (0, $53bcbd5d17089da8$export$d00c8e94622c940)(state);
        case 'radiusAxis':
            return (0, $53bcbd5d17089da8$export$e13d847e4d4f833f)(state, axisId);
        default:
            return undefined;
    }
};
var $6aac8fe27ae10a7b$export$d6d5faff23feedea = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f
], (0, $1dbac917d7459aa2$export$3f7e30291950e694));
var $6aac8fe27ae10a7b$var$selectCheckedAxisDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$af7761c6ea30fae4
], (0, $6c21bf4d095d2d4f$export$cd6ce636c480934e));
var $6aac8fe27ae10a7b$export$22e8e5f8924724ea = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$var$selectCheckedAxisDomain,
    $6aac8fe27ae10a7b$export$d6d5faff23feedea
], $6aac8fe27ae10a7b$export$e2fe61793fcf6495);
var $6aac8fe27ae10a7b$export$565b9812b1d7c04f = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d,
    $6aac8fe27ae10a7b$export$9429ab4550237b6d,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$var$combineRelevantErrorBarSettings);
function $6aac8fe27ae10a7b$var$compareIds(a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
}
var $6aac8fe27ae10a7b$var$pickAxisOrientation = (_state, orientation)=>orientation;
var $6aac8fe27ae10a7b$var$pickMirror = (_state, _orientation, mirror)=>mirror;
var $6aac8fe27ae10a7b$var$selectAllXAxesWithOffsetType = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $601e2713d7fc7a32$export$bd320344232f30af), $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($6aac8fe27ae10a7b$var$compareIds));
var $6aac8fe27ae10a7b$var$selectAllYAxesWithOffsetType = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $601e2713d7fc7a32$export$e22adabb0128cf25), $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($6aac8fe27ae10a7b$var$compareIds));
var $6aac8fe27ae10a7b$var$getXAxisSize = (offset, axisSettings)=>{
    return {
        width: offset.width,
        height: axisSettings.height
    };
};
var $6aac8fe27ae10a7b$var$getYAxisSize = (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $f6fce23ac63eec53$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
};
var $6aac8fe27ae10a7b$export$50d4085c87c19b12 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b), $6aac8fe27ae10a7b$export$d6895d8ddb4cee5, $6aac8fe27ae10a7b$var$getXAxisSize);
var $6aac8fe27ae10a7b$var$combineXAxisPositionStartingPoint = (offset, orientation, chartHeight)=>{
    switch(orientation){
        case 'top':
            return offset.top;
        case 'bottom':
            return chartHeight - offset.bottom;
        default:
            return 0;
    }
};
var $6aac8fe27ae10a7b$var$combineYAxisPositionStartingPoint = (offset, orientation, chartWidth)=>{
    switch(orientation){
        case 'left':
            return offset.left;
        case 'right':
            return chartWidth - offset.right;
        default:
            return 0;
    }
};
var $6aac8fe27ae10a7b$export$6cb04966ad155e81 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $0ab9657931cbbb24$export$5856a7d94c109505), (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b), $6aac8fe27ae10a7b$var$selectAllXAxesWithOffsetType, $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (chartHeight, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $6aac8fe27ae10a7b$var$getXAxisSize(offset, axis);
        if (position == null) position = $6aac8fe27ae10a7b$var$combineXAxisPositionStartingPoint(offset, orientation, chartHeight);
        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.height;
        position += (needSpace ? -1 : 1) * axisSize.height;
    });
    return steps;
});
var $6aac8fe27ae10a7b$export$edba808018e1c207 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $0ab9657931cbbb24$export$771ef0ac044f724d), (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b), $6aac8fe27ae10a7b$var$selectAllYAxesWithOffsetType, $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (chartWidth, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $6aac8fe27ae10a7b$var$getYAxisSize(offset, axis);
        if (position == null) position = $6aac8fe27ae10a7b$var$combineYAxisPositionStartingPoint(offset, orientation, chartWidth);
        var needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.width;
        position += (needSpace ? -1 : 1) * axisSize.width;
    });
    return steps;
});
var $6aac8fe27ae10a7b$var$selectXAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
    if (axisSettings == null) return undefined;
    return $6aac8fe27ae10a7b$export$6cb04966ad155e81(state, axisSettings.orientation, axisSettings.mirror);
};
var $6aac8fe27ae10a7b$export$92fdc590d2371053 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    $6aac8fe27ae10a7b$export$d6895d8ddb4cee5,
    $6aac8fe27ae10a7b$var$selectXAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: offset.left,
        y: 0
    };
    return {
        x: offset.left,
        y: stepOfThisAxis
    };
});
var $6aac8fe27ae10a7b$var$selectYAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
    if (axisSettings == null) return undefined;
    return $6aac8fe27ae10a7b$export$edba808018e1c207(state, axisSettings.orientation, axisSettings.mirror);
};
var $6aac8fe27ae10a7b$export$e67a320452ebcaef = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    $6aac8fe27ae10a7b$export$1f472705a332f1c9,
    $6aac8fe27ae10a7b$var$selectYAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: 0,
        y: offset.top
    };
    return {
        x: stepOfThisAxis,
        y: offset.top
    };
});
var $6aac8fe27ae10a7b$export$249bec756af8ac39 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b), $6aac8fe27ae10a7b$export$1f472705a332f1c9, (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $f6fce23ac63eec53$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
});
var $6aac8fe27ae10a7b$export$6d6e642aa7a0ae10 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$50d4085c87c19b12(state, axisId).width;
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$249bec756af8ac39(state, axisId).height;
        default:
            return undefined;
    }
};
var $6aac8fe27ae10a7b$export$bb1ebf56a37bd899 = (chartLayout, appliedValues, axis, axisType)=>{
    if (axis == null) return undefined;
    var { allowDuplicatedCategory: allowDuplicatedCategory, type: type, dataKey: dataKey } = axis;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(chartLayout, axisType);
    var allData = appliedValues.map((av)=>av.value);
    if (dataKey && isCategorical && type === 'category' && allowDuplicatedCategory && (0, $2ab3a7e25c8aba74$export$732baf6a98f122)(allData)) return allData;
    return undefined;
};
var $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $6aac8fe27ae10a7b$export$9cea618b690f07b7,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$bb1ebf56a37bd899);
var $6aac8fe27ae10a7b$export$911ef47868c9ab07 = (layout, appliedValues, axis, axisType)=>{
    if (axis == null || axis.dataKey == null) return undefined;
    var { type: type, scale: scale } = axis;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && (type === 'number' || scale !== 'auto')) return appliedValues.map((d)=>d.value);
    return undefined;
};
var $6aac8fe27ae10a7b$export$a6a79e7a5412631c = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $6aac8fe27ae10a7b$export$9cea618b690f07b7,
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$911ef47868c9ab07);
var $6aac8fe27ae10a7b$export$45cd57660792dd31 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $6aac8fe27ae10a7b$var$selectCartesianAxisSettings,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$22e8e5f8924724ea,
    $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c,
    $6aac8fe27ae10a7b$export$a6a79e7a5412631c,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f,
    $6aac8fe27ae10a7b$export$2efb9b5d95659d33,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], (layout, axis, realScaleType, scale, duplicateDomain, categoricalDomain, axisRange, niceTicks, axisType)=>{
    if (axis == null) return undefined;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    return {
        angle: axis.angle,
        interval: axis.interval,
        minTickGap: axis.minTickGap,
        orientation: axis.orientation,
        tick: axis.tick,
        tickCount: axis.tickCount,
        tickFormatter: axis.tickFormatter,
        ticks: axis.ticks,
        type: axis.type,
        unit: axis.unit,
        axisType: axisType,
        categoricalDomain: categoricalDomain,
        duplicateDomain: duplicateDomain,
        isCategorical: isCategorical,
        niceTicks: niceTicks,
        range: axisRange,
        realScaleType: realScaleType,
        scale: scale
    };
});
var $6aac8fe27ae10a7b$export$d033262fd214bffb = (layout, axis, realScaleType, scale, niceTicks, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null) return undefined;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    var { type: type, ticks: ticks, tickCount: tickCount } = axis;
    var offsetForBand = // @ts-expect-error This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
    realScaleType === 'scaleBand' && typeof scale.bandwidth === 'function' ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && axisRange != null && axisRange.length >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    var ticksOrNiceTicks = ticks || niceTicks;
    if (ticksOrNiceTicks) return ticksOrNiceTicks.map((entry, index)=>{
        var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
        var scaled = scale.map(scaleContent);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            index: index,
            coordinate: scaled + offset,
            value: entry,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    if (scale.ticks) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
};
var $6aac8fe27ae10a7b$export$f0d85e8287c47657 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$22e8e5f8924724ea,
    $6aac8fe27ae10a7b$export$2efb9b5d95659d33,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f,
    $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c,
    $6aac8fe27ae10a7b$export$a6a79e7a5412631c,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$d033262fd214bffb);
var $6aac8fe27ae10a7b$export$453d0e9212f0369b = (layout, axis, scale, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null || axisRange == null || axisRange[0] === axisRange[1]) return undefined;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    var { tickCount: tickCount } = axis;
    var offset = 0;
    offset = axisType === 'angleAxis' && (axisRange === null || axisRange === void 0 ? void 0 : axisRange.length) >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    if (scale.ticks) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use unknown as index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
};
var $6aac8fe27ae10a7b$export$b894cb5d8586b43d = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    $6aac8fe27ae10a7b$export$22e8e5f8924724ea,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f,
    $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c,
    $6aac8fe27ae10a7b$export$a6a79e7a5412631c,
    (0, $b940f2b84cdec1f7$export$8a7d579879340d98)
], $6aac8fe27ae10a7b$export$453d0e9212f0369b);
var $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7 = (0, $375276bea32f9eda$export$595d22ed68ca2841)($6aac8fe27ae10a7b$export$fc14c3706e09c50c, $6aac8fe27ae10a7b$export$22e8e5f8924724ea, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $6aac8fe27ae10a7b$var$_objectSpread($6aac8fe27ae10a7b$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $6aac8fe27ae10a7b$var$selectZAxisScale = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$4fc5ecb5227dd744,
    $6aac8fe27ae10a7b$export$d6d5faff23feedea
], $6aac8fe27ae10a7b$export$e2fe61793fcf6495);
var $6aac8fe27ae10a7b$export$4dab5213d1420bb3 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((state, _axisType, axisId)=>$6aac8fe27ae10a7b$export$26eadf639b453d0f(state, axisId), $6aac8fe27ae10a7b$var$selectZAxisScale, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $6aac8fe27ae10a7b$var$_objectSpread($6aac8fe27ae10a7b$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $6aac8fe27ae10a7b$export$430d623a94added7 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $601e2713d7fc7a32$export$bd320344232f30af),
    (0, $601e2713d7fc7a32$export$e22adabb0128cf25)
], (layout, allXAxes, allYAxes)=>{
    switch(layout){
        case 'horizontal':
            return allXAxes.some((axis)=>axis.reversed) ? 'right-to-left' : 'left-to-right';
        case 'vertical':
            return allYAxes.some((axis)=>axis.reversed) ? 'bottom-to-top' : 'top-to-bottom';
        // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
        // however, the tooltip moves an unintuitive direction because of how the indices are rendered
        case 'centric':
        case 'radial':
            return 'left-to-right';
        default:
            return undefined;
    }
});









var $21536fb21082ce97$export$877d2dd8db5f51fd = (state)=>state.options.defaultTooltipEventType;
var $21536fb21082ce97$export$7f95a7e594fa7911 = (state)=>state.options.validateTooltipEventTypes;
function $21536fb21082ce97$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes) {
    if (shared == null) return defaultTooltipEventType;
    var eventType = shared ? 'axis' : 'item';
    if (validateTooltipEventTypes == null) return defaultTooltipEventType;
    return validateTooltipEventTypes.includes(eventType) ? eventType : defaultTooltipEventType;
}
function $21536fb21082ce97$export$53af65c2db668fac(state, shared) {
    var defaultTooltipEventType = $21536fb21082ce97$export$877d2dd8db5f51fd(state);
    var validateTooltipEventTypes = $21536fb21082ce97$export$7f95a7e594fa7911(state);
    return $21536fb21082ce97$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes);
}
function $21536fb21082ce97$export$7ac1fe18a92be318(shared) {
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>$21536fb21082ce97$export$53af65c2db668fac(state, shared));
}



var $3b61016ee0a2b578$export$3213c4688ceb4c80 = (tooltipTicks, activeIndex)=>{
    var _tooltipTicks$n;
    var n = Number(activeIndex);
    if ((0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(n) || activeIndex == null) return undefined;
    return n >= 0 ? tooltipTicks === null || tooltipTicks === void 0 || (_tooltipTicks$n = tooltipTicks[n]) === null || _tooltipTicks$n === void 0 ? void 0 : _tooltipTicks$n.value : undefined;
};


var $ec4de2c43a3d7eef$export$26d1e95fb7dea02 = (state)=>state.tooltip.settings;




var $3be7536b77e1512b$export$66f2ad380b6acece = {
    active: false,
    index: null,
    dataKey: undefined,
    graphicalItemId: undefined,
    coordinate: undefined
};
var $3be7536b77e1512b$export$d4c72bab9d6cc13a = {
    itemInteraction: {
        click: $3be7536b77e1512b$export$66f2ad380b6acece,
        hover: $3be7536b77e1512b$export$66f2ad380b6acece
    },
    axisInteraction: {
        click: $3be7536b77e1512b$export$66f2ad380b6acece,
        hover: $3be7536b77e1512b$export$66f2ad380b6acece
    },
    keyboardInteraction: $3be7536b77e1512b$export$66f2ad380b6acece,
    syncInteraction: {
        active: false,
        index: null,
        dataKey: undefined,
        label: undefined,
        coordinate: undefined,
        sourceViewBox: undefined,
        graphicalItemId: undefined
    },
    tooltipItemPayloads: [],
    settings: {
        shared: undefined,
        trigger: 'hover',
        axisId: 0,
        active: false,
        defaultIndex: undefined
    }
};
/**
 * This is the event we get when user is interacting with a specific graphical item.
 */ /**
 * Keyboard interaction payload has no graphical item ID,
 * and no dataKey, because keyboard interaction is always
 * with the whole chart, not with a specific graphical item.
 */ var $3be7536b77e1512b$var$tooltipSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'tooltip',
    initialState: $3be7536b77e1512b$export$d4c72bab9d6cc13a,
    reducers: {
        addTooltipEntrySettings: {
            reducer (state, action) {
                state.tooltipItemPayloads.push((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        replaceTooltipEntrySettings: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).tooltipItemPayloads.indexOf((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(prev));
                if (index > -1) state.tooltipItemPayloads[index] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        removeTooltipEntrySettings: {
            reducer (state, action) {
                var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).tooltipItemPayloads.indexOf((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.tooltipItemPayloads.splice(index, 1);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        setTooltipSettingsState (state, action) {
            state.settings = action.payload;
        },
        setActiveMouseOverItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.itemInteraction.hover.active = true;
            state.itemInteraction.hover.index = action.payload.activeIndex;
            state.itemInteraction.hover.dataKey = action.payload.activeDataKey;
            state.itemInteraction.hover.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        mouseLeaveChart (state) {
            /*
       * Clear only the active flags. Why?
       * 1. Keep Coordinate to preserve animation - next time the Tooltip appears, we want to render it from
       * the last place where it was when it disappeared.
       * 2. We want to keep all the properties anyway just in case the tooltip has `active=true` prop
       * and continues being visible even after the mouse has left the chart.
       */ state.itemInteraction.hover.active = false;
            state.axisInteraction.hover.active = false;
        },
        mouseLeaveItem (state) {
            state.itemInteraction.hover.active = false;
        },
        setActiveClickItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.itemInteraction.click.active = true;
            state.keyboardInteraction.active = false;
            state.itemInteraction.click.index = action.payload.activeIndex;
            state.itemInteraction.click.dataKey = action.payload.activeDataKey;
            state.itemInteraction.click.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setMouseOverAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.axisInteraction.hover.active = true;
            state.keyboardInteraction.active = false;
            state.axisInteraction.hover.index = action.payload.activeIndex;
            state.axisInteraction.hover.dataKey = action.payload.activeDataKey;
            state.axisInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        setMouseClickAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.axisInteraction.click.active = true;
            state.axisInteraction.click.index = action.payload.activeIndex;
            state.axisInteraction.click.dataKey = action.payload.activeDataKey;
            state.axisInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setSyncInteraction (state, action) {
            state.syncInteraction = action.payload;
        },
        setKeyboardInteraction (state, action) {
            state.keyboardInteraction.active = action.payload.active;
            state.keyboardInteraction.index = action.payload.activeIndex;
            state.keyboardInteraction.coordinate = action.payload.activeCoordinate;
        }
    }
});
var { addTooltipEntrySettings: $3be7536b77e1512b$export$2eaa1babb4725485, replaceTooltipEntrySettings: $3be7536b77e1512b$export$7333cdb61d5073d3, removeTooltipEntrySettings: $3be7536b77e1512b$export$29793cde90169929, setTooltipSettingsState: $3be7536b77e1512b$export$8d517a53c4528750, setActiveMouseOverItemIndex: $3be7536b77e1512b$export$c78abbb2450f6b44, mouseLeaveItem: $3be7536b77e1512b$export$68742311289b8f85, mouseLeaveChart: $3be7536b77e1512b$export$73879bed3f2eef71, setActiveClickItemIndex: $3be7536b77e1512b$export$99be2464250d8cae, setMouseOverAxisIndex: $3be7536b77e1512b$export$a7277636863fc703, setMouseClickAxisIndex: $3be7536b77e1512b$export$d2b1af5c3a560528, setSyncInteraction: $3be7536b77e1512b$export$f2efc99b98e50938, setKeyboardInteraction: $3be7536b77e1512b$export$820c94985c9eba3f } = $3be7536b77e1512b$var$tooltipSlice.actions;
var $3be7536b77e1512b$export$cadd4678b967dba6 = $3be7536b77e1512b$var$tooltipSlice.reducer;


function $3d3790706a3050f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d3790706a3050f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d3790706a3050f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3d3790706a3050f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d3790706a3050f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3d3790706a3050f8$var$_defineProperty(e, r, t) {
    return (r = $3d3790706a3050f8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3d3790706a3050f8$var$_toPropertyKey(t) {
    var i = $3d3790706a3050f8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3d3790706a3050f8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3d3790706a3050f8$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger) {
    if (tooltipEventType === 'axis') {
        if (trigger === 'click') return tooltipState.axisInteraction.click;
        return tooltipState.axisInteraction.hover;
    }
    if (trigger === 'click') return tooltipState.itemInteraction.click;
    return tooltipState.itemInteraction.hover;
}
function $3d3790706a3050f8$var$hasBeenActivePreviously(tooltipInteractionState) {
    return tooltipInteractionState.index != null;
}
var $3d3790706a3050f8$export$d759c39cacfacf6a = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    if (tooltipEventType == null) return 0, $3be7536b77e1512b$export$66f2ad380b6acece;
    var appropriateMouseInteraction = $3d3790706a3050f8$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger);
    if (appropriateMouseInteraction == null) return 0, $3be7536b77e1512b$export$66f2ad380b6acece;
    if (appropriateMouseInteraction.active) return appropriateMouseInteraction;
    if (tooltipState.keyboardInteraction.active) return tooltipState.keyboardInteraction;
    if (tooltipState.syncInteraction.active && tooltipState.syncInteraction.index != null) return tooltipState.syncInteraction;
    var activeFromProps = tooltipState.settings.active === true;
    if ($3d3790706a3050f8$var$hasBeenActivePreviously(appropriateMouseInteraction)) {
        if (activeFromProps) return $3d3790706a3050f8$var$_objectSpread($3d3790706a3050f8$var$_objectSpread({}, appropriateMouseInteraction), {}, {
            active: true
        });
    } else if (defaultIndex != null) return {
        active: true,
        coordinate: undefined,
        dataKey: undefined,
        index: defaultIndex,
        graphicalItemId: undefined
    };
    return $3d3790706a3050f8$var$_objectSpread($3d3790706a3050f8$var$_objectSpread({}, (0, $3be7536b77e1512b$export$66f2ad380b6acece)), {}, {
        coordinate: appropriateMouseInteraction.coordinate
    });
};





function $927073e84a89ab02$var$toFiniteNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (value instanceof Date) {
        var numericValue = value.valueOf();
        return Number.isFinite(numericValue) ? numericValue : undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
function $927073e84a89ab02$var$isValueWithinNumberDomain(value, domain) {
    var numericValue = $927073e84a89ab02$var$toFiniteNumber(value);
    var lowerBound = domain[0];
    var upperBound = domain[1];
    if (numericValue === undefined) return false;
    var min = Math.min(lowerBound, upperBound);
    var max = Math.max(lowerBound, upperBound);
    return numericValue >= min && numericValue <= max;
}
function $927073e84a89ab02$var$isValueWithinDomain(entry, axisDataKey, domain) {
    if (domain == null || axisDataKey == null) return true;
    var value = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, axisDataKey);
    if (value == null) return true;
    if (!(0, $77a63a99eb6fec8b$export$ba29b24e2a92eb58)(domain)) return true;
    return $927073e84a89ab02$var$isValueWithinNumberDomain(value, domain);
}
var $927073e84a89ab02$export$32df4b03a0962e46 = (tooltipInteraction, chartData, axisDataKey, domain)=>{
    var desiredIndex = tooltipInteraction === null || tooltipInteraction === void 0 ? void 0 : tooltipInteraction.index;
    if (desiredIndex == null) return null;
    var indexAsNumber = Number(desiredIndex);
    if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(indexAsNumber)) // this is for charts like Sankey and Treemap that do not support numerical indexes. We need a proper solution for this before we can start supporting keyboard events on these charts.
    return desiredIndex;
    /*
   * Zero is a trivial limit for single-dimensional charts like Line and Area,
   * but this also needs a support for multidimensional charts like Sankey and Treemap! TODO
   */ var lowerLimit = 0;
    var upperLimit = Infinity;
    if (chartData.length > 0) upperLimit = chartData.length - 1;
    // now let's clamp the desiredIndex between the limits
    var clampedIndex = Math.max(lowerLimit, Math.min(indexAsNumber, upperLimit));
    var entry = chartData[clampedIndex];
    if (entry == null) return String(clampedIndex);
    if (!$927073e84a89ab02$var$isValueWithinDomain(entry, axisDataKey, domain)) return null;
    return String(clampedIndex);
};


var $40e435146911cfcc$export$c2cbc37a7546bbd0 = (width, height, layout, offset, tooltipTicks, defaultIndex, tooltipConfigurations)=>{
    if (defaultIndex == null) return undefined;
    /*
   * With defaultIndex alone, we don't have enough information to decide _which_ of the multiple tooltips to display.
   * Maybe one day we could add new prop `activeGraphicalItemId` to the chart to help with that.
   * Until then, we choose the first one.
   */ var firstConfiguration = tooltipConfigurations[0];
    var maybePosition = firstConfiguration === null || firstConfiguration === void 0 ? void 0 : firstConfiguration.getPosition(defaultIndex);
    if (maybePosition != null) return maybePosition;
    var tick = tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks[Number(defaultIndex)];
    if (!tick) return undefined;
    switch(layout){
        case 'horizontal':
            return {
                x: tick.coordinate,
                y: (offset.top + height) / 2
            };
        default:
            // This logic is not super sound - it conflates vertical, radial, centric layouts into just one. TODO improve!
            return {
                x: (offset.left + width) / 2,
                y: tick.coordinate
            };
    }
};




var $790486f25cd906b4$export$45044aaa79c0cddb = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    // if tooltip reacts to axis interaction, then we display all items at the same time.
    if (tooltipEventType === 'axis') return tooltipState.tooltipItemPayloads;
    /*
   * By now we already know that tooltipEventType is 'item', so we can only search in itemInteractions.
   * item means that only the hovered or clicked item will be present in the tooltip.
   */ if (tooltipState.tooltipItemPayloads.length === 0) // No point filtering if the payload is empty
    return [];
    var filterByGraphicalItemId;
    if (trigger === 'hover') filterByGraphicalItemId = tooltipState.itemInteraction.hover.graphicalItemId;
    else filterByGraphicalItemId = tooltipState.itemInteraction.click.graphicalItemId;
    if (filterByGraphicalItemId == null && defaultIndex != null) {
        /*
     * So when we use `defaultIndex` - we don't have a dataKey to filter by because user did not hover over anything yet.
     * In that case let's display the first item in the tooltip; after all, this is `item` interaction case,
     * so we should display only one item at a time instead of all.
     */ var firstItemPayload = tooltipState.tooltipItemPayloads[0];
        if (firstItemPayload != null) return [
            firstItemPayload
        ];
        return [];
    }
    return tooltipState.tooltipItemPayloads.filter((tpc)=>{
        var _tpc$settings;
        return ((_tpc$settings = tpc.settings) === null || _tpc$settings === void 0 ? void 0 : _tpc$settings.graphicalItemId) === filterByGraphicalItemId;
    });
};


var $30f1a9633819407c$export$6ae1ee94e6fa88a7 = (state)=>state.options.tooltipPayloadSearcher;


var $78fd7fcb0d81609e$export$703b585bc92b5bae = (state)=>state.tooltip;





function $51ff0ceee53f8296$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $51ff0ceee53f8296$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $51ff0ceee53f8296$var$ownKeys(Object(t), !0).forEach(function(r) {
            $51ff0ceee53f8296$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $51ff0ceee53f8296$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $51ff0ceee53f8296$var$_defineProperty(e, r, t) {
    return (r = $51ff0ceee53f8296$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $51ff0ceee53f8296$var$_toPropertyKey(t) {
    var i = $51ff0ceee53f8296$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $51ff0ceee53f8296$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $51ff0ceee53f8296$var$selectFinalData(dataDefinedOnItem, dataDefinedOnChart) {
    /*
   * If a payload has data specified directly from the graphical item, prefer that.
   * Otherwise, fill in data from the chart level, using the same index.
   */ if (dataDefinedOnItem != null) return dataDefinedOnItem;
    return dataDefinedOnChart;
}
var $51ff0ceee53f8296$export$e50d50655fe0e7ab = (tooltipPayloadConfigurations, activeIndex, chartDataState, tooltipAxisDataKey, activeLabel, tooltipPayloadSearcher, tooltipEventType)=>{
    if (activeIndex == null || tooltipPayloadSearcher == null) return undefined;
    var { chartData: chartData, computedData: computedData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = chartDataState;
    var init = [];
    return tooltipPayloadConfigurations.reduce((agg, _ref)=>{
        var _settings$dataKey;
        var { dataDefinedOnItem: dataDefinedOnItem, settings: settings } = _ref;
        var finalData = $51ff0ceee53f8296$var$selectFinalData(dataDefinedOnItem, chartData);
        var sliced = Array.isArray(finalData) ? (0, $c1b90a42ae6f9682$export$238176e5211cdc1a)(finalData, dataStartIndex, dataEndIndex) : finalData;
        var finalDataKey = (_settings$dataKey = settings === null || settings === void 0 ? void 0 : settings.dataKey) !== null && _settings$dataKey !== void 0 ? _settings$dataKey : tooltipAxisDataKey;
        // BaseAxisProps does not support nameKey but it could!
        var finalNameKey = settings === null || settings === void 0 ? void 0 : settings.nameKey; // ?? tooltipAxis?.nameKey;
        var tooltipPayload;
        if (tooltipAxisDataKey && Array.isArray(sliced) && /*
     * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
     * as tooltip payloads and findEntryInArray is not prepared to handle that.
     * Sad but also ScatterChart only allows 'item' tooltipEventType
     * and also this is only a problem if there are multiple Scatters and each has its own data array
     * so let's fix that some other time.
     */ !Array.isArray(sliced[0]) && /*
     * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
     * because thanks to allowDuplicatedCategory=false, the order of elements in the array
     * no longer matches the order of elements in the original data
     * and so we need to search by the active dataKey + label rather than by index.
     *
     * The same happens if multiple graphical items are present in the chart
     * and each of them has its own data array. Those arrays get concatenated
     * and again the tooltip index no longer matches the original data.
     *
     * On the other hand the tooltipEventType 'item' should always search by index
     * because we get the index from interacting over the individual elements
     * which is always accurate, irrespective of the allowDuplicatedCategory setting.
     */ tooltipEventType === 'axis') tooltipPayload = (0, $2ab3a7e25c8aba74$export$66950d3869f5cc67)(sliced, tooltipAxisDataKey, activeLabel);
        else /*
       * This is a problem because it assumes that the index is pointing to the displayed data
       * which it isn't because the index is pointing to the tooltip ticks array.
       * The above approach (with findEntryInArray) is the correct one, but it only works
       * if the axis dataKey is defined explicitly, and if the data is an array of objects.
       */ tooltipPayload = tooltipPayloadSearcher(sliced, activeIndex, computedData, finalNameKey);
        if (Array.isArray(tooltipPayload)) tooltipPayload.forEach((item)=>{
            var newSettings = $51ff0ceee53f8296$var$_objectSpread($51ff0ceee53f8296$var$_objectSpread({}, settings), {}, {
                // @ts-expect-error we're assuming that item has name and unit properties
                name: item.name,
                // @ts-expect-error we're assuming that item has name and unit properties
                unit: item.unit,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                color: undefined,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                fill: undefined
            });
            agg.push((0, $cd015374923bb5c7$export$3c1b390368bb3561)({
                tooltipEntrySettings: newSettings,
                // @ts-expect-error we're assuming that item has name and unit properties
                dataKey: item.dataKey,
                // @ts-expect-error we're assuming that item has name and unit properties
                payload: item.payload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(item.payload, item.dataKey),
                // @ts-expect-error we're assuming that item has name and unit properties
                name: item.name
            }));
        });
        else {
            var _getValueByDataKey;
            // I am not quite sure why these two branches (Array vs Array of Arrays) have to behave differently - I imagine we should unify these. 3.x breaking change?
            agg.push((0, $cd015374923bb5c7$export$3c1b390368bb3561)({
                tooltipEntrySettings: settings,
                dataKey: finalDataKey,
                payload: tooltipPayload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(tooltipPayload, finalDataKey),
                // @ts-expect-error getValueByDataKey does not validate the output type
                name: (_getValueByDataKey = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(tooltipPayload, finalNameKey)) !== null && _getValueByDataKey !== void 0 ? _getValueByDataKey : settings === null || settings === void 0 ? void 0 : settings.name
            }));
        }
        return agg;
    }, init);
};










var $51c6a3a12cea9b0d$export$221021c57c593b2 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    (0, $6aac8fe27ae10a7b$export$1c7798b82c8010cd),
    (0, $dcfc24e85ad2aefd$export$3247769c9dbde559)
], (0, $6aac8fe27ae10a7b$export$bebec32544750591));
var $51c6a3a12cea9b0d$export$4751149f4d54cbbf = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (state)=>state.graphicalItems.cartesianItems,
    (state)=>state.graphicalItems.polarItems
], (cartesianItems, polarItems)=>[
        ...cartesianItems,
        ...polarItems
    ]);
var $51c6a3a12cea9b0d$var$selectTooltipAxisPredicate = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482),
    (0, $c92d1f706423a70a$export$eeffdb10daff095d)
], (0, $6aac8fe27ae10a7b$export$a3923f321c6572c3));
var $51c6a3a12cea9b0d$export$645965005f643e6f = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$4751149f4d54cbbf,
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$var$selectTooltipAxisPredicate
], (0, $6aac8fe27ae10a7b$export$ad35679ce4582010), {
    memoizeOptions: {
        resultEqualityCheck: (0, $0499b9ab63ed35d4$export$dcc34c4213e7f4c)
    }
});
var $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItemsSettings = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $6bd3f90b40714619$export$2335dd91cc88053e)));
var $51c6a3a12cea9b0d$export$b3f948fbed0299f1 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (0, $6aac8fe27ae10a7b$export$d945cee965d266f0), {
    memoizeOptions: {
        resultEqualityCheck: (0, $0499b9ab63ed35d4$export$dcc34c4213e7f4c)
    }
});
var $51c6a3a12cea9b0d$export$5a8beccc8250d20e = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$b3f948fbed0299f1,
    (0, $d235e165ed12974e$export$519edd692222520)
], (0, $6aac8fe27ae10a7b$export$c2c6d012cffe2c75));
var $51c6a3a12cea9b0d$var$selectTooltipStackedData = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItemsSettings,
    (0, $d235e165ed12974e$export$519edd692222520),
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7)
], (0, $3bf52c7ae65ae57f$export$ae6c77e7720cddf9));
var $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (0, $6aac8fe27ae10a7b$export$3051da2013ba9cfe));
var $51c6a3a12cea9b0d$var$selectTooltipAxisDomainDefinition = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7)
], (0, $6aac8fe27ae10a7b$export$2e6262b6c952ab02));
var $51c6a3a12cea9b0d$var$selectTooltipDataOverflow = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7)
], (axisSettings)=>axisSettings.allowDataOverflow);
var $51c6a3a12cea9b0d$var$selectTooltipDomainFromUserPreferences = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipAxisDomainDefinition,
    $51c6a3a12cea9b0d$var$selectTooltipDataOverflow
], (0, $77a63a99eb6fec8b$export$fcbf88d4627b24df));
var $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItems = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $6bd3f90b40714619$export$2335dd91cc88053e)));
var $51c6a3a12cea9b0d$var$selectTooltipStackGroups = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipStackedData,
    $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItems,
    (0, $dcfc24e85ad2aefd$export$73aff39176364def),
    (0, $dcfc24e85ad2aefd$export$ec830dc49707c6da)
], (0, $6aac8fe27ae10a7b$export$9312914d13496409));
var $51c6a3a12cea9b0d$var$selectTooltipDomainOfStackGroups = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipStackGroups,
    (0, $d235e165ed12974e$export$519edd692222520),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482),
    $51c6a3a12cea9b0d$var$selectTooltipDomainFromUserPreferences
], (0, $6aac8fe27ae10a7b$export$3286b8ea6ff06720));
var $51c6a3a12cea9b0d$var$selectTooltipItemsSettingsExceptStacked = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (0, $6aac8fe27ae10a7b$export$a61da86823382adc));
var $51c6a3a12cea9b0d$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$var$selectTooltipItemsSettingsExceptStacked,
    (0, $6aac8fe27ae10a7b$export$9429ab4550237b6d),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$df56c8e9a3e45e65), {
    memoizeOptions: {
        resultEqualityCheck: (0, $192fdd139bcf9f78$export$45c01007b107f1a6)
    }
});
var $51c6a3a12cea9b0d$var$selectReferenceDotsByTooltipAxis = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$71580de5ed38161a),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482),
    (0, $c92d1f706423a70a$export$eeffdb10daff095d)
], (0, $6aac8fe27ae10a7b$export$2829d12117d2002f));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceDotsDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectReferenceDotsByTooltipAxis,
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$5da0b79fd816ec4b));
var $51c6a3a12cea9b0d$var$selectReferenceAreasByTooltipAxis = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$c7e152cb7f10c1a6),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482),
    (0, $c92d1f706423a70a$export$eeffdb10daff095d)
], (0, $6aac8fe27ae10a7b$export$2829d12117d2002f));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceAreasDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectReferenceAreasByTooltipAxis,
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$7b27918cf5e1fc19));
var $51c6a3a12cea9b0d$var$selectReferenceLinesByTooltipAxis = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$8fe2a49ce63c5348),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482),
    (0, $c92d1f706423a70a$export$eeffdb10daff095d)
], (0, $6aac8fe27ae10a7b$export$2829d12117d2002f));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceLinesDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectReferenceLinesByTooltipAxis,
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$f1d17aebd11953eb));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceElementsDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipReferenceDotsDomain,
    $51c6a3a12cea9b0d$var$selectTooltipReferenceLinesDomain,
    $51c6a3a12cea9b0d$var$selectTooltipReferenceAreasDomain
], (0, $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d));
var $51c6a3a12cea9b0d$var$selectTooltipNumericalDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$var$selectTooltipAxisDomainDefinition,
    $51c6a3a12cea9b0d$var$selectTooltipDomainFromUserPreferences,
    $51c6a3a12cea9b0d$var$selectTooltipDomainOfStackGroups,
    $51c6a3a12cea9b0d$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $51c6a3a12cea9b0d$var$selectTooltipReferenceElementsDomain,
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$b9eca0fd568f66a4));
var $51c6a3a12cea9b0d$export$76f7a1975f60ccf1 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues,
    (0, $dcfc24e85ad2aefd$export$73aff39176364def),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482),
    $51c6a3a12cea9b0d$var$selectTooltipNumericalDomain
], (0, $6aac8fe27ae10a7b$export$70e6ef68424edf74));
var $51c6a3a12cea9b0d$var$selectTooltipNiceTicks = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$76f7a1975f60ccf1,
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$export$221021c57c593b2
], (0, $6aac8fe27ae10a7b$export$aa1ef6c8f610e48c));
var $51c6a3a12cea9b0d$export$90be38154e4228b2 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$export$76f7a1975f60ccf1,
    $51c6a3a12cea9b0d$var$selectTooltipNiceTicks,
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$3a4530026b1860ff));
var $51c6a3a12cea9b0d$var$selectTooltipAxisRange = (state)=>{
    var axisType = (0, $37e5cc0fa883575c$export$898d3dfd98fb482)(state);
    var axisId = (0, $c92d1f706423a70a$export$eeffdb10daff095d)(state);
    var isPanorama = false; // Tooltip never displays in panorama so this is safe to assume
    return (0, $6aac8fe27ae10a7b$export$3506ed461810cc8f)(state, axisType, axisId, isPanorama);
};
var $51c6a3a12cea9b0d$export$cf4d6dfce3a76af3 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$var$selectTooltipAxisRange
], (0, $1dbac917d7459aa2$export$3f7e30291950e694));
var $51c6a3a12cea9b0d$export$cdeccbbdd343ae59 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$export$221021c57c593b2,
    $51c6a3a12cea9b0d$export$90be38154e4228b2,
    $51c6a3a12cea9b0d$export$cf4d6dfce3a76af3
], (0, $6aac8fe27ae10a7b$export$e2fe61793fcf6495));
var $51c6a3a12cea9b0d$var$selectTooltipDuplicateDomain = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues,
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$bb1ebf56a37bd899));
var $51c6a3a12cea9b0d$export$f7665d13a99c934c = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues,
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], (0, $6aac8fe27ae10a7b$export$911ef47868c9ab07));
var $51c6a3a12cea9b0d$var$combineTicksOfTooltipAxis = (layout, axis, realScaleType, scale, range, duplicateDomain, categoricalDomain, axisType)=>{
    if (!axis) return undefined;
    var { type: type } = axis;
    var isCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, axisType);
    if (!scale) return undefined;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range != null && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as an index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $2ab3a7e25c8aba74$export$7e515ab5fbd92bef));
};
var $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $6aac8fe27ae10a7b$export$27d9004292294cd7),
    $51c6a3a12cea9b0d$export$221021c57c593b2,
    $51c6a3a12cea9b0d$export$cdeccbbdd343ae59,
    $51c6a3a12cea9b0d$var$selectTooltipAxisRange,
    $51c6a3a12cea9b0d$var$selectTooltipDuplicateDomain,
    $51c6a3a12cea9b0d$export$f7665d13a99c934c,
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482)
], $51c6a3a12cea9b0d$var$combineTicksOfTooltipAxis);
var $51c6a3a12cea9b0d$var$selectTooltipEventType = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $21536fb21082ce97$export$877d2dd8db5f51fd),
    (0, $21536fb21082ce97$export$7f95a7e594fa7911),
    (0, $ec4de2c43a3d7eef$export$26d1e95fb7dea02)
], (defaultTooltipEventType, validateTooltipEventType, settings)=>(0, $21536fb21082ce97$export$d419a1f58b445a8f)(settings.shared, defaultTooltipEventType, validateTooltipEventType));
var $51c6a3a12cea9b0d$var$selectTooltipTrigger = (state)=>state.tooltip.settings.trigger;
var $51c6a3a12cea9b0d$var$selectDefaultIndex = (state)=>state.tooltip.settings.defaultIndex;
var $51c6a3a12cea9b0d$var$selectTooltipInteractionState = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $78fd7fcb0d81609e$export$703b585bc92b5bae),
    $51c6a3a12cea9b0d$var$selectTooltipEventType,
    $51c6a3a12cea9b0d$var$selectTooltipTrigger,
    $51c6a3a12cea9b0d$var$selectDefaultIndex
], (0, $3d3790706a3050f8$export$d759c39cacfacf6a));
var $51c6a3a12cea9b0d$export$8b2762260f5891c9 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState,
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    (0, $6aac8fe27ae10a7b$export$bf8397fefbaa3617),
    $51c6a3a12cea9b0d$export$76f7a1975f60ccf1
], (0, $927073e84a89ab02$export$32df4b03a0962e46));
var $51c6a3a12cea9b0d$export$400c35cc3b9a0487 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a,
    $51c6a3a12cea9b0d$export$8b2762260f5891c9
], (0, $3b61016ee0a2b578$export$3213c4688ceb4c80));
var $51c6a3a12cea9b0d$export$999f7a7ced063fab = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.dataKey;
});
var $51c6a3a12cea9b0d$export$3bddf33d79812741 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.graphicalItemId;
});
var $51c6a3a12cea9b0d$var$selectTooltipPayloadConfigurations = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $78fd7fcb0d81609e$export$703b585bc92b5bae),
    $51c6a3a12cea9b0d$var$selectTooltipEventType,
    $51c6a3a12cea9b0d$var$selectTooltipTrigger,
    $51c6a3a12cea9b0d$var$selectDefaultIndex
], (0, $790486f25cd906b4$export$45044aaa79c0cddb));
var $51c6a3a12cea9b0d$var$selectTooltipCoordinateForDefaultIndex = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $0ab9657931cbbb24$export$771ef0ac044f724d),
    (0, $0ab9657931cbbb24$export$5856a7d94c109505),
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a,
    $51c6a3a12cea9b0d$var$selectDefaultIndex,
    $51c6a3a12cea9b0d$var$selectTooltipPayloadConfigurations
], (0, $40e435146911cfcc$export$c2cbc37a7546bbd0));
var $51c6a3a12cea9b0d$export$90c565a5b196e427 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState,
    $51c6a3a12cea9b0d$var$selectTooltipCoordinateForDefaultIndex
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    if (tooltipInteractionState !== null && tooltipInteractionState !== void 0 && tooltipInteractionState.coordinate) return tooltipInteractionState.coordinate;
    return defaultIndexCoordinate;
});
var $51c6a3a12cea9b0d$export$c8884ed37796034a = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState
], (tooltipInteractionState)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState === null || tooltipInteractionState === void 0 ? void 0 : tooltipInteractionState.active) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : false;
});
var $51c6a3a12cea9b0d$export$a2bb5be6e87cbb86 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$var$selectTooltipPayloadConfigurations,
    $51c6a3a12cea9b0d$export$8b2762260f5891c9,
    (0, $d235e165ed12974e$export$519edd692222520),
    (0, $6aac8fe27ae10a7b$export$bf8397fefbaa3617),
    $51c6a3a12cea9b0d$export$400c35cc3b9a0487,
    (0, $30f1a9633819407c$export$6ae1ee94e6fa88a7),
    $51c6a3a12cea9b0d$var$selectTooltipEventType
], (0, $51ff0ceee53f8296$export$e50d50655fe0e7ab));
var $51c6a3a12cea9b0d$export$1a5b9bd341ad5f0e = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $51c6a3a12cea9b0d$export$a2bb5be6e87cbb86
], (payload)=>{
    if (payload == null) return undefined;
    var dataPoints = payload.map((p)=>p.payload).filter((p)=>p != null);
    return Array.from(new Set(dataPoints));
});




function $177f608375879b5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $177f608375879b5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $177f608375879b5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $177f608375879b5a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $177f608375879b5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $177f608375879b5a$var$_defineProperty(e, r, t) {
    return (r = $177f608375879b5a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $177f608375879b5a$var$_toPropertyKey(t) {
    var i = $177f608375879b5a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $177f608375879b5a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $177f608375879b5a$export$e43f7367e579f53d = 0;
/**
 * Properties shared in X, Y, and Z axes.
 * User defined axis settings, coming from props.
 */ /**
 * These are the external props, visible for users as they set them using our public API.
 * There is all sorts of internal computed things based on these, but they will come through selectors.
 *
 * Properties shared between X and Y axes
 */ /**
 * Z axis is special because it's never displayed. It controls the size of Scatter dots,
 * but it never displays ticks anywhere.
 */ var $177f608375879b5a$var$initialState = {
    xAxis: {},
    yAxis: {},
    zAxis: {}
};
/**
 * This is the slice where each individual Axis element pushes its own configuration.
 * Prefer to use this one instead of axisSlice.
 */ var $177f608375879b5a$var$cartesianAxisSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'cartesianAxis',
    initialState: $177f608375879b5a$var$initialState,
    reducers: {
        addXAxis: {
            reducer (state, action) {
                state.xAxis[action.payload.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        replaceXAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.xAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.xAxis[prev.id];
                    state.xAxis[next.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        removeXAxis: {
            reducer (state, action) {
                delete state.xAxis[action.payload.id];
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        addYAxis: {
            reducer (state, action) {
                state.yAxis[action.payload.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        replaceYAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.yAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.yAxis[prev.id];
                    state.yAxis[next.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        removeYAxis: {
            reducer (state, action) {
                delete state.yAxis[action.payload.id];
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        addZAxis: {
            reducer (state, action) {
                state.zAxis[action.payload.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        replaceZAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.zAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.zAxis[prev.id];
                    state.zAxis[next.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        removeZAxis: {
            reducer (state, action) {
                delete state.zAxis[action.payload.id];
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        updateYAxisWidth (state, action) {
            var { id: id, width: width } = action.payload;
            var axis = state.yAxis[id];
            if (axis) {
                var _history$;
                var history = axis.widthHistory || [];
                // An oscillation is detected when the new width is the same as the width before the last one.
                // This is a simple A -> B -> A pattern. If the next width is B, and the difference is less than 1 pixel, we ignore it.
                if (history.length === 3 && history[0] === history[2] && width === history[1] && width !== axis.width && Math.abs(width - ((_history$ = history[0]) !== null && _history$ !== void 0 ? _history$ : 0)) <= 1) return;
                var newHistory = [
                    ...history,
                    width
                ].slice(-3);
                state.yAxis[id] = $177f608375879b5a$var$_objectSpread($177f608375879b5a$var$_objectSpread({}, axis), {}, {
                    width: width,
                    widthHistory: newHistory
                });
            }
        }
    }
});
var { addXAxis: $177f608375879b5a$export$add6226ad7812fc8, replaceXAxis: $177f608375879b5a$export$40aac341c282a543, removeXAxis: $177f608375879b5a$export$f408189458c6a79b, addYAxis: $177f608375879b5a$export$4ed10a19d7febea1, replaceYAxis: $177f608375879b5a$export$58b7fa4a7d4572f6, removeYAxis: $177f608375879b5a$export$79db5e9bd25f14c4, addZAxis: $177f608375879b5a$export$1c8a1319a1571880, replaceZAxis: $177f608375879b5a$export$ad147e7505520476, removeZAxis: $177f608375879b5a$export$d823f07ec1da7041, updateYAxisWidth: $177f608375879b5a$export$6e42dbbf4e5a5faa } = $177f608375879b5a$var$cartesianAxisSlice.actions;
var $177f608375879b5a$export$c8ae79f5f6ae07c6 = $177f608375879b5a$var$cartesianAxisSlice.reducer;








var $db58c9c4dbfd259c$export$623d7e312118b313 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b)
], (offsetInternal)=>{
    return {
        top: offsetInternal.top,
        bottom: offsetInternal.bottom,
        left: offsetInternal.left,
        right: offsetInternal.right
    };
});





var $cf85589f32ad71bb$export$8a921ed356911d9a = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $db58c9c4dbfd259c$export$623d7e312118b313),
    (0, $0ab9657931cbbb24$export$771ef0ac044f724d),
    (0, $0ab9657931cbbb24$export$5856a7d94c109505)
], (offset, chartWidth, chartHeight)=>{
    if (!offset || chartWidth == null || chartHeight == null) return undefined;
    return {
        x: offset.left,
        y: offset.top,
        width: Math.max(0, chartWidth - offset.left - offset.right),
        height: Math.max(0, chartHeight - offset.top - offset.bottom)
    };
});


var $42890447eb7e6cfe$export$5acf30f46eb8262f = (xAxisId)=>{
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$db526816f6980005 = (yAxisId)=>{
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$44023ffa3b5a8134 = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$400c35cc3b9a0487));
};
var $42890447eb7e6cfe$export$99e5207fa7e69f17 = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $db58c9c4dbfd259c$export$623d7e312118b313));
};
var $42890447eb7e6cfe$export$f1ef8efc9ef6fe0c = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $cf85589f32ad71bb$export$8a921ed356911d9a));
};
var $42890447eb7e6cfe$export$a5935a9f8709ac28 = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$1a5b9bd341ad5f0e));
};
var $42890447eb7e6cfe$export$fef606eda509da71 = function useXAxisDomain() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $177f608375879b5a$export$e43f7367e579f53d);
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$4fc5ecb5227dd744)(state, 'xAxis', xAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$530156bda5a6e0b8 = function useYAxisDomain() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $177f608375879b5a$export$e43f7367e579f53d);
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$4fc5ecb5227dd744)(state, 'yAxis', yAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$664a603ccf171b5e = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$c8884ed37796034a))) !== null && _useAppSelector !== void 0 ? _useAppSelector : false;
};
var $42890447eb7e6cfe$export$c6c562f11dfccde2 = ()=>{
    var coordinate = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$90c565a5b196e427));
    if (coordinate == null) return undefined;
    return {
        x: coordinate.x,
        y: coordinate.y
    };
};






function $07378f2fb606b4ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07378f2fb606b4ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07378f2fb606b4ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $07378f2fb606b4ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07378f2fb606b4ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07378f2fb606b4ec$var$_defineProperty(e, r, t) {
    return (r = $07378f2fb606b4ec$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $07378f2fb606b4ec$var$_toPropertyKey(t) {
    var i = $07378f2fb606b4ec$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $07378f2fb606b4ec$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $07378f2fb606b4ec$var$ActivePoint = (_ref)=>{
    var { point: point, childIndex: childIndex, mainColor: mainColor, activeDot: activeDot, dataKey: dataKey, clipPath: clipPath } = _ref;
    if (activeDot === false || point.x == null || point.y == null) return null;
    var dotPropsTyped = {
        index: childIndex,
        dataKey: dataKey,
        cx: point.x,
        cy: point.y,
        r: 4,
        fill: mainColor !== null && mainColor !== void 0 ? mainColor : 'none',
        strokeWidth: 2,
        stroke: '#fff',
        payload: point.payload,
        value: point.value
    };
    // @ts-expect-error svgPropertiesNoEventsFromUnknown(activeDot) is contributing unknown props
    var dotProps = $07378f2fb606b4ec$var$_objectSpread($07378f2fb606b4ec$var$_objectSpread($07378f2fb606b4ec$var$_objectSpread({}, dotPropsTyped), (0, $37a0b0a95f0e25bf$export$6d5921c09aa671a9)(activeDot)), (0, $909d5f835f4e917b$export$7c4c290a4a9c1b1e)(activeDot));
    var dot;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(activeDot)) // @ts-expect-error we're improperly typing events
    dot = /*#__PURE__*/ (0, $acw62.cloneElement)(activeDot, dotProps);
    else if (typeof activeDot === 'function') dot = activeDot(dotProps);
    else dot = /*#__PURE__*/ $acw62.createElement((0, $1ab98349969d46e2$export$d046b3c4a416f60d), dotProps);
    return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: "recharts-active-dot",
        clipPath: clipPath
    }, dot);
};
function $07378f2fb606b4ec$export$dd2d3dc8acd956aa(_ref2) {
    var { points: points, mainColor: mainColor, activeDot: activeDot, itemDataKey: itemDataKey, clipPath: clipPath, zIndex: zIndex = (0, $c327287477e919da$export$96df16b28aa32702).activeDot } = _ref2;
    var activeTooltipIndex = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$8b2762260f5891c9));
    var activeDataPoints = (0, $42890447eb7e6cfe$export$a5935a9f8709ac28)();
    if (points == null || activeDataPoints == null) return null;
    var activePoint = points.find((p)=>activeDataPoints.includes(p.payload));
    if ((0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(activePoint)) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: zIndex
    }, /*#__PURE__*/ $acw62.createElement($07378f2fb606b4ec$var$ActivePoint, {
        point: activePoint,
        childIndex: Number(activeTooltipIndex),
        mainColor: mainColor,
        dataKey: itemDataKey,
        activeDot: activeDot,
        clipPath: clipPath
    }));
}



var $acw62 = parcelRequire("acw62");



function $1e712d1b3a15e741$export$7fa09c17ce18f3e8(_ref) {
    var { tooltipEntrySettings: tooltipEntrySettings } = _ref;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var prevSettingsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (isPanorama) // Panorama graphical items should never contribute to Tooltip payload.
        return;
        if (prevSettingsRef.current === null) dispatch((0, $3be7536b77e1512b$export$2eaa1babb4725485)(tooltipEntrySettings));
        else if (prevSettingsRef.current !== tooltipEntrySettings) dispatch((0, $3be7536b77e1512b$export$7333cdb61d5073d3)({
            prev: prevSettingsRef.current,
            next: tooltipEntrySettings
        }));
        prevSettingsRef.current = tooltipEntrySettings;
    }, [
        tooltipEntrySettings,
        dispatch,
        isPanorama
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $3be7536b77e1512b$export$29793cde90169929)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}



var $acw62 = parcelRequire("acw62");



function $dd677892692406d2$export$79e142f66441c204(xAxisId, yAxisId) {
    var _xAxis$allowDataOverf, _yAxis$allowDataOverf;
    var xAxis = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$d6895d8ddb4cee5)(state, xAxisId));
    var yAxis = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$1f472705a332f1c9)(state, yAxisId));
    var needClipX = (_xAxis$allowDataOverf = xAxis === null || xAxis === void 0 ? void 0 : xAxis.allowDataOverflow) !== null && _xAxis$allowDataOverf !== void 0 ? _xAxis$allowDataOverf : (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).allowDataOverflow;
    var needClipY = (_yAxis$allowDataOverf = yAxis === null || yAxis === void 0 ? void 0 : yAxis.allowDataOverflow) !== null && _yAxis$allowDataOverf !== void 0 ? _yAxis$allowDataOverf : (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).allowDataOverflow;
    var needClip = needClipX || needClipY;
    return {
        needClip: needClip,
        needClipX: needClipX,
        needClipY: needClipY
    };
}
function $dd677892692406d2$export$d65f7a7dd82fbb63(_ref) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, clipPathId: clipPathId } = _ref;
    var plotArea = (0, $42890447eb7e6cfe$export$f1ef8efc9ef6fe0c)();
    var { needClipX: needClipX, needClipY: needClipY, needClip: needClip } = $dd677892692406d2$export$79e142f66441c204(xAxisId, yAxisId);
    if (!needClip || !plotArea) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: needClipX ? x : x - width / 2,
        y: needClipY ? y : y - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
    }));
}











function $07dce3cd67839b77$export$eea16fee3026d9cf(state, id) {
    var _state$graphicalItems, _state$graphicalItems2;
    return (_state$graphicalItems = (_state$graphicalItems2 = state.graphicalItems.cartesianItems.find((item)=>item.id === id)) === null || _state$graphicalItems2 === void 0 ? void 0 : _state$graphicalItems2.xAxisId) !== null && _state$graphicalItems !== void 0 ? _state$graphicalItems : (0, $177f608375879b5a$export$e43f7367e579f53d);
}
function $07dce3cd67839b77$export$5babc813f7c13fff(state, id) {
    var _state$graphicalItems3, _state$graphicalItems4;
    return (_state$graphicalItems3 = (_state$graphicalItems4 = state.graphicalItems.cartesianItems.find((item)=>item.id === id)) === null || _state$graphicalItems4 === void 0 ? void 0 : _state$graphicalItems4.yAxisId) !== null && _state$graphicalItems3 !== void 0 ? _state$graphicalItems3 : (0, $177f608375879b5a$export$e43f7367e579f53d);
}


var $5fbeae2880aa4f3e$var$selectXAxisWithScale = (state, graphicalItemId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'xAxis', (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectXAxisTicks = (state, graphicalItemId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'xAxis', (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectYAxisWithScale = (state, graphicalItemId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'yAxis', (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectYAxisTicks = (state, graphicalItemId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'yAxis', (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectBandSize = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $5fbeae2880aa4f3e$var$selectXAxisWithScale,
    $5fbeae2880aa4f3e$var$selectYAxisWithScale,
    $5fbeae2880aa4f3e$var$selectXAxisTicks,
    $5fbeae2880aa4f3e$var$selectYAxisTicks
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks)=>{
    if ((0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, 'xAxis')) return (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(xAxis, xAxisTicks, false);
    return (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(yAxis, yAxisTicks, false);
});
var $5fbeae2880aa4f3e$var$pickAreaId = (_state, id)=>id;
/*
 * There is a race condition problem because we read some data from props and some from the state.
 * The state is updated through a dispatch and is one render behind,
 * and so we have this weird one tick render where the displayedData in one selector have the old dataKey
 * but the new dataKey in another selector.
 *
 * A proper fix is to either move everything into the state, or read the dataKey always from props
 * - but this is a smaller change.
 */ var $5fbeae2880aa4f3e$var$selectSynchronisedAreaSettings = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$f67c737adf41a3af),
    $5fbeae2880aa4f3e$var$pickAreaId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'area').find((item)=>item.id === id));
var $5fbeae2880aa4f3e$var$selectNumericalAxisType = (state)=>{
    var layout = (0, $e573f10901a87cfb$export$8426b6d9af801dee)(state);
    var isXAxisCategorical = (0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, 'xAxis');
    return isXAxisCategorical ? 'yAxis' : 'xAxis';
};
var $5fbeae2880aa4f3e$var$selectNumericalAxisIdFromGraphicalItemId = (state, graphicalItemId)=>{
    var axisType = $5fbeae2880aa4f3e$var$selectNumericalAxisType(state);
    if (axisType === 'yAxis') return (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, graphicalItemId);
    return (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, graphicalItemId);
};
var $5fbeae2880aa4f3e$var$selectNumericalAxisStackGroups = (state, graphicalItemId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$af2278e5e47fc440)(state, $5fbeae2880aa4f3e$var$selectNumericalAxisType(state), $5fbeae2880aa4f3e$var$selectNumericalAxisIdFromGraphicalItemId(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$export$cc6a257c8cf034c2 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $5fbeae2880aa4f3e$var$selectSynchronisedAreaSettings,
    $5fbeae2880aa4f3e$var$selectNumericalAxisStackGroups
], (areaSettings, stackGroups)=>{
    var _stackGroups$stackId;
    if (areaSettings == null || stackGroups == null) return undefined;
    var { stackId: stackId } = areaSettings;
    var stackSeriesIdentifier = (0, $c86621286e2c8ba6$export$58b095b87bc46727)(areaSettings);
    if (stackId == null || stackSeriesIdentifier == null) return undefined;
    var groups = (_stackGroups$stackId = stackGroups[stackId]) === null || _stackGroups$stackId === void 0 ? void 0 : _stackGroups$stackId.stackedData;
    var found = groups === null || groups === void 0 ? void 0 : groups.find((v)=>v.key === stackSeriesIdentifier);
    if (found == null) return undefined;
    return found.map((item)=>[
            item[0],
            item[1]
        ]);
});
var $5fbeae2880aa4f3e$export$5f2090c2af7a0678 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $5fbeae2880aa4f3e$var$selectXAxisWithScale,
    $5fbeae2880aa4f3e$var$selectYAxisWithScale,
    $5fbeae2880aa4f3e$var$selectXAxisTicks,
    $5fbeae2880aa4f3e$var$selectYAxisTicks,
    $5fbeae2880aa4f3e$export$cc6a257c8cf034c2,
    (0, $d235e165ed12974e$export$46bf9459876c0e0c),
    $5fbeae2880aa4f3e$var$selectBandSize,
    $5fbeae2880aa4f3e$var$selectSynchronisedAreaSettings,
    (0, $dcfc24e85ad2aefd$export$a1ad1f48be8d5def)
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks, stackedData, _ref, bandSize, areaSettings, chartBaseValue)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (areaSettings == null || layout !== 'horizontal' && layout !== 'vertical' || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || xAxisTicks.length === 0 || yAxisTicks.length === 0 || bandSize == null) return undefined;
    var { data: data } = areaSettings;
    var displayedData;
    if (data && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $551fcf7b84a33486$export$bb0068e0a912aef6)({
        layout: layout,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        dataStartIndex: dataStartIndex,
        areaSettings: areaSettings,
        stackedData: stackedData,
        displayedData: displayedData,
        chartBaseValue: chartBaseValue,
        bandSize: bandSize
    });
});

























function $d619218d8fdf3f2a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d619218d8fdf3f2a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d619218d8fdf3f2a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d619218d8fdf3f2a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d619218d8fdf3f2a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d619218d8fdf3f2a$var$_defineProperty(e, r, t) {
    return (r = $d619218d8fdf3f2a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d619218d8fdf3f2a$var$_toPropertyKey(t) {
    var i = $d619218d8fdf3f2a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d619218d8fdf3f2a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d619218d8fdf3f2a$export$cfad5721ad1fe55 = (layout, tooltipTicks, activeIndex, pointer)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: pointer.chartY
        };
        if (layout === 'vertical') return {
            x: pointer.chartX,
            y: entry.coordinate
        };
    }
    return {
        x: 0,
        y: 0
    };
};
var $d619218d8fdf3f2a$export$6bc723868198544 = (layout, tooltipTicks, activeIndex, rangeObj)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var { radius: _radius } = rangeObj;
            return $d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread({}, rangeObj), (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var { angle: angle } = rangeObj;
        return $d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread({}, rangeObj), (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return {
        angle: 0,
        clockWise: false,
        cx: 0,
        cy: 0,
        endAngle: 0,
        innerRadius: 0,
        outerRadius: 0,
        radius: 0,
        startAngle: 0,
        x: 0,
        y: 0
    };
};
function $d619218d8fdf3f2a$export$215f974420919247(pointer, offset) {
    var { chartX: x, chartY: y } = pointer;
    return x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
}
var $d619218d8fdf3f2a$export$3071d39cc844078e = (coordinate, ticks, unsortedTicks, axisType, range)=>{
    var _ticks$length;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or fewer ticks or if there is no coordinate then the active tick is at index 0
    if (len <= 1 || coordinate == null) return 0;
    if (axisType === 'angleAxis' && range != null && Math.abs(Math.abs(range[1] - range[0]) - 360) <= 1e-6) // ticks are distributed in a circle
    for(var i = 0; i < len; i++){
        var _unsortedTicks, _unsortedTicks2, _unsortedTicks$i, _unsortedTicks$, _unsortedTicks3;
        var before = i > 0 ? (_unsortedTicks = unsortedTicks[i - 1]) === null || _unsortedTicks === void 0 ? void 0 : _unsortedTicks.coordinate : (_unsortedTicks2 = unsortedTicks[len - 1]) === null || _unsortedTicks2 === void 0 ? void 0 : _unsortedTicks2.coordinate;
        var cur = (_unsortedTicks$i = unsortedTicks[i]) === null || _unsortedTicks$i === void 0 ? void 0 : _unsortedTicks$i.coordinate;
        var after = i >= len - 1 ? (_unsortedTicks$ = unsortedTicks[0]) === null || _unsortedTicks$ === void 0 ? void 0 : _unsortedTicks$.coordinate : (_unsortedTicks3 = unsortedTicks[i + 1]) === null || _unsortedTicks3 === void 0 ? void 0 : _unsortedTicks3.coordinate;
        var sameDirectionCoord = void 0;
        if (before == null || cur == null || after == null) continue;
        if ((0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(cur - before) !== (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(after - cur)) {
            var diffInterval = [];
            if ((0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(after - cur) === (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(range[1] - range[0])) {
                sameDirectionCoord = after;
                var curInRange = cur + range[1] - range[0];
                diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
            } else {
                sameDirectionCoord = before;
                var afterInRange = after + range[1] - range[0];
                diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
            }
            var sameInterval = [
                Math.min(cur, (sameDirectionCoord + cur) / 2),
                Math.max(cur, (sameDirectionCoord + cur) / 2)
            ];
            if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                var _unsortedTicks$i2;
                return (_unsortedTicks$i2 = unsortedTicks[i]) === null || _unsortedTicks$i2 === void 0 ? void 0 : _unsortedTicks$i2.index;
            }
        } else {
            var minValue = Math.min(before, after);
            var maxValue = Math.max(before, after);
            if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                var _unsortedTicks$i3;
                return (_unsortedTicks$i3 = unsortedTicks[i]) === null || _unsortedTicks$i3 === void 0 ? void 0 : _unsortedTicks$i3.index;
            }
        }
    }
    else if (ticks) // ticks are distributed in a single direction
    for(var _i = 0; _i < len; _i++){
        var curr = ticks[_i];
        if (curr == null) continue;
        var next = ticks[_i + 1];
        var prev = ticks[_i - 1];
        if (_i === 0 && next != null && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
        if (_i === len - 1 && prev != null && coordinate > (curr.coordinate + prev.coordinate) / 2) return curr.index;
        if (_i > 0 && _i < len - 1 && prev != null && next != null && coordinate > (curr.coordinate + prev.coordinate) / 2 && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
    }
    return -1;
};



var $5211e0f48c9883fe$export$ed30b3372172c46c = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$3247769c9dbde559));
};
var $5211e0f48c9883fe$var$pickTooltipEventType = (_state, tooltipEventType)=>tooltipEventType;
var $5211e0f48c9883fe$var$pickTrigger = (_state, _tooltipEventType, trigger)=>trigger;
var $5211e0f48c9883fe$var$pickDefaultIndex = (_state, _tooltipEventType, _trigger, defaultIndex)=>defaultIndex;
var $5211e0f48c9883fe$export$e133bec3c93a9247 = (0, $375276bea32f9eda$export$595d22ed68ca2841)((0, $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a), (ticks)=>(0, (/*@__PURE__*/$parcel$interopDefault($f89f7c674aff322e$exports)))(ticks, (o)=>o.coordinate));
var $5211e0f48c9883fe$export$1288ff5c64c4ac42 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $78fd7fcb0d81609e$export$703b585bc92b5bae),
    $5211e0f48c9883fe$var$pickTooltipEventType,
    $5211e0f48c9883fe$var$pickTrigger,
    $5211e0f48c9883fe$var$pickDefaultIndex
], (0, $3d3790706a3050f8$export$d759c39cacfacf6a));
var $5211e0f48c9883fe$export$95fb15d7bb7a8a94 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $5211e0f48c9883fe$export$1288ff5c64c4ac42,
    (0, $51c6a3a12cea9b0d$export$5a8beccc8250d20e),
    (0, $6aac8fe27ae10a7b$export$bf8397fefbaa3617),
    (0, $51c6a3a12cea9b0d$export$76f7a1975f60ccf1)
], (0, $927073e84a89ab02$export$32df4b03a0962e46));
var $5211e0f48c9883fe$export$faa2b8b92235e5bd = (state, tooltipEventType, trigger)=>{
    if (tooltipEventType == null) return undefined;
    var tooltipState = (0, $78fd7fcb0d81609e$export$703b585bc92b5bae)(state);
    if (tooltipEventType === 'axis') {
        if (trigger === 'hover') return tooltipState.axisInteraction.hover.dataKey;
        return tooltipState.axisInteraction.click.dataKey;
    }
    if (trigger === 'hover') return tooltipState.itemInteraction.hover.dataKey;
    return tooltipState.itemInteraction.click.dataKey;
};
var $5211e0f48c9883fe$export$8ff07a725463bd5 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $78fd7fcb0d81609e$export$703b585bc92b5bae),
    $5211e0f48c9883fe$var$pickTooltipEventType,
    $5211e0f48c9883fe$var$pickTrigger,
    $5211e0f48c9883fe$var$pickDefaultIndex
], (0, $790486f25cd906b4$export$45044aaa79c0cddb));
var $5211e0f48c9883fe$export$7dbe424d18defe7d = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $0ab9657931cbbb24$export$771ef0ac044f724d),
    (0, $0ab9657931cbbb24$export$5856a7d94c109505),
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    (0, $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a),
    $5211e0f48c9883fe$var$pickDefaultIndex,
    $5211e0f48c9883fe$export$8ff07a725463bd5
], (0, $40e435146911cfcc$export$c2cbc37a7546bbd0));
var $5211e0f48c9883fe$export$392a0083df9bfd7c = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $5211e0f48c9883fe$export$1288ff5c64c4ac42,
    $5211e0f48c9883fe$export$7dbe424d18defe7d
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState.coordinate) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : defaultIndexCoordinate;
});
var $5211e0f48c9883fe$export$400c35cc3b9a0487 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a),
    $5211e0f48c9883fe$export$95fb15d7bb7a8a94
], (0, $3b61016ee0a2b578$export$3213c4688ceb4c80));
var $5211e0f48c9883fe$export$529676bfdba08611 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $5211e0f48c9883fe$export$8ff07a725463bd5,
    $5211e0f48c9883fe$export$95fb15d7bb7a8a94,
    (0, $d235e165ed12974e$export$519edd692222520),
    (0, $6aac8fe27ae10a7b$export$bf8397fefbaa3617),
    $5211e0f48c9883fe$export$400c35cc3b9a0487,
    (0, $30f1a9633819407c$export$6ae1ee94e6fa88a7),
    $5211e0f48c9883fe$var$pickTooltipEventType
], (0, $51ff0ceee53f8296$export$e50d50655fe0e7ab));
var $5211e0f48c9883fe$export$c8884ed37796034a = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $5211e0f48c9883fe$export$1288ff5c64c4ac42,
    $5211e0f48c9883fe$export$95fb15d7bb7a8a94
], (tooltipInteractionState, activeIndex)=>{
    return {
        isActive: tooltipInteractionState.active && activeIndex != null,
        activeIndex: activeIndex
    };
});
var $5211e0f48c9883fe$var$combineActiveCartesianProps = (chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (!(0, $d619218d8fdf3f2a$export$215f974420919247)(chartEvent, offset)) return undefined;
    var pos = (0, $cd015374923bb5c7$export$f29fac779ccd75bc)(chartEvent, layout);
    var activeIndex = (0, $d619218d8fdf3f2a$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $d619218d8fdf3f2a$export$cfad5721ad1fe55)(layout, tooltipTicks, activeIndex, chartEvent);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $5211e0f48c9883fe$var$combineActivePolarProps = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks || !polarViewBox) return undefined;
    var rangeObj = (0, $0f9bc5dd76ad1109$export$e85a2bf8cd31c504)(chartEvent, polarViewBox);
    if (!rangeObj) return undefined;
    var pos = (0, $cd015374923bb5c7$export$fb2b0f76aa25d837)(rangeObj, layout);
    var activeIndex = (0, $d619218d8fdf3f2a$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $d619218d8fdf3f2a$export$6bc723868198544)(layout, tooltipTicks, activeIndex, rangeObj);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $5211e0f48c9883fe$export$e1c9f959fffb37b4 = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !layout || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (layout === 'horizontal' || layout === 'vertical') return $5211e0f48c9883fe$var$combineActiveCartesianProps(chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset);
    return $5211e0f48c9883fe$var$combineActivePolarProps(chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks);
};



var $acw62 = parcelRequire("acw62");





/**
 * The properties inside this state update independently of each other and quite often.
 * When selecting, never select the whole state because you are going to get
 * unnecessary re-renders. Select only the properties you need.
 *
 * This is why this state type is not exported - don't use it directly.
 */ var $056a3e7c624b08cd$var$initialState = {
    settings: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'middle',
        itemSorter: 'value'
    },
    size: {
        width: 0,
        height: 0
    },
    payload: []
};
var $056a3e7c624b08cd$var$legendSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'legend',
    initialState: $056a3e7c624b08cd$var$initialState,
    reducers: {
        setLegendSize (state, action) {
            state.size.width = action.payload.width;
            state.size.height = action.payload.height;
        },
        setLegendSettings (state, action) {
            state.settings.align = action.payload.align;
            state.settings.layout = action.payload.layout;
            state.settings.verticalAlign = action.payload.verticalAlign;
            state.settings.itemSorter = action.payload.itemSorter;
        },
        addLegendPayload: {
            reducer (state, action) {
                state.payload.push((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        replaceLegendPayload: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).payload.indexOf((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(prev));
                if (index > -1) state.payload[index] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        removeLegendPayload: {
            reducer (state, action) {
                var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).payload.indexOf((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.payload.splice(index, 1);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        }
    }
});
var { setLegendSize: $056a3e7c624b08cd$export$f9ba9ab9b90c340e, setLegendSettings: $056a3e7c624b08cd$export$a1a647a9c0dcc839, addLegendPayload: $056a3e7c624b08cd$export$236fd33b6ffe3f4b, replaceLegendPayload: $056a3e7c624b08cd$export$379d42d798953c3d, removeLegendPayload: $056a3e7c624b08cd$export$337e5f2bb3b9e128 } = $056a3e7c624b08cd$var$legendSlice.actions;
var $056a3e7c624b08cd$export$8d8dfb8d5acf8179 = $056a3e7c624b08cd$var$legendSlice.reducer;


function $8f8fe5838f5f31a4$export$34b61b169492c008(_ref) {
    var { legendPayload: legendPayload } = _ref;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var prevPayloadRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (isPanorama) return;
        if (prevPayloadRef.current === null) dispatch((0, $056a3e7c624b08cd$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $056a3e7c624b08cd$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        isPanorama,
        legendPayload
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $056a3e7c624b08cd$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $8f8fe5838f5f31a4$export$eb937fedea4aab3a(_ref2) {
    var { legendPayload: legendPayload } = _ref2;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var layout = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $e573f10901a87cfb$export$8426b6d9af801dee));
    var prevPayloadRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (layout !== 'centric' && layout !== 'radial') return;
        if (prevPayloadRef.current === null) dispatch((0, $056a3e7c624b08cd$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $056a3e7c624b08cd$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        layout,
        legendPayload
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $056a3e7c624b08cd$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}




var $acw62 = parcelRequire("acw62");

function $72206edefbff003d$export$e1042b2944b80b7f(input) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'animation-';
    var animationId = (0, $acw62.useRef)((0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)(prefix));
    var prevProps = (0, $acw62.useRef)(input);
    if (prevProps.current !== input) {
        animationId.current = (0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)(prefix);
        prevProps.current = input;
    }
    return animationId.current;
}






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $98bc6bba54b726bd$var$_ref;
var $98bc6bba54b726bd$export$bf86633db292cdb4 = ()=>{
    var [id] = $acw62.useState(()=>(0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('uid-'));
    return id;
};
var $98bc6bba54b726bd$export$f680877a34711e37 = ($98bc6bba54b726bd$var$_ref = $acw62['useId'.toString()]) !== null && $98bc6bba54b726bd$var$_ref !== void 0 ? $98bc6bba54b726bd$var$_ref : $98bc6bba54b726bd$export$bf86633db292cdb4;


function $47303e546b24d86f$export$c485849f2e393253(prefix, customId) {
    /*
   * We have to call this hook here even if we don't use the result because
   * rules of hooks demand that hooks are never called conditionally.
   */ var generatedId = (0, $98bc6bba54b726bd$export$f680877a34711e37)();
    // If a custom ID is provided, it always takes precedence.
    if (customId) return customId;
    // Apply the prefix if one was provided.
    return prefix ? "".concat(prefix, "-").concat(generatedId) : generatedId;
} /**
 * The useUniqueId hook returns a unique ID that is either reused from external props or generated internally.
 * Either way the ID is now guaranteed to be present so no more nulls or undefined.
 */ 


var $e0af6fe07417fba6$var$GraphicalItemIdContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e0af6fe07417fba6$export$8c2f307ff93f02ba = (_ref)=>{
    var { id: id, type: type, children: children } = _ref;
    var resolvedId = (0, $47303e546b24d86f$export$c485849f2e393253)("recharts-".concat(type), id);
    return /*#__PURE__*/ $acw62.createElement($e0af6fe07417fba6$var$GraphicalItemIdContext.Provider, {
        value: resolvedId
    }, children(resolvedId));
};
function $e0af6fe07417fba6$export$e24f341c4ff41691() {
    return (0, $acw62.useContext)($e0af6fe07417fba6$var$GraphicalItemIdContext);
}



var $acw62 = parcelRequire("acw62");



/**
 * Unique ID of the graphical item.
 * This is used to identify the graphical item in the state and in the React tree.
 * This is required for every graphical item - it's either provided by the user or generated automatically.
 */ var $7490850bee546723$var$initialState = {
    cartesianItems: [],
    polarItems: []
};
var $7490850bee546723$var$graphicalItemsSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'graphicalItems',
    initialState: $7490850bee546723$var$initialState,
    reducers: {
        addCartesianGraphicalItem: {
            reducer (state, action) {
                state.cartesianItems.push((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        replaceCartesianGraphicalItem: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).cartesianItems.indexOf((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(prev));
                if (index > -1) state.cartesianItems[index] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        removeCartesianGraphicalItem: {
            reducer (state, action) {
                var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).cartesianItems.indexOf((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.cartesianItems.splice(index, 1);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        addPolarGraphicalItem: {
            reducer (state, action) {
                state.polarItems.push((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        },
        removePolarGraphicalItem: {
            reducer (state, action) {
                var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).polarItems.indexOf((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.polarItems.splice(index, 1);
            },
            prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
        }
    }
});
var { addCartesianGraphicalItem: $7490850bee546723$export$3f947cc833f5129c, replaceCartesianGraphicalItem: $7490850bee546723$export$5e4d82f2e2775795, removeCartesianGraphicalItem: $7490850bee546723$export$cc47a48755a91e1a, addPolarGraphicalItem: $7490850bee546723$export$468d47d44d0e088f, removePolarGraphicalItem: $7490850bee546723$export$77442a5b47e92750 } = $7490850bee546723$var$graphicalItemsSlice.actions;
var $7490850bee546723$export$183eecd5cb7dbb38 = $7490850bee546723$var$graphicalItemsSlice.reducer;


var $7e3660a50bf15c81$var$SetCartesianGraphicalItemImpl = (props)=>{
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var prevPropsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, $7490850bee546723$export$3f947cc833f5129c)(props));
        else if (prevPropsRef.current !== props) dispatch((0, $7490850bee546723$export$5e4d82f2e2775795)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, $7490850bee546723$export$cc47a48755a91e1a)(prevPropsRef.current));
                /*
         * Here we have to reset the ref to null because in StrictMode, the effect will run twice,
         * but it will keep the same ref value from the first render.
         *
         * In browser, React will clear the ref after the first effect cleanup,
         * so that wouldn't be an issue.
         *
         * In StrictMode, however, the ref is kept,
         * and in the hook above the code checks for `prevPropsRef.current === null`
         * which would be false so it would not dispatch the `addCartesianGraphicalItem` action again.
         *
         * https://github.com/recharts/recharts/issues/6022
         */ prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var $7e3660a50bf15c81$export$b600bf9c1966a9c2 = /*#__PURE__*/ (0, $acw62.memo)($7e3660a50bf15c81$var$SetCartesianGraphicalItemImpl);
function $7e3660a50bf15c81$export$8d7124402ca6b71c(props) {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useLayoutEffect)(()=>{
        dispatch((0, $7490850bee546723$export$468d47d44d0e088f)(props));
        return ()=>{
            dispatch((0, $7490850bee546723$export$77442a5b47e92750)(props));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}




var $acw62 = parcelRequire("acw62");


function $1cc24ee9ad4a37a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1cc24ee9ad4a37a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1cc24ee9ad4a37a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1cc24ee9ad4a37a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1cc24ee9ad4a37a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1cc24ee9ad4a37a9$var$_defineProperty(e, r, t) {
    return (r = $1cc24ee9ad4a37a9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1cc24ee9ad4a37a9$var$_toPropertyKey(t) {
    var i = $1cc24ee9ad4a37a9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1cc24ee9ad4a37a9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1cc24ee9ad4a37a9$export$51610fddbf64bc9d = (name)=>name.replace(/([A-Z])/g, (v)=>"-".concat(v.toLowerCase()));
var $1cc24ee9ad4a37a9$export$1594c78389ee3429 = (props, duration, easing)=>props.map((prop)=>"".concat($1cc24ee9ad4a37a9$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing)).join(',');
var $1cc24ee9ad4a37a9$export$59e29973723da0b3 = (preObj, nextObj)=>[
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce((a, b)=>a.filter((c)=>b.includes(c)));
var $1cc24ee9ad4a37a9$export$d6051a0f7a227332 = (fn, obj)=>Object.keys(obj).reduce((res, key)=>$1cc24ee9ad4a37a9$var$_objectSpread($1cc24ee9ad4a37a9$var$_objectSpread({}, res), {}, {
            [key]: fn(key, obj[key])
        }), {});


function $df1c98a61feadf51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df1c98a61feadf51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df1c98a61feadf51$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df1c98a61feadf51$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df1c98a61feadf51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df1c98a61feadf51$var$_defineProperty(e, r, t) {
    return (r = $df1c98a61feadf51$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $df1c98a61feadf51$var$_toPropertyKey(t) {
    var i = $df1c98a61feadf51$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $df1c98a61feadf51$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $df1c98a61feadf51$export$58f0f39f63f3cf42 = (begin, end, k)=>begin + (end - begin) * k;
var $df1c98a61feadf51$var$needContinue = (_ref)=>{
    var { from: from, to: to } = _ref;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $df1c98a61feadf51$var$calStepperVals = (easing, preVals, steps)=>{
    var nextStepVals = (0, $1cc24ee9ad4a37a9$export$d6051a0f7a227332)((key, val)=>{
        if ($df1c98a61feadf51$var$needContinue(val)) {
            var [newX, newV] = easing(val.from, val.to, val.velocity);
            return $df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $1cc24ee9ad4a37a9$export$d6051a0f7a227332)((key, val)=>{
        if ($df1c98a61feadf51$var$needContinue(val) && nextStepVals[key] != null) return $df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, val), {}, {
            velocity: $df1c98a61feadf51$export$58f0f39f63f3cf42(val.velocity, nextStepVals[key].velocity, steps),
            from: $df1c98a61feadf51$export$58f0f39f63f3cf42(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return $df1c98a61feadf51$var$calStepperVals(easing, nextStepVals, steps - 1);
};
function $df1c98a61feadf51$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) {
    var preTime;
    var stepperStyle = interKeys.reduce((res, key)=>$df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, res), {}, {
            [key]: {
                from: from[key],
                velocity: 0,
                to: to[key]
            }
        }), {});
    var getCurrStyle = ()=>(0, $1cc24ee9ad4a37a9$export$d6051a0f7a227332)((key, val)=>val.from, stepperStyle);
    var shouldStopAnimation = ()=>!Object.values(stepperStyle).filter($df1c98a61feadf51$var$needContinue).length;
    var stopAnimation = null;
    var stepperUpdate = (now)=>{
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $df1c98a61feadf51$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, from), to), getCurrStyle()));
        preTime = now;
        if (!shouldStopAnimation()) stopAnimation = timeoutController.setTimeout(stepperUpdate);
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(stepperUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation;
            (_stopAnimation = stopAnimation) === null || _stopAnimation === void 0 || _stopAnimation();
        };
    };
}
function $df1c98a61feadf51$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController) {
    var stopAnimation = null;
    var timingStyle = interKeys.reduce((res, key)=>{
        var fromElement = from[key];
        var toElement = to[key];
        if (fromElement == null || toElement == null) return res;
        return $df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, res), {}, {
            [key]: [
                fromElement,
                toElement
            ]
        });
    }, {});
    var beginTime;
    var timingUpdate = (now)=>{
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $1cc24ee9ad4a37a9$export$d6051a0f7a227332)((key, val)=>$df1c98a61feadf51$export$58f0f39f63f3cf42(...val, easing(t)), timingStyle);
        // get union set and add compatible prefix
        render($df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) stopAnimation = timeoutController.setTimeout(timingUpdate);
        else {
            var finalStyle = (0, $1cc24ee9ad4a37a9$export$d6051a0f7a227332)((key, val)=>$df1c98a61feadf51$export$58f0f39f63f3cf42(...val, easing(1)), timingStyle);
            render($df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(timingUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation2;
            (_stopAnimation2 = stopAnimation) === null || _stopAnimation2 === void 0 || _stopAnimation2();
        };
    };
}
var // configure update function
// eslint-disable-next-line import/no-default-export
$df1c98a61feadf51$export$2e2bcd8739ae039 = (from, to, easing, duration, render, timeoutController)=>{
    var interKeys = (0, $1cc24ee9ad4a37a9$export$59e29973723da0b3)(from, to);
    if (easing == null) // no animation, just set to final state
    return ()=>{
        render($df1c98a61feadf51$var$_objectSpread($df1c98a61feadf51$var$_objectSpread({}, from), to));
        return ()=>{};
    };
    return easing.isStepper === true ? $df1c98a61feadf51$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) : $df1c98a61feadf51$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController);
};


var $7ee8bda874947449$export$73dea3ad38069b0e = 1e-4;
var $7ee8bda874947449$var$cubicBezierFactor = (c1, c2)=>[
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
var $7ee8bda874947449$var$evaluatePolynomial = (params, t)=>params.map((param, i)=>param * t ** i).reduce((pre, curr)=>pre + curr);
var $7ee8bda874947449$var$cubicBezier = (c1, c2)=>(t)=>{
        var params = $7ee8bda874947449$var$cubicBezierFactor(c1, c2);
        return $7ee8bda874947449$var$evaluatePolynomial(params, t);
    };
var $7ee8bda874947449$var$derivativeCubicBezier = (c1, c2)=>(t)=>{
        var params = $7ee8bda874947449$var$cubicBezierFactor(c1, c2);
        var newParams = [
            ...params.map((param, i)=>param * i).slice(1),
            0
        ];
        return $7ee8bda874947449$var$evaluatePolynomial(newParams, t);
    };
var $7ee8bda874947449$var$parseCubicBezier = (easing)=>{
    var _easingParts$;
    var easingParts = easing.split('(');
    if (easingParts.length !== 2 || easingParts[0] !== 'cubic-bezier') return null;
    var numbers = (_easingParts$ = easingParts[1]) === null || _easingParts$ === void 0 || (_easingParts$ = _easingParts$.split(')')[0]) === null || _easingParts$ === void 0 ? void 0 : _easingParts$.split(',');
    if (numbers == null || numbers.length !== 4) return null;
    var coords = numbers.map((x)=>parseFloat(x));
    return [
        coords[0],
        coords[1],
        coords[2],
        coords[3]
    ];
};
var $7ee8bda874947449$var$getBezierCoordinates = function getBezierCoordinates() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            return [
                0.0,
                0.0,
                1.0,
                1.0
            ];
        case 'ease':
            return [
                0.25,
                0.1,
                0.25,
                1.0
            ];
        case 'ease-in':
            return [
                0.42,
                0.0,
                1.0,
                1.0
            ];
        case 'ease-out':
            return [
                0.42,
                0.0,
                0.58,
                1.0
            ];
        case 'ease-in-out':
            return [
                0.0,
                0.0,
                0.58,
                1.0
            ];
        default:
            var easing = $7ee8bda874947449$var$parseCubicBezier(args[0]);
            if (easing) return easing;
    }
    if (args.length === 4) return args;
    // Fallback for invalid inputs. The previous implementation was buggy and would lead to NaN.
    // Returning linear easing is a safe default.
    return [
        0.0,
        0.0,
        1.0,
        1.0
    ];
};
var $7ee8bda874947449$var$createBezierEasing = (x1, y1, x2, y2)=>{
    var curveX = $7ee8bda874947449$var$cubicBezier(x1, x2);
    var curveY = $7ee8bda874947449$var$cubicBezier(y1, y2);
    var derCurveX = $7ee8bda874947449$var$derivativeCubicBezier(x1, x2);
    var rangeValue = (value)=>{
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = (_t)=>{
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $7ee8bda874947449$export$73dea3ad38069b0e || derVal < $7ee8bda874947449$export$73dea3ad38069b0e) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $7ee8bda874947449$export$56c51296f72f0592 = function configBezier() {
    return $7ee8bda874947449$var$createBezierEasing(...$7ee8bda874947449$var$getBezierCoordinates(...arguments));
};
var $7ee8bda874947449$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var { stiff: stiff = 100, damping: damping = 8, dt: dt = 17 } = config;
    var stepper = (currX, destX, currV)=>{
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $7ee8bda874947449$export$73dea3ad38069b0e && Math.abs(newV) < $7ee8bda874947449$export$73dea3ad38069b0e) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $7ee8bda874947449$export$e3e04925801e5434 = (easing)=>{
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $7ee8bda874947449$export$56c51296f72f0592(easing);
        case 'spring':
            return $7ee8bda874947449$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $7ee8bda874947449$export$56c51296f72f0592(easing);
    }
    if (typeof easing === 'function') return easing;
    return null;
};



var $acw62 = parcelRequire("acw62");
/**
 * Represents a single item in the ReactSmoothQueue.
 * The item can be:
 * - A number representing a delay in milliseconds.
 * - An object representing a style change
 * - A StartAnimationFunction that starts eased transition and calls different render
 *      because of course in Recharts we have to have three ways to do everything
 * - An arbitrary function to be executed
 */ function $3050d6e0f4ff1a2d$export$26646f0bb02941d1(timeoutController) {
    var currStyle;
    var handleChange = ()=>null;
    var shouldStop = false;
    var cancelTimeout = null;
    var setStyle = (_style)=>{
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var [curr, ...restStyles] = styles;
            if (typeof curr === 'number') {
                cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles));
            return;
        }
        if (typeof _style === 'string') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: ()=>{
            shouldStop = true;
        },
        start: (style)=>{
            shouldStop = false;
            if (cancelTimeout) {
                cancelTimeout();
                cancelTimeout = null;
            }
            setStyle(style);
        },
        subscribe: (_handleChange)=>{
            handleChange = _handleChange;
            return ()=>{
                handleChange = ()=>null;
            };
        },
        getTimeoutController: ()=>timeoutController
    };
}


/**
 * Callback type for the timeout function.
 * Receives current time in milliseconds as an argument.
 */ /**
 * A function that, when called, cancels the timeout.
 */ class $c671326bd558adef$export$fa255b8f41b568c2 {
    setTimeout(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var startTime = performance.now();
        var requestId = null;
        var executeCallback = (now)=>{
            if (now - startTime >= delay) callback(now);
            else if (typeof requestAnimationFrame === 'function') requestId = requestAnimationFrame(executeCallback);
        };
        requestId = requestAnimationFrame(executeCallback);
        return ()=>{
            if (requestId != null) cancelAnimationFrame(requestId);
        };
    }
}


function $8c1ea964da85719a$export$a649b7dd21ebb400() {
    return (0, $3050d6e0f4ff1a2d$export$26646f0bb02941d1)(new (0, $c671326bd558adef$export$fa255b8f41b568c2)());
}


var $bb62efec71a54172$export$ec4cae1386f040b6 = /*#__PURE__*/ (0, $acw62.createContext)((0, $8c1ea964da85719a$export$a649b7dd21ebb400));
function $bb62efec71a54172$export$996cb06187bf3507(animationId, animationManagerFromProps) {
    var contextAnimationManager = (0, $acw62.useContext)($bb62efec71a54172$export$ec4cae1386f040b6);
    return (0, $acw62.useMemo)(()=>animationManagerFromProps !== null && animationManagerFromProps !== void 0 ? animationManagerFromProps : contextAnimationManager(animationId), [
        animationId,
        animationManagerFromProps,
        contextAnimationManager
    ]);
}



var $464febc3f716710f$var$defaultJavascriptAnimateProps = {
    begin: 0,
    duration: 1000,
    easing: 'ease',
    isActive: true,
    canBegin: true,
    onAnimationEnd: ()=>{},
    onAnimationStart: ()=>{}
};
var $464febc3f716710f$var$from = {
    t: 0
};
var $464febc3f716710f$var$to = {
    t: 1
};
function $464febc3f716710f$export$5d41821894c47c52(outsideProps) {
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $464febc3f716710f$var$defaultJavascriptAnimateProps);
    var { isActive: isActiveProp, canBegin: canBegin, duration: duration, easing: easing, begin: begin, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart, children: children } = props;
    var isActive = isActiveProp === 'auto' ? !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr : isActiveProp;
    var animationManager = (0, $bb62efec71a54172$export$996cb06187bf3507)(props.animationId, props.animationManager);
    var [style, setStyle] = (0, $acw62.useState)(isActive ? $464febc3f716710f$var$from : $464febc3f716710f$var$to);
    var stopJSAnimation = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!isActive) setStyle($464febc3f716710f$var$to);
    }, [
        isActive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isActive || !canBegin) return 0, $2ab3a7e25c8aba74$export$8793edee2d425525;
        var startAnimation = (0, $df1c98a61feadf51$export$2e2bcd8739ae039)($464febc3f716710f$var$from, $464febc3f716710f$var$to, (0, $7ee8bda874947449$export$e3e04925801e5434)(easing), duration, setStyle, animationManager.getTimeoutController());
        var onAnimationActive = ()=>{
            stopJSAnimation.current = startAnimation();
        };
        animationManager.start([
            onAnimationStart,
            begin,
            onAnimationActive,
            duration,
            onAnimationEnd
        ]);
        return ()=>{
            animationManager.stop();
            if (stopJSAnimation.current) stopJSAnimation.current();
            onAnimationEnd();
        };
    }, [
        isActive,
        canBegin,
        duration,
        easing,
        begin,
        onAnimationStart,
        onAnimationEnd,
        animationManager
    ]);
    return children(style.t);
}



function $fef0b63aa3904588$export$af45be059e20a9dd(dot) {
    var props = (0, $37a0b0a95f0e25bf$export$6d5921c09aa671a9)(dot);
    var defaultR = 3;
    var defaultStrokeWidth = 2;
    if (props != null) {
        var { r: r, strokeWidth: strokeWidth } = props;
        var realR = Number(r);
        var realStrokeWidth = Number(strokeWidth);
        if (Number.isNaN(realR) || realR < 0) realR = defaultR;
        if (Number.isNaN(realStrokeWidth) || realStrokeWidth < 0) realStrokeWidth = defaultStrokeWidth;
        return {
            r: realR,
            strokeWidth: realStrokeWidth
        };
    }
    return {
        r: defaultR,
        strokeWidth: defaultStrokeWidth
    };
}






var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
'use strict';

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;


var $83a0fb8931561019$var$propsToShallowCompare = new Set([
    'axisLine',
    'tickLine',
    'activeBar',
    'activeDot',
    'activeLabel',
    'activeShape',
    'allowEscapeViewBox',
    'background',
    'cursor',
    'dot',
    'label',
    'line',
    'margin',
    'padding',
    'position',
    'shape',
    'style',
    'tick',
    'wrapperStyle',
    // radius can be an array of 4 numbers, easy to compare shallowly
    'radius'
]);
/**
 * When comparing two values, returns true if they are the same value or
 * are both NaN.
 *
 * If we used just a simple triple equals, we would get false negatives for two NaNs
 * which could cause extra re-renders so let's have this instead.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Equality_comparisons_and_sameness#same-value-zero_equality
 *
 * @param x first value to compare
 * @param y second value to compare
 * return true if the same, false if different
 */ function $83a0fb8931561019$var$sameValueZero(x, y) {
    if (x == null && y == null) /*
     * treat null and undefined as equal. Internally in Recharts we make no difference between these two
     * so there is no need to re-render.
     */ return true;
    if (typeof x === 'number' && typeof y === 'number') // x and y are equal (this is true for -0 and 0) or they are both NaN
    // eslint-disable-next-line no-self-compare
    return x === y || x !== x && y !== y;
    return x === y;
}
function $83a0fb8931561019$export$b8f09df787c278d9(prevProps, nextProps) {
    var allKeys = new Set([
        ...Object.keys(prevProps),
        ...Object.keys(nextProps)
    ]);
    for (var key of allKeys){
        /*
     * If a key is on a special allowlist, go one level deeper
     * and do a shallow comparison of the values.
     */ if ($83a0fb8931561019$var$propsToShallowCompare.has(key)) {
            if (prevProps[key] == null && nextProps[key] == null) continue;
            if (!(0, $55388fc2f116d4d7$export$d36bdfa510afb180)(prevProps[key], nextProps[key])) return false;
        /*
       * Otherwise do a simple same-value comparison (with NaN support).
       */ } else if (!$83a0fb8931561019$var$sameValueZero(prevProps[key], nextProps[key])) return false;
    }
    return true;
}


var $551fcf7b84a33486$var$_excluded = [
    "id"
], $551fcf7b84a33486$var$_excluded2 = [
    "activeDot",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "connectNulls",
    "dot",
    "fill",
    "fillOpacity",
    "hide",
    "isAnimationActive",
    "legendType",
    "stroke",
    "xAxisId",
    "yAxisId"
];
function $551fcf7b84a33486$var$_extends() {
    return $551fcf7b84a33486$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $551fcf7b84a33486$var$_extends.apply(null, arguments);
}
function $551fcf7b84a33486$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $551fcf7b84a33486$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $551fcf7b84a33486$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $551fcf7b84a33486$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $551fcf7b84a33486$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $551fcf7b84a33486$var$ownKeys(Object(t), !0).forEach(function(r) {
            $551fcf7b84a33486$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $551fcf7b84a33486$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $551fcf7b84a33486$var$_defineProperty(e, r, t) {
    return (r = $551fcf7b84a33486$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $551fcf7b84a33486$var$_toPropertyKey(t) {
    var i = $551fcf7b84a33486$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $551fcf7b84a33486$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * @inline
 */ /**
 * Our base value array has payload in it, and we expose it externally too.
 */ /**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ /**
 * Because of naming conflict, we are forced to ignore certain (valid) SVG attributes.
 */ function $551fcf7b84a33486$var$getLegendItemColor(stroke, fill) {
    return stroke && stroke !== 'none' ? stroke : fill;
}
var $551fcf7b84a33486$var$computeLegendPayloadFromAreaData = (props)=>{
    var { dataKey: dataKey, name: name, stroke: stroke, fill: fill, legendType: legendType, hide: hide } = props;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: $551fcf7b84a33486$var$getLegendItemColor(stroke, fill),
            value: (0, $cd015374923bb5c7$export$d3207de44081d2b3)(name, dataKey),
            payload: props
        }
    ];
};
var $551fcf7b84a33486$var$SetAreaTooltipEntrySettings = /*#__PURE__*/ $acw62.memo((_ref)=>{
    var { dataKey: dataKey, data: data, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, unit: unit, tooltipType: tooltipType, id: id } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        getPosition: (0, $2ab3a7e25c8aba74$export$8793edee2d425525),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $cd015374923bb5c7$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: $551fcf7b84a33486$var$getLegendItemColor(stroke, fill),
            unit: unit,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $1e712d1b3a15e741$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $551fcf7b84a33486$var$AreaDotsWrapper(_ref2) {
    var { clipPathId: clipPathId, points: points, props: props } = _ref2;
    var { needClip: needClip, dot: dot, dataKey: dataKey } = props;
    var areaProps = (0, $37a0b0a95f0e25bf$export$8b56257912140094)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $6dcd61e97c26c79c$export$8da50d3722682be0), {
        points: points,
        dot: dot,
        className: "recharts-area-dots",
        dotClassName: "recharts-area-dot",
        dataKey: dataKey,
        baseProps: areaProps,
        needClip: needClip,
        clipPathId: clipPathId
    });
}
function $551fcf7b84a33486$var$AreaLabelListProvider(_ref3) {
    var { showLabels: showLabels, children: children, points: points } = _ref3;
    var labelListEntries = points.map((point)=>{
        var _point$x, _point$y;
        var viewBox = {
            x: (_point$x = point.x) !== null && _point$x !== void 0 ? _point$x : 0,
            y: (_point$y = point.y) !== null && _point$y !== void 0 ? _point$y : 0,
            width: 0,
            lowerWidth: 0,
            upperWidth: 0,
            height: 0
        };
        return $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, viewBox), {}, {
            value: point.value,
            payload: point.payload,
            parentViewBox: undefined,
            viewBox: viewBox,
            fill: undefined
        });
    });
    return /*#__PURE__*/ $acw62.createElement((0, $88ab0dba0fc78576$export$64e384eac5db53f7), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $551fcf7b84a33486$var$StaticArea(_ref4) {
    var { points: points, baseLine: baseLine, needClip: needClip, clipPathId: clipPathId, props: props } = _ref4;
    var { layout: layout, type: type, stroke: stroke, connectNulls: connectNulls, isRange: isRange } = props;
    var { id: id } = props, propsWithoutId = $551fcf7b84a33486$var$_objectWithoutProperties(props, $551fcf7b84a33486$var$_excluded);
    var allOtherProps = (0, $37a0b0a95f0e25bf$export$8b56257912140094)(propsWithoutId);
    var propsWithEvents = (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(propsWithoutId);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (points === null || points === void 0 ? void 0 : points.length) > 1 && /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined
    }, /*#__PURE__*/ $acw62.createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $551fcf7b84a33486$var$_extends({}, propsWithEvents, {
        id: id,
        points: points,
        connectNulls: connectNulls,
        type: type,
        baseLine: baseLine,
        layout: layout,
        stroke: "none",
        className: "recharts-area-area"
    })), stroke !== 'none' && /*#__PURE__*/ $acw62.createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $551fcf7b84a33486$var$_extends({}, allOtherProps, {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: points
    })), stroke !== 'none' && isRange && /*#__PURE__*/ $acw62.createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), $551fcf7b84a33486$var$_extends({}, allOtherProps, {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: baseLine
    }))), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaDotsWrapper, {
        points: points,
        props: propsWithoutId,
        clipPathId: clipPathId
    }));
}
function $551fcf7b84a33486$var$VerticalRect(_ref5) {
    var _points$, _points;
    var { alpha: alpha, baseLine: baseLine, points: points, strokeWidth: strokeWidth } = _ref5;
    var startY = (_points$ = points[0]) === null || _points$ === void 0 ? void 0 : _points$.y;
    var endY = (_points = points[points.length - 1]) === null || _points === void 0 ? void 0 : _points.y;
    if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(startY) || !(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(endY)) return null;
    var height = alpha * Math.abs(startY - endY);
    var maxX = Math.max(...points.map((entry)=>entry.x || 0));
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) maxX = Math.max(baseLine, maxX);
    else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max(...baseLine.map((entry)=>entry.x || 0), maxX);
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ $acw62.createElement("rect", {
        x: 0,
        y: startY < endY ? startY : startY - height,
        width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
        height: Math.floor(height)
    });
    return null;
}
function $551fcf7b84a33486$var$HorizontalRect(_ref6) {
    var _points$2, _points2;
    var { alpha: alpha, baseLine: baseLine, points: points, strokeWidth: strokeWidth } = _ref6;
    var startX = (_points$2 = points[0]) === null || _points$2 === void 0 ? void 0 : _points$2.x;
    var endX = (_points2 = points[points.length - 1]) === null || _points2 === void 0 ? void 0 : _points2.x;
    if (!(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(startX) || !(0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(endX)) return null;
    var width = alpha * Math.abs(startX - endX);
    var maxY = Math.max(...points.map((entry)=>entry.y || 0));
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) maxY = Math.max(baseLine, maxY);
    else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max(...baseLine.map((entry)=>entry.y || 0), maxY);
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ $acw62.createElement("rect", {
        x: startX < endX ? startX : startX - width,
        y: 0,
        width: width,
        height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
    });
    return null;
}
function $551fcf7b84a33486$var$ClipRect(_ref7) {
    var { alpha: alpha, layout: layout, points: points, baseLine: baseLine, strokeWidth: strokeWidth } = _ref7;
    if (layout === 'vertical') return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$VerticalRect, {
        alpha: alpha,
        points: points,
        baseLine: baseLine,
        strokeWidth: strokeWidth
    });
    return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$HorizontalRect, {
        alpha: alpha,
        points: points,
        baseLine: baseLine,
        strokeWidth: strokeWidth
    });
}
function $551fcf7b84a33486$var$AreaWithAnimation(_ref8) {
    var { needClip: needClip, clipPathId: clipPathId, props: props, previousPointsRef: previousPointsRef, previousBaselineRef: previousBaselineRef } = _ref8;
    var { points: points, baseLine: baseLine, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, onAnimationStart: onAnimationStart, onAnimationEnd: onAnimationEnd } = props;
    var animationInput = (0, $acw62.useMemo)(()=>({
            points: points,
            baseLine: baseLine
        }), [
        points,
        baseLine
    ]);
    var animationId = (0, $72206edefbff003d$export$e1042b2944b80b7f)(animationInput, 'recharts-area-');
    var layout = (0, $e573f10901a87cfb$export$c9942bdfc7f2781c)();
    var [isAnimating, setIsAnimating] = (0, $acw62.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    if (layout == null) return null;
    var prevPoints = previousPointsRef.current;
    var prevBaseLine = previousBaselineRef.current;
    return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaLabelListProvider, {
        showLabels: showLabels,
        points: points
    }, props.children, /*#__PURE__*/ $acw62.createElement((0, $464febc3f716710f$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        if (prevPoints) {
            var prevPointsDiffFactor = prevPoints.length / points.length;
            var stepPoints = /*
       * Here it is important that at the very end of the animation, on the last frame,
       * we render the original points without any interpolation.
       * This is needed because the code above is checking for reference equality to decide if the animation should run
       * and if we create a new array instance (even if the numbers were the same)
       * then we would break animations.
       */ t === 1 ? points : points.map((entry, index)=>{
                var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                if (prevPoints[prevPointIndex]) {
                    var prev = prevPoints[prevPointIndex];
                    return $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, entry), {}, {
                        x: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                        y: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.y, entry.y, t)
                    });
                }
                return entry;
            });
            var stepBaseLine;
            if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseLine)) stepBaseLine = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevBaseLine, baseLine, t);
            else if ((0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(baseLine) || (0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(baseLine)) stepBaseLine = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevBaseLine, 0, t);
            else stepBaseLine = baseLine.map((entry, index)=>{
                var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                if (Array.isArray(prevBaseLine) && prevBaseLine[prevPointIndex]) {
                    var prev = prevBaseLine[prevPointIndex];
                    return $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, entry), {}, {
                        x: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                        y: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.y, entry.y, t)
                    });
                }
                return entry;
            });
            if (t > 0) {
                /*
         * We need to keep the refs in the parent component because we need to remember the last shape of the animation
         * even if AreaWithAnimation is unmounted as that happens when changing props.
         *
         * And we need to update the refs here because here is where the interpolation is computed.
         * Eslint doesn't like changing function arguments, but we need it so here is an eslint-disable.
         */ // eslint-disable-next-line no-param-reassign
                previousPointsRef.current = stepPoints;
                // eslint-disable-next-line no-param-reassign
                previousBaselineRef.current = stepBaseLine;
            }
            return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$StaticArea, {
                points: stepPoints,
                baseLine: stepBaseLine,
                needClip: needClip,
                clipPathId: clipPathId,
                props: props
            });
        }
        if (t > 0) {
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = points;
            // eslint-disable-next-line no-param-reassign
            previousBaselineRef.current = baseLine;
        }
        return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), null, isAnimationActive && /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("clipPath", {
            id: "animationClipPath-".concat(clipPathId)
        }, /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$ClipRect, {
            alpha: t,
            points: points,
            baseLine: baseLine,
            layout: layout,
            strokeWidth: props.strokeWidth
        }))), /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
        }, /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$StaticArea, {
            points: points,
            baseLine: baseLine,
            needClip: needClip,
            clipPathId: clipPathId,
            props: props
        })));
    }), /*#__PURE__*/ $acw62.createElement((0, $88ab0dba0fc78576$export$9a402bc8de2b410e), {
        label: props.label
    }));
}
/*
 * This components decides if the area should be animated or not.
 * It also holds the state of the animation.
 */ function $551fcf7b84a33486$var$RenderArea(_ref9) {
    var { needClip: needClip, clipPathId: clipPathId, props: props } = _ref9;
    /*
   * These two must be refs, not state!
   * Because we want to store the most recent shape of the animation in case we have to interrupt the animation;
   * that happens when user initiates another animation before the current one finishes.
   *
   * If this was a useState, then every step in the animation would trigger a re-render.
   * So, useRef it is.
   */ var previousPointsRef = (0, $acw62.useRef)(null);
    var previousBaselineRef = (0, $acw62.useRef)();
    return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaWithAnimation, {
        needClip: needClip,
        clipPathId: clipPathId,
        props: props,
        previousPointsRef: previousPointsRef,
        previousBaselineRef: previousBaselineRef
    });
}
class $551fcf7b84a33486$var$AreaWithState extends (0, $acw62.PureComponent) {
    render() {
        var { hide: hide, dot: dot, points: points, className: className, top: top, left: left, needClip: needClip, xAxisId: xAxisId, yAxisId: yAxisId, width: width, height: height, id: id, baseLine: baseLine, zIndex: zIndex } = this.props;
        if (hide) return null;
        var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-area', className);
        var clipPathId = id;
        var { r: r, strokeWidth: strokeWidth } = (0, $fef0b63aa3904588$export$af45be059e20a9dd)(dot);
        var clipDot = (0, $008f02516c156322$export$28c0c718114c1a2e)(dot);
        var dotSize = r * 2 + strokeWidth;
        var activePointsClipPath = needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : undefined;
        return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
            zIndex: zIndex
        }, /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            className: layerClass
        }, needClip && /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement((0, $dd677892692406d2$export$d65f7a7dd82fbb63), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        }), !clipDot && /*#__PURE__*/ $acw62.createElement("clipPath", {
            id: "clipPath-dots-".concat(clipPathId)
        }, /*#__PURE__*/ $acw62.createElement("rect", {
            x: left - dotSize / 2,
            y: top - dotSize / 2,
            width: width + dotSize,
            height: height + dotSize
        }))), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$RenderArea, {
            needClip: needClip,
            clipPathId: clipPathId,
            props: this.props
        })), /*#__PURE__*/ $acw62.createElement((0, $07378f2fb606b4ec$export$dd2d3dc8acd956aa), {
            points: points,
            mainColor: $551fcf7b84a33486$var$getLegendItemColor(this.props.stroke, this.props.fill),
            itemDataKey: this.props.dataKey,
            activeDot: this.props.activeDot,
            clipPath: activePointsClipPath
        }), this.props.isRange && Array.isArray(baseLine) && /*#__PURE__*/ $acw62.createElement((0, $07378f2fb606b4ec$export$dd2d3dc8acd956aa), {
            points: baseLine,
            mainColor: $551fcf7b84a33486$var$getLegendItemColor(this.props.stroke, this.props.fill),
            itemDataKey: this.props.dataKey,
            activeDot: this.props.activeDot,
            clipPath: activePointsClipPath
        }));
    }
}
var $551fcf7b84a33486$export$c2f93abcbcbe507c = {
    activeDot: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    connectNulls: false,
    dot: false,
    fill: '#3182bd',
    fillOpacity: 0.6,
    hide: false,
    isAnimationActive: 'auto',
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    type: 'linear',
    label: false,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).area
};
function $551fcf7b84a33486$var$AreaImpl(props) {
    var _useAppSelector;
    var _resolveDefaultProps = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(props, $551fcf7b84a33486$export$c2f93abcbcbe507c), { activeDot: activeDot, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, connectNulls: connectNulls, dot: dot, fill: fill, fillOpacity: fillOpacity, hide: hide, isAnimationActive: isAnimationActive, legendType: legendType, stroke: stroke, xAxisId: xAxisId, yAxisId: yAxisId } = _resolveDefaultProps, everythingElse = $551fcf7b84a33486$var$_objectWithoutProperties(_resolveDefaultProps, $551fcf7b84a33486$var$_excluded2);
    var layout = (0, $e573f10901a87cfb$export$970c79ecc7081cc)();
    var chartName = (0, $5211e0f48c9883fe$export$ed30b3372172c46c)();
    var { needClip: needClip } = (0, $dd677892692406d2$export$79e142f66441c204)(xAxisId, yAxisId);
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var { points: points, isRange: isRange, baseLine: baseLine } = (_useAppSelector = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $5fbeae2880aa4f3e$export$5f2090c2af7a0678)(state, props.id, isPanorama))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {};
    var plotArea = (0, $42890447eb7e6cfe$export$f1ef8efc9ef6fe0c)();
    if (layout !== 'horizontal' && layout !== 'vertical' || plotArea == null) // Can't render Area in an unsupported layout
    return null;
    if (chartName !== 'AreaChart' && chartName !== 'ComposedChart') // There is nothing stopping us from rendering Area in other charts, except for historical reasons. Do we want to allow that?
    return null;
    var { height: height, width: width, x: left, y: top } = plotArea;
    if (!points || !points.length) return null;
    return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaWithState, $551fcf7b84a33486$var$_extends({}, everythingElse, {
        activeDot: activeDot,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        baseLine: baseLine,
        connectNulls: connectNulls,
        dot: dot,
        fill: fill,
        fillOpacity: fillOpacity,
        height: height,
        hide: hide,
        layout: layout,
        isAnimationActive: isAnimationActive === 'auto' ? !(0, $795299547b24e258$export$98f03c5d19621d70).isSsr : isAnimationActive,
        isRange: isRange,
        legendType: legendType,
        needClip: needClip,
        points: points,
        stroke: stroke,
        width: width,
        left: left,
        top: top,
        xAxisId: xAxisId,
        yAxisId: yAxisId
    }));
}
var $551fcf7b84a33486$export$82ef48a36e8cf480 = (layout, chartBaseValue, itemBaseValue, xAxis, yAxis)=>{
    // The baseValue can be defined both on the AreaChart, and on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(baseValue)) return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    // @ts-expect-error d3scale .domain() returns unknown, Math.max expects number
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
};
function $551fcf7b84a33486$export$bb0068e0a912aef6(_ref0) {
    var { areaSettings: { connectNulls: connectNulls, baseValue: itemBaseValue, dataKey: dataKey }, stackedData: stackedData, layout: layout, chartBaseValue: chartBaseValue, xAxis: xAxis, yAxis: yAxis, displayedData: displayedData, dataStartIndex: dataStartIndex, xAxisTicks: xAxisTicks, yAxisTicks: yAxisTicks, bandSize: bandSize } = _ref0;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $551fcf7b84a33486$export$82ef48a36e8cf480(layout, chartBaseValue, itemBaseValue, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map((entry, index)=>{
        var _valueAsArray$, _valueAsArray, _xAxis$scale$map;
        var valueAsArray;
        if (hasStack) valueAsArray = stackedData[dataStartIndex + index];
        else {
            var rawValue = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(rawValue)) // @ts-expect-error getValueByDataKey is not checking its return value
            valueAsArray = [
                baseValue,
                rawValue
            ];
            else {
                // @ts-expect-error getValueByDataKey is not checking its return value
                valueAsArray = rawValue;
                isRange = true;
            }
        }
        var value1 = (_valueAsArray$ = (_valueAsArray = valueAsArray) === null || _valueAsArray === void 0 ? void 0 : _valueAsArray[1]) !== null && _valueAsArray$ !== void 0 ? _valueAsArray$ : null;
        var isBreakPoint = value1 == null || hasStack && !connectNulls && (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey) == null;
        if (isHorizontalLayout) {
            var _yAxis$scale$map;
            return {
                x: (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
                    axis: xAxis,
                    ticks: xAxisTicks,
                    bandSize: bandSize,
                    entry: entry,
                    index: index
                }),
                y: isBreakPoint ? null : (_yAxis$scale$map = yAxis.scale.map(value1)) !== null && _yAxis$scale$map !== void 0 ? _yAxis$scale$map : null,
                value: valueAsArray,
                payload: entry
            };
        }
        return {
            x: isBreakPoint ? null : (_xAxis$scale$map = xAxis.scale.map(value1)) !== null && _xAxis$scale$map !== void 0 ? _xAxis$scale$map : null,
            y: (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: valueAsArray,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map((entry)=>{
        var _xAxis$scale$map2;
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) {
            var _yAxis$scale$map2;
            return {
                x: entry.x,
                y: x != null && entry.y != null ? (_yAxis$scale$map2 = yAxis.scale.map(x)) !== null && _yAxis$scale$map2 !== void 0 ? _yAxis$scale$map2 : null : null,
                payload: entry.payload
            };
        }
        return {
            x: x != null ? (_xAxis$scale$map2 = xAxis.scale.map(x)) !== null && _xAxis$scale$map2 !== void 0 ? _xAxis$scale$map2 : null : null,
            y: entry.y,
            payload: entry.payload
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale.map(baseValue) : xAxis.scale.map(baseValue);
    return {
        points: points,
        baseLine: baseLine !== null && baseLine !== void 0 ? baseLine : 0,
        isRange: isRange
    };
}
function $551fcf7b84a33486$var$AreaFn(outsideProps) {
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $551fcf7b84a33486$export$c2f93abcbcbe507c);
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    // Report all props to Redux store first, before calling any hooks, to avoid circular dependencies.
    return /*#__PURE__*/ $acw62.createElement((0, $e0af6fe07417fba6$export$8c2f307ff93f02ba), {
        id: props.id,
        type: "area"
    }, (id)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $8f8fe5838f5f31a4$export$34b61b169492c008), {
            legendPayload: $551fcf7b84a33486$var$computeLegendPayloadFromAreaData(props)
        }), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$SetAreaTooltipEntrySettings, {
            dataKey: props.dataKey,
            data: props.data,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $acw62.createElement((0, $7e3660a50bf15c81$export$b600bf9c1966a9c2), {
            type: "area",
            id: id,
            data: props.data,
            dataKey: props.dataKey,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            stackId: (0, $cd015374923bb5c7$export$f0871da41ca7fc82)(props.stackId),
            hide: props.hide,
            barSize: undefined,
            baseValue: props.baseValue,
            isPanorama: isPanorama,
            connectNulls: props.connectNulls
        }), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaImpl, $551fcf7b84a33486$var$_extends({}, props, {
            id: id
        }))));
}
var $551fcf7b84a33486$export$ea1a111407f37557 = /*#__PURE__*/ $acw62.memo($551fcf7b84a33486$var$AreaFn, (0, $83a0fb8931561019$export$b8f09df787c278d9));
$551fcf7b84a33486$export$ea1a111407f37557.displayName = 'Area';


var $acw62 = parcelRequire("acw62");


var $886d067545e9f9a0$export$3d996ff386c7802d = (data, strIndex)=>{
    if (!strIndex) return undefined;
    if (!Array.isArray(data)) return undefined;
    var numIndex = Number.parseInt(strIndex, 10);
    if ((0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(numIndex)) return undefined;
    return data[numIndex];
};
var $886d067545e9f9a0$var$initialState = {
    chartName: '',
    tooltipPayloadSearcher: ()=>undefined,
    eventEmitter: undefined,
    defaultTooltipEventType: 'axis'
};
var $886d067545e9f9a0$var$optionsSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'options',
    initialState: $886d067545e9f9a0$var$initialState,
    reducers: {
        createEventEmitter: (state)=>{
            if (state.eventEmitter == null) state.eventEmitter = Symbol('rechartsEventEmitter');
        }
    }
});
var $886d067545e9f9a0$export$81a3ba457dd82bec = $886d067545e9f9a0$var$optionsSlice.reducer;
var { createEventEmitter: $886d067545e9f9a0$export$abfecd6a8e6070c1 } = $886d067545e9f9a0$var$optionsSlice.actions;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






var $4dcdb3a18a3e2ca4$export$7285b50bc333b067 = {
    chartData: undefined,
    computedData: undefined,
    dataStartIndex: 0,
    dataEndIndex: 0
};
var $4dcdb3a18a3e2ca4$var$chartDataSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'chartData',
    initialState: $4dcdb3a18a3e2ca4$export$7285b50bc333b067,
    reducers: {
        setChartData (state, action) {
            state.chartData = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload);
            if (action.payload == null) {
                state.dataStartIndex = 0;
                state.dataEndIndex = 0;
                return;
            }
            if (action.payload.length > 0 && state.dataEndIndex !== action.payload.length - 1) state.dataEndIndex = action.payload.length - 1;
        },
        setComputedData (state, action) {
            state.computedData = action.payload;
        },
        setDataStartEndIndexes (state, action) {
            var { startIndex: startIndex, endIndex: endIndex } = action.payload;
            if (startIndex != null) state.dataStartIndex = startIndex;
            if (endIndex != null) state.dataEndIndex = endIndex;
        }
    }
});
var { setChartData: $4dcdb3a18a3e2ca4$export$624c47d88733f253, setDataStartEndIndexes: $4dcdb3a18a3e2ca4$export$427d605cc4e3bbdd, setComputedData: $4dcdb3a18a3e2ca4$export$9b2e7f4962514250 } = $4dcdb3a18a3e2ca4$var$chartDataSlice.actions;
var $4dcdb3a18a3e2ca4$export$52973ca5fce0a5d5 = $4dcdb3a18a3e2ca4$var$chartDataSlice.reducer;












var $48dcf93c036bf043$var$pickChartPointer = (_state, chartPointer)=>chartPointer;
var $48dcf93c036bf043$export$2cfb761a54690867 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $48dcf93c036bf043$var$pickChartPointer,
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $53bcbd5d17089da8$export$57f4101c1e20bd95),
    (0, $37e5cc0fa883575c$export$898d3dfd98fb482),
    (0, $51c6a3a12cea9b0d$export$cf4d6dfce3a76af3),
    (0, $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a),
    (0, $5211e0f48c9883fe$export$e133bec3c93a9247),
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b)
], (0, $5211e0f48c9883fe$export$e1c9f959fffb37b4));



/**
 * Computes the chart coordinates from the mouse event.
 *
 * The coordinates are relative to the top-left corner of the chart,
 * where the top-left corner of the chart is (0, 0).
 * Moving right, the x-coordinate increases, and moving down, the y-coordinate increases.
 *
 * The coordinates are rounded to the nearest integer and are including a CSS transform scale.
 * So a chart that's scaled will return the same coordinates as a chart that's not scaled.
 *
 * @param event The mouse event from React event handlers
 * @return chartPointer The chart coordinates relative to the top-left corner of the chart
 */ var $353b3d604f86d014$export$96f447b11b1279d1 = (event)=>{
    var rect = event.currentTarget.getBoundingClientRect();
    var scaleX = rect.width / event.currentTarget.offsetWidth;
    var scaleY = rect.height / event.currentTarget.offsetHeight;
    return {
        /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */ chartX: Math.round((event.clientX - rect.left) / scaleX),
        chartY: Math.round((event.clientY - rect.top) / scaleY)
    };
};


var $303fec236f990197$export$f06e14b484aecafc = (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)('mouseClick');
var $303fec236f990197$export$fb3df626ae9864a = (0, $d91034f47eb948f2$export$1228acebbbcb485b)();
// TODO: there's a bug here when you click the chart the activeIndex resets to zero
$303fec236f990197$export$fb3df626ae9864a.startListening({
    actionCreator: $303fec236f990197$export$f06e14b484aecafc,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var activeProps = (0, $48dcf93c036bf043$export$2cfb761a54690867)(listenerApi.getState(), (0, $353b3d604f86d014$export$96f447b11b1279d1)(mousePointer));
        if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $3be7536b77e1512b$export$d2b1af5c3a560528)({
            activeIndex: activeProps.activeIndex,
            activeDataKey: undefined,
            activeCoordinate: activeProps.activeCoordinate
        }));
    }
});
var $303fec236f990197$export$f9de213dbfb2e32c = (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)('mouseMove');
var $303fec236f990197$export$b7e1b38eb227944a = (0, $d91034f47eb948f2$export$1228acebbbcb485b)();
/*
 * This single rafId is safe because:
 * 1. Each chart has its own Redux store instance with its own middleware
 * 2. mouseMoveAction only fires from one DOM element (the chart wrapper)
 * 3. Rapid mousemove events from the same element SHOULD debounce - we only care about the latest position
 * This is different from externalEventsMiddleware which handles multiple event types
 * (click, mouseenter, mouseleave, etc.) that should NOT cancel each other.
 */ var $303fec236f990197$var$rafId = null;
$303fec236f990197$export$b7e1b38eb227944a.startListening({
    actionCreator: $303fec236f990197$export$f9de213dbfb2e32c,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        // Cancel any pending animation frame
        if ($303fec236f990197$var$rafId !== null) cancelAnimationFrame($303fec236f990197$var$rafId);
        var chartPointer = (0, $353b3d604f86d014$export$96f447b11b1279d1)(mousePointer);
        // Schedule the dispatch for the next animation frame
        $303fec236f990197$var$rafId = requestAnimationFrame(()=>{
            var state = listenerApi.getState();
            var tooltipEventType = (0, $21536fb21082ce97$export$53af65c2db668fac)(state, state.tooltip.settings.shared);
            // this functionality only applies to charts that have axes
            if (tooltipEventType === 'axis') {
                var activeProps = (0, $48dcf93c036bf043$export$2cfb761a54690867)(state, chartPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $3be7536b77e1512b$export$a7277636863fc703)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
                else // this is needed to clear tooltip state when the mouse moves out of the inRange (svg - offset) function, but not yet out of the svg
                listenerApi.dispatch((0, $3be7536b77e1512b$export$73879bed3f2eef71)());
            }
            $303fec236f990197$var$rafId = null;
        });
    }
});


function $69e4aa2369c694bd$export$b5f053baf756345f(key, value) {
    if (value instanceof HTMLElement) return "HTMLElement <".concat(value.tagName, " class=\"").concat(value.className, "\">");
    if (value === window) return 'global.window';
    if (key === 'children' && typeof value === 'object' && value !== null) return '<<CHILDREN>>';
    return value;
}






var $2c9e0e659123dd04$var$initialState = {
    dots: [],
    areas: [],
    lines: []
};
var $2c9e0e659123dd04$export$cbde679baaad2c79 = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'referenceElements',
    initialState: $2c9e0e659123dd04$var$initialState,
    reducers: {
        addDot: (state, action)=>{
            state.dots.push(action.payload);
        },
        removeDot: (state, action)=>{
            var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).dots.findIndex((dot)=>dot === action.payload);
            if (index !== -1) state.dots.splice(index, 1);
        },
        addArea: (state, action)=>{
            state.areas.push(action.payload);
        },
        removeArea: (state, action)=>{
            var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).areas.findIndex((area)=>area === action.payload);
            if (index !== -1) state.areas.splice(index, 1);
        },
        addLine: (state, action)=>{
            state.lines.push((0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload));
        },
        removeLine: (state, action)=>{
            var index = (0, $b9146244dc19043a$export$97aac956da55dae9)(state).lines.findIndex((line)=>line === action.payload);
            if (index !== -1) state.lines.splice(index, 1);
        }
    }
});
var { addDot: $2c9e0e659123dd04$export$9be8ef3add1f8c1e, removeDot: $2c9e0e659123dd04$export$57ff7495ce685163, addArea: $2c9e0e659123dd04$export$d604a18565cfc1b3, removeArea: $2c9e0e659123dd04$export$a8da2ad4123475fe, addLine: $2c9e0e659123dd04$export$a9ce8e8146745e3e, removeLine: $2c9e0e659123dd04$export$fd7919a5491769ec } = $2c9e0e659123dd04$export$cbde679baaad2c79.actions;
var $2c9e0e659123dd04$export$f30a87c263d1acf8 = $2c9e0e659123dd04$export$cbde679baaad2c79.reducer;



/**
 * From all Brush properties, only height has a default value and will always be defined.
 * Other properties are nullable and will be computed from offsets and margins if they are not set.
 */ var $c4046d366b5068fc$var$initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
var $c4046d366b5068fc$export$d64e835ef4b0c23a = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'brush',
    initialState: $c4046d366b5068fc$var$initialState,
    reducers: {
        setBrushSettings (_state, action) {
            if (action.payload == null) return $c4046d366b5068fc$var$initialState;
            return action.payload;
        }
    }
});
var { setBrushSettings: $c4046d366b5068fc$export$1860ec7d971c6a5b } = $c4046d366b5068fc$export$d64e835ef4b0c23a.actions;
var $c4046d366b5068fc$export$b8c9ca32ee9dbf92 = $c4046d366b5068fc$export$d64e835ef4b0c23a.reducer;




var $a889d3323d3ea0c2$export$d4c72bab9d6cc13a = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    barSize: undefined,
    className: undefined,
    maxBarSize: undefined,
    stackOffset: 'none',
    syncId: undefined,
    syncMethod: 'index',
    baseValue: undefined,
    reverseStackOrder: false
};
var $a889d3323d3ea0c2$var$rootPropsSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'rootProps',
    initialState: $a889d3323d3ea0c2$export$d4c72bab9d6cc13a,
    reducers: {
        updateOptions: (state, action)=>{
            var _action$payload$barGa;
            state.accessibilityLayer = action.payload.accessibilityLayer;
            state.barCategoryGap = action.payload.barCategoryGap;
            state.barGap = (_action$payload$barGa = action.payload.barGap) !== null && _action$payload$barGa !== void 0 ? _action$payload$barGa : $a889d3323d3ea0c2$export$d4c72bab9d6cc13a.barGap;
            state.barSize = action.payload.barSize;
            state.maxBarSize = action.payload.maxBarSize;
            state.stackOffset = action.payload.stackOffset;
            state.syncId = action.payload.syncId;
            state.syncMethod = action.payload.syncMethod;
            state.className = action.payload.className;
            state.baseValue = action.payload.baseValue;
            state.reverseStackOrder = action.payload.reverseStackOrder;
        }
    }
});
var $a889d3323d3ea0c2$export$291d6468e221147e = $a889d3323d3ea0c2$var$rootPropsSlice.reducer;
var { updateOptions: $a889d3323d3ea0c2$export$c6fe4049d20353ac } = $a889d3323d3ea0c2$var$rootPropsSlice.actions;




var $75941617e5c22485$var$initialState = {
    radiusAxis: {},
    angleAxis: {}
};
var $75941617e5c22485$var$polarAxisSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'polarAxis',
    initialState: $75941617e5c22485$var$initialState,
    reducers: {
        addRadiusAxis (state, action) {
            state.radiusAxis[action.payload.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload);
        },
        removeRadiusAxis (state, action) {
            delete state.radiusAxis[action.payload.id];
        },
        addAngleAxis (state, action) {
            state.angleAxis[action.payload.id] = (0, $5f9e38360d79f95a$export$c05b21e3257751e5)(action.payload);
        },
        removeAngleAxis (state, action) {
            delete state.angleAxis[action.payload.id];
        }
    }
});
var { addRadiusAxis: $75941617e5c22485$export$3555d359361c9fe3, removeRadiusAxis: $75941617e5c22485$export$104b2ce9f0baf86f, addAngleAxis: $75941617e5c22485$export$bf871b0db8674238, removeAngleAxis: $75941617e5c22485$export$d540ed209cfbb147 } = $75941617e5c22485$var$polarAxisSlice.actions;
var $75941617e5c22485$export$97e65520f1278b5 = $75941617e5c22485$var$polarAxisSlice.reducer;



var $d33a23b3ebfb586d$var$initialState = null;
var $d33a23b3ebfb586d$var$reducers = {
    updatePolarOptions: (_state, action)=>{
        return action.payload;
    }
};
var $d33a23b3ebfb586d$var$polarOptionsSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'polarOptions',
    initialState: $d33a23b3ebfb586d$var$initialState,
    reducers: $d33a23b3ebfb586d$var$reducers
});
var { updatePolarOptions: $d33a23b3ebfb586d$export$5dfe4dcb848af93f } = $d33a23b3ebfb586d$var$polarOptionsSlice.actions;
var $d33a23b3ebfb586d$export$8d4054f1936f7f4d = $d33a23b3ebfb586d$var$polarOptionsSlice.reducer;








var $6f317037c3555952$export$4839538efb7414c = (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)('keyDown');
var $6f317037c3555952$export$d95192eee5865567 = (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)('focus');
var $6f317037c3555952$export$b4d762ee62ea3f99 = (0, $d91034f47eb948f2$export$1228acebbbcb485b)();
$6f317037c3555952$export$b4d762ee62ea3f99.startListening({
    actionCreator: $6f317037c3555952$export$4839538efb7414c,
    effect: (action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        var key = action.payload;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Enter') return;
        // TODO this is lacking index for charts that do not support numeric indexes
        var resolvedIndex = (0, $927073e84a89ab02$export$32df4b03a0962e46)(keyboardInteraction, (0, $51c6a3a12cea9b0d$export$5a8beccc8250d20e)(state), (0, $6aac8fe27ae10a7b$export$bf8397fefbaa3617)(state), (0, $51c6a3a12cea9b0d$export$76f7a1975f60ccf1)(state));
        var currentIndex = resolvedIndex == null ? -1 : Number(resolvedIndex);
        if (!Number.isFinite(currentIndex) || currentIndex < 0) return;
        var tooltipTicks = (0, $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a)(state);
        if (key === 'Enter') {
            var _coordinate = (0, $5211e0f48c9883fe$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(keyboardInteraction.index));
            listenerApi.dispatch((0, $3be7536b77e1512b$export$820c94985c9eba3f)({
                active: !keyboardInteraction.active,
                activeIndex: keyboardInteraction.index,
                activeCoordinate: _coordinate
            }));
            return;
        }
        var direction = (0, $6aac8fe27ae10a7b$export$430d623a94added7)(state);
        var directionMultiplier = direction === 'left-to-right' ? 1 : -1;
        var movement = key === 'ArrowRight' ? 1 : -1;
        var nextIndex = currentIndex + movement * directionMultiplier;
        if (tooltipTicks == null || nextIndex >= tooltipTicks.length || nextIndex < 0) return;
        var coordinate = (0, $5211e0f48c9883fe$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(nextIndex));
        listenerApi.dispatch((0, $3be7536b77e1512b$export$820c94985c9eba3f)({
            active: true,
            activeIndex: nextIndex.toString(),
            activeCoordinate: coordinate
        }));
    }
});
$6f317037c3555952$export$b4d762ee62ea3f99.startListening({
    actionCreator: $6f317037c3555952$export$d95192eee5865567,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        if (keyboardInteraction.active) return;
        if (keyboardInteraction.index == null) {
            var nextIndex = '0';
            var coordinate = (0, $5211e0f48c9883fe$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(nextIndex));
            listenerApi.dispatch((0, $3be7536b77e1512b$export$820c94985c9eba3f)({
                active: true,
                activeIndex: nextIndex,
                activeCoordinate: coordinate
            }));
        }
    }
});




var $76ce3aa82d5f6fc2$export$1d0268b9f89859f0 = (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)('externalEvent');
var $76ce3aa82d5f6fc2$export$3c5d447f046d0ec3 = (0, $d91034f47eb948f2$export$1228acebbbcb485b)();
/*
 * We need a Map keyed by event type because this middleware handles MULTIPLE different event types
 * (click, mouseenter, mouseleave, mousedown, mouseup, contextmenu, dblclick, touchstart, touchmove, touchend)
 * from the same DOM element. Different event types should NOT cancel each other's animation frames.
 * For example, a click event and a mousemove event can happen in quick succession and both should be processed.
 * This is different from mouseMoveMiddleware which only handles one event type and uses a single rafId.
 */ var $76ce3aa82d5f6fc2$var$rafIdMap = new Map();
$76ce3aa82d5f6fc2$export$3c5d447f046d0ec3.startListening({
    actionCreator: $76ce3aa82d5f6fc2$export$1d0268b9f89859f0,
    effect: (action, listenerApi)=>{
        var { handler: handler, reactEvent: reactEvent } = action.payload;
        if (handler == null) return;
        reactEvent.persist();
        var eventType = reactEvent.type;
        // Cancel any pending animation frame for this event type
        var existingRafId = $76ce3aa82d5f6fc2$var$rafIdMap.get(eventType);
        if (existingRafId !== undefined) cancelAnimationFrame(existingRafId);
        var rafId = requestAnimationFrame(()=>{
            try {
                /*
         * Here it is important that we get the latest state inside the animation frame callback,
         * not from the outer scope, because there may have been other actions dispatched
         * between the time the event was fired and the animation frame callback is executed.
         * One of those actions is the one that actually sets the active tooltip state!
         */ var state = listenerApi.getState();
                var nextState = {
                    activeCoordinate: (0, $51c6a3a12cea9b0d$export$90c565a5b196e427)(state),
                    activeDataKey: (0, $51c6a3a12cea9b0d$export$999f7a7ced063fab)(state),
                    activeIndex: (0, $51c6a3a12cea9b0d$export$8b2762260f5891c9)(state),
                    activeLabel: (0, $51c6a3a12cea9b0d$export$400c35cc3b9a0487)(state),
                    activeTooltipIndex: (0, $51c6a3a12cea9b0d$export$8b2762260f5891c9)(state),
                    isTooltipActive: (0, $51c6a3a12cea9b0d$export$c8884ed37796034a)(state)
                };
                handler(nextState, reactEvent);
            } finally{
                $76ce3aa82d5f6fc2$var$rafIdMap.delete(eventType);
            }
        });
        $76ce3aa82d5f6fc2$var$rafIdMap.set(eventType, rafId);
    }
});










var $915981a107e1f6e9$var$selectAllTooltipPayloadConfiguration = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $78fd7fcb0d81609e$export$703b585bc92b5bae)
], (tooltipState)=>tooltipState.tooltipItemPayloads);
var $915981a107e1f6e9$export$4e32c9da1f3ea7ce = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $915981a107e1f6e9$var$selectAllTooltipPayloadConfiguration,
    (_state, tooltipIndex)=>tooltipIndex,
    (_state, _tooltipIndex, graphicalItemId)=>graphicalItemId
], (allTooltipConfigurations, tooltipIndex, graphicalItemId)=>{
    if (tooltipIndex == null) return undefined;
    var mostRelevantTooltipConfiguration = allTooltipConfigurations.find((tooltipConfiguration)=>{
        return tooltipConfiguration.settings.graphicalItemId === graphicalItemId;
    });
    if (mostRelevantTooltipConfiguration == null) return undefined;
    var { getPosition: getPosition } = mostRelevantTooltipConfiguration;
    if (getPosition == null) return undefined;
    return getPosition(tooltipIndex);
});



var $1560e93fcb4e9208$export$ba46b5fda0e2985f = (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)('touchMove');
var $1560e93fcb4e9208$export$923ceddc5a79736a = (0, $d91034f47eb948f2$export$1228acebbbcb485b)();
$1560e93fcb4e9208$export$923ceddc5a79736a.startListening({
    actionCreator: $1560e93fcb4e9208$export$ba46b5fda0e2985f,
    effect: (action, listenerApi)=>{
        var touchEvent = action.payload;
        if (touchEvent.touches == null || touchEvent.touches.length === 0) return;
        var state = listenerApi.getState();
        var tooltipEventType = (0, $21536fb21082ce97$export$53af65c2db668fac)(state, state.tooltip.settings.shared);
        if (tooltipEventType === 'axis') {
            var touch = touchEvent.touches[0];
            if (touch == null) return;
            var activeProps = (0, $48dcf93c036bf043$export$2cfb761a54690867)(state, (0, $353b3d604f86d014$export$96f447b11b1279d1)({
                clientX: touch.clientX,
                clientY: touch.clientY,
                currentTarget: touchEvent.currentTarget
            }));
            if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $3be7536b77e1512b$export$a7277636863fc703)({
                activeIndex: activeProps.activeIndex,
                activeDataKey: undefined,
                activeCoordinate: activeProps.activeCoordinate
            }));
        } else if (tooltipEventType === 'item') {
            var _target$getAttribute;
            var _touch = touchEvent.touches[0];
            if (document.elementFromPoint == null || _touch == null) return;
            var target = document.elementFromPoint(_touch.clientX, _touch.clientY);
            if (!target || !target.getAttribute) return;
            var itemIndex = target.getAttribute((0, $f6fce23ac63eec53$export$c0f3d78d63b3e065));
            var graphicalItemId = (_target$getAttribute = target.getAttribute((0, $f6fce23ac63eec53$export$5c80c48c1d137460))) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : undefined;
            var settings = (0, $51c6a3a12cea9b0d$export$645965005f643e6f)(state).find((item)=>item.id === graphicalItemId);
            if (itemIndex == null || settings == null || graphicalItemId == null) return;
            var { dataKey: dataKey } = settings;
            var coordinate = (0, $915981a107e1f6e9$export$4e32c9da1f3ea7ce)(state, itemIndex, graphicalItemId);
            listenerApi.dispatch((0, $3be7536b77e1512b$export$c78abbb2450f6b44)({
                activeDataKey: dataKey,
                activeIndex: itemIndex,
                activeCoordinate: coordinate,
                activeGraphicalItemId: graphicalItemId
            }));
        }
    }
});



/**
 * ErrorBars have lot more settings but all the others are scoped to the component itself.
 * Only some of them required to be reported to the global store because XAxis and YAxis need to know
 * if the error bar is contributing to extending the axis domain.
 */ var $9da41aabd5381b30$var$initialState = {};
var $9da41aabd5381b30$var$errorBarSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: 'errorBars',
    initialState: $9da41aabd5381b30$var$initialState,
    reducers: {
        addErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (!state[itemId]) state[itemId] = [];
            state[itemId].push(errorBar);
        },
        replaceErrorBar: (state, action)=>{
            var { itemId: itemId, prev: prev, next: next } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].map((e)=>e.dataKey === prev.dataKey && e.direction === prev.direction ? next : e);
        },
        removeErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].filter((e)=>e.dataKey !== errorBar.dataKey || e.direction !== errorBar.direction);
        }
    }
});
var { addErrorBar: $9da41aabd5381b30$export$155912f95c88abac, replaceErrorBar: $9da41aabd5381b30$export$f1ebd3b9f70a9f5f, removeErrorBar: $9da41aabd5381b30$export$b0d2fb6a7d9d3b45 } = $9da41aabd5381b30$var$errorBarSlice.actions;
var $9da41aabd5381b30$export$6dda85fa3c67ca19 = $9da41aabd5381b30$var$errorBarSlice.reducer;




var $4044c9e072e449ea$var$rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)({
    brush: (0, $c4046d366b5068fc$export$b8c9ca32ee9dbf92),
    cartesianAxis: (0, $177f608375879b5a$export$c8ae79f5f6ae07c6),
    chartData: (0, $4dcdb3a18a3e2ca4$export$52973ca5fce0a5d5),
    errorBars: (0, $9da41aabd5381b30$export$6dda85fa3c67ca19),
    graphicalItems: (0, $7490850bee546723$export$183eecd5cb7dbb38),
    layout: (0, $2c79e8f39a8896b6$export$701395c4acfabc85),
    legend: (0, $056a3e7c624b08cd$export$8d8dfb8d5acf8179),
    options: (0, $886d067545e9f9a0$export$81a3ba457dd82bec),
    polarAxis: (0, $75941617e5c22485$export$97e65520f1278b5),
    polarOptions: (0, $d33a23b3ebfb586d$export$8d4054f1936f7f4d),
    referenceElements: (0, $2c9e0e659123dd04$export$f30a87c263d1acf8),
    rootProps: (0, $a889d3323d3ea0c2$export$291d6468e221147e),
    tooltip: (0, $3be7536b77e1512b$export$cadd4678b967dba6),
    zIndex: (0, $2e81d63b6460b61d$export$a34096cdea3a022a)
});
var $4044c9e072e449ea$export$a4383593d58e8efa = function createRechartsStore(preloadedState) {
    var chartName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Chart';
    return (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
        reducer: $4044c9e072e449ea$var$rootReducer,
        // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
        preloadedState: preloadedState,
        // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
        middleware: (getDefaultMiddleware)=>{
            var _process$env$NODE_ENV;
            return getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: ![
                    'commonjs',
                    'es6',
                    'production'
                ].includes((_process$env$NODE_ENV = "es6", _process$env$NODE_ENV !== void 0) ? _process$env$NODE_ENV : '')
            }).concat([
                (0, $303fec236f990197$export$fb3df626ae9864a).middleware,
                (0, $303fec236f990197$export$b7e1b38eb227944a).middleware,
                (0, $6f317037c3555952$export$b4d762ee62ea3f99).middleware,
                (0, $76ce3aa82d5f6fc2$export$3c5d447f046d0ec3).middleware,
                (0, $1560e93fcb4e9208$export$923ceddc5a79736a).middleware
            ]);
        },
        /*
     * I can't find out how to satisfy typescript here.
     * We return `EnhancerArray<[StoreEnhancer<{}, {}>, StoreEnhancer]>` from this function,
     * but the types say we should return `EnhancerArray<StoreEnhancer<{}, {}>`.
     * Looks like it's badly inferred generics, but it won't allow me to provide the correct type manually either.
     * So let's just ignore the error for now.
     */ // @ts-expect-error mismatched generics
        enhancers: (getDefaultEnhancers)=>{
            var enhancers = getDefaultEnhancers;
            if (typeof getDefaultEnhancers === 'function') /*
         * In RTK v2 this is always a function, but in v1 it is an array.
         * Because we have @types/redux-toolkit v1 as a dependency, typescript is going to flag this as an error.
         * We support both RTK v1 and v2, so we need to do this check.
         * https://redux-toolkit.js.org/usage/migrating-rtk-2#configurestoreenhancers-must-be-a-callback
         */ // @ts-expect-error RTK v2 behaviour on RTK v1 types
            enhancers = getDefaultEnhancers();
            return enhancers.concat((0, $d91034f47eb948f2$export$676277d7dca0f396)({
                type: 'raf'
            }));
        },
        devTools: (0, $795299547b24e258$export$98f03c5d19621d70).devToolsEnabled && {
            serialize: {
                replacer: (0, $69e4aa2369c694bd$export$b5f053baf756345f)
            },
            name: "recharts-".concat(chartName)
        }
    });
};




function $d43b7042472c8a15$export$debe87639f2707f9(_ref) {
    var { preloadedState: preloadedState, children: children, reduxStoreName: reduxStoreName } = _ref;
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    /*
   * Why the ref? Redux official documentation recommends to use store as a singleton,
   * and reuse that everywhere: https://redux-toolkit.js.org/api/configureStore#basic-example
   *
   * Which is correct! Except that is considering deploying Redux in an app.
   * Recharts as a library supports multiple charts on the same page.
   * And each of these charts needs its own store independent of others!
   *
   * The alternative is to have everything in the store keyed by the chart id.
   * Which would make working with everything a little bit more painful because we need the chart id everywhere.
   */ var storeRef = (0, $acw62.useRef)(null);
    /*
   * Panorama means that this chart is not its own chart, it's only a "preview"
   * being rendered as a child of Brush.
   * In such case, it should not have a store on its own - it should implicitly inherit
   * whatever data is in the "parent" or "root" chart.
   * Which here is represented by not having a Provider at all. All selectors will use the root store by default.
   */ if (isPanorama) return children;
    if (storeRef.current == null) storeRef.current = (0, $4044c9e072e449ea$export$a4383593d58e8efa)(preloadedState, reduxStoreName);
    // @ts-expect-error React-Redux types demand that the context internal value is not null, but we have that as default.
    var nonNullContext = (0, $4546adee7e5b0920$export$876ef70bc88b13cb);
    return /*#__PURE__*/ $acw62.createElement((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        context: nonNullContext,
        store: storeRef.current
    }, children);
}



var $acw62 = parcelRequire("acw62");



var $15e3dd90a1832e09$export$2100a1dedbca0238 = (props)=>{
    var { chartData: chartData } = props;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    (0, $acw62.useEffect)(()=>{
        if (isPanorama) // Panorama mode reuses data from the main chart, so we must not overwrite it here.
        return ()=>{
        // there is nothing to clean up
        };
        dispatch((0, $4dcdb3a18a3e2ca4$export$624c47d88733f253)(chartData));
        return ()=>{
            dispatch((0, $4dcdb3a18a3e2ca4$export$624c47d88733f253)(undefined));
        };
    }, [
        chartData,
        dispatch,
        isPanorama
    ]);
    return null;
};
var $15e3dd90a1832e09$export$91a155b0e28498ba = (props)=>{
    var { computedData: computedData } = props;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $4dcdb3a18a3e2ca4$export$9b2e7f4962514250)(computedData));
        return ()=>{
            dispatch((0, $4dcdb3a18a3e2ca4$export$624c47d88733f253)(undefined));
        };
    }, [
        computedData,
        dispatch
    ]);
    return null;
};
var $15e3dd90a1832e09$var$selectChartData = (state)=>state.chartData.chartData;
var $15e3dd90a1832e09$export$551a2a6f7431b8ad = ()=>(0, $8512ea9be24774fb$export$a7347740d65f620b)($15e3dd90a1832e09$var$selectChartData);
var $15e3dd90a1832e09$var$selectDataIndex = (state)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = state.chartData;
    return {
        startIndex: dataStartIndex,
        endIndex: dataEndIndex
    };
};
var $15e3dd90a1832e09$export$824568c74ea1faec = ()=>{
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)($15e3dd90a1832e09$var$selectDataIndex);
};



var $acw62 = parcelRequire("acw62");




/**
 * "Main" props are props that are only accepted on the main chart,
 * as opposed to the small panorama chart inside a Brush.
 */ function $afc35d1bda6a54e7$var$ReportMainChartPropsImpl(_ref) {
    var { layout: layout, margin: margin } = _ref;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    /*
   * useEffect here is required to avoid the "Cannot update a component while rendering a different component" error.
   * https://github.com/facebook/react/issues/18178
   *
   * Reported in https://github.com/recharts/recharts/issues/5514
   */ (0, $acw62.useEffect)(()=>{
        if (!isPanorama) {
            dispatch((0, $2c79e8f39a8896b6$export$e8437af1f2483b8e)(layout));
            dispatch((0, $2c79e8f39a8896b6$export$3f8f25b83912855f)(margin));
        }
    }, [
        dispatch,
        isPanorama,
        layout,
        margin
    ]);
    return null;
}
var $afc35d1bda6a54e7$export$6faeaad6e02c2e9d = /*#__PURE__*/ (0, $acw62.memo)($afc35d1bda6a54e7$var$ReportMainChartPropsImpl, (0, $83a0fb8931561019$export$b8f09df787c278d9));



var $acw62 = parcelRequire("acw62");


function $dcaaff4a864a6bc4$export$6fabfb9ba230d12b(props) {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $a889d3323d3ea0c2$export$c6fe4049d20353ac)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $58e3484536fdae50$export$276788f18f24cad3 = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>state.rootProps.accessibilityLayer)) !== null && _useAppSelector !== void 0 ? _useAppSelector : true;
};




var $acw62 = parcelRequire("acw62");


var $bfae0ec07b91e499$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $bfae0ec07b91e499$var$_extends() {
    return $bfae0ec07b91e499$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bfae0ec07b91e499$var$_extends.apply(null, arguments);
}
function $bfae0ec07b91e499$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bfae0ec07b91e499$export$7b92b459e668cb21 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { children: children, width: width, height: height, viewBox: viewBox, className: className, style: style, title: title, desc: desc } = props, others = $bfae0ec07b91e499$var$_objectWithoutProperties(props, $bfae0ec07b91e499$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-surface', className);
    return /*#__PURE__*/ $acw62.createElement("svg", $bfae0ec07b91e499$var$_extends({}, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(others), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        ref: ref
    }), /*#__PURE__*/ $acw62.createElement("title", null, title), /*#__PURE__*/ $acw62.createElement("desc", null, desc), children);
});






var $acw62 = parcelRequire("acw62");



function $c3567a9b07e71565$var$ZIndexSvgPortal(_ref) {
    var { zIndex: zIndex, isPanorama: isPanorama } = _ref;
    var ref = (0, $acw62.useRef)(null);
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useLayoutEffect)(()=>{
        if (ref.current) dispatch((0, $2e81d63b6460b61d$export$2e6026208075bd4f)({
            zIndex: zIndex,
            element: ref.current,
            isPanorama: isPanorama
        }));
        return ()=>{
            dispatch((0, $2e81d63b6460b61d$export$b735943939e8125)({
                zIndex: zIndex,
                isPanorama: isPanorama
            }));
        };
    }, [
        dispatch,
        zIndex,
        isPanorama
    ]);
    // these g elements should not be tabbable
    return /*#__PURE__*/ $acw62.createElement("g", {
        tabIndex: -1,
        ref: ref
    });
}
function $c3567a9b07e71565$export$7a76624f8e4da531(_ref2) {
    var { children: children, isPanorama: isPanorama } = _ref2;
    var allRegisteredZIndexes = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $5f08f563d5a1ffa5$export$7967bffce127e19c));
    if (!allRegisteredZIndexes || allRegisteredZIndexes.length === 0) return children;
    var allNegativeZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex < 0);
    // We exclude zero on purpose - that is the default layer, and it doesn't need a portal.
    var allPositiveZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex > 0);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, allNegativeZIndexes.map((zIndex)=>/*#__PURE__*/ $acw62.createElement($c3567a9b07e71565$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })), children, allPositiveZIndexes.map((zIndex)=>/*#__PURE__*/ $acw62.createElement($c3567a9b07e71565$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })));
}


var $a2354a93b9e04e81$var$_excluded = [
    "children"
];
function $a2354a93b9e04e81$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a2354a93b9e04e81$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a2354a93b9e04e81$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $a2354a93b9e04e81$var$_extends() {
    return $a2354a93b9e04e81$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a2354a93b9e04e81$var$_extends.apply(null, arguments);
}
var $a2354a93b9e04e81$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%',
    /*
   * display: block is necessary here because the default for an SVG is display: inline,
   * which in some browsers (Chrome) adds a little bit of extra space above and below the SVG
   * to make space for the descender of letters like "g" and "y". This throws off the height calculation
   * and causes the container to grow indefinitely on each render with responsive=true.
   * Display: block removes that extra space.
   *
   * Interestingly, Firefox does not have this problem, but it doesn't hurt to add the style anyway.
   */ display: 'block'
};
var $a2354a93b9e04e81$var$MainChartSurface = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var width = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var height = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var hasAccessibilityLayer = (0, $58e3484536fdae50$export$276788f18f24cad3)();
    if (!(0, $dabee322b52312f4$export$5374bb854d0e41c8)(width) || !(0, $dabee322b52312f4$export$5374bb854d0e41c8)(height)) return null;
    var { children: children, otherAttributes: otherAttributes, title: title, desc: desc } = props;
    var tabIndex, role;
    if (otherAttributes != null) {
        if (typeof otherAttributes.tabIndex === 'number') tabIndex = otherAttributes.tabIndex;
        else tabIndex = hasAccessibilityLayer ? 0 : undefined;
        if (typeof otherAttributes.role === 'string') role = otherAttributes.role;
        else role = hasAccessibilityLayer ? 'application' : undefined;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), $a2354a93b9e04e81$var$_extends({}, otherAttributes, {
        title: title,
        desc: desc,
        role: role,
        tabIndex: tabIndex,
        width: width,
        height: height,
        style: $a2354a93b9e04e81$var$FULL_WIDTH_AND_HEIGHT,
        ref: ref
    }), children);
});
var $a2354a93b9e04e81$var$BrushPanoramaSurface = (_ref)=>{
    var { children: children } = _ref;
    var brushDimensions = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $2779731b2b31d554$export$3b81e97eae001823));
    if (!brushDimensions) return null;
    var { width: width, height: height, y: y, x: x } = brushDimensions;
    return /*#__PURE__*/ $acw62.createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), {
        width: width,
        height: height,
        x: x,
        y: y
    }, children);
};
var $a2354a93b9e04e81$export$b6c051d2e0bcd3e9 = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref2, ref)=>{
    var { children: children } = _ref2, rest = $a2354a93b9e04e81$var$_objectWithoutProperties(_ref2, $a2354a93b9e04e81$var$_excluded);
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    if (isPanorama) return /*#__PURE__*/ $acw62.createElement($a2354a93b9e04e81$var$BrushPanoramaSurface, null, /*#__PURE__*/ $acw62.createElement((0, $c3567a9b07e71565$export$7a76624f8e4da531), {
        isPanorama: true
    }, children));
    return /*#__PURE__*/ $acw62.createElement($a2354a93b9e04e81$var$MainChartSurface, $a2354a93b9e04e81$var$_extends({
        ref: ref
    }, rest), /*#__PURE__*/ $acw62.createElement((0, $c3567a9b07e71565$export$7a76624f8e4da531), {
        isPanorama: false
    }, children));
});



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $28edd11f6c7e9f5f$exports = {};
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


var $bbd08cd38300f8df$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports)))();
var $bbd08cd38300f8df$export$e2631176295fd79b = 'recharts.syncEvent.tooltip';
var $bbd08cd38300f8df$export$5069141294af4ee8 = 'recharts.syncEvent.brush';






function $156d26eca16ead28$export$54e3aed0d8d4a717(state) {
    return state.tooltip.syncInteraction;
}





var $ab88b765f694b562$var$_excluded = [
    "x",
    "y"
];
function $ab88b765f694b562$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab88b765f694b562$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab88b765f694b562$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab88b765f694b562$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab88b765f694b562$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ab88b765f694b562$var$_defineProperty(e, r, t) {
    return (r = $ab88b765f694b562$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ab88b765f694b562$var$_toPropertyKey(t) {
    var i = $ab88b765f694b562$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ab88b765f694b562$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab88b765f694b562$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ab88b765f694b562$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ab88b765f694b562$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $ab88b765f694b562$var$useTooltipSyncEventsListener() {
    var mySyncId = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$d3b88e5c88540018));
    var myEventEmitter = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$b89defd58e84e980));
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var syncMethod = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$f3cbf53653105e96));
    var tooltipTicks = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a));
    var layout = (0, $e573f10901a87cfb$export$970c79ecc7081cc)();
    var viewBox = (0, $e573f10901a87cfb$export$76b29bb074e0c45a)();
    var className = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>state.rootProps.className);
    (0, $acw62.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $2ab3a7e25c8aba74$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId !== incomingSyncId) // This event is not for this chart
            return;
            if (syncMethod === 'index') {
                var _action$payload;
                if (viewBox && action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.coordinate && action.payload.sourceViewBox) {
                    var _action$payload$coord = action.payload.coordinate, { x: _x, y: _y } = _action$payload$coord, otherCoordinateProps = $ab88b765f694b562$var$_objectWithoutProperties(_action$payload$coord, $ab88b765f694b562$var$_excluded);
                    var { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight } = action.payload.sourceViewBox;
                    var scaledCoordinate = $ab88b765f694b562$var$_objectSpread($ab88b765f694b562$var$_objectSpread({}, otherCoordinateProps), {}, {
                        x: viewBox.x + (sourceWidth ? (_x - sourceX) / sourceWidth : 0) * viewBox.width,
                        y: viewBox.y + (sourceHeight ? (_y - sourceY) / sourceHeight : 0) * viewBox.height
                    });
                    dispatch($ab88b765f694b562$var$_objectSpread($ab88b765f694b562$var$_objectSpread({}, action), {}, {
                        payload: $ab88b765f694b562$var$_objectSpread($ab88b765f694b562$var$_objectSpread({}, action.payload), {}, {
                            coordinate: scaledCoordinate
                        })
                    }));
                } else dispatch(action);
                return;
            }
            if (tooltipTicks == null) // for the other two sync methods, we need the ticks to be available
            return;
            var activeTick;
            if (typeof syncMethod === 'function') {
                /*
         * This is what the data shape in 2.x CategoricalChartState used to look like.
         * In 3.x we store things differently but let's try to keep the old shape for compatibility.
         */ var syncMethodParam = {
                    activeTooltipIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    isTooltipActive: action.payload.active,
                    activeIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    activeLabel: action.payload.label,
                    activeDataKey: action.payload.dataKey,
                    activeCoordinate: action.payload.coordinate
                };
                // Call a callback function. If there is an application specific algorithm
                var activeTooltipIndex = syncMethod(tooltipTicks, syncMethodParam);
                activeTick = tooltipTicks[activeTooltipIndex];
            } else if (syncMethod === 'value') // labels are always strings, tick.value might be a string or a number, depending on axis type
            activeTick = tooltipTicks.find((tick)=>String(tick.value) === action.payload.label);
            var { coordinate: coordinate } = action.payload;
            if (activeTick == null || action.payload.active === false || coordinate == null || viewBox == null) {
                dispatch((0, $3be7536b77e1512b$export$f2efc99b98e50938)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined,
                    graphicalItemId: undefined
                }));
                return;
            }
            var { x: x, y: y } = coordinate;
            var validateChartX = Math.min(x, viewBox.x + viewBox.width);
            var validateChartY = Math.min(y, viewBox.y + viewBox.height);
            var activeCoordinate = {
                x: layout === 'horizontal' ? activeTick.coordinate : validateChartX,
                y: layout === 'horizontal' ? validateChartY : activeTick.coordinate
            };
            var syncAction = (0, $3be7536b77e1512b$export$f2efc99b98e50938)({
                active: action.payload.active,
                coordinate: activeCoordinate,
                dataKey: action.payload.dataKey,
                index: String(activeTick.index),
                label: action.payload.label,
                sourceViewBox: action.payload.sourceViewBox,
                graphicalItemId: action.payload.graphicalItemId
            });
            dispatch(syncAction);
        };
        (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).on((0, $bbd08cd38300f8df$export$e2631176295fd79b), listener);
        return ()=>{
            (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).off((0, $bbd08cd38300f8df$export$e2631176295fd79b), listener);
        };
    }, [
        className,
        dispatch,
        myEventEmitter,
        mySyncId,
        syncMethod,
        tooltipTicks,
        layout,
        viewBox
    ]);
}
function $ab88b765f694b562$var$useBrushSyncEventsListener() {
    var mySyncId = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$d3b88e5c88540018));
    var myEventEmitter = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$b89defd58e84e980));
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $2ab3a7e25c8aba74$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId === incomingSyncId) dispatch((0, $4dcdb3a18a3e2ca4$export$427d605cc4e3bbdd)(action));
        };
        (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).on((0, $bbd08cd38300f8df$export$5069141294af4ee8), listener);
        return ()=>{
            (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).off((0, $bbd08cd38300f8df$export$5069141294af4ee8), listener);
        };
    }, [
        dispatch,
        myEventEmitter,
        mySyncId
    ]);
}
function $ab88b765f694b562$export$3a6efefeed76accf() {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $886d067545e9f9a0$export$abfecd6a8e6070c1)());
    }, [
        dispatch
    ]);
    $ab88b765f694b562$var$useTooltipSyncEventsListener();
    $ab88b765f694b562$var$useBrushSyncEventsListener();
}
function $ab88b765f694b562$export$21f8394fb189b529(tooltipEventType, trigger, activeCoordinate, activeLabel, activeIndex, isTooltipActive) {
    var activeDataKey = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $5211e0f48c9883fe$export$faa2b8b92235e5bd)(state, tooltipEventType, trigger));
    var eventEmitterSymbol = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$b89defd58e84e980));
    var syncId = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$d3b88e5c88540018));
    var syncMethod = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$f3cbf53653105e96));
    var tooltipState = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $156d26eca16ead28$export$54e3aed0d8d4a717));
    var isReceivingSynchronisation = tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.active;
    var viewBox = (0, $e573f10901a87cfb$export$76b29bb074e0c45a)();
    (0, $acw62.useEffect)(()=>{
        if (isReceivingSynchronisation) /*
       * This chart currently has active tooltip, synchronised from another chart.
       * Let's not send any outgoing synchronisation events while that's happening
       * to avoid infinite loops.
       */ return;
        if (syncId == null) /*
       * syncId is not set, means that this chart is not synchronised with any other chart,
       * means we don't need to send synchronisation events
       */ return;
        if (eventEmitterSymbol == null) /*
       * When using Recharts internal hooks and selectors outside charts context,
       * these properties will be undefined. Let's return silently instead of throwing an error.
       */ return;
        var syncAction = (0, $3be7536b77e1512b$export$f2efc99b98e50938)({
            active: isTooltipActive,
            coordinate: activeCoordinate,
            dataKey: activeDataKey,
            index: activeIndex,
            label: typeof activeLabel === 'number' ? String(activeLabel) : activeLabel,
            sourceViewBox: viewBox,
            graphicalItemId: undefined
        });
        (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).emit((0, $bbd08cd38300f8df$export$e2631176295fd79b), syncId, syncAction, eventEmitterSymbol);
    }, [
        isReceivingSynchronisation,
        activeCoordinate,
        activeDataKey,
        activeIndex,
        activeLabel,
        eventEmitterSymbol,
        syncId,
        syncMethod,
        isTooltipActive,
        viewBox
    ]);
}
function $ab88b765f694b562$export$d3c93a99675de51f() {
    var syncId = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$d3b88e5c88540018));
    var eventEmitterSymbol = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $dcfc24e85ad2aefd$export$b89defd58e84e980));
    var brushStartIndex = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>state.chartData.dataStartIndex);
    var brushEndIndex = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>state.chartData.dataEndIndex);
    (0, $acw62.useEffect)(()=>{
        if (syncId == null || brushStartIndex == null || brushEndIndex == null || eventEmitterSymbol == null) return;
        var syncAction = {
            startIndex: brushStartIndex,
            endIndex: brushEndIndex
        };
        (0, $bbd08cd38300f8df$export$9bcdfe5f29bb33).emit((0, $bbd08cd38300f8df$export$5069141294af4ee8), syncId, syncAction, eventEmitterSymbol);
    }, [
        brushEndIndex,
        brushStartIndex,
        eventEmitterSymbol,
        syncId
    ]);
}




var $acw62 = parcelRequire("acw62");




function $f05b1a56072a2a66$export$20f53c2c914d2da0() {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var [ref, setRef] = (0, $acw62.useState)(null);
    var scale = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $0ab9657931cbbb24$export$317b55dda5fb5617));
    (0, $acw62.useEffect)(()=>{
        if (ref == null) return;
        var rect = ref.getBoundingClientRect();
        var newScale = rect.width / ref.offsetWidth;
        if ((0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(newScale) && newScale !== scale) dispatch((0, $2c79e8f39a8896b6$export$4dc523f7f9b3edd6)(newScale));
    }, [
        ref,
        dispatch,
        scale
    ]);
    return setRef;
}





var $acw62 = parcelRequire("acw62");
var $7e46a321e54335ab$export$cf22c67346dd99a4 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $7e46a321e54335ab$export$2842d70d9d62127a = ()=>(0, $acw62.useContext)($7e46a321e54335ab$export$cf22c67346dd99a4);



var $acw62 = parcelRequire("acw62");
var $10caa8aee2f82bd9$export$63a23315bebc1b2 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $10caa8aee2f82bd9$export$36ebc0838785d4af = ()=>(0, $acw62.useContext)($10caa8aee2f82bd9$export$63a23315bebc1b2);




function $4839b40e60bab7c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4839b40e60bab7c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4839b40e60bab7c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4839b40e60bab7c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4839b40e60bab7c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4839b40e60bab7c7$var$_defineProperty(e, r, t) {
    return (r = $4839b40e60bab7c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4839b40e60bab7c7$var$_toPropertyKey(t) {
    var i = $4839b40e60bab7c7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4839b40e60bab7c7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4839b40e60bab7c7$var$_extends() {
    return $4839b40e60bab7c7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4839b40e60bab7c7$var$_extends.apply(null, arguments);
}
var $4839b40e60bab7c7$var$EventSynchronizer = ()=>{
    (0, $ab88b765f694b562$export$3a6efefeed76accf)();
    return null;
};
function $4839b40e60bab7c7$var$getNumberOrZero(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
}
var $4839b40e60bab7c7$var$ResponsiveDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _props$style, _props$style2;
    var observerRef = (0, $acw62.useRef)(null);
    var [sizes, setSizes] = (0, $acw62.useState)({
        containerWidth: $4839b40e60bab7c7$var$getNumberOrZero((_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width),
        containerHeight: $4839b40e60bab7c7$var$getNumberOrZero((_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.height)
    });
    var setContainerSize = (0, $acw62.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $acw62.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null && typeof ResizeObserver !== 'undefined') {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
            var callback = (entries)=>{
                var entry = entries[0];
                if (entry == null) return;
                var { width: width, height: height } = entry.contentRect;
                setContainerSize(width, height);
            };
            var observer = new ResizeObserver(callback);
            observer.observe(node);
            observerRef.current = observer;
        }
    }, [
        ref,
        setContainerSize
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var observer = observerRef.current;
            if (observer != null) observer.disconnect();
        };
    }, [
        setContainerSize
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $e573f10901a87cfb$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: innerRef
    }, props)));
});
var $4839b40e60bab7c7$var$ReadSizeOnceDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    var [sizes, setSizes] = (0, $acw62.useState)({
        containerWidth: $4839b40e60bab7c7$var$getNumberOrZero(width),
        containerHeight: $4839b40e60bab7c7$var$getNumberOrZero(height)
    });
    var setContainerSize = (0, $acw62.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $acw62.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null) {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
        }
    }, [
        ref,
        setContainerSize
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $e573f10901a87cfb$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: innerRef
    }, props)));
});
var $4839b40e60bab7c7$var$StaticDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $e573f10901a87cfb$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: ref
    }, props)));
});
var $4839b40e60bab7c7$var$NonResponsiveDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    // When width or height are percentages or CSS short names, read size from DOM once
    if (typeof width === 'string' || typeof height === 'string') return /*#__PURE__*/ $acw62.createElement($4839b40e60bab7c7$var$ReadSizeOnceDiv, $4839b40e60bab7c7$var$_extends({}, props, {
        ref: ref
    }));
    // When both are numbers, use them directly
    if (typeof width === 'number' && typeof height === 'number') return /*#__PURE__*/ $acw62.createElement($4839b40e60bab7c7$var$StaticDiv, $4839b40e60bab7c7$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
    // When width/height are undefined, render wrapper div without reporting size
    // This results in no SVG being rendered (intentional for backwards compatibility)
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $e573f10901a87cfb$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: ref
    }, props)));
});
function $4839b40e60bab7c7$var$getWrapperDivComponent(responsive) {
    return responsive ? $4839b40e60bab7c7$var$ResponsiveDiv : $4839b40e60bab7c7$var$NonResponsiveDiv;
}
var $4839b40e60bab7c7$export$81bb7974a33f88b = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { children: children, className: className, height: heightFromProps, onClick: onClick, onContextMenu: onContextMenu, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, style: style, width: widthFromProps, responsive: responsive, dispatchTouchEvents: dispatchTouchEvents = true } = props;
    var containerRef = (0, $acw62.useRef)(null);
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var [tooltipPortal, setTooltipPortal] = (0, $acw62.useState)(null);
    var [legendPortal, setLegendPortal] = (0, $acw62.useState)(null);
    var setScaleRef = (0, $f05b1a56072a2a66$export$20f53c2c914d2da0)();
    var responsiveContainerCalculations = (0, $0431397098acacbe$export$4ec9972d4f677af6)();
    var width = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.width) > 0 ? responsiveContainerCalculations.width : widthFromProps;
    var height = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.height) > 0 ? responsiveContainerCalculations.height : heightFromProps;
    var innerRef = (0, $acw62.useCallback)((node)=>{
        setScaleRef(node);
        if (typeof ref === 'function') ref(node);
        setTooltipPortal(node);
        setLegendPortal(node);
        if (node != null) containerRef.current = node;
    }, [
        setScaleRef,
        ref,
        setTooltipPortal,
        setLegendPortal
    ]);
    var myOnClick = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $303fec236f990197$export$f06e14b484aecafc)(e));
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onClick
    ]);
    var myOnMouseEnter = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $303fec236f990197$export$f9de213dbfb2e32c)(e));
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onMouseEnter,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseEnter
    ]);
    var myOnMouseLeave = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $3be7536b77e1512b$export$73879bed3f2eef71)());
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onMouseLeave,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseLeave
    ]);
    var myOnMouseMove = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $303fec236f990197$export$f9de213dbfb2e32c)(e));
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onMouseMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseMove
    ]);
    var onFocus = (0, $acw62.useCallback)(()=>{
        dispatch((0, $6f317037c3555952$export$d95192eee5865567)());
    }, [
        dispatch
    ]);
    var onKeyDown = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $6f317037c3555952$export$4839538efb7414c)(e.key));
    }, [
        dispatch
    ]);
    var myOnContextMenu = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onContextMenu,
            reactEvent: e
        }));
    }, [
        dispatch,
        onContextMenu
    ]);
    var myOnDoubleClick = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onDoubleClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onDoubleClick
    ]);
    var myOnMouseDown = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onMouseDown,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseDown
    ]);
    var myOnMouseUp = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onMouseUp,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseUp
    ]);
    var myOnTouchStart = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onTouchStart,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchStart
    ]);
    /*
   * onTouchMove is special because it behaves different from mouse events.
   * Mouse events have 'enter' + 'leave' combo that notify us when the mouse is over
   * a certain element. Touch events don't have that; touch only gives us
   * start (finger down), end (finger up) and move (finger moving).
   * So we need to figure out which element the user is touching
   * ourselves. Fortunately, there's a convenient method for that:
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint
   */ var myOnTouchMove = (0, $acw62.useCallback)((e)=>{
        if (dispatchTouchEvents) dispatch((0, $1560e93fcb4e9208$export$ba46b5fda0e2985f)(e));
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onTouchMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        dispatchTouchEvents,
        onTouchMove
    ]);
    var myOnTouchEnd = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $76ce3aa82d5f6fc2$export$1d0268b9f89859f0)({
            handler: onTouchEnd,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchEnd
    ]);
    var WrapperDiv = $4839b40e60bab7c7$var$getWrapperDivComponent(responsive);
    return /*#__PURE__*/ $acw62.createElement((0, $7e46a321e54335ab$export$cf22c67346dd99a4).Provider, {
        value: tooltipPortal
    }, /*#__PURE__*/ $acw62.createElement((0, $10caa8aee2f82bd9$export$63a23315bebc1b2).Provider, {
        value: legendPortal
    }, /*#__PURE__*/ $acw62.createElement(WrapperDiv, {
        width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width,
        height: height !== null && height !== void 0 ? height : style === null || style === void 0 ? void 0 : style.height,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-wrapper', className),
        style: $4839b40e60bab7c7$var$_objectSpread({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
        }, style),
        onClick: myOnClick,
        onContextMenu: myOnContextMenu,
        onDoubleClick: myOnDoubleClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: myOnMouseDown,
        onMouseEnter: myOnMouseEnter,
        onMouseLeave: myOnMouseLeave,
        onMouseMove: myOnMouseMove,
        onMouseUp: myOnMouseUp,
        onTouchEnd: myOnTouchEnd,
        onTouchMove: myOnTouchMove,
        onTouchStart: myOnTouchStart,
        ref: innerRef
    }, /*#__PURE__*/ $acw62.createElement($4839b40e60bab7c7$var$EventSynchronizer, null), children)));
});



var $acw62 = parcelRequire("acw62");


var $0114c9960f9c8c96$var$ClipPathIdContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $0114c9960f9c8c96$export$8b42b9b49a38ca72 = (_ref)=>{
    var { children: children } = _ref;
    var [clipPathId] = (0, $acw62.useState)("".concat((0, $2ab3a7e25c8aba74$export$8b15d37bc3f197d4)('recharts'), "-clip"));
    var plotArea = (0, $42890447eb7e6cfe$export$f1ef8efc9ef6fe0c)();
    if (plotArea == null) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $acw62.createElement($0114c9960f9c8c96$var$ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: x,
        y: y,
        height: height,
        width: width
    }))), children);
};
var $0114c9960f9c8c96$export$71e825c43eae6ca6 = ()=>{
    return (0, $acw62.useContext)($0114c9960f9c8c96$var$ClipPathIdContext);
};




var $d83d807ecbeb257e$var$_excluded = [
    "width",
    "height",
    "responsive",
    "children",
    "className",
    "style",
    "compact",
    "title",
    "desc"
];
function $d83d807ecbeb257e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $d83d807ecbeb257e$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $d83d807ecbeb257e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d83d807ecbeb257e$export$d49e03133b3316a9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { width: width, height: height, responsive: responsive, children: children, className: className, style: style, compact: compact, title: title, desc: desc } = props, others = $d83d807ecbeb257e$var$_objectWithoutProperties(props, $d83d807ecbeb257e$var$_excluded);
    var attrs = (0, $37a0b0a95f0e25bf$export$8b56257912140094)(others);
    /*
   * The "compact" mode is used as the panorama within Brush.
   * However because `compact` is a public prop, let's assume that it can render outside of Brush too.
   */ if (compact) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $e573f10901a87cfb$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $acw62.createElement((0, $a2354a93b9e04e81$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc
    }, children));
    return /*#__PURE__*/ $acw62.createElement((0, $4839b40e60bab7c7$export$81bb7974a33f88b), {
        className: className,
        style: style,
        width: width,
        height: height,
        responsive: responsive !== null && responsive !== void 0 ? responsive : false,
        onClick: props.onClick,
        onMouseLeave: props.onMouseLeave,
        onMouseEnter: props.onMouseEnter,
        onMouseMove: props.onMouseMove,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        onContextMenu: props.onContextMenu,
        onDoubleClick: props.onDoubleClick,
        onTouchStart: props.onTouchStart,
        onTouchMove: props.onTouchMove,
        onTouchEnd: props.onTouchEnd
    }, /*#__PURE__*/ $acw62.createElement((0, $a2354a93b9e04e81$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc,
        ref: ref
    }, /*#__PURE__*/ $acw62.createElement((0, $0114c9960f9c8c96$export$8b42b9b49a38ca72), null, children)));
});



function $b5deaf479b23783f$var$_extends() {
    return $b5deaf479b23783f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5deaf479b23783f$var$_extends.apply(null, arguments);
}
var $b5deaf479b23783f$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var $b5deaf479b23783f$export$2663cf0965a16cf2 = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    layout: 'horizontal',
    margin: $b5deaf479b23783f$var$defaultMargin,
    responsive: false,
    reverseStackOrder: false,
    stackOffset: 'none',
    syncMethod: 'index'
};
var $b5deaf479b23783f$export$855bb85b2910abc9 = /*#__PURE__*/ (0, $acw62.forwardRef)(function CartesianChart(props, ref) {
    var _categoricalChartProp;
    var rootChartProps = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(props.categoricalChartProps, $b5deaf479b23783f$export$2663cf0965a16cf2);
    var { chartName: chartName, defaultTooltipEventType: defaultTooltipEventType, validateTooltipEventTypes: validateTooltipEventTypes, tooltipPayloadSearcher: tooltipPayloadSearcher, categoricalChartProps: categoricalChartProps } = props;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $acw62.createElement((0, $d43b7042472c8a15$export$debe87639f2707f9), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_categoricalChartProp = categoricalChartProps.id) !== null && _categoricalChartProp !== void 0 ? _categoricalChartProp : chartName
    }, /*#__PURE__*/ $acw62.createElement((0, $15e3dd90a1832e09$export$2100a1dedbca0238), {
        chartData: categoricalChartProps.data
    }), /*#__PURE__*/ $acw62.createElement((0, $afc35d1bda6a54e7$export$6faeaad6e02c2e9d), {
        layout: rootChartProps.layout,
        margin: rootChartProps.margin
    }), /*#__PURE__*/ $acw62.createElement((0, $dcaaff4a864a6bc4$export$6fabfb9ba230d12b), {
        baseValue: rootChartProps.baseValue,
        accessibilityLayer: rootChartProps.accessibilityLayer,
        barCategoryGap: rootChartProps.barCategoryGap,
        maxBarSize: rootChartProps.maxBarSize,
        stackOffset: rootChartProps.stackOffset,
        barGap: rootChartProps.barGap,
        barSize: rootChartProps.barSize,
        syncId: rootChartProps.syncId,
        syncMethod: rootChartProps.syncMethod,
        className: rootChartProps.className,
        reverseStackOrder: rootChartProps.reverseStackOrder
    }), /*#__PURE__*/ $acw62.createElement((0, $d83d807ecbeb257e$export$d49e03133b3316a9), $b5deaf479b23783f$var$_extends({}, rootChartProps, {
        ref: ref
    })));
});


var $40df630ec903a4ea$var$allowedTooltipTypes = [
    'axis'
];
var $40df630ec903a4ea$export$f510429275d6f1a8 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $b5deaf479b23783f$export$855bb85b2910abc9), {
        chartName: "AreaChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $40df630ec903a4ea$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $886d067545e9f9a0$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $acw62 = parcelRequire("acw62");


/**
 * Cell component used to define colors and styles of chart elements.
 *
 * This component is now deprecated and will be removed in Recharts 4.0.
 *
 * Please use the `shape` prop or `content` prop on the respective chart components
 * to customize the rendering of chart elements instead of using `Cell`.
 *
 * @see {@link https://recharts.github.io/en-US/guide/cell/ Guide: Migrate from Cell component to shape prop}
 *
 * @deprecated
 * @consumes CellReader
 */ var $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea = (_props)=>null;
$b43ffe30f81b14f2$export$f6f0c3fe4ec306ea.displayName = 'Cell';








var $acw62 = parcelRequire("acw62");
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}



var $acw62 = parcelRequire("acw62");
var $813b8cd372f70d1b$exports = {};

$813b8cd372f70d1b$exports = (parcelRequire("hm1Vt")).isPlainObject;



var $acw62 = parcelRequire("acw62");








var $70f75e095c9bb92d$var$_excluded = [
    "radius"
], $70f75e095c9bb92d$var$_excluded2 = [
    "radius"
];
var $70f75e095c9bb92d$var$_templateObject, $70f75e095c9bb92d$var$_templateObject2, $70f75e095c9bb92d$var$_templateObject3, $70f75e095c9bb92d$var$_templateObject4, $70f75e095c9bb92d$var$_templateObject5, $70f75e095c9bb92d$var$_templateObject6, $70f75e095c9bb92d$var$_templateObject7, $70f75e095c9bb92d$var$_templateObject8, $70f75e095c9bb92d$var$_templateObject9, $70f75e095c9bb92d$var$_templateObject0;
function $70f75e095c9bb92d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70f75e095c9bb92d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70f75e095c9bb92d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $70f75e095c9bb92d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70f75e095c9bb92d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $70f75e095c9bb92d$var$_defineProperty(e, r, t) {
    return (r = $70f75e095c9bb92d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $70f75e095c9bb92d$var$_toPropertyKey(t) {
    var i = $70f75e095c9bb92d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $70f75e095c9bb92d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $70f75e095c9bb92d$var$_extends() {
    return $70f75e095c9bb92d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $70f75e095c9bb92d$var$_extends.apply(null, arguments);
}
function $70f75e095c9bb92d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $70f75e095c9bb92d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $70f75e095c9bb92d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $70f75e095c9bb92d$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
/**
 * @inline
 */ var $70f75e095c9bb92d$var$getRectanglePath = (x, y, width, height, radius)=>{
    var roundedWidth = (0, $a838779be6c997fd$export$2077e0241d6afd3c)(width);
    var roundedHeight = (0, $a838779be6c997fd$export$2077e0241d6afd3c)(height);
    var maxRadius = Math.min(Math.abs(roundedWidth) / 2, Math.abs(roundedHeight) / 2);
    var ySign = roundedHeight >= 0 ? 1 : -1;
    var xSign = roundedWidth >= 0 ? 1 : -1;
    var clockWise = roundedHeight >= 0 && roundedWidth >= 0 || roundedHeight < 0 && roundedWidth < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && Array.isArray(radius)) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++){
            var _radius$i;
            var r = (_radius$i = radius[i]) !== null && _radius$i !== void 0 ? _radius$i : 0;
            newRadius[i] = r > maxRadius ? maxRadius : r;
        }
        path = (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject || ($70f75e095c9bb92d$var$_templateObject = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "M",
            ",",
            ""
        ])), x, y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject2 || ($70f75e095c9bb92d$var$_templateObject2 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",",
            ",",
            ""
        ])), newRadius[0], newRadius[0], clockWise, x + xSign * newRadius[0], y);
        path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject3 || ($70f75e095c9bb92d$var$_templateObject3 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width - xSign * newRadius[1], y);
        if (newRadius[1] > 0) path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject4 || ($70f75e095c9bb92d$var$_templateObject4 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[1], newRadius[1], clockWise, x + width, y + ySign * newRadius[1]);
        path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject5 || ($70f75e095c9bb92d$var$_templateObject5 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width, y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject6 || ($70f75e095c9bb92d$var$_templateObject6 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[2], newRadius[2], clockWise, x + width - xSign * newRadius[2], y + height);
        path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject7 || ($70f75e095c9bb92d$var$_templateObject7 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + xSign * newRadius[3], y + height);
        if (newRadius[3] > 0) path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject8 || ($70f75e095c9bb92d$var$_templateObject8 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[3], newRadius[3], clockWise, x, y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject9 || ($70f75e095c9bb92d$var$_templateObject9 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            " Z"
        ])), x, y + ySign * _newRadius, _newRadius, _newRadius, clockWise, x + xSign * _newRadius, y, x + width - xSign * _newRadius, y, _newRadius, _newRadius, clockWise, x + width, y + ySign * _newRadius, x + width, y + height - ySign * _newRadius, _newRadius, _newRadius, clockWise, x + width - xSign * _newRadius, y + height, x + xSign * _newRadius, y + height, _newRadius, _newRadius, clockWise, x, y + height - ySign * _newRadius);
    } else path = (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($70f75e095c9bb92d$var$_templateObject0 || ($70f75e095c9bb92d$var$_templateObject0 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
        "M ",
        ",",
        " h ",
        " v ",
        " h ",
        " Z"
    ])), x, y, width, height, -width);
    return path;
};
var $70f75e095c9bb92d$export$90e429de6eb3e62f = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $70f75e095c9bb92d$export$4617fb02663045ef = (rectangleProps)=>{
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(rectangleProps, $70f75e095c9bb92d$export$90e429de6eb3e62f);
    var pathRef = (0, $acw62.useRef)(null);
    var [totalLength, setTotalLength] = (0, $acw62.useState)(-1);
    (0, $acw62.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    var { x: x, y: y, width: width, height: height, radius: radius, className: className } = props;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isAnimationActive: isAnimationActive, isUpdateAnimationActive: isUpdateAnimationActive } = props;
    var prevWidthRef = (0, $acw62.useRef)(width);
    var prevHeightRef = (0, $acw62.useRef)(height);
    var prevXRef = (0, $acw62.useRef)(x);
    var prevYRef = (0, $acw62.useRef)(y);
    var animationIdInput = (0, $acw62.useMemo)(()=>({
            x: x,
            y: y,
            width: width,
            height: height,
            radius: radius
        }), [
        x,
        y,
        width,
        height,
        radius
    ]);
    var animationId = (0, $72206edefbff003d$export$e1042b2944b80b7f)(animationIdInput, 'rectangle-');
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) {
        var _svgPropertiesAndEven = (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven, otherPathProps = $70f75e095c9bb92d$var$_objectWithoutProperties(_svgPropertiesAndEven, $70f75e095c9bb92d$var$_excluded);
        return /*#__PURE__*/ $acw62.createElement("path", $70f75e095c9bb92d$var$_extends({}, otherPathProps, {
            x: (0, $a838779be6c997fd$export$2077e0241d6afd3c)(x),
            y: (0, $a838779be6c997fd$export$2077e0241d6afd3c)(y),
            width: (0, $a838779be6c997fd$export$2077e0241d6afd3c)(width),
            height: (0, $a838779be6c997fd$export$2077e0241d6afd3c)(height),
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $70f75e095c9bb92d$var$getRectanglePath(x, y, width, height, radius)
        }));
    }
    var prevWidth = prevWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, $1cc24ee9ad4a37a9$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, typeof animationEasing === 'string' ? animationEasing : $70f75e095c9bb92d$export$90e429de6eb3e62f.animationEasing);
    return /*#__PURE__*/ $acw62.createElement((0, $464febc3f716710f$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currWidth = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevWidth, width, t);
        var currHeight = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevWidthRef.current = currWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle;
        if (!isAnimationActive) animationStyle = {
            strokeDasharray: to
        };
        else if (t > 0) animationStyle = {
            transition: transition,
            strokeDasharray: to
        };
        else animationStyle = {
            strokeDasharray: from
        };
        var _svgPropertiesAndEven2 = (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven2, otherPathProps = $70f75e095c9bb92d$var$_objectWithoutProperties(_svgPropertiesAndEven2, $70f75e095c9bb92d$var$_excluded2);
        return /*#__PURE__*/ $acw62.createElement("path", $70f75e095c9bb92d$var$_extends({}, otherPathProps, {
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $70f75e095c9bb92d$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef,
            style: $70f75e095c9bb92d$var$_objectSpread($70f75e095c9bb92d$var$_objectSpread({}, animationStyle), props.style)
        }));
    });
};



var $acw62 = parcelRequire("acw62");








var $b0f8b4122c292e26$var$_templateObject, $b0f8b4122c292e26$var$_templateObject2, $b0f8b4122c292e26$var$_templateObject3, $b0f8b4122c292e26$var$_templateObject4, $b0f8b4122c292e26$var$_templateObject5;
function $b0f8b4122c292e26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0f8b4122c292e26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0f8b4122c292e26$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b0f8b4122c292e26$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0f8b4122c292e26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0f8b4122c292e26$var$_defineProperty(e, r, t) {
    return (r = $b0f8b4122c292e26$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b0f8b4122c292e26$var$_toPropertyKey(t) {
    var i = $b0f8b4122c292e26$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b0f8b4122c292e26$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b0f8b4122c292e26$var$_extends() {
    return $b0f8b4122c292e26$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b0f8b4122c292e26$var$_extends.apply(null, arguments);
}
function $b0f8b4122c292e26$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $b0f8b4122c292e26$var$getTrapezoidPath = (x, y, upperWidth, lowerWidth, height)=>{
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($b0f8b4122c292e26$var$_templateObject || ($b0f8b4122c292e26$var$_templateObject = $b0f8b4122c292e26$var$_taggedTemplateLiteral([
        "M ",
        ",",
        ""
    ])), x, y);
    path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($b0f8b4122c292e26$var$_templateObject2 || ($b0f8b4122c292e26$var$_templateObject2 = $b0f8b4122c292e26$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth, y);
    path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($b0f8b4122c292e26$var$_templateObject3 || ($b0f8b4122c292e26$var$_templateObject3 = $b0f8b4122c292e26$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2, y + height);
    path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($b0f8b4122c292e26$var$_templateObject4 || ($b0f8b4122c292e26$var$_templateObject4 = $b0f8b4122c292e26$var$_taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2 - lowerWidth, y + height);
    path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($b0f8b4122c292e26$var$_templateObject5 || ($b0f8b4122c292e26$var$_templateObject5 = $b0f8b4122c292e26$var$_taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), x, y);
    return path;
};
var $b0f8b4122c292e26$export$d414f170eb9e3706 = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $b0f8b4122c292e26$export$d1ed33dc592f5337 = (outsideProps)=>{
    var trapezoidProps = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $b0f8b4122c292e26$export$d414f170eb9e3706);
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, height: height, className: className } = trapezoidProps;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isUpdateAnimationActive: isUpdateAnimationActive } = trapezoidProps;
    var pathRef = (0, $acw62.useRef)(null);
    var [totalLength, setTotalLength] = (0, $acw62.useState)(-1);
    var prevUpperWidthRef = (0, $acw62.useRef)(upperWidth);
    var prevLowerWidthRef = (0, $acw62.useRef)(lowerWidth);
    var prevHeightRef = (0, $acw62.useRef)(height);
    var prevXRef = (0, $acw62.useRef)(x);
    var prevYRef = (0, $acw62.useRef)(y);
    var animationId = (0, $72206edefbff003d$export$e1042b2944b80b7f)(outsideProps, 'trapezoid-');
    (0, $acw62.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ $acw62.createElement("g", null, /*#__PURE__*/ $acw62.createElement("path", $b0f8b4122c292e26$var$_extends({}, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(trapezoidProps), {
        className: layerClass,
        d: $b0f8b4122c292e26$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    var prevUpperWidth = prevUpperWidthRef.current;
    var prevLowerWidth = prevLowerWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, $1cc24ee9ad4a37a9$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, animationEasing);
    return /*#__PURE__*/ $acw62.createElement((0, $464febc3f716710f$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currUpperWidth = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevUpperWidth, upperWidth, t);
        var currLowerWidth = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevLowerWidth, lowerWidth, t);
        var currHeight = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevUpperWidthRef.current = currUpperWidth;
            prevLowerWidthRef.current = currLowerWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle = t > 0 ? {
            transition: transition,
            strokeDasharray: to
        } : {
            strokeDasharray: from
        };
        return /*#__PURE__*/ $acw62.createElement("path", $b0f8b4122c292e26$var$_extends({}, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(trapezoidProps), {
            className: layerClass,
            d: $b0f8b4122c292e26$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef,
            style: $b0f8b4122c292e26$var$_objectSpread($b0f8b4122c292e26$var$_objectSpread({}, animationStyle), trapezoidProps.style)
        }));
    });
};



var $acw62 = parcelRequire("acw62");






var $353ca4069312fa59$var$_templateObject, $353ca4069312fa59$var$_templateObject2, $353ca4069312fa59$var$_templateObject3, $353ca4069312fa59$var$_templateObject4, $353ca4069312fa59$var$_templateObject5, $353ca4069312fa59$var$_templateObject6, $353ca4069312fa59$var$_templateObject7;
function $353ca4069312fa59$var$_extends() {
    return $353ca4069312fa59$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $353ca4069312fa59$var$_extends.apply(null, arguments);
}
function $353ca4069312fa59$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $353ca4069312fa59$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $353ca4069312fa59$var$getTangentCircle = (_ref)=>{
    var { cx: cx, cy: cy, radius: radius, angle: angle, sign: sign, isExternal: isExternal, cornerRadius: cornerRadius, cornerIsExternal: cornerIsExternal } = _ref;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $353ca4069312fa59$var$getSectorPath = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = _ref2;
    var angle = $353ca4069312fa59$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($353ca4069312fa59$var$_templateObject || ($353ca4069312fa59$var$_templateObject = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A ",
        ",",
        ",0,\n    ",
        ",",
        ",\n    ",
        ",",
        "\n  "
    ])), outerStartPoint.x, outerStartPoint.y, outerRadius, outerRadius, +(Math.abs(angle) > 180), +(startAngle > tempEndAngle), outerEndPoint.x, outerEndPoint.y);
    if (innerRadius > 0) {
        var innerStartPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($353ca4069312fa59$var$_templateObject2 || ($353ca4069312fa59$var$_templateObject2 = $353ca4069312fa59$var$_taggedTemplateLiteral([
            "L ",
            ",",
            "\n            A ",
            ",",
            ",0,\n            ",
            ",",
            ",\n            ",
            ",",
            " Z"
        ])), innerEndPoint.x, innerEndPoint.y, innerRadius, innerRadius, +(Math.abs(angle) > 180), +(startAngle <= tempEndAngle), innerStartPoint.x, innerStartPoint.y);
    } else path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($353ca4069312fa59$var$_templateObject3 || ($353ca4069312fa59$var$_templateObject3 = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), cx, cy);
    return path;
};
var $353ca4069312fa59$var$getSectorWithCorner = (_ref3)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle } = _ref3;
    var sign = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(endAngle - startAngle);
    var { circleTangency: soct, lineTangency: solt, theta: sot } = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var { circleTangency: eoct, lineTangency: eolt, theta: eot } = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($353ca4069312fa59$var$_templateObject4 || ($353ca4069312fa59$var$_templateObject4 = $353ca4069312fa59$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n        a",
            ",",
            ",0,0,1,",
            ",0\n        a",
            ",",
            ",0,0,1,",
            ",0\n      "
        ])), solt.x, solt.y, cornerRadius, cornerRadius, cornerRadius * 2, cornerRadius, cornerRadius, -cornerRadius * 2);
        return $353ca4069312fa59$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($353ca4069312fa59$var$_templateObject5 || ($353ca4069312fa59$var$_templateObject5 = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,",
        ",",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n  "
    ])), solt.x, solt.y, cornerRadius, cornerRadius, +(sign < 0), soct.x, soct.y, outerRadius, outerRadius, +(outerArcAngle > 180), +(sign < 0), eoct.x, eoct.y, cornerRadius, cornerRadius, +(sign < 0), eolt.x, eolt.y);
    if (innerRadius > 0) {
        var { circleTangency: sict, lineTangency: silt, theta: sit } = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var { circleTangency: eict, lineTangency: eilt, theta: eit } = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($353ca4069312fa59$var$_templateObject6 || ($353ca4069312fa59$var$_templateObject6 = $353ca4069312fa59$var$_taggedTemplateLiteral([
            "L",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,",
            ",",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "Z"
        ])), eilt.x, eilt.y, cornerRadius, cornerRadius, +(sign < 0), eict.x, eict.y, innerRadius, innerRadius, +(innerArcAngle > 180), +(sign > 0), sict.x, sict.y, cornerRadius, cornerRadius, +(sign < 0), silt.x, silt.y);
    } else path += (0, $a838779be6c997fd$export$f8a24ecc3d6c26c3)($353ca4069312fa59$var$_templateObject7 || ($353ca4069312fa59$var$_templateObject7 = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "L",
        ",",
        "Z"
    ])), cx, cy);
    return path;
};
var $353ca4069312fa59$export$1d63e9c2e020b2a7 = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $353ca4069312fa59$export$e98c2c7eb2b14f45 = (sectorProps)=>{
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(sectorProps, $353ca4069312fa59$export$1d63e9c2e020b2a7);
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle, className: className } = props;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $353ca4069312fa59$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $353ca4069312fa59$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ $acw62.createElement("path", $353ca4069312fa59$var$_extends({}, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(props), {
        className: layerClass,
        d: path
    }));
};




var $acw62 = parcelRequire("acw62");




var $61aa615b92178b76$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $61aa615b92178b76$var$_extends() {
    return $61aa615b92178b76$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $61aa615b92178b76$var$_extends.apply(null, arguments);
}
function $61aa615b92178b76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61aa615b92178b76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61aa615b92178b76$var$ownKeys(Object(t), !0).forEach(function(r) {
            $61aa615b92178b76$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61aa615b92178b76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $61aa615b92178b76$var$_defineProperty(e, r, t) {
    return (r = $61aa615b92178b76$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $61aa615b92178b76$var$_toPropertyKey(t) {
    var i = $61aa615b92178b76$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $61aa615b92178b76$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $61aa615b92178b76$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $61aa615b92178b76$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $61aa615b92178b76$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $61aa615b92178b76$var$symbolFactories = {
    symbolCircle: $9b23116271105198$exports.symbolCircle,
    symbolCross: $9b23116271105198$exports.symbolCross,
    symbolDiamond: $9b23116271105198$exports.symbolDiamond,
    symbolSquare: $9b23116271105198$exports.symbolSquare,
    symbolStar: $9b23116271105198$exports.symbolStar,
    symbolTriangle: $9b23116271105198$exports.symbolTriangle,
    symbolWye: $9b23116271105198$exports.symbolWye
};
var $61aa615b92178b76$var$RADIAN = Math.PI / 180;
var $61aa615b92178b76$var$getSymbolFactory = (type)=>{
    var name = "symbol".concat((0, $2ab3a7e25c8aba74$export$3061f22cd819074d)(type));
    return $61aa615b92178b76$var$symbolFactories[name] || (0, $9b23116271105198$exports.symbolCircle);
};
var $61aa615b92178b76$var$calculateAreaSize = (size, sizeType, type)=>{
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $61aa615b92178b76$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.tan(angle) ** 2);
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $61aa615b92178b76$var$registerSymbol = (key, factory)=>{
    $61aa615b92178b76$var$symbolFactories["symbol".concat((0, $2ab3a7e25c8aba74$export$3061f22cd819074d)(key))] = factory;
};
var $61aa615b92178b76$export$fa456266707bf4e4 = (_ref)=>{
    var { type: type = 'circle', size: size = 64, sizeType: sizeType = 'area' } = _ref, rest = $61aa615b92178b76$var$_objectWithoutProperties(_ref, $61aa615b92178b76$var$_excluded);
    var props = $61aa615b92178b76$var$_objectSpread($61aa615b92178b76$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    var realType = 'circle';
    if (typeof type === 'string') /*
     * Our type guard is not as strong as it could be (i.e. non-existent),
     * and so despite the typescript type saying that `type` is a `SymbolType`,
     * we can get numbers or really anything, so let's have a runtime check here to fix the exception.
     *
     * https://github.com/recharts/recharts/issues/6197
     */ realType = type;
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = ()=>{
        var symbolFactory = $61aa615b92178b76$var$getSymbolFactory(realType);
        var symbol = (0, $9b23116271105198$exports.symbol)().type(symbolFactory).size($61aa615b92178b76$var$calculateAreaSize(size, sizeType, realType));
        var s = symbol();
        if (s === null) return undefined;
        return s;
    };
    var { className: className, cx: cx, cy: cy } = props;
    var filteredProps = (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(props);
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cx) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(cy) && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(size)) return /*#__PURE__*/ $acw62.createElement("path", $61aa615b92178b76$var$_extends({}, filteredProps, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$61aa615b92178b76$export$fa456266707bf4e4.registerSymbol = $61aa615b92178b76$var$registerSymbol;



var $4696e249b64cd95e$var$_excluded = [
    "option",
    "shapeType",
    "activeClassName"
];
function $4696e249b64cd95e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4696e249b64cd95e$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4696e249b64cd95e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $4696e249b64cd95e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4696e249b64cd95e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4696e249b64cd95e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4696e249b64cd95e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4696e249b64cd95e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4696e249b64cd95e$var$_defineProperty(e, r, t) {
    return (r = $4696e249b64cd95e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4696e249b64cd95e$var$_toPropertyKey(t) {
    var i = $4696e249b64cd95e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4696e249b64cd95e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a React element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $4696e249b64cd95e$var$defaultPropTransformer(option, props) {
    return $4696e249b64cd95e$var$_objectSpread($4696e249b64cd95e$var$_objectSpread({}, props), option);
}
function $4696e249b64cd95e$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $4696e249b64cd95e$var$ShapeSelector(_ref) {
    var { shapeType: shapeType, elementProps: elementProps } = _ref;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ $acw62.createElement((0, $70f75e095c9bb92d$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ $acw62.createElement((0, $b0f8b4122c292e26$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ $acw62.createElement((0, $353ca4069312fa59$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($4696e249b64cd95e$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ $acw62.createElement((0, $61aa615b92178b76$export$fa456266707bf4e4), elementProps);
            break;
        case 'curve':
            return /*#__PURE__*/ $acw62.createElement((0, $af2055905739b7f2$export$b0e83c3ef8d2db1), elementProps);
        default:
            return null;
    }
}
function $4696e249b64cd95e$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) return option.props;
    return option;
}
function $4696e249b64cd95e$export$6428a7f2611ef1fa(_ref2) {
    var { option: option, shapeType: shapeType, activeClassName: activeClassName = 'recharts-active-shape' } = _ref2, props = $4696e249b64cd95e$var$_objectWithoutProperties(_ref2, $4696e249b64cd95e$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) // @ts-expect-error we can't know the type of cloned element props
    shape = /*#__PURE__*/ (0, $acw62.cloneElement)(option, $4696e249b64cd95e$var$_objectSpread($4696e249b64cd95e$var$_objectSpread({}, props), $4696e249b64cd95e$export$33c4f706a443da24(option)));
    else if (typeof option === 'function') shape = option(props, props.index);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($813b8cd372f70d1b$exports)))(option) && typeof option !== 'boolean') {
        var nextProps = $4696e249b64cd95e$var$defaultPropTransformer(option, props);
        shape = /*#__PURE__*/ $acw62.createElement($4696e249b64cd95e$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ $acw62.createElement($4696e249b64cd95e$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (props.isActive) return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}



function $b5efd6b8794dbdeb$var$_extends() {
    return $b5efd6b8794dbdeb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5efd6b8794dbdeb$var$_extends.apply(null, arguments);
}
function $b5efd6b8794dbdeb$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ $acw62.createElement((0, $4696e249b64cd95e$export$6428a7f2611ef1fa), $b5efd6b8794dbdeb$var$_extends({
        shapeType: "rectangle",
        activeClassName: "recharts-active-bar"
    }, props));
}
var $b5efd6b8794dbdeb$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (value, index)=>{
        if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(minPointSize)) return minPointSize;
        var isValueNumberOrNil = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(value) || (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false, "minPointSize callback function received a value with type of ".concat(typeof value, ". Currently only numbers or null/undefined are supported."));
        return defaultValue;
    };
};




var $1d6cbb89ea2b356d$export$6162f642d41f88ea = (onMouseEnterFromProps, dataKey, graphicalItemId)=>{
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseEnterFromProps === null || onMouseEnterFromProps === void 0 || onMouseEnterFromProps(data, index, event);
            dispatch((0, $3be7536b77e1512b$export$c78abbb2450f6b44)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition,
                activeGraphicalItemId: graphicalItemId
            }));
        };
};
var $1d6cbb89ea2b356d$export$27cbf444bf0be2d0 = (onMouseLeaveFromProps)=>{
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseLeaveFromProps === null || onMouseLeaveFromProps === void 0 || onMouseLeaveFromProps(data, index, event);
            dispatch((0, $3be7536b77e1512b$export$68742311289b8f85)());
        };
};
var $1d6cbb89ea2b356d$export$c9154937ad8393fc = (onMouseClickFromProps, dataKey, graphicalItemId)=>{
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseClickFromProps === null || onMouseClickFromProps === void 0 || onMouseClickFromProps(data, index, event);
            dispatch((0, $3be7536b77e1512b$export$99be2464250d8cae)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition,
                activeGraphicalItemId: graphicalItemId
            }));
        };
};




var $acw62 = parcelRequire("acw62");



var $f02a6cc200a05058$var$_excluded = [
    "children"
];
function $f02a6cc200a05058$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f02a6cc200a05058$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f02a6cc200a05058$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f02a6cc200a05058$var$initialContextState = {
    data: [],
    xAxisId: 'xAxis-0',
    yAxisId: 'yAxis-0',
    dataPointFormatter: ()=>({
            x: 0,
            y: 0,
            value: 0
        }),
    errorBarOffset: 0
};
var $f02a6cc200a05058$var$ErrorBarContext = /*#__PURE__*/ (0, $acw62.createContext)($f02a6cc200a05058$var$initialContextState);
function $f02a6cc200a05058$export$fcd6ba6fb4bc66e7(props) {
    var { children: children } = props, rest = $f02a6cc200a05058$var$_objectWithoutProperties(props, $f02a6cc200a05058$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($f02a6cc200a05058$var$ErrorBarContext.Provider, {
        value: rest
    }, children);
}
var $f02a6cc200a05058$export$ce29452bff119c97 = ()=>(0, $acw62.useContext)($f02a6cc200a05058$var$ErrorBarContext);
function $f02a6cc200a05058$export$18dc5be7c8cb3008(props) {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var graphicalItemId = (0, $e0af6fe07417fba6$export$e24f341c4ff41691)();
    var prevPropsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (graphicalItemId == null) // ErrorBar outside a graphical item context does not do anything.
        return;
        if (prevPropsRef.current === null) dispatch((0, $9da41aabd5381b30$export$155912f95c88abac)({
            itemId: graphicalItemId,
            errorBar: props
        }));
        else if (prevPropsRef.current !== props) dispatch((0, $9da41aabd5381b30$export$f1ebd3b9f70a9f5f)({
            itemId: graphicalItemId,
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        graphicalItemId,
        props
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current != null && graphicalItemId != null) {
                dispatch((0, $9da41aabd5381b30$export$b0d2fb6a7d9d3b45)({
                    itemId: graphicalItemId,
                    errorBar: prevPropsRef.current
                }));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch,
        graphicalItemId
    ]);
    return null;
}















var $245a14c08b4396b4$var$getBarSize = (globalSize, totalSize, selfSize)=>{
    var barSize = selfSize !== null && selfSize !== void 0 ? selfSize : globalSize;
    if ((0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(barSize)) return undefined;
    return (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barSize, totalSize, 0);
};
var $245a14c08b4396b4$export$fa5aca2cbc42e692 = (allBars, globalSize, totalSize)=>{
    var initialValue = {};
    var stackedBars = allBars.filter((0, $6bd3f90b40714619$export$2335dd91cc88053e));
    var unstackedBars = allBars.filter((b)=>b.stackId == null);
    var groupByStack = stackedBars.reduce((acc, bar)=>{
        var s = acc[bar.stackId];
        if (s == null) s = [];
        s.push(bar);
        acc[bar.stackId] = s;
        return acc;
    }, initialValue);
    var stackedSizeList = Object.entries(groupByStack).map((_ref)=>{
        var _bars$;
        var [stackId, bars] = _ref;
        var dataKeys = bars.map((b)=>b.dataKey);
        var barSize = $245a14c08b4396b4$var$getBarSize(globalSize, totalSize, (_bars$ = bars[0]) === null || _bars$ === void 0 ? void 0 : _bars$.barSize);
        return {
            stackId: stackId,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    var unstackedSizeList = unstackedBars.map((b)=>{
        var dataKeys = [
            b.dataKey
        ].filter((dk)=>dk != null);
        var barSize = $245a14c08b4396b4$var$getBarSize(globalSize, totalSize, b.barSize);
        return {
            stackId: undefined,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    return [
        ...stackedSizeList,
        ...unstackedSizeList
    ];
};




function $2a7e66941f072ae1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a7e66941f072ae1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a7e66941f072ae1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a7e66941f072ae1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a7e66941f072ae1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a7e66941f072ae1$var$_defineProperty(e, r, t) {
    return (r = $2a7e66941f072ae1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2a7e66941f072ae1$var$_toPropertyKey(t) {
    var i = $2a7e66941f072ae1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2a7e66941f072ae1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2a7e66941f072ae1$var$getBarPositions(barGap, barCategoryGap, bandSize, sizeList, maxBarSize) {
    var _sizeList$;
    var len = sizeList.length;
    if (len < 1) return undefined;
    var realBarGap = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether is barSize set by user
    // Okay but why does it check only for the first element? What if the first element is set but others are not?
    if ((0, $dabee322b52312f4$export$f8a8fc612ced9bb0)((_sizeList$ = sizeList[0]) === null || _sizeList$ === void 0 ? void 0 : _sizeList$.barSize)) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce((res, entry)=>res + (entry.barSize || 0), 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce((res, entry)=>{
            var _entry$barSize;
            var newPosition = {
                stackId: entry.stackId,
                dataKeys: entry.dataKeys,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    size: useFull ? fullBarSize : (_entry$barSize = entry.barSize) !== null && _entry$barSize !== void 0 ? _entry$barSize : 0
                }
            };
            var newRes = [
                ...res,
                newPosition
            ];
            prev = newPosition.position;
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $2ab3a7e25c8aba74$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = (0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(maxBarSize) ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce((res, entry, i)=>[
                ...res,
                {
                    stackId: entry.stackId,
                    dataKeys: entry.dataKeys,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ], initialValue);
    }
    return result;
}
var $2a7e66941f072ae1$export$5068ec6da13c95bb = (sizeList, globalMaxBarSize, barGap, barCategoryGap, barBandSize, bandSize, childMaxBarSize)=>{
    var maxBarSize = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var allBarPositions = $2a7e66941f072ae1$var$getBarPositions(barGap, barCategoryGap, barBandSize !== bandSize ? barBandSize : bandSize, sizeList, maxBarSize);
    if (barBandSize !== bandSize && allBarPositions != null) allBarPositions = allBarPositions.map((pos)=>$2a7e66941f072ae1$var$_objectSpread($2a7e66941f072ae1$var$_objectSpread({}, pos), {}, {
            position: $2a7e66941f072ae1$var$_objectSpread($2a7e66941f072ae1$var$_objectSpread({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
            })
        }));
    return allBarPositions;
};



var $ed174a0e62d48311$export$66625d959aa66f0f = (stackGroups, barSettings)=>{
    var stackSeriesIdentifier = (0, $c86621286e2c8ba6$export$58b095b87bc46727)(barSettings);
    if (!stackGroups || stackSeriesIdentifier == null || barSettings == null) return undefined;
    var { stackId: stackId } = barSettings;
    if (stackId == null) return undefined;
    var stackGroup = stackGroups[stackId];
    if (!stackGroup) return undefined;
    var { stackedData: stackedData } = stackGroup;
    if (!stackedData) return undefined;
    return stackedData.find((sd)=>sd.key === stackSeriesIdentifier);
};



var $fe72261e429a4d95$export$77fea8543499527d = (allBarPositions, barSettings)=>{
    if (allBarPositions == null || barSettings == null) return undefined;
    var position = allBarPositions.find((p)=>p.stackId === barSettings.stackId && barSettings.dataKey != null && p.dataKeys.includes(barSettings.dataKey));
    if (position == null) return undefined;
    return position.position;
};


var $768c0ec0ed64a741$var$pickIsPanorama = (_state, _id, isPanorama)=>isPanorama;
var $768c0ec0ed64a741$var$pickBarId = (_state, id)=>id;
var $768c0ec0ed64a741$var$selectSynchronisedBarSettings = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$f67c737adf41a3af),
    $768c0ec0ed64a741$var$pickBarId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'bar').find((item)=>item.id === id));
var $768c0ec0ed64a741$export$50baca3091205310 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings
], (barSettings)=>barSettings === null || barSettings === void 0 ? void 0 : barSettings.maxBarSize);
var $768c0ec0ed64a741$var$pickCells = (_state, _id, _isPanorama, cells)=>cells;
var $768c0ec0ed64a741$export$bf2e7c2f01f3feee = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $6aac8fe27ae10a7b$export$f67c737adf41a3af),
    (0, $07dce3cd67839b77$export$eea16fee3026d9cf),
    (0, $07dce3cd67839b77$export$5babc813f7c13fff),
    $768c0ec0ed64a741$var$pickIsPanorama
], (layout, allItems, xAxisId, yAxisId, isPanorama)=>allItems.filter((i)=>{
        if (layout === 'horizontal') return i.xAxisId === xAxisId;
        return i.yAxisId === yAxisId;
    }).filter((i)=>i.isPanorama === isPanorama).filter((i)=>i.hide === false).filter((i)=>i.type === 'bar'));
var $768c0ec0ed64a741$var$selectBarStackGroups = (state, id, isPanorama)=>{
    var layout = (0, $e573f10901a87cfb$export$8426b6d9af801dee)(state);
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    if (layout === 'horizontal') return (0, $6aac8fe27ae10a7b$export$af2278e5e47fc440)(state, 'yAxis', yAxisId, isPanorama);
    return (0, $6aac8fe27ae10a7b$export$af2278e5e47fc440)(state, 'xAxis', xAxisId, isPanorama);
};
var $768c0ec0ed64a741$export$d463f1583eab6c4c = (state, id)=>{
    var layout = (0, $e573f10901a87cfb$export$8426b6d9af801dee)(state);
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    if (layout === 'horizontal') return (0, $6aac8fe27ae10a7b$export$6d6e642aa7a0ae10)(state, 'xAxis', xAxisId);
    return (0, $6aac8fe27ae10a7b$export$6d6e642aa7a0ae10)(state, 'yAxis', yAxisId);
};
var $768c0ec0ed64a741$export$2ef868bbad239fe0 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $768c0ec0ed64a741$export$bf2e7c2f01f3feee,
    (0, $dcfc24e85ad2aefd$export$be00206a4a82272f),
    $768c0ec0ed64a741$export$d463f1583eab6c4c
], (0, $245a14c08b4396b4$export$fa5aca2cbc42e692));
var $768c0ec0ed64a741$export$32ce49801f050c73 = (state, id, isPanorama)=>{
    var _ref, _getBandSizeOfAxis;
    var barSettings = $768c0ec0ed64a741$var$selectSynchronisedBarSettings(state, id);
    if (barSettings == null) return 0;
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return 0;
    var layout = (0, $e573f10901a87cfb$export$8426b6d9af801dee)(state);
    var globalMaxBarSize = (0, $dcfc24e85ad2aefd$export$db43f3089e0ec1e9)(state);
    var { maxBarSize: childMaxBarSize } = barSettings;
    var maxBarSize = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (_ref = (_getBandSizeOfAxis = (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(axis, ticks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref !== void 0 ? _ref : 0;
};
var $768c0ec0ed64a741$export$bc27c715442861c7 = (state, id, isPanorama)=>{
    var layout = (0, $e573f10901a87cfb$export$8426b6d9af801dee)(state);
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(axis, ticks);
};
var $768c0ec0ed64a741$export$d5f086f9524dc338 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $768c0ec0ed64a741$export$2ef868bbad239fe0,
    (0, $dcfc24e85ad2aefd$export$db43f3089e0ec1e9),
    (0, $dcfc24e85ad2aefd$export$9b8e3d53e72fb7a8),
    (0, $dcfc24e85ad2aefd$export$a73f9d39b015942a),
    $768c0ec0ed64a741$export$32ce49801f050c73,
    $768c0ec0ed64a741$export$bc27c715442861c7,
    $768c0ec0ed64a741$export$50baca3091205310
], (0, $2a7e66941f072ae1$export$5068ec6da13c95bb));
var $768c0ec0ed64a741$var$selectXAxisWithScale = (state, id, isPanorama)=>{
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    if (xAxisId == null) return undefined;
    return (0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
};
var $768c0ec0ed64a741$var$selectYAxisWithScale = (state, id, isPanorama)=>{
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (yAxisId == null) return undefined;
    return (0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
};
var $768c0ec0ed64a741$var$selectXAxisTicks = (state, id, isPanorama)=>{
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    if (xAxisId == null) return undefined;
    return (0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
};
var $768c0ec0ed64a741$var$selectYAxisTicks = (state, id, isPanorama)=>{
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (yAxisId == null) return undefined;
    return (0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
};
var $768c0ec0ed64a741$export$713ac88b203ac3be = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $768c0ec0ed64a741$export$d5f086f9524dc338,
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings
], (0, $fe72261e429a4d95$export$77fea8543499527d));
var $768c0ec0ed64a741$export$bb6e63f631e695ca = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $768c0ec0ed64a741$var$selectBarStackGroups,
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings
], (0, $ed174a0e62d48311$export$66625d959aa66f0f));
var $768c0ec0ed64a741$export$bb89ca2d15dbced9 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $f90bc049d1e95f26$export$1e34c8efb0bc9b3b),
    (0, $f90bc049d1e95f26$export$32c8e778bac69ce4),
    $768c0ec0ed64a741$var$selectXAxisWithScale,
    $768c0ec0ed64a741$var$selectYAxisWithScale,
    $768c0ec0ed64a741$var$selectXAxisTicks,
    $768c0ec0ed64a741$var$selectYAxisTicks,
    $768c0ec0ed64a741$export$713ac88b203ac3be,
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    (0, $d235e165ed12974e$export$46bf9459876c0e0c),
    $768c0ec0ed64a741$export$bc27c715442861c7,
    $768c0ec0ed64a741$export$bb6e63f631e695ca,
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings,
    $768c0ec0ed64a741$var$pickCells
], (offset, axisViewBox, xAxis, yAxis, xAxisTicks, yAxisTicks, pos, layout, _ref2, bandSize, stackedData, barSettings, cells)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref2;
    if (barSettings == null || pos == null || axisViewBox == null || layout !== 'horizontal' && layout !== 'vertical' || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || bandSize == null) return undefined;
    var { data: data } = barSettings;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $e752e700473a8894$export$3b2ba7a38b022e)({
        layout: layout,
        barSettings: barSettings,
        pos: pos,
        parentViewBox: axisViewBox,
        bandSize: bandSize,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        stackedData: stackedData,
        displayedData: displayedData,
        offset: offset,
        cells: cells,
        dataStartIndex: dataStartIndex
    });
});















function $20d9e46a95ab88fd$export$384f306fbc0d3ce9(input, defaultZIndex) {
    if (input && typeof input === 'object' && 'zIndex' in input && typeof input.zIndex === 'number' && (0, $dabee322b52312f4$export$f8a8fc612ced9bb0)(input.zIndex)) return input.zIndex;
    return defaultZIndex;
}




var $acw62 = parcelRequire("acw62");







var $7f648dde7f9e015e$var$pickStackId = (state, stackId)=>stackId;
var $7f648dde7f9e015e$var$pickIsPanorama = (state, stackId, isPanorama)=>isPanorama;
var $7f648dde7f9e015e$export$7f05d1a8fbacd727 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $7f648dde7f9e015e$var$pickStackId,
    (0, $6aac8fe27ae10a7b$export$f67c737adf41a3af),
    $7f648dde7f9e015e$var$pickIsPanorama
], (stackId, allItems, isPanorama)=>{
    return allItems.filter((i)=>i.type === 'bar').filter((i)=>i.stackId === stackId).filter((i)=>i.isPanorama === isPanorama).filter((i)=>!i.hide);
});
var $7f648dde7f9e015e$var$selectAllBarIdsInStack = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    $7f648dde7f9e015e$export$7f05d1a8fbacd727
], (allBars)=>{
    return allBars.map((bar)=>bar.id);
});
var $7f648dde7f9e015e$export$54063602295685e1 = (rect1, rect2)=>{
    if (!rect1) return rect2;
    if (!rect2) return rect1;
    var x = Math.min(rect1.x, rect1.x + rect1.width, rect2.x, rect2.x + rect2.width);
    var y = Math.min(rect1.y, rect1.y + rect1.height, rect2.y, rect2.y + rect2.height);
    var maxX = Math.max(rect1.x, rect1.x + rect1.width, rect2.x, rect2.x + rect2.width);
    var maxY = Math.max(rect1.y, rect1.y + rect1.height, rect2.y, rect2.y + rect2.height);
    var width = maxX - x;
    var height = maxY - y;
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
};
var $7f648dde7f9e015e$var$combineStackRects = (state, stackId, isPanorama)=>{
    var allBarIds = $7f648dde7f9e015e$var$selectAllBarIdsInStack(state, stackId, isPanorama);
    var stackRects = [];
    allBarIds.forEach((barId)=>{
        var rectangles = (0, $768c0ec0ed64a741$export$bb89ca2d15dbced9)(state, barId, isPanorama, undefined);
        rectangles === null || rectangles === void 0 || rectangles.forEach((rect, index)=>{
            stackRects[index] = $7f648dde7f9e015e$export$54063602295685e1(stackRects[index], rect);
        });
    });
    return stackRects;
};
var $7f648dde7f9e015e$export$7518e012f9c78033 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (state)=>state,
    $7f648dde7f9e015e$var$pickStackId,
    $7f648dde7f9e015e$var$pickIsPanorama
], $7f648dde7f9e015e$var$combineStackRects);






var $b8a2be1f3c4055dc$var$_excluded = [
    "index"
];
function $b8a2be1f3c4055dc$var$_extends() {
    return $b8a2be1f3c4055dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8a2be1f3c4055dc$var$_extends.apply(null, arguments);
}
function $b8a2be1f3c4055dc$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b8a2be1f3c4055dc$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b8a2be1f3c4055dc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b8a2be1f3c4055dc$var$BarStackContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $b8a2be1f3c4055dc$export$837efb24f50d011e = (childStackId)=>{
    var stackSettings = (0, $acw62.useContext)($b8a2be1f3c4055dc$var$BarStackContext);
    if (stackSettings != null) return stackSettings.stackId;
    if (childStackId == null) return undefined;
    return (0, $cd015374923bb5c7$export$f0871da41ca7fc82)(childStackId);
};
var $b8a2be1f3c4055dc$export$49f633eb2d560a47 = {
    radius: 0
};
var $b8a2be1f3c4055dc$var$getClipPathId = (stackId, index)=>{
    return "recharts-bar-stack-clip-path-".concat(stackId, "-").concat(index);
};
var $b8a2be1f3c4055dc$export$7c5499b8b81f5acf = (index)=>{
    var barStackContext = (0, $acw62.useContext)($b8a2be1f3c4055dc$var$BarStackContext);
    if (barStackContext == null) return undefined;
    var { stackId: stackId } = barStackContext;
    return "url(#".concat($b8a2be1f3c4055dc$var$getClipPathId(stackId, index), ")");
};
var $b8a2be1f3c4055dc$export$6374d9b2eea9076f = (_ref)=>{
    var { index: index } = _ref, rest = $b8a2be1f3c4055dc$var$_objectWithoutProperties(_ref, $b8a2be1f3c4055dc$var$_excluded);
    var clipPathUrl = $b8a2be1f3c4055dc$export$7c5499b8b81f5acf(index);
    return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $b8a2be1f3c4055dc$var$_extends({
        className: "recharts-bar-stack-layer",
        clipPath: clipPathUrl
    }, rest));
};
/**
 * This React component will render a clipPath that the individual bars in the stack will reference
 * to achieve rounded corners for the entire stack.
 */ var $b8a2be1f3c4055dc$var$BarStackClipPath = (_ref2)=>{
    var { stackId: stackId, radius: radius } = _ref2;
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var positions = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $7f648dde7f9e015e$export$7518e012f9c78033)(state, stackId, isPanorama));
    if (positions == null || positions.length === 0) return null;
    /*
   * Render one clipPath per rectangle in the stack.
   * Each rectangle corresponds to one data entry in the chart.
   */ return /*#__PURE__*/ $acw62.createElement("defs", null, positions.map((pos, index)=>{
        if (pos == null) return null;
        var clipPathId = $b8a2be1f3c4055dc$var$getClipPathId(stackId, index);
        return /*#__PURE__*/ $acw62.createElement("clipPath", {
            key: clipPathId,
            id: clipPathId
        }, /*#__PURE__*/ $acw62.createElement((0, $70f75e095c9bb92d$export$4617fb02663045ef), {
            isAnimationActive: false,
            isUpdateAnimationActive: false,
            x: pos.x,
            y: pos.y,
            width: pos.width,
            height: pos.height,
            radius: radius
        }));
    }));
};
var $b8a2be1f3c4055dc$var$BarStackImpl = (props)=>{
    var resolvedStackId = (0, $47303e546b24d86f$export$c485849f2e393253)('recharts-bar-stack', (0, $cd015374923bb5c7$export$f0871da41ca7fc82)(props.stackId));
    var { children: children, radius: radius } = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(props, $b8a2be1f3c4055dc$export$49f633eb2d560a47);
    var context = (0, $acw62.useMemo)(()=>({
            stackId: resolvedStackId,
            radius: radius
        }), [
        resolvedStackId,
        radius
    ]);
    return /*#__PURE__*/ $acw62.createElement($b8a2be1f3c4055dc$var$BarStackContext.Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement($b8a2be1f3c4055dc$var$BarStackClipPath, {
        stackId: resolvedStackId,
        radius: radius
    }), children);
};
var $b8a2be1f3c4055dc$export$ebd6167c687e5b8b = /*#__PURE__*/ $acw62.memo($b8a2be1f3c4055dc$var$BarStackImpl, (0, $83a0fb8931561019$export$b8f09df787c278d9));


var $e752e700473a8894$var$_excluded = [
    "onMouseEnter",
    "onMouseLeave",
    "onClick"
], $e752e700473a8894$var$_excluded2 = [
    "value",
    "background",
    "tooltipPosition"
], $e752e700473a8894$var$_excluded3 = [
    "id"
], $e752e700473a8894$var$_excluded4 = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave"
];
function $e752e700473a8894$var$_extends() {
    return $e752e700473a8894$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e752e700473a8894$var$_extends.apply(null, arguments);
}
function $e752e700473a8894$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e752e700473a8894$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e752e700473a8894$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e752e700473a8894$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e752e700473a8894$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e752e700473a8894$var$_defineProperty(e, r, t) {
    return (r = $e752e700473a8894$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e752e700473a8894$var$_toPropertyKey(t) {
    var i = $e752e700473a8894$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e752e700473a8894$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e752e700473a8894$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e752e700473a8894$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e752e700473a8894$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e752e700473a8894$var$computeLegendPayloadFromBarData = (props)=>{
    var { dataKey: dataKey, name: name, fill: fill, legendType: legendType, hide: hide } = props;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: fill,
            value: (0, $cd015374923bb5c7$export$d3207de44081d2b3)(name, dataKey),
            payload: props
        }
    ];
};
var $e752e700473a8894$var$SetBarTooltipEntrySettings = /*#__PURE__*/ $acw62.memo((_ref)=>{
    var { dataKey: dataKey, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, unit: unit, tooltipType: tooltipType, id: id } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: undefined,
        getPosition: (0, $2ab3a7e25c8aba74$export$8793edee2d425525),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $cd015374923bb5c7$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: unit,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $1e712d1b3a15e741$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $e752e700473a8894$var$BarBackground(props) {
    var activeIndex = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$8b2762260f5891c9));
    var { data: data, dataKey: dataKey, background: backgroundFromProps, allOtherBarProps: allOtherBarProps } = props;
    var { onMouseEnter: onMouseEnterFromProps, onMouseLeave: onMouseLeaveFromProps, onClick: onItemClickFromProps } = allOtherBarProps, restOfAllOtherProps = $e752e700473a8894$var$_objectWithoutProperties(allOtherBarProps, $e752e700473a8894$var$_excluded);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseEnterFromContext = (0, $1d6cbb89ea2b356d$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey, allOtherBarProps.id);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseLeaveFromContext = (0, $1d6cbb89ea2b356d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onClickFromContext = (0, $1d6cbb89ea2b356d$export$c9154937ad8393fc)(onItemClickFromProps, dataKey, allOtherBarProps.id);
    if (!backgroundFromProps || data == null) return null;
    var backgroundProps = (0, $37a0b0a95f0e25bf$export$6d5921c09aa671a9)(backgroundFromProps);
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: (0, $20d9e46a95ab88fd$export$384f306fbc0d3ce9)(backgroundFromProps, (0, $c327287477e919da$export$96df16b28aa32702).barBackground)
    }, data.map((entry, i)=>{
        var { value: value, background: backgroundFromDataEntry, tooltipPosition: tooltipPosition } = entry, rest = $e752e700473a8894$var$_objectWithoutProperties(entry, $e752e700473a8894$var$_excluded2);
        if (!backgroundFromDataEntry) return null;
        // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
        var onMouseEnter = onMouseEnterFromContext(entry, i);
        // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
        var onMouseLeave = onMouseLeaveFromContext(entry, i);
        // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
        var onClick = onClickFromContext(entry, i);
        var barRectangleProps = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({
            option: backgroundFromProps,
            isActive: String(i) === activeIndex
        }, rest), {}, {
            // @ts-expect-error backgroundProps is contributing unknown props
            fill: '#eee'
        }, backgroundFromDataEntry), backgroundProps), (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i)), {}, {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            dataKey: dataKey,
            index: i,
            className: 'recharts-bar-background-rectangle'
        });
        return /*#__PURE__*/ $acw62.createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({
            key: "background-bar-".concat(i)
        }, barRectangleProps));
    }));
}
function $e752e700473a8894$var$BarLabelListProvider(_ref2) {
    var { showLabels: showLabels, children: children, rects: rects } = _ref2;
    var labelListEntries = rects === null || rects === void 0 ? void 0 : rects.map((entry)=>{
        var viewBox = {
            x: entry.x,
            y: entry.y,
            width: entry.width,
            lowerWidth: entry.width,
            upperWidth: entry.width,
            height: entry.height
        };
        return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, viewBox), {}, {
            value: entry.value,
            payload: entry.payload,
            parentViewBox: entry.parentViewBox,
            viewBox: viewBox,
            fill: entry.fill
        });
    });
    return /*#__PURE__*/ $acw62.createElement((0, $88ab0dba0fc78576$export$64e384eac5db53f7), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $e752e700473a8894$var$BarRectangleWithActiveState(props) {
    var { shape: shape, activeBar: activeBar, baseProps: baseProps, entry: entry, index: index, dataKey: dataKey } = props;
    var activeIndex = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$8b2762260f5891c9));
    var activeDataKey = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$999f7a7ced063fab));
    /*
   * Bars support stacking, meaning that there can be multiple bars at the same x value.
   * With Tooltip shared=false we only want to highlight the currently active Bar, not all.
   *
   * Also, if the tooltip is shared, we want to highlight all bars at the same x value
   * regardless of the dataKey.
   *
   * With shared Tooltip, the activeDataKey is undefined.
   */ var isActive = activeBar && String(index) === activeIndex && (activeDataKey == null || dataKey === activeDataKey);
    var option = isActive ? activeBar : shape;
    if (isActive) return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: (0, $c327287477e919da$export$96df16b28aa32702).activeBar
    }, /*#__PURE__*/ $acw62.createElement((0, $b8a2be1f3c4055dc$export$6374d9b2eea9076f), {
        index: index
    }, /*#__PURE__*/ $acw62.createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: isActive,
        option: option,
        index: index,
        dataKey: dataKey
    }))));
    return /*#__PURE__*/ $acw62.createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: isActive,
        option: option,
        index: index,
        dataKey: dataKey
    }));
}
function $e752e700473a8894$var$BarRectangleNeverActive(props) {
    var { shape: shape, baseProps: baseProps, entry: entry, index: index, dataKey: dataKey } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: false,
        option: shape,
        index: index,
        dataKey: dataKey
    }));
}
function $e752e700473a8894$var$BarRectangles(_ref3) {
    var _svgPropertiesNoEvent;
    var { data: data, props: props } = _ref3;
    var _ref4 = (_svgPropertiesNoEvent = (0, $37a0b0a95f0e25bf$export$8b56257912140094)(props)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { id: id } = _ref4, baseProps = $e752e700473a8894$var$_objectWithoutProperties(_ref4, $e752e700473a8894$var$_excluded3);
    var { shape: shape, dataKey: dataKey, activeBar: activeBar } = props;
    var { onMouseEnter: onMouseEnterFromProps, onClick: onItemClickFromProps, onMouseLeave: onMouseLeaveFromProps } = props, restOfAllOtherProps = $e752e700473a8894$var$_objectWithoutProperties(props, $e752e700473a8894$var$_excluded4);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseEnterFromContext = (0, $1d6cbb89ea2b356d$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey, id);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseLeaveFromContext = (0, $1d6cbb89ea2b356d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onClickFromContext = (0, $1d6cbb89ea2b356d$export$c9154937ad8393fc)(onItemClickFromProps, dataKey, id);
    if (!data) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, data.map((entry, i)=>{
        return /*#__PURE__*/ $acw62.createElement((0, $b8a2be1f3c4055dc$export$6374d9b2eea9076f), $e752e700473a8894$var$_extends({
            index: i,
            key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i),
            className: "recharts-bar-rectangle"
        }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i), {
            // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
            onMouseEnter: onMouseEnterFromContext(entry, i),
            onMouseLeave: onMouseLeaveFromContext(entry, i),
            onClick: onClickFromContext(entry, i)
        }), activeBar ? /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarRectangleWithActiveState, {
            shape: shape,
            activeBar: activeBar,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey
        }) : /*#__PURE__*/ /*
     * If the `activeBar` prop is falsy, then let's call the variant without hooks.
     * Using the `selectActiveTooltipIndex` selector is usually fast
     * but in charts with large-ish amount of data even the few nanoseconds add up to a noticeable jank.
     * If the activeBar is false then we don't need to know which index is active - because we won't use it anyway.
     * So let's just skip the hooks altogether. That way, React can skip rendering the component,
     * and can skip the tree reconciliation for its children too.
     * Because we can't call hooks conditionally, we need to have a separate component for that.
     */ $acw62.createElement($e752e700473a8894$var$BarRectangleNeverActive, {
            shape: shape,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey
        }));
    }));
}
function $e752e700473a8894$var$RectanglesWithAnimation(_ref5) {
    var { props: props, previousRectanglesRef: previousRectanglesRef } = _ref5;
    var { data: data, layout: layout, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart } = props;
    var prevData = previousRectanglesRef.current;
    var animationId = (0, $72206edefbff003d$export$e1042b2944b80b7f)(props, 'recharts-bar-');
    var [isAnimating, setIsAnimating] = (0, $acw62.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    return /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarLabelListProvider, {
        showLabels: showLabels,
        rects: data
    }, /*#__PURE__*/ $acw62.createElement((0, $464febc3f716710f$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        var stepData = t === 1 ? data : data === null || data === void 0 ? void 0 : data.map((entry, index)=>{
            var prev = prevData && prevData[index];
            if (prev) return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                x: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                y: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.y, entry.y, t),
                width: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.width, entry.width, t),
                height: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.height, entry.height, t)
            });
            if (layout === 'horizontal') {
                var height = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(0, entry.height, t);
                var y = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(entry.stackedBarStart, entry.y, t);
                return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                    y: y,
                    height: height
                });
            }
            var w = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(0, entry.width, t);
            var x = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(entry.stackedBarStart, entry.x, t);
            return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
                width: w,
                x: x
            });
        });
        if (t > 0) // eslint-disable-next-line no-param-reassign
        previousRectanglesRef.current = stepData !== null && stepData !== void 0 ? stepData : null;
        if (stepData == null) return null;
        return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), null, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarRectangles, {
            props: props,
            data: stepData
        }));
    }), /*#__PURE__*/ $acw62.createElement((0, $88ab0dba0fc78576$export$9a402bc8de2b410e), {
        label: props.label
    }), props.children);
}
function $e752e700473a8894$var$RenderRectangles(props) {
    var previousRectanglesRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$RectanglesWithAnimation, {
        previousRectanglesRef: previousRectanglesRef,
        props: props
    });
}
var $e752e700473a8894$var$defaultMinPointSize = 0;
var $e752e700473a8894$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    /**
   * if the value coming from `selectBarRectangles` is an array then this is a stacked bar chart.
   * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
   * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
    return {
        x: dataPoint.x,
        y: dataPoint.y,
        value: value,
        // @ts-expect-error getValueByDataKey does not validate the output type
        errorVal: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(dataPoint, dataKey)
    };
};
class $e752e700473a8894$var$BarWithState extends (0, $acw62.PureComponent) {
    render() {
        var { hide: hide, data: data, dataKey: dataKey, className: className, xAxisId: xAxisId, yAxisId: yAxisId, needClip: needClip, background: background, id: id } = this.props;
        if (hide || data == null) return null;
        var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-bar', className);
        var clipPathId = id;
        return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            className: layerClass,
            id: id
        }, needClip && /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement((0, $dd677892692406d2$export$d65f7a7dd82fbb63), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        })), /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            className: "recharts-bar-rectangles",
            clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined
        }, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarBackground, {
            data: data,
            dataKey: dataKey,
            background: background,
            allOtherBarProps: this.props
        }), /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$RenderRectangles, this.props)));
    }
}
var $e752e700473a8894$export$ae0fe71c3c345c68 = {
    activeBar: false,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease',
    background: false,
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'rect',
    minPointSize: $e752e700473a8894$var$defaultMinPointSize,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).bar
};
function $e752e700473a8894$var$BarImpl(props) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, hide: hide, legendType: legendType, minPointSize: minPointSize, activeBar: activeBar, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, isAnimationActive: isAnimationActive } = props;
    var { needClip: needClip } = (0, $dd677892692406d2$export$79e142f66441c204)(xAxisId, yAxisId);
    var layout = (0, $e573f10901a87cfb$export$970c79ecc7081cc)();
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var cells = (0, $008f02516c156322$export$fdd5e64c0e8495bb)(props.children, (0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea));
    var rects = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $768c0ec0ed64a741$export$bb89ca2d15dbced9)(state, props.id, isPanorama, cells));
    if (layout !== 'vertical' && layout !== 'horizontal') return null;
    var errorBarOffset;
    var firstDataPoint = rects === null || rects === void 0 ? void 0 : rects[0];
    if (firstDataPoint == null || firstDataPoint.height == null || firstDataPoint.width == null) errorBarOffset = 0;
    else errorBarOffset = layout === 'vertical' ? firstDataPoint.height / 2 : firstDataPoint.width / 2;
    return /*#__PURE__*/ $acw62.createElement((0, $f02a6cc200a05058$export$fcd6ba6fb4bc66e7), {
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        data: rects,
        dataPointFormatter: $e752e700473a8894$var$errorBarDataPointFormatter,
        errorBarOffset: errorBarOffset
    }, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarWithState, $e752e700473a8894$var$_extends({}, props, {
        layout: layout,
        needClip: needClip,
        data: rects,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        hide: hide,
        legendType: legendType,
        minPointSize: minPointSize,
        activeBar: activeBar,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive
    })));
}
function $e752e700473a8894$export$3b2ba7a38b022e(_ref6) {
    var { layout: layout, barSettings: { dataKey: dataKey, minPointSize: minPointSizeProp }, pos: pos, bandSize: bandSize, xAxis: xAxis, yAxis: yAxis, xAxisTicks: xAxisTicks, yAxisTicks: yAxisTicks, stackedData: stackedData, displayedData: displayedData, offset: offset, cells: cells, parentViewBox: parentViewBox, dataStartIndex: dataStartIndex } = _ref6;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    // @ts-expect-error this assumes that the domain is always numeric, but doesn't check for it
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $cd015374923bb5c7$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var stackedBarStart = numericAxis.scale.map(baseValue);
    return displayedData.map((entry, index)=>{
        var value, x, y, width, height, background;
        if (stackedData) {
            // Use dataStartIndex to access the correct element in the full stackedData array
            var untruncatedValue = stackedData[index + dataStartIndex];
            if (untruncatedValue == null) return null;
            value = (0, $cd015374923bb5c7$export$c7ec0fa96d0c462e)(untruncatedValue, stackedDomain);
        } else {
            value = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $b5efd6b8794dbdeb$export$c20d73790de171f0)(minPointSizeProp, $e752e700473a8894$var$defaultMinPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref7;
            var baseValueScale = yAxis.scale.map(value[0]);
            var currentValueScale = yAxis.scale.map(value[1]);
            if (baseValueScale == null || currentValueScale == null) return null;
            x = (0, $cd015374923bb5c7$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref7 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref7 !== void 0 ? _ref7 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = (0, $2ab3a7e25c8aba74$export$e426a261f3212d7d)(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: offset.top,
                width: width,
                height: offset.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _baseValueScale = xAxis.scale.map(value[0]);
            var _currentValueScale = xAxis.scale.map(value[1]);
            if (_baseValueScale == null || _currentValueScale == null) return null;
            x = _baseValueScale;
            y = (0, $cd015374923bb5c7$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: offset.left,
                y: y,
                width: offset.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        if (x == null || y == null || width == null || height == null) return null;
        var barRectangleItem = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
            stackedBarStart: stackedBarStart,
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background,
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            },
            parentViewBox: parentViewBox
        }, cells && cells[index] && cells[index].props);
        return barRectangleItem;
    }).filter(Boolean);
}
function $e752e700473a8894$var$BarFn(outsideProps) {
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $e752e700473a8894$export$ae0fe71c3c345c68);
    // stackId may arrive from props or from BarStack context
    var stackId = (0, $b8a2be1f3c4055dc$export$837efb24f50d011e)(props.stackId);
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    // Report all props to Redux store first, before calling any hooks, to avoid circular dependencies.
    return /*#__PURE__*/ $acw62.createElement((0, $e0af6fe07417fba6$export$8c2f307ff93f02ba), {
        id: props.id,
        type: "bar"
    }, (id)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $8f8fe5838f5f31a4$export$34b61b169492c008), {
            legendPayload: $e752e700473a8894$var$computeLegendPayloadFromBarData(props)
        }), /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$SetBarTooltipEntrySettings, {
            dataKey: props.dataKey,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $acw62.createElement((0, $7e3660a50bf15c81$export$b600bf9c1966a9c2), {
            type: "bar",
            id: id,
            data: undefined,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            stackId: stackId,
            hide: props.hide,
            barSize: props.barSize,
            minPointSize: props.minPointSize,
            maxBarSize: props.maxBarSize,
            isPanorama: isPanorama
        }), /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
            zIndex: props.zIndex
        }, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarImpl, $e752e700473a8894$var$_extends({}, props, {
            id: id
        })))));
}
var $e752e700473a8894$export$bbc6c6369b38e3d1 = /*#__PURE__*/ $acw62.memo($e752e700473a8894$var$BarFn, (0, $83a0fb8931561019$export$b8f09df787c278d9));
$e752e700473a8894$export$bbc6c6369b38e3d1.displayName = 'Bar';


var $acw62 = parcelRequire("acw62");


var $74d07378047db57c$var$allowedTooltipTypes = [
    'axis',
    'item'
];
var $74d07378047db57c$export$94aefc399ef206a9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $b5deaf479b23783f$export$855bb85b2910abc9), {
        chartName: "BarChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $74d07378047db57c$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $886d067545e9f9a0$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $acw62 = parcelRequire("acw62");






var $7dad4d5151ba4a01$export$c7964a5b9439ae62 = (_ref, _ref2)=>{
    var { x: x1, y: y1 } = _ref;
    var { x: x2, y: y2 } = _ref2;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $7dad4d5151ba4a01$export$6df2062b9e15eec0 = (_ref3)=>{
    var { x1: x1, y1: y1, x2: x2, y2: y2 } = _ref3;
    return $7dad4d5151ba4a01$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
function $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $7dad4d5151ba4a01$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref4) {
    var { width: width, height: height } = _ref4;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * For n equal to 1, the input array is returned as is.
 * For n greater than the length of the array, an array containing the first element
 * and every nTh element after that (if any) is returned.
 *
 * @param array An input array.
 * @param n A number specifying which elements to take.
 * @returns The result array of the same type as the input array.
 */ function $db7169829440b476$export$c0c2f0af9f98bc62(array, n) {
    if (n < 1) return [];
    if (n === 1) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        var item = array[i];
        if (item !== undefined) result.push(item);
    }
    return result;
}


function $19a932367b9d461a$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $7dad4d5151ba4a01$export$3ee78d51cffc2b68)(size, angle);
}
function $19a932367b9d461a$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var { x: x, y: y, width: width, height: height } = viewBox;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $19a932367b9d461a$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $19a932367b9d461a$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $db7169829440b476$export$c0c2f0af9f98bc62)(ticks, interval + 1);
}




function $ca4e8736ea4f469e$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    var result = (ticks || []).slice();
    var { start: initialStart, end: end } = boundaries;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluated all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $db7169829440b476$export$c0c2f0af9f98bc62)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}
function $ca4e8736ea4f469e$export$635ece29a4bbdfac(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    // Reworked logic for getEquidistantPreserveEndTicks
    var result = (ticks || []).slice();
    var len = result.length;
    if (len === 0) return [];
    var { start: initialStart, end: end } = boundaries;
    // Start with stepsize = 1 (every tick) up to the maximum possible stepsize (len)
    for(var stepsize = 1; stepsize <= len; stepsize++){
        // 1. Calculate the offset so the last tick (index len - 1) is always included in the sequence.
        var offset = (len - 1) % stepsize;
        var start = initialStart; // `start` tracks the coordinate of the last successfully drawn tick + gap
        var ok = true;
        // 2. Iterate through the end-anchored sequence: offset, offset + stepsize, ..., len - 1
        var _loop2 = function _loop2() {
            var entry = ticks[index];
            if (entry == null) return 0; // continue
            var i = index;
            var size;
            // Use a function to get size, as in the original code
            var getSize = ()=>{
                if (size === undefined) size = getTickSize(entry, i);
                return size;
            };
            var tickCoord = entry.coordinate;
            // 3. Apply visibility logic (including the first tick special case)
            // The reviewer says *not* to unconditionally bypass checks for the last tick.
            var isShow = index === offset || (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
            if (!isShow) {
                // If any tick in this end-anchored sequence fails visibility/collision,
                // reject this stepsize and move to the next iteration (larger stepsize).
                ok = false;
                return 1; // break
            }
            // 4. If showable, update the 'start' coordinate for the next collision check
            if (isShow) start = tickCoord + sign * (getSize() / 2 + minTickGap);
        }, _ret2;
        for(var index = offset; index < len; index += stepsize){
            _ret2 = _loop2();
            if (_ret2 === 0) continue;
            if (_ret2 === 1) break;
        }
        // 5. If the entire sequence for this stepsize passed the visibility check, return the result
        if (ok) {
            // Build the final result array explicitly using the validated stepsize and offset.
            var finalTicks = [];
            for(var _index = offset; _index < len; _index += stepsize){
                var tick = ticks[_index];
                if (tick != null) finalTicks.push(tick);
            }
            return finalTicks;
        }
    }
    // If no stepsize works (this shouldn't happen unless minTickGap is huge), return an empty array.
    return [];
}


function $582ebde04d312f24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $582ebde04d312f24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $582ebde04d312f24$var$ownKeys(Object(t), !0).forEach(function(r) {
            $582ebde04d312f24$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $582ebde04d312f24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $582ebde04d312f24$var$_defineProperty(e, r, t) {
    return (r = $582ebde04d312f24$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $582ebde04d312f24$var$_toPropertyKey(t) {
    var i = $582ebde04d312f24$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $582ebde04d312f24$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start } = boundaries;
    var { end: end } = boundaries;
    var _loop = function _loop(i) {
        var initialEntry = result[i];
        if (initialEntry == null) return 1; // continue
        var entry = initialEntry;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(initialEntry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
                result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = len - 1; i >= 0; i--){
        if (_loop(i)) continue;
    }
    return result;
}
function $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    // This method is mutating the array so clone is indeed necessary here
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start, end: end } = boundaries;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        if (tail != null) {
            var tailSize = getTickSize(tail, len - 1);
            var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
            result[len - 1] = tail = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
                tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
            });
            if (tail.tickCoord != null) {
                var isTailShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, tail.tickCoord, ()=>tailSize, start, end);
                if (isTailShow) {
                    end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                    result[len - 1] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
                        isShow: true
                    });
                }
            }
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var initialEntry = result[i];
        if (initialEntry == null) return 1; // continue
        var entry = initialEntry;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(initialEntry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $19a932367b9d461a$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
                result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = 0; i < count; i++){
        if (_loop2(i)) continue;
    }
    return result;
}
function $582ebde04d312f24$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var { tick: tick, ticks: ticks, viewBox: viewBox, minTickGap: minTickGap, orientation: orientation, interval: interval, tickFormatter: tickFormatter, unit: unit, angle: angle } = props;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(interval) || (0, $795299547b24e258$export$98f03c5d19621d70).isSsr) {
        var _getNumberIntervalTic;
        return (_getNumberIntervalTic = (0, $19a932367b9d461a$export$beeebbe3ff1b306b)(ticks, (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(interval) ? interval : 0)) !== null && _getNumberIntervalTic !== void 0 ? _getNumberIntervalTic : [];
    }
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $41867cca6cb93873$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = (content, index)=>{
        var value = typeof tickFormatter === 'function' ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $19a932367b9d461a$export$a1966f4ad955c82b)((0, $41867cca6cb93873$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $41867cca6cb93873$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var tick0 = ticks[0];
    var tick1 = ticks[1];
    var sign = ticks.length >= 2 && tick0 != null && tick1 != null ? (0, $2ab3a7e25c8aba74$export$9d334328eb75e624)(tick1.coordinate - tick0.coordinate) : 1;
    var boundaries = (0, $19a932367b9d461a$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $ca4e8736ea4f469e$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'equidistantPreserveEnd') return (0, $ca4e8736ea4f469e$export$635ece29a4bbdfac)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter((entry)=>entry.isShow);
}



var $acw62 = parcelRequire("acw62");









/**
 * Calculates the width of the Y-axis based on the tick labels and the axis label.
 * @param params - The parameters object.
 * @param [params.ticks] - An array-like object of tick elements, each with a `getBoundingClientRect` method.
 * @param [params.label] - The axis label element, with a `getBoundingClientRect` method.
 * @param [params.labelGapWithTick=5] - The gap between the label and the tick.
 * @param [params.tickSize=0] - The length of the tick line.
 * @param [params.tickMargin=0] - The margin between the tick line and the tick text.
 * @returns The calculated width of the Y-axis.
 */ var $53536bea4cb8dced$export$b70f70a4fdbed242 = (_ref)=>{
    var { ticks: ticks, label: label, labelGapWithTick: labelGapWithTick = 5, tickSize: // Default gap between label and tick
    tickSize = 0, tickMargin: tickMargin = 0 } = _ref;
    // find the max width of the tick labels
    var maxTickWidth = 0;
    if (ticks) {
        Array.from(ticks).forEach((tickNode)=>{
            if (tickNode) {
                var bbox = tickNode.getBoundingClientRect();
                if (bbox.width > maxTickWidth) maxTickWidth = bbox.width;
            }
        });
        // calculate width of the axis label
        var labelWidth = label ? label.getBoundingClientRect().width : 0;
        var tickWidth = tickSize + tickMargin;
        // calculate the updated width of the y-axis
        var updatedYAxisWidth = maxTickWidth + tickWidth + labelWidth + (label ? labelGapWithTick : 0);
        return Math.round(updatedYAxisWidth);
    }
    return 0;
};





function $15c2f7112dc9bdea$export$154498af6dc3c303(u) {
    if (u && typeof u === 'object' && 'className' in u && typeof u.className === 'string') return u.className;
    return '';
}


var $247385db510d7b7c$var$_excluded = [
    "axisLine",
    "width",
    "height",
    "className",
    "hide",
    "ticks",
    "axisType"
];
function $247385db510d7b7c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $247385db510d7b7c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $247385db510d7b7c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $247385db510d7b7c$var$_extends() {
    return $247385db510d7b7c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $247385db510d7b7c$var$_extends.apply(null, arguments);
}
function $247385db510d7b7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $247385db510d7b7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $247385db510d7b7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $247385db510d7b7c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $247385db510d7b7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $247385db510d7b7c$var$_defineProperty(e, r, t) {
    return (r = $247385db510d7b7c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $247385db510d7b7c$var$_toPropertyKey(t) {
    var i = $247385db510d7b7c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $247385db510d7b7c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $247385db510d7b7c$export$179c35154a9748c0 = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd',
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).axis
};
/*
 * `viewBox` and `scale` are SVG attributes.
 * Recharts however - unfortunately - has its own attributes named `viewBox` and `scale`
 * that are completely different data shape and different purpose.
 */ function $247385db510d7b7c$var$AxisLine(axisLineProps) {
    var { x: x, y: y, width: width, height: height, orientation: orientation, mirror: mirror, axisLine: axisLine, otherSvgProps: otherSvgProps } = axisLineProps;
    if (!axisLine) return null;
    var props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, otherSvgProps), (0, $37a0b0a95f0e25bf$export$8b56257912140094)(axisLine)), {}, {
        fill: 'none'
    });
    if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: y + needHeight * height,
            x2: x + width,
            y2: y + needHeight * height
        });
    } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
            x1: x + needWidth * width,
            y1: y,
            x2: x + needWidth * width,
            y2: y + height
        });
    }
    return /*#__PURE__*/ $acw62.createElement("line", $247385db510d7b7c$var$_extends({}, props, {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($7bb38c04d3b378db$exports)))(axisLine, 'className'))
    }));
}
/**
 * Calculate the coordinates of endpoints in ticks.
 * @param data The data of a simple tick.
 * @param x The x-coordinate of the axis.
 * @param y The y-coordinate of the axis.
 * @param width The width of the axis.
 * @param height The height of the axis.
 * @param orientation The orientation of the axis.
 * @param tickSize The length of the tick line.
 * @param mirror If true, the ticks are mirrored.
 * @param tickMargin The margin between the tick line and the tick text.
 * @returns An object with `line` and `tick` coordinates.
 * `line` is the coordinates for the tick line, and `tick` is the coordinate for the tick text.
 */ function $247385db510d7b7c$var$getTickLineCoord(data, x, y, width, height, orientation, tickSize, mirror, tickMargin) {
    var x1, x2, y1, y2, tx, ty;
    var sign = mirror ? -1 : 1;
    var finalTickSize = data.tickSize || tickSize;
    var tickCoord = (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
    switch(orientation){
        case 'top':
            x1 = x2 = data.coordinate;
            y2 = y + +!mirror * height;
            y1 = y2 - sign * finalTickSize;
            ty = y1 - sign * tickMargin;
            tx = tickCoord;
            break;
        case 'left':
            y1 = y2 = data.coordinate;
            x2 = x + +!mirror * width;
            x1 = x2 - sign * finalTickSize;
            tx = x1 - sign * tickMargin;
            ty = tickCoord;
            break;
        case 'right':
            y1 = y2 = data.coordinate;
            x2 = x + +mirror * width;
            x1 = x2 + sign * finalTickSize;
            tx = x1 + sign * tickMargin;
            ty = tickCoord;
            break;
        default:
            x1 = x2 = data.coordinate;
            y2 = y + +mirror * height;
            y1 = y2 + sign * finalTickSize;
            ty = y1 + sign * tickMargin;
            tx = tickCoord;
            break;
    }
    return {
        line: {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        },
        tick: {
            x: tx,
            y: ty
        }
    };
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The text anchor of the tick.
 */ function $247385db510d7b7c$var$getTickTextAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
            return mirror ? 'start' : 'end';
        case 'right':
            return mirror ? 'end' : 'start';
        default:
            return 'middle';
    }
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The vertical text anchor of the tick.
 */ function $247385db510d7b7c$var$getTickVerticalAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
        case 'right':
            return 'middle';
        case 'top':
            return mirror ? 'start' : 'end';
        default:
            return mirror ? 'end' : 'start';
    }
}
function $247385db510d7b7c$var$TickItem(props) {
    var { option: option, tickProps: tickProps, value: value } = props;
    var tickItem;
    var combinedClassName = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(tickProps.className, 'recharts-cartesian-axis-tick-value');
    if (/*#__PURE__*/ $acw62.isValidElement(option)) // @ts-expect-error element cloning is not typed
    tickItem = /*#__PURE__*/ $acw62.cloneElement(option, $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else if (typeof option === 'function') tickItem = option($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else {
        var className = 'recharts-cartesian-axis-tick-value';
        if (typeof option !== 'boolean') className = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(className, (0, $15c2f7112dc9bdea$export$154498af6dc3c303)(option));
        tickItem = /*#__PURE__*/ $acw62.createElement((0, $964be52cc11879b4$export$5f1af8db9871e1d6), $247385db510d7b7c$var$_extends({}, tickProps, {
            className: className
        }), value);
    }
    return tickItem;
}
var $247385db510d7b7c$var$Ticks = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { ticks: ticks = [], tick: tick, tickLine: tickLine, stroke: stroke, tickFormatter: tickFormatter, unit: unit, padding: padding, tickTextProps: tickTextProps, orientation: orientation, mirror: mirror, x: x, y: y, width: width, height: height, tickSize: tickSize, tickMargin: tickMargin, fontSize: fontSize, letterSpacing: letterSpacing, getTicksConfig: getTicksConfig, events: events, axisType: axisType } = props;
    // @ts-expect-error some properties are optional in props but required in getTicks
    var finalTicks = (0, $582ebde04d312f24$export$3d27d42b1034de5c)($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, getTicksConfig), {}, {
        ticks: ticks
    }), fontSize, letterSpacing);
    var textAnchor = $247385db510d7b7c$var$getTickTextAnchor(orientation, mirror);
    var verticalAnchor = $247385db510d7b7c$var$getTickVerticalAnchor(orientation, mirror);
    var axisProps = (0, $37a0b0a95f0e25bf$export$8b56257912140094)(getTicksConfig);
    var customTickProps = (0, $37a0b0a95f0e25bf$export$6d5921c09aa671a9)(tick);
    var tickLinePropsObject = {};
    if (typeof tickLine === 'object') tickLinePropsObject = tickLine;
    var tickLineProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, axisProps), {}, {
        fill: 'none'
    }, tickLinePropsObject);
    var tickLineCoords = finalTicks.map((entry)=>$247385db510d7b7c$var$_objectSpread({
            entry: entry
        }, $247385db510d7b7c$var$getTickLineCoord(entry, x, y, width, height, orientation, tickSize, mirror, tickMargin)));
    var tickLines = tickLineCoords.map((_ref)=>{
        var { entry: entry, line: lineCoord } = _ref;
        return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, tickLine && /*#__PURE__*/ $acw62.createElement("line", $247385db510d7b7c$var$_extends({}, tickLineProps, lineCoord, {
            className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($7bb38c04d3b378db$exports)))(tickLine, 'className'))
        })));
    });
    var tickLabels = tickLineCoords.map((_ref2, i)=>{
        var _ref3, _tickTextProps$angle;
        var { entry: entry, tick: tickCoord } = _ref2;
        // @ts-expect-error we're not checking that padding and orientation types are in sync
        var tickProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({
            verticalAnchor: verticalAnchor
        }, axisProps), {}, {
            textAnchor: textAnchor,
            stroke: 'none',
            fill: stroke
        }, tickCoord), {}, {
            index: i,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter: tickFormatter,
            padding: padding
        }, tickTextProps), {}, {
            angle: (_ref3 = (_tickTextProps$angle = tickTextProps === null || tickTextProps === void 0 ? void 0 : tickTextProps.angle) !== null && _tickTextProps$angle !== void 0 ? _tickTextProps$angle : axisProps.angle) !== null && _ref3 !== void 0 ? _ref3 : 0
        });
        // @ts-expect-error customTickProps is contributing unknown props which we don't type properly
        var finalTickProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, tickProps), customTickProps);
        return /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), $247385db510d7b7c$var$_extends({
            className: "recharts-cartesian-axis-tick-label",
            key: "tick-label-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(events, entry, i)), tick && /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$TickItem, {
            option: tick,
            tickProps: finalTickProps,
            value: "".concat(typeof tickFormatter === 'function' ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')
        }));
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-axis-ticks recharts-".concat(axisType, "-ticks")
    }, tickLabels.length > 0 && /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: (0, $c327287477e919da$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-axis-tick-labels recharts-".concat(axisType, "-tick-labels"),
        ref: ref
    }, tickLabels)), tickLines.length > 0 && /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-axis-tick-lines recharts-".concat(axisType, "-tick-lines")
    }, tickLines));
});
var $247385db510d7b7c$var$CartesianAxisComponent = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { axisLine: axisLine, width: width, height: height, className: className, hide: hide, ticks: ticks, axisType: axisType } = props, rest = $247385db510d7b7c$var$_objectWithoutProperties(props, $247385db510d7b7c$var$_excluded);
    var [fontSize, setFontSize] = (0, $acw62.useState)('');
    var [letterSpacing, setLetterSpacing] = (0, $acw62.useState)('');
    var tickRefs = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            getCalculatedWidth: ()=>{
                var _props$labelRef;
                return (0, $53536bea4cb8dced$export$b70f70a4fdbed242)({
                    ticks: tickRefs.current,
                    label: (_props$labelRef = props.labelRef) === null || _props$labelRef === void 0 ? void 0 : _props$labelRef.current,
                    labelGapWithTick: 5,
                    tickSize: props.tickSize,
                    tickMargin: props.tickMargin
                });
            }
        }));
    var layerRef = (0, $acw62.useCallback)((el)=>{
        if (el) {
            var tickNodes = el.getElementsByClassName('recharts-cartesian-axis-tick-value');
            tickRefs.current = tickNodes;
            var tick = tickNodes[0];
            if (tick) {
                var computedStyle = window.getComputedStyle(tick);
                var calculatedFontSize = computedStyle.fontSize;
                var calculatedLetterSpacing = computedStyle.letterSpacing;
                if (calculatedFontSize !== fontSize || calculatedLetterSpacing !== letterSpacing) {
                    setFontSize(calculatedFontSize);
                    setLetterSpacing(calculatedLetterSpacing);
                }
            }
        }
    }, [
        fontSize,
        letterSpacing
    ]);
    if (hide) return null;
    /*
   * This is different condition from what validateWidthHeight is doing;
   * the CartesianAxis does allow width or height to be undefined.
   */ if (width != null && width <= 0 || height != null && height <= 0) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-cartesian-axis', className)
    }, /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$AxisLine, {
        x: props.x,
        y: props.y,
        width: width,
        height: height,
        orientation: props.orientation,
        mirror: props.mirror,
        axisLine: axisLine,
        otherSvgProps: (0, $37a0b0a95f0e25bf$export$8b56257912140094)(props)
    }), /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$Ticks, {
        ref: layerRef,
        axisType: axisType,
        events: rest,
        fontSize: fontSize,
        getTicksConfig: props,
        height: props.height,
        letterSpacing: letterSpacing,
        mirror: props.mirror,
        orientation: props.orientation,
        padding: props.padding,
        stroke: props.stroke,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        tickLine: props.tickLine,
        tickMargin: props.tickMargin,
        tickSize: props.tickSize,
        tickTextProps: props.tickTextProps,
        ticks: ticks,
        unit: props.unit,
        width: props.width,
        x: props.x,
        y: props.y
    }), /*#__PURE__*/ $acw62.createElement((0, $77be8884b5ec622c$export$3b4df77eaec10b03), {
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        lowerWidth: props.width,
        upperWidth: props.width
    }, /*#__PURE__*/ $acw62.createElement((0, $77be8884b5ec622c$export$3c82c3a3704539d8), {
        label: props.label,
        labelRef: props.labelRef
    }), props.children)));
});
var $247385db510d7b7c$export$bdd99f2cdf352bae = /*#__PURE__*/ $acw62.forwardRef((outsideProps, ref)=>{
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $247385db510d7b7c$export$179c35154a9748c0);
    return /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$CartesianAxisComponent, $247385db510d7b7c$var$_extends({}, props, {
        ref: ref
    }));
});
$247385db510d7b7c$export$bdd99f2cdf352bae.displayName = 'CartesianAxis';











var $eae69ed53f30e7ce$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $eae69ed53f30e7ce$var$_excluded2 = [
    "offset"
], $eae69ed53f30e7ce$var$_excluded3 = [
    "xAxisId",
    "yAxisId"
], $eae69ed53f30e7ce$var$_excluded4 = [
    "xAxisId",
    "yAxisId"
];
function $eae69ed53f30e7ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eae69ed53f30e7ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eae69ed53f30e7ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eae69ed53f30e7ce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eae69ed53f30e7ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eae69ed53f30e7ce$var$_defineProperty(e, r, t) {
    return (r = $eae69ed53f30e7ce$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $eae69ed53f30e7ce$var$_toPropertyKey(t) {
    var i = $eae69ed53f30e7ce$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $eae69ed53f30e7ce$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eae69ed53f30e7ce$var$_extends() {
    return $eae69ed53f30e7ce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eae69ed53f30e7ce$var$_extends.apply(null, arguments);
}
function $eae69ed53f30e7ce$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * The <CartesianGrid horizontal
 */ var $eae69ed53f30e7ce$var$Background = (props)=>{
    var { fill: fill } = props;
    if (!fill || fill === 'none') return null;
    var { fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, ry: ry } = props;
    return /*#__PURE__*/ $acw62.createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $eae69ed53f30e7ce$var$LineItem(_ref) {
    var { option: option, lineItemProps: lineItemProps } = _ref;
    var lineItem;
    if (/*#__PURE__*/ $acw62.isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ $acw62.cloneElement(option, lineItemProps);
    else if (typeof option === 'function') lineItem = option(lineItemProps);
    else {
        var _svgPropertiesNoEvent;
        var { x1: x1, y1: y1, x2: x2, y2: y2, key: key } = lineItemProps, others = $eae69ed53f30e7ce$var$_objectWithoutProperties(lineItemProps, $eae69ed53f30e7ce$var$_excluded);
        var _ref2 = (_svgPropertiesNoEvent = (0, $37a0b0a95f0e25bf$export$8b56257912140094)(others)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { offset: __ } = _ref2, restOfFilteredProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(_ref2, $eae69ed53f30e7ce$var$_excluded2);
        lineItem = /*#__PURE__*/ $acw62.createElement("line", $eae69ed53f30e7ce$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $eae69ed53f30e7ce$var$HorizontalGridLines(props) {
    var { x: x, width: width, horizontal: horizontal = true, horizontalPoints: horizontalPoints } = props;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(props, $eae69ed53f30e7ce$var$_excluded3);
    var items = horizontalPoints.map((entry, i)=>{
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$LineItem, {
            key: "line-".concat(i),
            option: horizontal,
            lineItemProps: lineItemProps
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalGridLines(props) {
    var { y: y, height: height, vertical: vertical = true, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(props, $eae69ed53f30e7ce$var$_excluded4);
    var items = verticalPoints.map((entry, i)=>{
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$LineItem, {
            option: vertical,
            lineItemProps: lineItemProps,
            key: "line-".concat(i)
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $eae69ed53f30e7ce$var$HorizontalStripes(props) {
    var { horizontalFill: horizontalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, horizontalPoints: horizontalPoints, horizontal: horizontal = true } = props;
    if (!horizontal || !horizontalFill || !horizontalFill.length || horizontalPoints == null) return null;
    var roundedSortedHorizontalPoints = horizontalPoints.map((e)=>Math.round(e + y - y)).sort((a, b)=>a - b);
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map((entry, i)=>{
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var nextPoint = roundedSortedHorizontalPoints[i + 1];
        var lastStripe = nextPoint == null;
        var lineHeight = lastStripe ? y + height - entry : nextPoint - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ $acw62.createElement("rect", {
            key: "react-".concat(i),
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalStripes(props) {
    var { vertical: vertical = true, verticalFill: verticalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map((e)=>Math.round(e + x - x)).sort((a, b)=>a - b);
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map((entry, i)=>{
        var nextPoint = roundedSortedVerticalPoints[i + 1];
        var lastStripe = nextPoint == null;
        var lineWidth = lastStripe ? x + width - entry : nextPoint - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ $acw62.createElement("rect", {
            key: "react-".concat(i),
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator = (_ref3, syncWithTicks)=>{
    var { xAxis: xAxis, width: width, height: height, offset: offset } = _ref3;
    return (0, $cd015374923bb5c7$export$846dc5ac5fecff74)((0, $582ebde04d312f24$export$3d27d42b1034de5c)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $247385db510d7b7c$export$179c35154a9748c0)), xAxis), {}, {
        ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator = (_ref4, syncWithTicks)=>{
    var { yAxis: yAxis, width: width, height: height, offset: offset } = _ref4;
    return (0, $cd015374923bb5c7$export$846dc5ac5fecff74)((0, $582ebde04d312f24$export$3d27d42b1034de5c)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $247385db510d7b7c$export$179c35154a9748c0)), yAxis), {}, {
        ticks: (0, $cd015374923bb5c7$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $eae69ed53f30e7ce$export$58f1dfa394f98e54 = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: [],
    xAxisId: 0,
    yAxisId: 0,
    syncWithTicks: false,
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).grid
};
function $eae69ed53f30e7ce$export$6440e27b9f186856(props) {
    var chartWidth = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var chartHeight = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    var offset = (0, $e573f10901a87cfb$export$10605f61bef2858a)();
    var propsIncludingDefaults = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(props, $eae69ed53f30e7ce$export$58f1dfa394f98e54)), {}, {
        x: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var { xAxisId: xAxisId, yAxisId: yAxisId, x: x, y: y, width: width, height: height, syncWithTicks: syncWithTicks, horizontalValues: horizontalValues, verticalValues: verticalValues } = propsIncludingDefaults;
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var xAxis = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$45cd57660792dd31)(state, 'xAxis', xAxisId, isPanorama));
    var yAxis = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$45cd57660792dd31)(state, 'yAxis', yAxisId, isPanorama));
    if (!(0, $dabee322b52312f4$export$5374bb854d0e41c8)(width) || !(0, $dabee322b52312f4$export$5374bb854d0e41c8)(height) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y)) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator;
    var { horizontalPoints: horizontalPoints, verticalPoints: verticalPoints } = propsIncludingDefaults;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && typeof horizontalCoordinatesGenerator === 'function') {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(typeof generatorResult, "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && typeof verticalCoordinatesGenerator === 'function') {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $0c26188443d0bc67$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(typeof _generatorResult, "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: propsIncludingDefaults.zIndex
    }, /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$HorizontalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$VerticalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$HorizontalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$VerticalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    }))));
}
$eae69ed53f30e7ce$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");





function $ea93c1a04fc562aa$var$_extends() {
    return $ea93c1a04fc562aa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea93c1a04fc562aa$var$_extends.apply(null, arguments);
}
function $ea93c1a04fc562aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea93c1a04fc562aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea93c1a04fc562aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ea93c1a04fc562aa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea93c1a04fc562aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ea93c1a04fc562aa$var$_defineProperty(e, r, t) {
    return (r = $ea93c1a04fc562aa$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ea93c1a04fc562aa$var$_toPropertyKey(t) {
    var i = $ea93c1a04fc562aa$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ea93c1a04fc562aa$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ea93c1a04fc562aa$var$SIZE = 32;
var $ea93c1a04fc562aa$var$defaultLegendContentDefaultProps = {
    align: 'center',
    iconSize: 14,
    inactiveColor: '#ccc',
    layout: 'horizontal',
    verticalAlign: 'middle'
};
function $ea93c1a04fc562aa$var$Icon(_ref) {
    var { data: data, iconType: iconType, inactiveColor: inactiveColor } = _ref;
    var halfSize = $ea93c1a04fc562aa$var$SIZE / 2;
    var sixthSize = $ea93c1a04fc562aa$var$SIZE / 6;
    var thirdSize = $ea93c1a04fc562aa$var$SIZE / 3;
    var color = data.inactive ? inactiveColor : data.color;
    var preferredIcon = iconType !== null && iconType !== void 0 ? iconType : data.type;
    if (preferredIcon === 'none') return null;
    if (preferredIcon === 'plainline') {
        var _data$payload;
        return /*#__PURE__*/ $acw62.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: color,
            strokeDasharray: (_data$payload = data.payload) === null || _data$payload === void 0 ? void 0 : _data$payload.strokeDasharray,
            x1: 0,
            y1: halfSize,
            x2: $ea93c1a04fc562aa$var$SIZE,
            y2: halfSize,
            className: "recharts-legend-icon"
        });
    }
    if (preferredIcon === 'line') return /*#__PURE__*/ $acw62.createElement("path", {
        strokeWidth: 4,
        fill: "none",
        stroke: color,
        d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($ea93c1a04fc562aa$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
        className: "recharts-legend-icon"
    });
    if (preferredIcon === 'rect') return /*#__PURE__*/ $acw62.createElement("path", {
        stroke: "none",
        fill: color,
        d: "M0,".concat($ea93c1a04fc562aa$var$SIZE / 8, "h").concat($ea93c1a04fc562aa$var$SIZE, "v").concat($ea93c1a04fc562aa$var$SIZE * 3 / 4, "h").concat(-$ea93c1a04fc562aa$var$SIZE, "z"),
        className: "recharts-legend-icon"
    });
    if (/*#__PURE__*/ $acw62.isValidElement(data.legendIcon)) {
        var iconProps = $ea93c1a04fc562aa$var$_objectSpread({}, data);
        delete iconProps.legendIcon;
        return /*#__PURE__*/ $acw62.cloneElement(data.legendIcon, iconProps);
    }
    return /*#__PURE__*/ $acw62.createElement((0, $61aa615b92178b76$export$fa456266707bf4e4), {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: $ea93c1a04fc562aa$var$SIZE,
        sizeType: "diameter",
        type: preferredIcon
    });
}
function $ea93c1a04fc562aa$var$Items(props) {
    var { payload: payload, iconSize: iconSize, layout: layout, formatter: formatter, inactiveColor: inactiveColor, iconType: iconType } = props;
    var viewBox = {
        x: 0,
        y: 0,
        width: $ea93c1a04fc562aa$var$SIZE,
        height: $ea93c1a04fc562aa$var$SIZE
    };
    var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
    };
    var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
    };
    return payload.map((entry, i)=>{
        var finalFormatter = entry.formatter || formatter;
        var className = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)({
            'recharts-legend-item': true,
            ["legend-item-".concat(i)]: true,
            inactive: entry.inactive
        });
        if (entry.type === 'none') return null;
        var color = entry.inactive ? inactiveColor : entry.color;
        var finalValue = finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value;
        return /*#__PURE__*/ $acw62.createElement("li", $ea93c1a04fc562aa$var$_extends({
            className: className,
            style: itemStyle,
            key: "legend-item-".concat(i)
        }, (0, $909d5f835f4e917b$export$ca62be0d67a3158c)(props, entry, i)), /*#__PURE__*/ $acw62.createElement((0, $bfae0ec07b91e499$export$7b92b459e668cb21), {
            width: iconSize,
            height: iconSize,
            viewBox: viewBox,
            style: svgStyle,
            "aria-label": "".concat(finalValue, " legend icon")
        }, /*#__PURE__*/ $acw62.createElement($ea93c1a04fc562aa$var$Icon, {
            data: entry,
            iconType: iconType,
            inactiveColor: inactiveColor
        })), /*#__PURE__*/ $acw62.createElement("span", {
            className: "recharts-legend-item-text",
            style: {
                color: color
            }
        }, finalValue));
    });
}
var $ea93c1a04fc562aa$export$99f8d96ed0cededa = (outsideProps)=>{
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $ea93c1a04fc562aa$var$defaultLegendContentDefaultProps);
    var { payload: payload, layout: layout, align: align } = props;
    if (!payload || !payload.length) return null;
    var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
    };
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
    }, /*#__PURE__*/ $acw62.createElement($ea93c1a04fc562aa$var$Items, $ea93c1a04fc562aa$var$_extends({}, props, {
        payload: payload
    })));
};


var $aa21fb961cb4f94f$exports = {};

$aa21fb961cb4f94f$exports = (parcelRequire("k3IAw")).uniqBy;


function $12cc16c3e91089ee$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($aa21fb961cb4f94f$exports)))(payload, defaultUniqBy);
    if (typeof option === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($aa21fb961cb4f94f$exports)))(payload, option);
    return payload;
}




function $5f41bd8478f19331$export$5e7711dbef7c() {
    return (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $a3c7059a0e295f7c$export$9a6de64b691a7304));
}



var $acw62 = parcelRequire("acw62");
var $5df7cd4fc39ce268$var$EPS = 1;
function $5df7cd4fc39ce268$export$35f58fcda6094144() {
    var extraDependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var [lastBoundingBox, setLastBoundingBox] = (0, $acw62.useState)({
        height: 0,
        left: 0,
        top: 0,
        width: 0
    });
    var updateBoundingBox = (0, $acw62.useCallback)((node)=>{
        if (node != null) {
            var rect = node.getBoundingClientRect();
            var box = {
                height: rect.height,
                left: rect.left,
                top: rect.top,
                width: rect.width
            };
            if (Math.abs(box.height - lastBoundingBox.height) > $5df7cd4fc39ce268$var$EPS || Math.abs(box.left - lastBoundingBox.left) > $5df7cd4fc39ce268$var$EPS || Math.abs(box.top - lastBoundingBox.top) > $5df7cd4fc39ce268$var$EPS || Math.abs(box.width - lastBoundingBox.width) > $5df7cd4fc39ce268$var$EPS) setLastBoundingBox({
                height: box.height,
                left: box.left,
                top: box.top,
                width: box.width
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lastBoundingBox.width,
        lastBoundingBox.height,
        lastBoundingBox.top,
        lastBoundingBox.left,
        ...extraDependencies
    ]);
    return [
        lastBoundingBox,
        updateBoundingBox
    ];
}






var $1f4bd73be8c7e839$var$_excluded = [
    "contextPayload"
];
function $1f4bd73be8c7e839$var$_extends() {
    return $1f4bd73be8c7e839$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1f4bd73be8c7e839$var$_extends.apply(null, arguments);
}
function $1f4bd73be8c7e839$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f4bd73be8c7e839$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f4bd73be8c7e839$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1f4bd73be8c7e839$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f4bd73be8c7e839$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1f4bd73be8c7e839$var$_defineProperty(e, r, t) {
    return (r = $1f4bd73be8c7e839$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1f4bd73be8c7e839$var$_toPropertyKey(t) {
    var i = $1f4bd73be8c7e839$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1f4bd73be8c7e839$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1f4bd73be8c7e839$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1f4bd73be8c7e839$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $1f4bd73be8c7e839$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $1f4bd73be8c7e839$var$defaultUniqBy(entry) {
    return entry.value;
}
function $1f4bd73be8c7e839$var$LegendContent(props) {
    var { contextPayload: contextPayload } = props, otherProps = $1f4bd73be8c7e839$var$_objectWithoutProperties(props, $1f4bd73be8c7e839$var$_excluded);
    var finalPayload = (0, $12cc16c3e91089ee$export$b67e33c2fb1535fa)(contextPayload, props.payloadUniqBy, $1f4bd73be8c7e839$var$defaultUniqBy);
    var contentProps = $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, otherProps), {}, {
        payload: finalPayload
    });
    if (/*#__PURE__*/ $acw62.isValidElement(props.content)) return /*#__PURE__*/ $acw62.cloneElement(props.content, contentProps);
    if (typeof props.content === 'function') return /*#__PURE__*/ $acw62.createElement(props.content, contentProps);
    return /*#__PURE__*/ $acw62.createElement((0, $ea93c1a04fc562aa$export$99f8d96ed0cededa), contentProps);
}
function $1f4bd73be8c7e839$var$getDefaultPosition(style, props, margin, chartWidth, chartHeight, box) {
    var { layout: layout, align: align, verticalAlign: verticalAlign } = props;
    var hPos, vPos;
    if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') hPos = {
            left: ((chartWidth || 0) - box.width) / 2
        };
        else hPos = align === 'right' ? {
            right: margin && margin.right || 0
        } : {
            left: margin && margin.left || 0
        };
    }
    if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') vPos = {
            top: ((chartHeight || 0) - box.height) / 2
        };
        else vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
        } : {
            top: margin && margin.top || 0
        };
    }
    return $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({}, hPos), vPos);
}
function $1f4bd73be8c7e839$var$LegendSettingsDispatcher(props) {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $056a3e7c624b08cd$export$a1a647a9c0dcc839)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $1f4bd73be8c7e839$var$LegendSizeDispatcher(props) {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $056a3e7c624b08cd$export$f9ba9ab9b90c340e)(props));
        return ()=>{
            dispatch((0, $056a3e7c624b08cd$export$f9ba9ab9b90c340e)({
                width: 0,
                height: 0
            }));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $1f4bd73be8c7e839$var$getWidthOrHeight(layout, height, width, maxWidth) {
    if (layout === 'vertical' && height != null) return {
        height: height
    };
    if (layout === 'horizontal') return {
        width: width || maxWidth
    };
    return null;
}
var $1f4bd73be8c7e839$export$af43120f4eb40347 = {
    align: 'center',
    iconSize: 14,
    inactiveColor: '#ccc',
    itemSorter: 'value',
    layout: 'horizontal',
    verticalAlign: 'bottom'
};
function $1f4bd73be8c7e839$export$ed247974535929c7(outsideProps) {
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $1f4bd73be8c7e839$export$af43120f4eb40347);
    var contextPayload = (0, $5f41bd8478f19331$export$5e7711dbef7c)();
    var legendPortalFromContext = (0, $10caa8aee2f82bd9$export$36ebc0838785d4af)();
    var margin = (0, $e573f10901a87cfb$export$58ac794108fd8ca)();
    var { width: widthFromProps, height: heightFromProps, wrapperStyle: wrapperStyle, portal: portalFromProps } = props;
    // The contextPayload is not used directly inside the hook, but we need the onBBoxUpdate call
    // when the payload changes, therefore it's here as a dependency.
    var [lastBoundingBox, updateBoundingBox] = (0, $5df7cd4fc39ce268$export$35f58fcda6094144)([
        contextPayload
    ]);
    var chartWidth = (0, $e573f10901a87cfb$export$8854f7ece606854b)();
    var chartHeight = (0, $e573f10901a87cfb$export$369ae257969c6f9f)();
    if (chartWidth == null || chartHeight == null) return null;
    var maxWidth = chartWidth - ((margin === null || margin === void 0 ? void 0 : margin.left) || 0) - ((margin === null || margin === void 0 ? void 0 : margin.right) || 0);
    var widthOrHeight = $1f4bd73be8c7e839$var$getWidthOrHeight(props.layout, heightFromProps, widthFromProps, maxWidth);
    // if the user supplies their own portal, only use their defined wrapper styles
    var outerStyle = portalFromProps ? wrapperStyle : $1f4bd73be8c7e839$var$_objectSpread($1f4bd73be8c7e839$var$_objectSpread({
        position: 'absolute',
        width: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.width) || widthFromProps || 'auto',
        height: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.height) || heightFromProps || 'auto'
    }, $1f4bd73be8c7e839$var$getDefaultPosition(wrapperStyle, props, margin, chartWidth, chartHeight, lastBoundingBox)), wrapperStyle);
    var legendPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : legendPortalFromContext;
    if (legendPortal == null || contextPayload == null) return null;
    var legendElement = /*#__PURE__*/ $acw62.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: updateBoundingBox
    }, /*#__PURE__*/ $acw62.createElement($1f4bd73be8c7e839$var$LegendSettingsDispatcher, {
        layout: props.layout,
        align: props.align,
        verticalAlign: props.verticalAlign,
        itemSorter: props.itemSorter
    }), !portalFromProps && /*#__PURE__*/ $acw62.createElement($1f4bd73be8c7e839$var$LegendSizeDispatcher, {
        width: lastBoundingBox.width,
        height: lastBoundingBox.height
    }), /*#__PURE__*/ $acw62.createElement($1f4bd73be8c7e839$var$LegendContent, $1f4bd73be8c7e839$var$_extends({}, props, widthOrHeight, {
        margin: margin,
        chartWidth: chartWidth,
        chartHeight: chartHeight,
        contextPayload: contextPayload
    })));
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(legendElement, legendPortal);
}
$1f4bd73be8c7e839$export$ed247974535929c7.displayName = 'Legend';


var $acw62 = parcelRequire("acw62");



















var $7a902e28b5b16ff9$var$selectXAxisWithScale = (state, xAxisId, _yAxisId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectXAxisTicks = (state, xAxisId, _yAxisId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectYAxisWithScale = (state, _xAxisId, yAxisId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectYAxisTicks = (state, _xAxisId, yAxisId, isPanorama)=>(0, $6aac8fe27ae10a7b$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectBandSize = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $7a902e28b5b16ff9$var$selectXAxisWithScale,
    $7a902e28b5b16ff9$var$selectYAxisWithScale,
    $7a902e28b5b16ff9$var$selectXAxisTicks,
    $7a902e28b5b16ff9$var$selectYAxisTicks
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks)=>{
    if ((0, $cd015374923bb5c7$export$9fc1baaa6c6368b)(layout, 'xAxis')) return (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(xAxis, xAxisTicks, false);
    return (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(yAxis, yAxisTicks, false);
});
var $7a902e28b5b16ff9$var$pickLineId = (_state, _xAxisId, _yAxisId, _isPanorama, id)=>id;
function $7a902e28b5b16ff9$var$isLineSettings(item) {
    return item.type === 'line';
}
/*
 * There is a race condition problem because we read some data from props and some from the state.
 * The state is updated through a dispatch and is one render behind,
 * and so we have this weird one tick render where the displayedData in one selector have the old dataKey
 * but the new dataKey in another selector.
 *
 * So here instead of reading the dataKey from the props, we always read it from the state.
 */ var $7a902e28b5b16ff9$var$selectSynchronisedLineSettings = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $6aac8fe27ae10a7b$export$f67c737adf41a3af),
    $7a902e28b5b16ff9$var$pickLineId
], (graphicalItems, id)=>graphicalItems.filter($7a902e28b5b16ff9$var$isLineSettings).find((x)=>x.id === id));
var $7a902e28b5b16ff9$export$3eaebea0f6c183c0 = (0, $375276bea32f9eda$export$595d22ed68ca2841)([
    (0, $e573f10901a87cfb$export$8426b6d9af801dee),
    $7a902e28b5b16ff9$var$selectXAxisWithScale,
    $7a902e28b5b16ff9$var$selectYAxisWithScale,
    $7a902e28b5b16ff9$var$selectXAxisTicks,
    $7a902e28b5b16ff9$var$selectYAxisTicks,
    $7a902e28b5b16ff9$var$selectSynchronisedLineSettings,
    $7a902e28b5b16ff9$var$selectBandSize,
    (0, $d235e165ed12974e$export$fe05134c2701d897)
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks, lineSettings, bandSize, _ref)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (lineSettings == null || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || xAxisTicks.length === 0 || yAxisTicks.length === 0 || bandSize == null || layout !== 'horizontal' && layout !== 'vertical') return undefined;
    var { dataKey: dataKey, data: data } = lineSettings;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $f8a3115883abd1dc$export$bfbd9a993cf94d79)({
        layout: layout,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        dataKey: dataKey,
        bandSize: bandSize,
        displayedData: displayedData
    });
});

















var $f8a3115883abd1dc$var$_excluded = [
    "id"
], $f8a3115883abd1dc$var$_excluded2 = [
    "type",
    "layout",
    "connectNulls",
    "needClip",
    "shape"
], $f8a3115883abd1dc$var$_excluded3 = [
    "activeDot",
    "animateNewValues",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "connectNulls",
    "dot",
    "hide",
    "isAnimationActive",
    "label",
    "legendType",
    "xAxisId",
    "yAxisId",
    "id"
];
function $f8a3115883abd1dc$var$_extends() {
    return $f8a3115883abd1dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f8a3115883abd1dc$var$_extends.apply(null, arguments);
}
function $f8a3115883abd1dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8a3115883abd1dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8a3115883abd1dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f8a3115883abd1dc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8a3115883abd1dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8a3115883abd1dc$var$_defineProperty(e, r, t) {
    return (r = $f8a3115883abd1dc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f8a3115883abd1dc$var$_toPropertyKey(t) {
    var i = $f8a3115883abd1dc$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f8a3115883abd1dc$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f8a3115883abd1dc$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f8a3115883abd1dc$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f8a3115883abd1dc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ /**
 * Because of naming conflict, we are forced to ignore certain (valid) SVG attributes.
 */ var $f8a3115883abd1dc$var$computeLegendPayloadFromAreaData = (props)=>{
    var { dataKey: dataKey, name: name, stroke: stroke, legendType: legendType, hide: hide } = props;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: stroke,
            value: (0, $cd015374923bb5c7$export$d3207de44081d2b3)(name, dataKey),
            payload: props
        }
    ];
};
var $f8a3115883abd1dc$var$SetLineTooltipEntrySettings = /*#__PURE__*/ $acw62.memo((_ref)=>{
    var { dataKey: dataKey, data: data, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, unit: unit, tooltipType: tooltipType, id: id } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        getPosition: (0, $2ab3a7e25c8aba74$export$8793edee2d425525),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $cd015374923bb5c7$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: stroke,
            unit: unit,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $1e712d1b3a15e741$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
var $f8a3115883abd1dc$var$generateSimpleStrokeDasharray = (totalLength, length)=>{
    return "".concat(length, "px ").concat(totalLength - length, "px");
};
function $f8a3115883abd1dc$var$repeat(lines, count) {
    var linesUnit = lines.length % 2 !== 0 ? [
        ...lines,
        0
    ] : lines;
    var result = [];
    for(var i = 0; i < count; ++i)result = [
        ...result,
        ...linesUnit
    ];
    return result;
}
var $f8a3115883abd1dc$var$getStrokeDasharray = (length, totalLength, lines)=>{
    var lineLength = lines.reduce((pre, next)=>pre + next);
    // if lineLength is 0 return the default when no strokeDasharray is provided
    if (!lineLength) return $f8a3115883abd1dc$var$generateSimpleStrokeDasharray(totalLength, length);
    var count = Math.floor(length / lineLength);
    var remainLength = length % lineLength;
    var restLength = totalLength - length;
    var remainLines = [];
    for(var i = 0, sum = 0; i < lines.length; sum += (_lines$i = lines[i]) !== null && _lines$i !== void 0 ? _lines$i : 0, ++i){
        var _lines$i;
        var lineValue = lines[i];
        if (lineValue != null && sum + lineValue > remainLength) {
            remainLines = [
                ...lines.slice(0, i),
                remainLength - sum
            ];
            break;
        }
    }
    var emptyLines = remainLines.length % 2 === 0 ? [
        0,
        restLength
    ] : [
        restLength
    ];
    return [
        ...$f8a3115883abd1dc$var$repeat(lines, count),
        ...remainLines,
        ...emptyLines
    ].map((line)=>"".concat(line, "px")).join(', ');
};
function $f8a3115883abd1dc$var$LineDotsWrapper(_ref2) {
    var { clipPathId: clipPathId, points: points, props: props } = _ref2;
    var { dot: dot, dataKey: dataKey, needClip: needClip } = props;
    /*
   * Exclude ID from the props passed to the Dots component
   * because then the ID would be applied to multiple dots, and it would no longer be unique.
   */ var { id: id } = props, propsWithoutId = $f8a3115883abd1dc$var$_objectWithoutProperties(props, $f8a3115883abd1dc$var$_excluded);
    var lineProps = (0, $37a0b0a95f0e25bf$export$8b56257912140094)(propsWithoutId);
    return /*#__PURE__*/ $acw62.createElement((0, $6dcd61e97c26c79c$export$8da50d3722682be0), {
        points: points,
        dot: dot,
        className: "recharts-line-dots",
        dotClassName: "recharts-line-dot",
        dataKey: dataKey,
        baseProps: lineProps,
        needClip: needClip,
        clipPathId: clipPathId
    });
}
function $f8a3115883abd1dc$var$LineLabelListProvider(_ref3) {
    var { showLabels: showLabels, children: children, points: points } = _ref3;
    var labelListEntries = (0, $acw62.useMemo)(()=>{
        return points === null || points === void 0 ? void 0 : points.map((point)=>{
            var _point$x, _point$y;
            var viewBox = {
                x: (_point$x = point.x) !== null && _point$x !== void 0 ? _point$x : 0,
                y: (_point$y = point.y) !== null && _point$y !== void 0 ? _point$y : 0,
                width: 0,
                lowerWidth: 0,
                upperWidth: 0,
                height: 0
            };
            return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, viewBox), {}, {
                value: point.value,
                payload: point.payload,
                viewBox: viewBox,
                /*
         * Line is not passing parentViewBox to the LabelList so the labels can escape - looks like a bug, should we pass parentViewBox?
         * Or should this just be the root chart viewBox?
         */ parentViewBox: undefined,
                fill: undefined
            });
        });
    }, [
        points
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $88ab0dba0fc78576$export$64e384eac5db53f7), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $f8a3115883abd1dc$var$StaticCurve(_ref4) {
    var { clipPathId: clipPathId, pathRef: pathRef, points: points, strokeDasharray: strokeDasharray, props: props } = _ref4;
    var { type: type, layout: layout, connectNulls: connectNulls, needClip: needClip, shape: shape } = props, others = $f8a3115883abd1dc$var$_objectWithoutProperties(props, $f8a3115883abd1dc$var$_excluded2);
    var curveProps = $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(others)), {}, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined,
        points: points,
        type: type,
        layout: layout,
        connectNulls: connectNulls,
        strokeDasharray: strokeDasharray !== null && strokeDasharray !== void 0 ? strokeDasharray : props.strokeDasharray
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (points === null || points === void 0 ? void 0 : points.length) > 1 && /*#__PURE__*/ $acw62.createElement((0, $4696e249b64cd95e$export$6428a7f2611ef1fa), $f8a3115883abd1dc$var$_extends({
        shapeType: "curve",
        option: shape
    }, curveProps, {
        pathRef: pathRef
    })), /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineDotsWrapper, {
        points: points,
        clipPathId: clipPathId,
        props: props
    }));
}
function $f8a3115883abd1dc$var$getTotalLength(mainCurve) {
    try {
        return mainCurve && mainCurve.getTotalLength && mainCurve.getTotalLength() || 0;
    } catch (_unused) {
        return 0;
    }
}
function $f8a3115883abd1dc$var$CurveWithAnimation(_ref5) {
    var { clipPathId: clipPathId, props: props, pathRef: pathRef, previousPointsRef: previousPointsRef, longestAnimatedLengthRef: longestAnimatedLengthRef } = _ref5;
    var { points: points, strokeDasharray: strokeDasharray, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, animateNewValues: animateNewValues, width: width, height: height, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart } = props;
    var prevPoints = previousPointsRef.current;
    var animationId = (0, $72206edefbff003d$export$e1042b2944b80b7f)(points, 'recharts-line-');
    var animationIdRef = (0, $acw62.useRef)(animationId);
    var [isAnimating, setIsAnimating] = (0, $acw62.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    var totalLength = $f8a3115883abd1dc$var$getTotalLength(pathRef.current);
    /*
   * Here we want to detect if the length animation has been interrupted.
   * For that we keep a reference to the furthest length that has been animated.
   *
   * And then, to keep things smooth, we add to it the current length that is being animated right now.
   *
   * If we did Math.max then it makes the length animation "pause" but we want to keep it smooth
   * so in case we have some "leftover" length from the previous animation we add it to the current length.
   *
   * This is not perfect because the animation changes speed due to easing. The default easing is 'ease' which is not linear
   * and makes it stand out. But it's good enough I suppose.
   * If we want to fix it then we need to keep track of multiple animations and their easing and timings.
   *
   * If you want to see this in action, try to change the dataKey of the line chart while the initial animation is running.
   * The Line begins with zero length and slowly grows to the full length. While this growth is in progress,
   * change the dataKey and the Line will continue growing from where it has grown so far.
   *
   * This is for the case when new animation triggers. When that happens we get new points, everything re-renders,
   * and we get fresh new state in this component and use the ref stored above.
   *
   * In case when we get render without new animation - for example when opacity changes, or color changes,
   * then the animationId remains the same, and we do not update the starting point.
   * See https://github.com/recharts/recharts/issues/6044
   */ var startingPointRef = (0, $acw62.useRef)(0);
    if (animationIdRef.current !== animationId) {
        startingPointRef.current = longestAnimatedLengthRef.current;
        animationIdRef.current = animationId;
    }
    var startingPoint = startingPointRef.current;
    return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineLabelListProvider, {
        points: points,
        showLabels: showLabels
    }, props.children, /*#__PURE__*/ $acw62.createElement((0, $464febc3f716710f$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        var lengthInterpolated = (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(startingPoint, totalLength + startingPoint, t);
        var curLength = Math.min(lengthInterpolated, totalLength);
        var currentStrokeDasharray;
        if (isAnimationActive) {
            if (strokeDasharray) {
                var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map((num)=>parseFloat(num));
                currentStrokeDasharray = $f8a3115883abd1dc$var$getStrokeDasharray(curLength, totalLength, lines);
            } else currentStrokeDasharray = $f8a3115883abd1dc$var$generateSimpleStrokeDasharray(totalLength, curLength);
        } else currentStrokeDasharray = strokeDasharray == null ? undefined : String(strokeDasharray);
        /*
     * Here it is important to wait a little bit with updating the previousPointsRef
     * before the animation has a time to initialize.
     * If we set the previous pointsRef immediately, we set it before the Legend height it calculated
     * and before pathRef is set.
     * If that happens, the Line will re-render again after Legend had reported its height
     * which will start a new animation with the previous points as the starting point
     * which gives the effect of the Line animating slightly upwards (where the animation distance equals the Legend height).
     * Waiting for t > 0 is indirect but good enough to ensure that the Legend height is calculated and animation works properly.
     *
     * Total length similarly is calculated from the pathRef. We should not update the previousPointsRef
     * before the pathRef is set, otherwise we will have a wrong total length.
     */ if (t > 0 && totalLength > 0) {
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = points;
            /*
       * totalLength is set from a ref and is not updated in the first tick of the animation.
       * It defaults to zero which is exactly what we want here because we want to grow from zero,
       * however the same happens when the data change.
       *
       * In that case we want to remember the previous length and continue from there, and only animate the shape.
       *
       * Therefore the totalLength > 0 check.
       *
       * The Animate is about to fire handleAnimationStart which will update the state
       * and cause a re-render and read a new proper totalLength which will be used in the next tick
       * and update the longestAnimatedLengthRef.
       *
       * Why Math.max? Sometimes the curve goes through a smaller length than previously recorded.
       * If we just set it to curLength, then the next animation would start from a smaller length
       * which looks weird. So we keep the longest length ever reached and then animate from there.
       */ // eslint-disable-next-line no-param-reassign
            longestAnimatedLengthRef.current = Math.max(longestAnimatedLengthRef.current, curLength);
        }
        if (prevPoints) {
            var prevPointsDiffFactor = prevPoints.length / points.length;
            var stepData = t === 1 ? points : points.map((entry, index)=>{
                var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                if (prevPoints[prevPointIndex]) {
                    var prev = prevPoints[prevPointIndex];
                    return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, entry), {}, {
                        x: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                        y: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(prev.y, entry.y, t)
                    });
                }
                // magic number of faking previous x and y location
                if (animateNewValues) return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, entry), {}, {
                    x: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(width * 2, entry.x, t),
                    y: (0, $2ab3a7e25c8aba74$export$89e29e4ab65e70a9)(height / 2, entry.y, t)
                });
                return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, entry), {}, {
                    x: entry.x,
                    y: entry.y
                });
            });
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = stepData;
            return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$StaticCurve, {
                props: props,
                points: stepData,
                clipPathId: clipPathId,
                pathRef: pathRef,
                strokeDasharray: currentStrokeDasharray
            });
        }
        return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$StaticCurve, {
            props: props,
            points: points,
            clipPathId: clipPathId,
            pathRef: pathRef,
            strokeDasharray: currentStrokeDasharray
        });
    }), /*#__PURE__*/ $acw62.createElement((0, $88ab0dba0fc78576$export$9a402bc8de2b410e), {
        label: props.label
    }));
}
function $f8a3115883abd1dc$var$RenderCurve(_ref6) {
    var { clipPathId: clipPathId, props: props } = _ref6;
    var previousPointsRef = (0, $acw62.useRef)(null);
    var longestAnimatedLengthRef = (0, $acw62.useRef)(0);
    var pathRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$CurveWithAnimation, {
        props: props,
        clipPathId: clipPathId,
        previousPointsRef: previousPointsRef,
        longestAnimatedLengthRef: longestAnimatedLengthRef,
        pathRef: pathRef
    });
}
var $f8a3115883abd1dc$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    var _dataPoint$x, _dataPoint$y;
    return {
        x: (_dataPoint$x = dataPoint.x) !== null && _dataPoint$x !== void 0 ? _dataPoint$x : undefined,
        y: (_dataPoint$y = dataPoint.y) !== null && _dataPoint$y !== void 0 ? _dataPoint$y : undefined,
        value: dataPoint.value,
        // @ts-expect-error getValueByDataKey does not validate the output type
        errorVal: (0, $cd015374923bb5c7$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
    };
};
// eslint-disable-next-line react/prefer-stateless-function
class $f8a3115883abd1dc$var$LineWithState extends (0, $acw62.Component) {
    render() {
        var { hide: hide, dot: dot, points: points, className: className, xAxisId: xAxisId, yAxisId: yAxisId, top: top, left: left, width: width, height: height, id: id, needClip: needClip, zIndex: zIndex } = this.props;
        if (hide) return null;
        var layerClass = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-line', className);
        var clipPathId = id;
        var { r: r, strokeWidth: strokeWidth } = (0, $fef0b63aa3904588$export$af45be059e20a9dd)(dot);
        var clipDot = (0, $008f02516c156322$export$28c0c718114c1a2e)(dot);
        var dotSize = r * 2 + strokeWidth;
        var activePointsClipPath = needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : undefined;
        return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
            zIndex: zIndex
        }, /*#__PURE__*/ $acw62.createElement((0, $04149ae279e74c50$export$936d0764594b6eb3), {
            className: layerClass
        }, needClip && /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement((0, $dd677892692406d2$export$d65f7a7dd82fbb63), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        }), !clipDot && /*#__PURE__*/ $acw62.createElement("clipPath", {
            id: "clipPath-dots-".concat(clipPathId)
        }, /*#__PURE__*/ $acw62.createElement("rect", {
            x: left - dotSize / 2,
            y: top - dotSize / 2,
            width: width + dotSize,
            height: height + dotSize
        }))), /*#__PURE__*/ $acw62.createElement((0, $f02a6cc200a05058$export$fcd6ba6fb4bc66e7), {
            xAxisId: xAxisId,
            yAxisId: yAxisId,
            data: points,
            dataPointFormatter: $f8a3115883abd1dc$var$errorBarDataPointFormatter,
            errorBarOffset: 0
        }, /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$RenderCurve, {
            props: this.props,
            clipPathId: clipPathId
        }))), /*#__PURE__*/ $acw62.createElement((0, $07378f2fb606b4ec$export$dd2d3dc8acd956aa), {
            activeDot: this.props.activeDot,
            points: points,
            mainColor: this.props.stroke,
            itemDataKey: this.props.dataKey,
            clipPath: activePointsClipPath
        }));
    }
}
var $f8a3115883abd1dc$export$ab40e5efc5c9973f = {
    activeDot: true,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    connectNulls: false,
    dot: true,
    fill: '#fff',
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $c327287477e919da$export$96df16b28aa32702).line,
    type: 'linear'
};
function $f8a3115883abd1dc$var$LineImpl(props) {
    var _resolveDefaultProps = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(props, $f8a3115883abd1dc$export$ab40e5efc5c9973f), { activeDot: activeDot, animateNewValues: animateNewValues, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, connectNulls: connectNulls, dot: dot, hide: hide, isAnimationActive: isAnimationActive, label: label, legendType: legendType, xAxisId: xAxisId, yAxisId: yAxisId, id: id } = _resolveDefaultProps, everythingElse = $f8a3115883abd1dc$var$_objectWithoutProperties(_resolveDefaultProps, $f8a3115883abd1dc$var$_excluded3);
    var { needClip: needClip } = (0, $dd677892692406d2$export$79e142f66441c204)(xAxisId, yAxisId);
    var plotArea = (0, $42890447eb7e6cfe$export$f1ef8efc9ef6fe0c)();
    var layout = (0, $e573f10901a87cfb$export$970c79ecc7081cc)();
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var points = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $7a902e28b5b16ff9$export$3eaebea0f6c183c0)(state, xAxisId, yAxisId, isPanorama, id));
    if (layout !== 'horizontal' && layout !== 'vertical' || points == null || plotArea == null) // Cannot render Line in an unsupported layout
    return null;
    var { height: height, width: width, x: left, y: top } = plotArea;
    return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineWithState, $f8a3115883abd1dc$var$_extends({}, everythingElse, {
        id: id,
        connectNulls: connectNulls,
        dot: dot,
        activeDot: activeDot,
        animateNewValues: animateNewValues,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        hide: hide,
        label: label,
        legendType: legendType,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        points: points,
        layout: layout,
        height: height,
        width: width,
        left: left,
        top: top,
        needClip: needClip
    }));
}
function $f8a3115883abd1dc$export$bfbd9a993cf94d79(_ref7) {
    var { layout: layout, xAxis: xAxis, yAxis: yAxis, xAxisTicks: xAxisTicks, yAxisTicks: yAxisTicks, dataKey: dataKey, bandSize: bandSize, displayedData: displayedData } = _ref7;
    return displayedData.map((entry, index)=>{
        // @ts-expect-error getValueByDataKey does not validate the output type
        var value = (0, $cd015374923bb5c7$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') {
            var _x = (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            });
            var _y = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(value) ? null : yAxis.scale.map(value);
            return {
                x: _x,
                y: _y !== null && _y !== void 0 ? _y : null,
                value: value,
                payload: entry
            };
        }
        var x = (0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(value) ? null : xAxis.scale.map(value);
        var y = (0, $cd015374923bb5c7$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: bandSize,
            entry: entry,
            index: index
        });
        if (x == null || y == null) return null;
        return {
            x: x,
            y: y,
            value: value,
            payload: entry
        };
    }).filter(Boolean);
}
function $f8a3115883abd1dc$var$LineFn(outsideProps) {
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $f8a3115883abd1dc$export$ab40e5efc5c9973f);
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    return /*#__PURE__*/ $acw62.createElement((0, $e0af6fe07417fba6$export$8c2f307ff93f02ba), {
        id: props.id,
        type: "line"
    }, (id)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $8f8fe5838f5f31a4$export$34b61b169492c008), {
            legendPayload: $f8a3115883abd1dc$var$computeLegendPayloadFromAreaData(props)
        }), /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$SetLineTooltipEntrySettings, {
            dataKey: props.dataKey,
            data: props.data,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $acw62.createElement((0, $7e3660a50bf15c81$export$b600bf9c1966a9c2), {
            type: "line",
            id: id,
            data: props.data,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            hide: props.hide,
            isPanorama: isPanorama
        }), /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineImpl, $f8a3115883abd1dc$var$_extends({}, props, {
            id: id
        }))));
}
var $f8a3115883abd1dc$export$17d680238e50603e = /*#__PURE__*/ $acw62.memo($f8a3115883abd1dc$var$LineFn, (0, $83a0fb8931561019$export$b8f09df787c278d9));
$f8a3115883abd1dc$export$17d680238e50603e.displayName = 'Line';


var $acw62 = parcelRequire("acw62");


var $d1341a4ce4753cde$var$allowedTooltipTypes = [
    'axis'
];
var $d1341a4ce4753cde$export$54d0e8420ac838ac = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $b5deaf479b23783f$export$855bb85b2910abc9), {
        chartName: "LineChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $d1341a4ce4753cde$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $886d067545e9f9a0$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");



function $c0a796aac01127ca$var$_extends() {
    return $c0a796aac01127ca$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c0a796aac01127ca$var$_extends.apply(null, arguments);
}
function $c0a796aac01127ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0a796aac01127ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0a796aac01127ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0a796aac01127ca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0a796aac01127ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0a796aac01127ca$var$_defineProperty(e, r, t) {
    return (r = $c0a796aac01127ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c0a796aac01127ca$var$_toPropertyKey(t) {
    var i = $c0a796aac01127ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c0a796aac01127ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c0a796aac01127ca$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(value[0]) && (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $c0a796aac01127ca$export$b002681d77efe9ac = {
    separator: ' : ',
    contentStyle: {
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    },
    itemStyle: {
        display: 'block',
        paddingTop: 4,
        paddingBottom: 4,
        color: '#000'
    },
    labelStyle: {},
    accessibilityLayer: false
};
var $c0a796aac01127ca$export$6fe33945eebf9ac8 = (props)=>{
    var { separator: separator = $c0a796aac01127ca$export$b002681d77efe9ac.separator, contentStyle: contentStyle, itemStyle: itemStyle, labelStyle: labelStyle = $c0a796aac01127ca$export$b002681d77efe9ac.labelStyle, payload: payload, formatter: formatter, itemSorter: itemSorter, wrapperClassName: wrapperClassName, labelClassName: labelClassName, label: label, labelFormatter: labelFormatter, accessibilityLayer: accessibilityLayer = $c0a796aac01127ca$export$b002681d77efe9ac.accessibilityLayer } = props;
    var renderContent = ()=>{
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($f89f7c674aff322e$exports)))(payload, itemSorter) : payload).map((entry, i)=>{
                if (entry.type === 'none') return null;
                var finalFormatter = entry.formatter || formatter || $c0a796aac01127ca$var$defaultFormatter;
                var { value: value, name: name } = entry;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) [finalValue, finalName] = formatted;
                    else if (formatted != null) finalValue = formatted;
                    else return null;
                }
                var finalItemStyle = $c0a796aac01127ca$var$_objectSpread($c0a796aac01127ca$var$_objectSpread({}, $c0a796aac01127ca$export$b002681d77efe9ac.itemStyle), {}, {
                    color: entry.color || $c0a796aac01127ca$export$b002681d77efe9ac.itemStyle.color
                }, itemStyle);
                return /*#__PURE__*/ $acw62.createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $2ab3a7e25c8aba74$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || ''));
            });
            return /*#__PURE__*/ $acw62.createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $c0a796aac01127ca$var$_objectSpread($c0a796aac01127ca$var$_objectSpread({}, $c0a796aac01127ca$export$b002681d77efe9ac.contentStyle), contentStyle);
    var finalLabelStyle = $c0a796aac01127ca$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, $2ab3a7e25c8aba74$export$b931b78cbb3caf86)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ $acw62.createElement("div", $c0a796aac01127ca$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ $acw62.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ $acw62.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $acw62 = parcelRequire("acw62");


var $32b135afcb061cab$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $32b135afcb061cab$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $32b135afcb061cab$export$46aee7ef09f78756(_ref) {
    var { coordinate: coordinate, translateX: translateX, translateY: translateY } = _ref;
    return (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)($32b135afcb061cab$var$CSS_CLASS_PREFIX, {
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-right")]: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateX) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x,
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-left")]: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateX) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x,
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-bottom")]: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateY) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y,
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-top")]: (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(translateY) && coordinate && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y
    });
}
function $32b135afcb061cab$export$4cccba03fe0eccc6(_ref2) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, key: key, offset: offset, position: position, reverseDirection: reverseDirection, tooltipDimension: tooltipDimension, viewBox: viewBox, viewBoxDimension: viewBoxDimension } = _ref2;
    if (position && (0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - (offset > 0 ? offset : 0);
    var positive = coordinate[key] + offset;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    var viewBoxKey = viewBox[key];
    if (viewBoxKey == null) return 0;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBoxKey;
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBoxKey);
        return Math.max(negative, viewBoxKey);
    }
    if (viewBoxDimension == null) return 0;
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBoxKey + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBoxKey);
    return Math.max(positive, viewBoxKey);
}
function $32b135afcb061cab$export$4fe0982879780f9b(_ref3) {
    var { translateX: translateX, translateY: translateY, useTranslate3d: useTranslate3d } = _ref3;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $32b135afcb061cab$export$25e3b0ae21503056(_ref4) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, offsetTop: offsetTop, offsetLeft: offsetLeft, position: position, reverseDirection: reverseDirection, tooltipBox: tooltipBox, useTranslate3d: useTranslate3d, viewBox: viewBox } = _ref4;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offset: offsetLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offset: offsetTop,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $32b135afcb061cab$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $32b135afcb061cab$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $32b135afcb061cab$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $2a173c9072cdf4ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a173c9072cdf4ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a173c9072cdf4ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a173c9072cdf4ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a173c9072cdf4ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a173c9072cdf4ec$var$_defineProperty(e, r, t) {
    return (r = $2a173c9072cdf4ec$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2a173c9072cdf4ec$var$_toPropertyKey(t) {
    var i = $2a173c9072cdf4ec$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2a173c9072cdf4ec$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $2a173c9072cdf4ec$export$9e6cee7b86551b9c extends (0, $acw62.PureComponent) {
    constructor(){
        super(...arguments);
        $2a173c9072cdf4ec$var$_defineProperty(this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        $2a173c9072cdf4ec$var$_defineProperty(this, "handleKeyDown", (event)=>{
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    componentDidUpdate() {
        var _this$props$coordinat5, _this$props$coordinat6;
        if (!this.state.dismissed) return;
        if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
    }
    render() {
        var { active: active, allowEscapeViewBox: allowEscapeViewBox, animationDuration: animationDuration, animationEasing: animationEasing, children: children, coordinate: coordinate, hasPayload: hasPayload, isAnimationActive: isAnimationActive, offset: offset, position: position, reverseDirection: reverseDirection, useTranslate3d: useTranslate3d, viewBox: viewBox, wrapperStyle: wrapperStyle, lastBoundingBox: lastBoundingBox, innerRef: innerRef, hasPortalFromProps: hasPortalFromProps } = this.props;
        var offsetLeft = typeof offset === 'number' ? offset : offset.x;
        var offsetTop = typeof offset === 'number' ? offset : offset.y;
        var { cssClasses: cssClasses, cssProperties: cssProperties } = (0, $32b135afcb061cab$export$25e3b0ae21503056)({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            offsetLeft: offsetLeft,
            offsetTop: offsetTop,
            position: position,
            reverseDirection: reverseDirection,
            tooltipBox: {
                height: lastBoundingBox.height,
                width: lastBoundingBox.width
            },
            useTranslate3d: useTranslate3d,
            viewBox: viewBox
        });
        // do not use absolute styles if the user has passed a custom portal prop
        var positionStyles = hasPortalFromProps ? {} : $2a173c9072cdf4ec$var$_objectSpread($2a173c9072cdf4ec$var$_objectSpread({
            transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
        }, cssProperties), {}, {
            pointerEvents: 'none',
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
            position: 'absolute',
            top: 0,
            left: 0
        });
        var outerStyle = $2a173c9072cdf4ec$var$_objectSpread($2a173c9072cdf4ec$var$_objectSpread({}, positionStyles), {}, {
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden'
        }, wrapperStyle);
        return(/*#__PURE__*/ // This element allow listening to the `Escape` key. See https://github.com/recharts/recharts/pull/2925
        $acw62.createElement("div", {
            // @ts-expect-error typescript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
            xmlns: "http://www.w3.org/1999/xhtml",
            tabIndex: -1,
            className: cssClasses,
            style: outerStyle,
            ref: innerRef
        }, children));
    }
}







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



var $2ae8a72d4579aba0$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $2ae8a72d4579aba0$var$_extends() {
    return $2ae8a72d4579aba0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2ae8a72d4579aba0$var$_extends.apply(null, arguments);
}
function $2ae8a72d4579aba0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ae8a72d4579aba0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ae8a72d4579aba0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ae8a72d4579aba0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ae8a72d4579aba0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ae8a72d4579aba0$var$_defineProperty(e, r, t) {
    return (r = $2ae8a72d4579aba0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2ae8a72d4579aba0$var$_toPropertyKey(t) {
    var i = $2ae8a72d4579aba0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2ae8a72d4579aba0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2ae8a72d4579aba0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2ae8a72d4579aba0$var$getPath = (x, y, width, height, top, left)=>{
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $2ae8a72d4579aba0$export$3c877bb842c36952 = (_ref)=>{
    var { x: x = 0, y: y = 0, top: top = 0, left: left = 0, width: width = 0, height: height = 0, className: className } = _ref, rest = $2ae8a72d4579aba0$var$_objectWithoutProperties(_ref, $2ae8a72d4579aba0$var$_excluded);
    var props = $2ae8a72d4579aba0$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(x) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(y) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(width) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(height) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(top) || !(0, $2ab3a7e25c8aba74$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ $acw62.createElement("path", $2ae8a72d4579aba0$var$_extends({}, (0, $fefe4263beb558e0$export$67f8fc03e57e2747)(props), {
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-cross', className),
        d: $2ae8a72d4579aba0$var$getPath(x, y, width, height, top, left)
    }));
};


function $f95663c86cd8230d$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $2f00d3350e823531$export$ad661ef85a042a4f(activeCoordinate) {
    var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = activeCoordinate;
    var startPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}






function $747acf019ef7786e$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    if (layout === 'horizontal') return [
        {
            x: activeCoordinate.x,
            y: offset.top
        },
        {
            x: activeCoordinate.x,
            y: offset.top + offset.height
        }
    ];
    if (layout === 'vertical') return [
        {
            x: offset.left,
            y: activeCoordinate.y
        },
        {
            x: offset.left + offset.width,
            y: activeCoordinate.y
        }
    ];
    if ((0, $909d5f835f4e917b$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        if (layout === 'centric') {
            var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, angle: angle } = activeCoordinate;
            var innerPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $0f9bc5dd76ad1109$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            return [
                {
                    x: innerPoint.x,
                    y: innerPoint.y
                },
                {
                    x: outerPoint.x,
                    y: outerPoint.y
                }
            ];
        }
        return (0, $2f00d3350e823531$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return undefined;
}







function $2d1a122fcf18b245$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d1a122fcf18b245$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d1a122fcf18b245$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2d1a122fcf18b245$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d1a122fcf18b245$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2d1a122fcf18b245$var$_defineProperty(e, r, t) {
    return (r = $2d1a122fcf18b245$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2d1a122fcf18b245$var$_toPropertyKey(t) {
    var i = $2d1a122fcf18b245$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2d1a122fcf18b245$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2d1a122fcf18b245$export$952de9be87065336 = ()=>(0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $6aac8fe27ae10a7b$export$27d9004292294cd7));
var $2d1a122fcf18b245$export$fd17f57c33e9d17e = ()=>{
    var tooltipAxis = $2d1a122fcf18b245$export$952de9be87065336();
    var tooltipTicks = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a));
    var tooltipAxisScale = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $51c6a3a12cea9b0d$export$cdeccbbdd343ae59));
    if (!tooltipAxis || !tooltipAxisScale) return (0, $cd015374923bb5c7$export$212ec45c42fe68a7)(undefined, tooltipTicks);
    return (0, $cd015374923bb5c7$export$212ec45c42fe68a7)($2d1a122fcf18b245$var$_objectSpread($2d1a122fcf18b245$var$_objectSpread({}, tooltipAxis), {}, {
        scale: tooltipAxisScale
    }), tooltipTicks);
};






function $d690e81478a10d12$var$_extends() {
    return $d690e81478a10d12$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d690e81478a10d12$var$_extends.apply(null, arguments);
}
function $d690e81478a10d12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d690e81478a10d12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d690e81478a10d12$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d690e81478a10d12$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d690e81478a10d12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d690e81478a10d12$var$_defineProperty(e, r, t) {
    return (r = $d690e81478a10d12$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d690e81478a10d12$var$_toPropertyKey(t) {
    var i = $d690e81478a10d12$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d690e81478a10d12$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * If set false, no cursor will be drawn when tooltip is active.
 * If set an object, the option is the configuration of cursor.
 * If set a React element, the option is the custom react element of drawing cursor
 */ function $d690e81478a10d12$var$RenderCursor(_ref) {
    var { cursor: cursor, cursorComp: cursorComp, cursorProps: cursorProps } = _ref;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(cursor)) return /*#__PURE__*/ (0, $acw62.cloneElement)(cursor, cursorProps);
    return /*#__PURE__*/ (0, $acw62.createElement)(cursorComp, cursorProps);
}
function $d690e81478a10d12$export$3ea3a57cbaeb6b4e(props) {
    var _props$zIndex;
    var { coordinate: coordinate, payload: payload, index: index, offset: offset, tooltipAxisBandSize: tooltipAxisBandSize, layout: layout, cursor: cursor, tooltipEventType: tooltipEventType, chartName: chartName } = props;
    // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
    var activeCoordinate = coordinate;
    var activePayload = payload;
    var activeTooltipIndex = index;
    if (!cursor || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps, cursorComp, preferredZIndex;
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $2ae8a72d4579aba0$export$3c877bb842c36952);
        preferredZIndex = (0, $c327287477e919da$export$96df16b28aa32702).cursorLine;
    } else if (chartName === 'BarChart') {
        restProps = (0, $f95663c86cd8230d$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $70f75e095c9bb92d$export$4617fb02663045ef);
        preferredZIndex = (0, $c327287477e919da$export$96df16b28aa32702).cursorRectangle;
    } else if (layout === 'radial' && (0, $909d5f835f4e917b$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = (0, $2f00d3350e823531$export$ad661ef85a042a4f)(activeCoordinate);
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $353ca4069312fa59$export$e98c2c7eb2b14f45);
        preferredZIndex = (0, $c327287477e919da$export$96df16b28aa32702).cursorLine;
    } else {
        restProps = {
            points: (0, $747acf019ef7786e$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $af2055905739b7f2$export$b0e83c3ef8d2db1);
        preferredZIndex = (0, $c327287477e919da$export$96df16b28aa32702).cursorLine;
    }
    var extraClassName = typeof cursor === 'object' && 'className' in cursor ? cursor.className : undefined;
    var cursorProps = $d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $37a0b0a95f0e25bf$export$6d5921c09aa671a9)(cursor)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)('recharts-tooltip-cursor', extraClassName)
    });
    return /*#__PURE__*/ $acw62.createElement((0, $8de5347dd9805c3d$export$b37befaf92aba9f1), {
        zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : preferredZIndex
    }, /*#__PURE__*/ $acw62.createElement($d690e81478a10d12$var$RenderCursor, {
        cursor: cursor,
        cursorComp: cursorComp,
        cursorProps: cursorProps
    }));
}
function $d690e81478a10d12$export$b6a79797ad180576(props) {
    var tooltipAxisBandSize = (0, $2d1a122fcf18b245$export$fd17f57c33e9d17e)();
    var offset = (0, $e573f10901a87cfb$export$10605f61bef2858a)();
    var layout = (0, $e573f10901a87cfb$export$970c79ecc7081cc)();
    var chartName = (0, $5211e0f48c9883fe$export$ed30b3372172c46c)();
    if (tooltipAxisBandSize == null || offset == null || layout == null || chartName == null) return null;
    return /*#__PURE__*/ $acw62.createElement($d690e81478a10d12$export$3ea3a57cbaeb6b4e, $d690e81478a10d12$var$_extends({}, props, {
        offset: offset,
        layout: layout,
        tooltipAxisBandSize: tooltipAxisBandSize,
        chartName: chartName
    }));
}









function $3258e2bab55a6a07$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3258e2bab55a6a07$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3258e2bab55a6a07$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3258e2bab55a6a07$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3258e2bab55a6a07$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3258e2bab55a6a07$var$_defineProperty(e, r, t) {
    return (r = $3258e2bab55a6a07$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3258e2bab55a6a07$var$_toPropertyKey(t) {
    var i = $3258e2bab55a6a07$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3258e2bab55a6a07$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3258e2bab55a6a07$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $3258e2bab55a6a07$var$renderContent(content, props) {
    if (/*#__PURE__*/ $acw62.isValidElement(content)) return /*#__PURE__*/ $acw62.cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ $acw62.createElement(content, props);
    return /*#__PURE__*/ $acw62.createElement((0, $c0a796aac01127ca$export$6fe33945eebf9ac8), props);
}
var $3258e2bab55a6a07$var$emptyPayload = [];
var $3258e2bab55a6a07$export$3e858c907a5012de = {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    axisId: 0,
    contentStyle: {},
    cursor: true,
    filterNull: true,
    includeHidden: false,
    isAnimationActive: 'auto',
    itemSorter: 'name',
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    wrapperStyle: {}
};
function $3258e2bab55a6a07$export$28c660c63b792dea(outsideProps) {
    var _useAppSelector, _ref;
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $3258e2bab55a6a07$export$3e858c907a5012de);
    var { active: activeFromProps, allowEscapeViewBox: allowEscapeViewBox, animationDuration: animationDuration, animationEasing: animationEasing, content: content, filterNull: filterNull, isAnimationActive: isAnimationActive, offset: offset, payloadUniqBy: payloadUniqBy, position: position, reverseDirection: reverseDirection, useTranslate3d: useTranslate3d, wrapperStyle: wrapperStyle, cursor: cursor, shared: shared, trigger: trigger, defaultIndex: defaultIndex, portal: portalFromProps, axisId: axisId } = props;
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var defaultIndexAsString = typeof defaultIndex === 'number' ? String(defaultIndex) : defaultIndex;
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $3be7536b77e1512b$export$8d517a53c4528750)({
            shared: shared,
            trigger: trigger,
            axisId: axisId,
            active: activeFromProps,
            defaultIndex: defaultIndexAsString
        }));
    }, [
        dispatch,
        shared,
        trigger,
        axisId,
        activeFromProps,
        defaultIndexAsString
    ]);
    var viewBox = (0, $e573f10901a87cfb$export$76b29bb074e0c45a)();
    var accessibilityLayer = (0, $58e3484536fdae50$export$276788f18f24cad3)();
    var tooltipEventType = (0, $21536fb21082ce97$export$7ac1fe18a92be318)(shared);
    var { activeIndex: activeIndex, isActive: isActive } = (_useAppSelector = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $5211e0f48c9883fe$export$c8884ed37796034a)(state, tooltipEventType, trigger, defaultIndexAsString))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {};
    var payloadFromRedux = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $5211e0f48c9883fe$export$529676bfdba08611)(state, tooltipEventType, trigger, defaultIndexAsString));
    var labelFromRedux = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $5211e0f48c9883fe$export$400c35cc3b9a0487)(state, tooltipEventType, trigger, defaultIndexAsString));
    var coordinate = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $5211e0f48c9883fe$export$392a0083df9bfd7c)(state, tooltipEventType, trigger, defaultIndexAsString));
    var payload = payloadFromRedux;
    var tooltipPortalFromContext = (0, $7e46a321e54335ab$export$2842d70d9d62127a)();
    /*
   * The user can set `active=true` on the Tooltip in which case the Tooltip will stay always active,
   * or `active=false` in which case the Tooltip never shows.
   *
   * If the `active` prop is not defined then it will show and hide based on mouse or keyboard activity.
   */ var finalIsActive = (_ref = activeFromProps !== null && activeFromProps !== void 0 ? activeFromProps : isActive) !== null && _ref !== void 0 ? _ref : false;
    var [lastBoundingBox, updateBoundingBox] = (0, $5df7cd4fc39ce268$export$35f58fcda6094144)([
        payload,
        finalIsActive
    ]);
    var finalLabel = tooltipEventType === 'axis' ? labelFromRedux : undefined;
    (0, $ab88b765f694b562$export$21f8394fb189b529)(tooltipEventType, trigger, coordinate, finalLabel, activeIndex, finalIsActive);
    var tooltipPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : tooltipPortalFromContext;
    if (tooltipPortal == null || viewBox == null || tooltipEventType == null) return null;
    var finalPayload = payload !== null && payload !== void 0 ? payload : $3258e2bab55a6a07$var$emptyPayload;
    if (!finalIsActive) finalPayload = $3258e2bab55a6a07$var$emptyPayload;
    if (filterNull && finalPayload.length) finalPayload = (0, $12cc16c3e91089ee$export$b67e33c2fb1535fa)(finalPayload.filter((entry)=>entry.value != null && (entry.hide !== true || props.includeHidden)), payloadUniqBy, $3258e2bab55a6a07$var$defaultUniqBy);
    var hasPayload = finalPayload.length > 0;
    var tooltipElement = /*#__PURE__*/ $acw62.createElement((0, $2a173c9072cdf4ec$export$9e6cee7b86551b9c), {
        allowEscapeViewBox: allowEscapeViewBox,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        active: finalIsActive,
        coordinate: coordinate,
        hasPayload: hasPayload,
        offset: offset,
        position: position,
        reverseDirection: reverseDirection,
        useTranslate3d: useTranslate3d,
        viewBox: viewBox,
        wrapperStyle: wrapperStyle,
        lastBoundingBox: lastBoundingBox,
        innerRef: updateBoundingBox,
        hasPortalFromProps: Boolean(portalFromProps)
    }, $3258e2bab55a6a07$var$renderContent(content, $3258e2bab55a6a07$var$_objectSpread($3258e2bab55a6a07$var$_objectSpread({}, props), {}, {
        payload: finalPayload,
        label: finalLabel,
        active: finalIsActive,
        activeIndex: activeIndex,
        coordinate: coordinate,
        accessibilityLayer: accessibilityLayer
    })));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ (0, $1u0KT.createPortal)(tooltipElement, tooltipPortal), finalIsActive && /*#__PURE__*/ $acw62.createElement((0, $d690e81478a10d12$export$b6a79797ad180576), {
        cursor: cursor,
        tooltipEventType: tooltipEventType,
        coordinate: coordinate,
        payload: finalPayload,
        index: activeIndex
    }));
}


var $acw62 = parcelRequire("acw62");









var $baa910eb7a58f9d8$var$_excluded = [
    "domain",
    "range"
], $baa910eb7a58f9d8$var$_excluded2 = [
    "domain",
    "range"
];
function $baa910eb7a58f9d8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $baa910eb7a58f9d8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $baa910eb7a58f9d8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $baa910eb7a58f9d8$var$shortArraysAreEqual(arr1, arr2) {
    if (arr1 === arr2) return true;
    if (Array.isArray(arr1) && arr1.length === 2 && Array.isArray(arr2) && arr2.length === 2) return arr1[0] === arr2[0] && arr1[1] === arr2[1];
    return false;
}
function $baa910eb7a58f9d8$export$a803260e379f3736(prevProps, nextProps) {
    if (prevProps === nextProps) return true;
    var { domain: prevDomain, range: prevRange } = prevProps, prevRest = $baa910eb7a58f9d8$var$_objectWithoutProperties(prevProps, $baa910eb7a58f9d8$var$_excluded);
    var { domain: nextDomain, range: nextRange } = nextProps, nextRest = $baa910eb7a58f9d8$var$_objectWithoutProperties(nextProps, $baa910eb7a58f9d8$var$_excluded2);
    if (!$baa910eb7a58f9d8$var$shortArraysAreEqual(prevDomain, nextDomain)) return false;
    if (!$baa910eb7a58f9d8$var$shortArraysAreEqual(prevRange, nextRange)) return false;
    return (0, $83a0fb8931561019$export$b8f09df787c278d9)(prevRest, nextRest);
}




var $f21953d5ea7d4fb8$var$_excluded = [
    "type"
], $f21953d5ea7d4fb8$var$_excluded2 = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $f21953d5ea7d4fb8$var$_excluded3 = [
    "id",
    "scale"
];
function $f21953d5ea7d4fb8$var$_extends() {
    return $f21953d5ea7d4fb8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f21953d5ea7d4fb8$var$_extends.apply(null, arguments);
}
function $f21953d5ea7d4fb8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f21953d5ea7d4fb8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f21953d5ea7d4fb8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f21953d5ea7d4fb8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f21953d5ea7d4fb8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f21953d5ea7d4fb8$var$_defineProperty(e, r, t) {
    return (r = $f21953d5ea7d4fb8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f21953d5ea7d4fb8$var$_toPropertyKey(t) {
    var i = $f21953d5ea7d4fb8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f21953d5ea7d4fb8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f21953d5ea7d4fb8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f21953d5ea7d4fb8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f21953d5ea7d4fb8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $f21953d5ea7d4fb8$var$SetXAxisSettings(props) {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $acw62.useRef)(null);
    var layout = (0, $e573f10901a87cfb$export$c9942bdfc7f2781c)();
    var { type: typeFromProps } = props, restProps = $f21953d5ea7d4fb8$var$_objectWithoutProperties(props, $f21953d5ea7d4fb8$var$_excluded);
    var evaluatedType = (0, $ec27de6f1bfb1a1f$export$c71ab14baba33626)(layout, 'xAxis', typeFromProps);
    var settings = (0, $acw62.useMemo)(()=>{
        if (evaluatedType == null) return undefined;
        return $f21953d5ea7d4fb8$var$_objectSpread($f21953d5ea7d4fb8$var$_objectSpread({}, restProps), {}, {
            type: evaluatedType
        });
    }, [
        restProps,
        evaluatedType
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (settings == null) return;
        if (prevSettingsRef.current === null) dispatch((0, $177f608375879b5a$export$add6226ad7812fc8)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $177f608375879b5a$export$40aac341c282a543)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $177f608375879b5a$export$f408189458c6a79b)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var $f21953d5ea7d4fb8$var$XAxisImpl = (props)=>{
    var { xAxisId: xAxisId, className: className } = props;
    var viewBox = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $f90bc049d1e95f26$export$32c8e778bac69ce4));
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var axisType = 'xAxis';
    var cartesianTickItems = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$f0d85e8287c47657)(state, axisType, xAxisId, isPanorama));
    var axisSize = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$50d4085c87c19b12)(state, xAxisId));
    var position = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$92fdc590d2371053)(state, xAxisId));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$8079b33b4a6a2ac5)(state, xAxisId));
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks, scale: del } = props, allOtherProps = $f21953d5ea7d4fb8$var$_objectWithoutProperties(props, $f21953d5ea7d4fb8$var$_excluded2);
    var { id: id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = $f21953d5ea7d4fb8$var$_objectWithoutProperties(synchronizedSettings, $f21953d5ea7d4fb8$var$_excluded3);
    return /*#__PURE__*/ $acw62.createElement((0, $247385db510d7b7c$export$bdd99f2cdf352bae), $f21953d5ea7d4fb8$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        x: position.x,
        y: position.y,
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
};
var $f21953d5ea7d4fb8$export$bf921d6fd02045a0 = {
    allowDataOverflow: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).allowDataOverflow,
    allowDecimals: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).allowDecimals,
    allowDuplicatedCategory: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).allowDuplicatedCategory,
    angle: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).angle,
    axisLine: (0, $247385db510d7b7c$export$179c35154a9748c0).axisLine,
    height: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).height,
    hide: false,
    includeHidden: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).includeHidden,
    interval: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).interval,
    label: false,
    minTickGap: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).minTickGap,
    mirror: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).mirror,
    orientation: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).orientation,
    padding: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).padding,
    reversed: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).reversed,
    scale: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).scale,
    tick: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).tick,
    tickCount: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).tickCount,
    tickLine: (0, $247385db510d7b7c$export$179c35154a9748c0).tickLine,
    tickSize: (0, $247385db510d7b7c$export$179c35154a9748c0).tickSize,
    type: (0, $6aac8fe27ae10a7b$export$21aec091b6ac8422).type,
    xAxisId: 0
};
var $f21953d5ea7d4fb8$var$XAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $f21953d5ea7d4fb8$export$bf921d6fd02045a0);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($f21953d5ea7d4fb8$var$SetXAxisSettings, {
        allowDataOverflow: props.allowDataOverflow,
        allowDecimals: props.allowDecimals,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        angle: props.angle,
        dataKey: props.dataKey,
        domain: props.domain,
        height: props.height,
        hide: props.hide,
        id: props.xAxisId,
        includeHidden: props.includeHidden,
        interval: props.interval,
        minTickGap: props.minTickGap,
        mirror: props.mirror,
        name: props.name,
        orientation: props.orientation,
        padding: props.padding,
        reversed: props.reversed,
        scale: props.scale,
        tick: props.tick,
        tickCount: props.tickCount,
        tickFormatter: props.tickFormatter,
        ticks: props.ticks,
        type: props.type,
        unit: props.unit
    }), /*#__PURE__*/ $acw62.createElement($f21953d5ea7d4fb8$var$XAxisImpl, props));
};
var $f21953d5ea7d4fb8$export$ea77231de273b52d = /*#__PURE__*/ $acw62.memo($f21953d5ea7d4fb8$var$XAxisSettingsDispatcher, (0, $baa910eb7a58f9d8$export$a803260e379f3736));
$f21953d5ea7d4fb8$export$ea77231de273b52d.displayName = 'XAxis';


var $acw62 = parcelRequire("acw62");












var $0e2dfd8b3bfb4506$var$_excluded = [
    "type"
], $0e2dfd8b3bfb4506$var$_excluded2 = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $0e2dfd8b3bfb4506$var$_excluded3 = [
    "id",
    "scale"
];
function $0e2dfd8b3bfb4506$var$_extends() {
    return $0e2dfd8b3bfb4506$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e2dfd8b3bfb4506$var$_extends.apply(null, arguments);
}
function $0e2dfd8b3bfb4506$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e2dfd8b3bfb4506$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e2dfd8b3bfb4506$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0e2dfd8b3bfb4506$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e2dfd8b3bfb4506$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e2dfd8b3bfb4506$var$_defineProperty(e, r, t) {
    return (r = $0e2dfd8b3bfb4506$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0e2dfd8b3bfb4506$var$_toPropertyKey(t) {
    var i = $0e2dfd8b3bfb4506$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0e2dfd8b3bfb4506$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0e2dfd8b3bfb4506$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0e2dfd8b3bfb4506$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0e2dfd8b3bfb4506$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0e2dfd8b3bfb4506$var$SetYAxisSettings(props) {
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $acw62.useRef)(null);
    var layout = (0, $e573f10901a87cfb$export$c9942bdfc7f2781c)();
    var { type: typeFromProps } = props, restProps = $0e2dfd8b3bfb4506$var$_objectWithoutProperties(props, $0e2dfd8b3bfb4506$var$_excluded);
    var evaluatedType = (0, $ec27de6f1bfb1a1f$export$c71ab14baba33626)(layout, 'yAxis', typeFromProps);
    var settings = (0, $acw62.useMemo)(()=>{
        if (evaluatedType == null) return undefined;
        return $0e2dfd8b3bfb4506$var$_objectSpread($0e2dfd8b3bfb4506$var$_objectSpread({}, restProps), {}, {
            type: evaluatedType
        });
    }, [
        evaluatedType,
        restProps
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (settings == null) return;
        if (prevSettingsRef.current === null) dispatch((0, $177f608375879b5a$export$4ed10a19d7febea1)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $177f608375879b5a$export$58b7fa4a7d4572f6)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $177f608375879b5a$export$79db5e9bd25f14c4)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $0e2dfd8b3bfb4506$var$YAxisImpl(props) {
    var { yAxisId: yAxisId, className: className, width: width, label: label } = props;
    var cartesianAxisRef = (0, $acw62.useRef)(null);
    var labelRef = (0, $acw62.useRef)(null);
    var viewBox = (0, $8512ea9be24774fb$export$a7347740d65f620b)((0, $f90bc049d1e95f26$export$32c8e778bac69ce4));
    var isPanorama = (0, $2e0e14143329e31b$export$4b0c59f8845ba920)();
    var dispatch = (0, $8512ea9be24774fb$export$f51d452c10d5b956)();
    var axisType = 'yAxis';
    var axisSize = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$249bec756af8ac39)(state, yAxisId));
    var position = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$e67a320452ebcaef)(state, yAxisId));
    var cartesianTickItems = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$f0d85e8287c47657)(state, axisType, yAxisId, isPanorama));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $8512ea9be24774fb$export$a7347740d65f620b)((state)=>(0, $6aac8fe27ae10a7b$export$d0970661da76c14c)(state, yAxisId));
    (0, $acw62.useLayoutEffect)(()=>{
        // No dynamic width calculation is done when width !== 'auto'
        // or when a function/react element is used for label
        if (width !== 'auto' || !axisSize || (0, $77be8884b5ec622c$export$96a48941c06f377f)(label) || /*#__PURE__*/ (0, $acw62.isValidElement)(label) || synchronizedSettings == null) return;
        var axisComponent = cartesianAxisRef.current;
        if (!axisComponent) return;
        var updatedYAxisWidth = axisComponent.getCalculatedWidth();
        // if the width has changed, dispatch an action to update the width
        if (Math.round(axisSize.width) !== Math.round(updatedYAxisWidth)) dispatch((0, $177f608375879b5a$export$6e42dbbf4e5a5faa)({
            id: yAxisId,
            width: updatedYAxisWidth
        }));
    }, [
        // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
        // The ref will be populated by then.
        // To re-run this effect when ticks change, we can depend on the ticks array from the store.
        cartesianTickItems,
        axisSize,
        dispatch,
        label,
        yAxisId,
        width,
        synchronizedSettings
    ]);
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks, scale: del } = props, allOtherProps = $0e2dfd8b3bfb4506$var$_objectWithoutProperties(props, $0e2dfd8b3bfb4506$var$_excluded2);
    var { id: id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = $0e2dfd8b3bfb4506$var$_objectWithoutProperties(synchronizedSettings, $0e2dfd8b3bfb4506$var$_excluded3);
    return /*#__PURE__*/ $acw62.createElement((0, $247385db510d7b7c$export$bdd99f2cdf352bae), $0e2dfd8b3bfb4506$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        ref: cartesianAxisRef,
        labelRef: labelRef,
        x: position.x,
        y: position.y,
        tickTextProps: width === 'auto' ? {
            width: undefined
        } : {
            width: width
        },
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
}
var $0e2dfd8b3bfb4506$export$299ffbfed5267dce = {
    allowDataOverflow: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).allowDataOverflow,
    allowDecimals: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).allowDecimals,
    allowDuplicatedCategory: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).allowDuplicatedCategory,
    angle: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).angle,
    axisLine: (0, $247385db510d7b7c$export$179c35154a9748c0).axisLine,
    hide: false,
    includeHidden: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).includeHidden,
    interval: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).interval,
    label: false,
    minTickGap: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).minTickGap,
    mirror: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).mirror,
    orientation: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).orientation,
    padding: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).padding,
    reversed: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).reversed,
    scale: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).scale,
    tick: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).tick,
    tickCount: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).tickCount,
    tickLine: (0, $247385db510d7b7c$export$179c35154a9748c0).tickLine,
    tickSize: (0, $247385db510d7b7c$export$179c35154a9748c0).tickSize,
    type: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).type,
    width: (0, $6aac8fe27ae10a7b$export$397148de2ecdec3c).width,
    yAxisId: 0
};
var $0e2dfd8b3bfb4506$var$YAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $8e3e05537b79f9d5$export$45004cc70a390ee8)(outsideProps, $0e2dfd8b3bfb4506$export$299ffbfed5267dce);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0e2dfd8b3bfb4506$var$SetYAxisSettings, {
        interval: props.interval,
        id: props.yAxisId,
        scale: props.scale,
        type: props.type,
        domain: props.domain,
        allowDataOverflow: props.allowDataOverflow,
        dataKey: props.dataKey,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        allowDecimals: props.allowDecimals,
        tickCount: props.tickCount,
        padding: props.padding,
        includeHidden: props.includeHidden,
        reversed: props.reversed,
        ticks: props.ticks,
        width: props.width,
        orientation: props.orientation,
        mirror: props.mirror,
        hide: props.hide,
        unit: props.unit,
        name: props.name,
        angle: props.angle,
        minTickGap: props.minTickGap,
        tick: props.tick,
        tickFormatter: props.tickFormatter
    }), /*#__PURE__*/ $acw62.createElement($0e2dfd8b3bfb4506$var$YAxisImpl, props));
};
var $0e2dfd8b3bfb4506$export$f96c4024c52de8f4 = /*#__PURE__*/ $acw62.memo($0e2dfd8b3bfb4506$var$YAxisSettingsDispatcher, (0, $baa910eb7a58f9d8$export$a803260e379f3736));
$0e2dfd8b3bfb4506$export$f96c4024c52de8f4.displayName = 'YAxis';


// ─── RAW DATA ────────────────────────────────────────────────────────────────
const $681acae7fda8566f$var$RAW_POLLS = [
    {
        poll: "MDW Communications",
        date: "2025-06-15",
        candidates: {
            "Kat Abughazaleh": 10,
            "Bushra Amiwala": 2,
            "Daniel Biss": 17,
            "Laura Fine": 8,
            "Hoan Huynh": 0,
            "Mike Simmons": 0,
            "Phil Andrew": 0,
            Undecided: 53
        }
    },
    {
        poll: "MDW Communications",
        date: "2025-10-16",
        candidates: {
            "Kat Abughazaleh": 13,
            "Bushra Amiwala": 2,
            "Daniel Biss": 18,
            "Laura Fine": 9,
            "Hoan Huynh": 0,
            "Mike Simmons": 0,
            "Phil Andrew": 0,
            Undecided: 48
        }
    },
    {
        poll: "Data for Progress",
        date: "2025-11-03",
        candidates: {
            "Kat Abughazaleh": 18,
            "Bushra Amiwala": 6,
            "Daniel Biss": 18,
            "Laura Fine": 10,
            "Hoan Huynh": 0,
            "Mike Simmons": 6,
            "Phil Andrew": 0,
            Undecided: 31
        }
    },
    {
        poll: "Impact Research",
        date: "2025-11-09",
        candidates: {
            "Kat Abughazaleh": 17,
            "Bushra Amiwala": 3,
            "Daniel Biss": 31,
            "Laura Fine": 10,
            "Hoan Huynh": 4,
            "Mike Simmons": 6,
            "Phil Andrew": 3,
            Undecided: 21
        }
    },
    {
        poll: "GBAO Strategies",
        date: "2026-01-29",
        candidates: {
            "Kat Abughazaleh": 14,
            "Bushra Amiwala": 4,
            "Daniel Biss": 21,
            "Laura Fine": 21,
            "Hoan Huynh": 2,
            "Mike Simmons": 7,
            "Phil Andrew": 4,
            Undecided: 23
        }
    },
    {
        poll: "Impact Research",
        date: "2026-02-10",
        candidates: {
            "Kat Abughazaleh": 18,
            "Bushra Amiwala": 4,
            "Daniel Biss": 31,
            "Laura Fine": 18,
            "Hoan Huynh": 3,
            "Mike Simmons": 7,
            "Phil Andrew": 7,
            Undecided: 11
        }
    },
    {
        poll: "Public Policy Polling",
        date: "2026-03-10",
        candidates: {
            "Kat Abughazaleh": 20,
            "Bushra Amiwala": 6,
            "Daniel Biss": 24,
            "Laura Fine": 14,
            "Hoan Huynh": 1,
            "Mike Simmons": 10,
            "Phil Andrew": 7,
            Undecided: 17
        }
    }
];
const $681acae7fda8566f$var$GRADE_WEIGHTS = {
    "A+": 1.0,
    A: 0.9,
    "A-": 0.8,
    "B+": 0.7,
    B: 0.6,
    "B-": 0.5,
    "B/C": 0.4,
    "C+": 0.3,
    C: 0.25
};
const $681acae7fda8566f$var$POLLSTER_GRADES = {
    "Impact Research": "B+",
    "GBAO Strategies": "B/C",
    "Data for Progress": "B+",
    "MDW Communications": "B/C",
    "Public Policy Polling": "B"
};
const $681acae7fda8566f$var$DEFAULT_POLL_GRADE = "C";
const $681acae7fda8566f$var$POLLS = $681acae7fda8566f$var$RAW_POLLS.map((poll)=>{
    const grade = $681acae7fda8566f$var$POLLSTER_GRADES[poll.poll] || $681acae7fda8566f$var$DEFAULT_POLL_GRADE;
    const weight = $681acae7fda8566f$var$GRADE_WEIGHTS[grade] || $681acae7fda8566f$var$GRADE_WEIGHTS[$681acae7fda8566f$var$DEFAULT_POLL_GRADE];
    return {
        ...poll,
        grade: grade,
        weight: weight
    };
});
const $681acae7fda8566f$var$KALSHI_KAT = [
    {
        date: "2025-03-30",
        prob: 15
    },
    {
        date: "2025-03-31",
        prob: 25
    },
    {
        date: "2025-04-09",
        prob: 16
    },
    {
        date: "2025-04-23",
        prob: 15
    },
    {
        date: "2025-04-24",
        prob: 16
    },
    {
        date: "2025-04-25",
        prob: 17
    },
    {
        date: "2025-04-30",
        prob: 16
    },
    {
        date: "2025-05-01",
        prob: 19
    },
    {
        date: "2025-05-30",
        prob: 15
    },
    {
        date: "2025-06-26",
        prob: 19
    },
    {
        date: "2025-06-27",
        prob: 22
    },
    {
        date: "2025-06-28",
        prob: 23
    },
    {
        date: "2025-06-29",
        prob: 28
    },
    {
        date: "2025-07-01",
        prob: 28
    },
    {
        date: "2025-07-03",
        prob: 20
    },
    {
        date: "2025-07-04",
        prob: 27
    },
    {
        date: "2025-07-08",
        prob: 23
    },
    {
        date: "2025-07-13",
        prob: 21
    },
    {
        date: "2025-07-15",
        prob: 15
    },
    {
        date: "2025-07-17",
        prob: 12
    },
    {
        date: "2025-07-19",
        prob: 23
    },
    {
        date: "2025-07-24",
        prob: 22
    },
    {
        date: "2025-08-03",
        prob: 15
    },
    {
        date: "2025-08-09",
        prob: 25
    },
    {
        date: "2025-09-07",
        prob: 30
    },
    {
        date: "2025-09-09",
        prob: 29
    },
    {
        date: "2025-09-11",
        prob: 30
    },
    {
        date: "2025-09-13",
        prob: 30
    },
    {
        date: "2025-09-19",
        prob: 30
    },
    {
        date: "2025-09-20",
        prob: 30
    },
    {
        date: "2025-09-21",
        prob: 30
    },
    {
        date: "2025-09-25",
        prob: 32
    },
    {
        date: "2025-09-26",
        prob: 31
    },
    {
        date: "2025-10-01",
        prob: 17
    },
    {
        date: "2025-10-08",
        prob: 17
    },
    {
        date: "2025-10-09",
        prob: 31
    },
    {
        date: "2025-10-16",
        prob: 32
    },
    {
        date: "2025-10-19",
        prob: 32
    },
    {
        date: "2025-10-21",
        prob: 32
    },
    {
        date: "2025-10-22",
        prob: 21
    },
    {
        date: "2025-10-23",
        prob: 34
    },
    {
        date: "2025-10-24",
        prob: 35
    },
    {
        date: "2025-10-27",
        prob: 33
    },
    {
        date: "2025-10-28",
        prob: 34
    },
    {
        date: "2025-10-30",
        prob: 54
    },
    {
        date: "2025-10-31",
        prob: 45
    },
    {
        date: "2025-11-04",
        prob: 45
    },
    {
        date: "2025-11-08",
        prob: 43
    },
    {
        date: "2025-11-11",
        prob: 43
    },
    {
        date: "2025-11-14",
        prob: 33
    },
    {
        date: "2025-11-17",
        prob: 33
    },
    {
        date: "2025-11-21",
        prob: 35
    },
    {
        date: "2025-11-22",
        prob: 44
    },
    {
        date: "2025-11-24",
        prob: 36
    },
    {
        date: "2025-11-25",
        prob: 46
    },
    {
        date: "2025-11-26",
        prob: 45
    },
    {
        date: "2025-11-28",
        prob: 43
    },
    {
        date: "2025-11-29",
        prob: 44
    },
    {
        date: "2025-12-01",
        prob: 35
    },
    {
        date: "2025-12-04",
        prob: 37
    },
    {
        date: "2025-12-05",
        prob: 38
    },
    {
        date: "2025-12-08",
        prob: 32
    },
    {
        date: "2025-12-09",
        prob: 39
    },
    {
        date: "2025-12-11",
        prob: 30
    },
    {
        date: "2025-12-12",
        prob: 32
    },
    {
        date: "2025-12-13",
        prob: 31
    },
    {
        date: "2025-12-14",
        prob: 32
    },
    {
        date: "2025-12-15",
        prob: 31
    },
    {
        date: "2025-12-16",
        prob: 32
    },
    {
        date: "2025-12-19",
        prob: 32
    },
    {
        date: "2025-12-22",
        prob: 32
    },
    {
        date: "2025-12-23",
        prob: 32
    },
    {
        date: "2025-12-24",
        prob: 32
    },
    {
        date: "2025-12-26",
        prob: 30
    },
    {
        date: "2025-12-27",
        prob: 32
    },
    {
        date: "2025-12-28",
        prob: 32
    },
    {
        date: "2025-12-30",
        prob: 32
    },
    {
        date: "2025-12-31",
        prob: 32
    },
    {
        date: "2026-01-02",
        prob: 29
    },
    {
        date: "2026-01-04",
        prob: 29
    },
    {
        date: "2026-01-05",
        prob: 26
    },
    {
        date: "2026-01-07",
        prob: 20
    },
    {
        date: "2026-01-08",
        prob: 20
    },
    {
        date: "2026-01-09",
        prob: 16
    },
    {
        date: "2026-01-10",
        prob: 17
    },
    {
        date: "2026-01-11",
        prob: 17
    },
    {
        date: "2026-01-12",
        prob: 12
    },
    {
        date: "2026-01-13",
        prob: 18
    },
    {
        date: "2026-01-14",
        prob: 18
    },
    {
        date: "2026-01-15",
        prob: 12
    },
    {
        date: "2026-01-16",
        prob: 17
    },
    {
        date: "2026-01-17",
        prob: 23
    },
    {
        date: "2026-01-18",
        prob: 21
    },
    {
        date: "2026-01-19",
        prob: 15
    },
    {
        date: "2026-01-20",
        prob: 14
    },
    {
        date: "2026-01-21",
        prob: 23
    },
    {
        date: "2026-01-22",
        prob: 24
    },
    {
        date: "2026-01-23",
        prob: 24
    },
    {
        date: "2026-01-24",
        prob: 23
    },
    {
        date: "2026-01-25",
        prob: 22
    },
    {
        date: "2026-01-26",
        prob: 20
    },
    {
        date: "2026-01-27",
        prob: 19
    },
    {
        date: "2026-01-28",
        prob: 18
    },
    {
        date: "2026-01-29",
        prob: 20
    },
    {
        date: "2026-01-30",
        prob: 17
    },
    {
        date: "2026-01-31",
        prob: 18
    },
    {
        date: "2026-02-01",
        prob: 20
    },
    {
        date: "2026-02-02",
        prob: 19
    },
    {
        date: "2026-02-03",
        prob: 15
    },
    {
        date: "2026-02-04",
        prob: 14
    },
    {
        date: "2026-02-05",
        prob: 14
    },
    {
        date: "2026-02-06",
        prob: 18
    },
    {
        date: "2026-02-07",
        prob: 18
    },
    {
        date: "2026-02-08",
        prob: 37
    },
    {
        date: "2026-02-09",
        prob: 21
    },
    {
        date: "2026-02-10",
        prob: 22
    },
    {
        date: "2026-02-11",
        prob: 22
    },
    {
        date: "2026-02-12",
        prob: 30
    },
    {
        date: "2026-02-13",
        prob: 17
    },
    {
        date: "2026-02-14",
        prob: 20
    },
    {
        date: "2026-02-15",
        prob: 28
    },
    {
        date: "2026-02-16",
        prob: 17
    },
    {
        date: "2026-02-17",
        prob: 14
    },
    {
        date: "2026-02-18",
        prob: 14
    },
    {
        date: "2026-02-19",
        prob: 22
    },
    {
        date: "2026-02-20",
        prob: 23
    },
    {
        date: "2026-02-21",
        prob: 22
    },
    {
        date: "2026-02-22",
        prob: 21
    },
    {
        date: "2026-02-23",
        prob: 20
    },
    {
        date: "2026-02-24",
        prob: 21
    },
    {
        date: "2026-02-25",
        prob: 21
    },
    {
        date: "2026-02-26",
        prob: 20
    },
    {
        date: "2026-02-27",
        prob: 23
    },
    {
        date: "2026-02-28",
        prob: 26
    },
    {
        date: "2026-03-01",
        prob: 29
    },
    {
        date: "2026-03-02",
        prob: 30
    },
    {
        date: "2026-03-03",
        prob: 27
    },
    {
        date: "2026-03-04",
        prob: 26
    },
    {
        date: "2026-03-05",
        prob: 26
    },
    {
        date: "2026-03-06",
        prob: 25
    },
    {
        date: "2026-03-07",
        prob: 29
    },
    {
        date: "2026-03-08",
        prob: 29
    },
    {
        date: "2026-03-09",
        prob: 26
    },
    {
        date: "2026-03-10",
        prob: 20
    },
    {
        date: "2026-03-11",
        prob: 32
    },
    {
        date: "2026-03-12",
        prob: 38
    },
    {
        date: "2026-03-13",
        prob: 34
    }
];
const $681acae7fda8566f$var$KALSHI_BISS = [
    {
        date: "2025-04-24",
        prob: 58
    },
    {
        date: "2025-05-16",
        prob: 75
    },
    {
        date: "2025-05-24",
        prob: 67
    },
    {
        date: "2025-07-22",
        prob: 72
    },
    {
        date: "2025-07-23",
        prob: 73
    },
    {
        date: "2025-08-03",
        prob: 68
    },
    {
        date: "2025-08-07",
        prob: 70
    },
    {
        date: "2025-09-11",
        prob: 68
    },
    {
        date: "2025-09-19",
        prob: 68
    },
    {
        date: "2025-09-27",
        prob: 66
    },
    {
        date: "2025-10-01",
        prob: 65
    },
    {
        date: "2025-10-22",
        prob: 65
    },
    {
        date: "2025-10-28",
        prob: 65
    },
    {
        date: "2025-10-31",
        prob: 60
    },
    {
        date: "2025-11-04",
        prob: 64
    },
    {
        date: "2025-11-05",
        prob: 50
    },
    {
        date: "2025-11-06",
        prob: 64
    },
    {
        date: "2025-11-08",
        prob: 66
    },
    {
        date: "2025-11-11",
        prob: 65
    },
    {
        date: "2025-11-17",
        prob: 63
    },
    {
        date: "2025-11-21",
        prob: 61
    },
    {
        date: "2025-11-24",
        prob: 58
    },
    {
        date: "2025-11-26",
        prob: 57
    },
    {
        date: "2025-12-01",
        prob: 50
    },
    {
        date: "2025-12-03",
        prob: 41
    },
    {
        date: "2025-12-04",
        prob: 50
    },
    {
        date: "2025-12-06",
        prob: 58
    },
    {
        date: "2025-12-08",
        prob: 58
    },
    {
        date: "2025-12-09",
        prob: 51
    },
    {
        date: "2025-12-11",
        prob: 58
    },
    {
        date: "2025-12-15",
        prob: 58
    },
    {
        date: "2025-12-22",
        prob: 44
    },
    {
        date: "2025-12-23",
        prob: 45
    },
    {
        date: "2025-12-30",
        prob: 46
    },
    {
        date: "2026-01-01",
        prob: 43
    },
    {
        date: "2026-01-02",
        prob: 43
    },
    {
        date: "2026-01-05",
        prob: 42
    },
    {
        date: "2026-01-06",
        prob: 60
    },
    {
        date: "2026-01-07",
        prob: 73
    },
    {
        date: "2026-01-08",
        prob: 73
    },
    {
        date: "2026-01-09",
        prob: 61
    },
    {
        date: "2026-01-10",
        prob: 65
    },
    {
        date: "2026-01-11",
        prob: 75
    },
    {
        date: "2026-01-12",
        prob: 74
    },
    {
        date: "2026-01-13",
        prob: 74
    },
    {
        date: "2026-01-14",
        prob: 71
    },
    {
        date: "2026-01-15",
        prob: 76
    },
    {
        date: "2026-01-16",
        prob: 79
    },
    {
        date: "2026-01-17",
        prob: 80
    },
    {
        date: "2026-01-18",
        prob: 75
    },
    {
        date: "2026-01-19",
        prob: 73
    },
    {
        date: "2026-01-20",
        prob: 74
    },
    {
        date: "2026-01-21",
        prob: 74
    },
    {
        date: "2026-01-22",
        prob: 75
    },
    {
        date: "2026-01-23",
        prob: 70
    },
    {
        date: "2026-01-24",
        prob: 63
    },
    {
        date: "2026-01-25",
        prob: 68
    },
    {
        date: "2026-01-26",
        prob: 72
    },
    {
        date: "2026-01-27",
        prob: 72
    },
    {
        date: "2026-01-28",
        prob: 61
    },
    {
        date: "2026-01-29",
        prob: 65
    },
    {
        date: "2026-01-30",
        prob: 68
    },
    {
        date: "2026-01-31",
        prob: 72
    },
    {
        date: "2026-02-01",
        prob: 69
    },
    {
        date: "2026-02-02",
        prob: 69
    },
    {
        date: "2026-02-03",
        prob: 68
    },
    {
        date: "2026-02-04",
        prob: 65
    },
    {
        date: "2026-02-05",
        prob: 62
    },
    {
        date: "2026-02-06",
        prob: 61
    },
    {
        date: "2026-02-07",
        prob: 60
    },
    {
        date: "2026-02-08",
        prob: 59
    },
    {
        date: "2026-02-09",
        prob: 62
    },
    {
        date: "2026-02-10",
        prob: 56
    },
    {
        date: "2026-02-11",
        prob: 55
    },
    {
        date: "2026-02-12",
        prob: 62
    },
    {
        date: "2026-02-13",
        prob: 71
    },
    {
        date: "2026-02-14",
        prob: 64
    },
    {
        date: "2026-02-15",
        prob: 69
    },
    {
        date: "2026-02-16",
        prob: 68
    },
    {
        date: "2026-02-17",
        prob: 72
    },
    {
        date: "2026-02-18",
        prob: 66
    },
    {
        date: "2026-02-19",
        prob: 63
    },
    {
        date: "2026-02-20",
        prob: 64
    },
    {
        date: "2026-02-21",
        prob: 61
    },
    {
        date: "2026-02-22",
        prob: 63
    },
    {
        date: "2026-02-23",
        prob: 61
    },
    {
        date: "2026-02-24",
        prob: 58
    },
    {
        date: "2026-02-25",
        prob: 59
    },
    {
        date: "2026-02-26",
        prob: 67
    },
    {
        date: "2026-02-27",
        prob: 62
    },
    {
        date: "2026-02-28",
        prob: 62
    },
    {
        date: "2026-03-01",
        prob: 63
    },
    {
        date: "2026-03-02",
        prob: 63
    },
    {
        date: "2026-03-03",
        prob: 65
    },
    {
        date: "2026-03-04",
        prob: 66
    },
    {
        date: "2026-03-05",
        prob: 69
    },
    {
        date: "2026-03-06",
        prob: 68
    },
    {
        date: "2026-03-07",
        prob: 66
    },
    {
        date: "2026-03-08",
        prob: 69
    },
    {
        date: "2026-03-09",
        prob: 72
    },
    {
        date: "2026-03-10",
        prob: 75
    },
    {
        date: "2026-03-11",
        prob: 69
    },
    {
        date: "2026-03-12",
        prob: 62
    },
    {
        date: "2026-03-13",
        prob: 65
    }
];
const $681acae7fda8566f$var$KALSHI_FINE = [
    {
        date: "2025-04-24",
        prob: 25
    },
    {
        date: "2025-09-20",
        prob: 1
    },
    {
        date: "2025-09-21",
        prob: 1
    },
    {
        date: "2025-09-26",
        prob: 1
    },
    {
        date: "2025-10-22",
        prob: 6
    },
    {
        date: "2025-10-27",
        prob: 6
    },
    {
        date: "2025-10-31",
        prob: 2
    },
    {
        date: "2025-11-04",
        prob: 5
    },
    {
        date: "2025-11-06",
        prob: 7
    },
    {
        date: "2025-11-26",
        prob: 1
    },
    {
        date: "2025-11-27",
        prob: 17
    },
    {
        date: "2025-11-28",
        prob: 9
    },
    {
        date: "2025-11-30",
        prob: 17
    },
    {
        date: "2025-12-04",
        prob: 14
    },
    {
        date: "2025-12-05",
        prob: 5
    },
    {
        date: "2025-12-12",
        prob: 13
    },
    {
        date: "2025-12-21",
        prob: 18
    },
    {
        date: "2025-12-22",
        prob: 20
    },
    {
        date: "2025-12-23",
        prob: 20
    },
    {
        date: "2025-12-24",
        prob: 18
    },
    {
        date: "2025-12-25",
        prob: 17
    },
    {
        date: "2026-01-01",
        prob: 31
    },
    {
        date: "2026-01-02",
        prob: 27
    },
    {
        date: "2026-01-06",
        prob: 24
    },
    {
        date: "2026-01-07",
        prob: 14
    },
    {
        date: "2026-01-08",
        prob: 5
    },
    {
        date: "2026-01-09",
        prob: 8
    },
    {
        date: "2026-01-10",
        prob: 15
    },
    {
        date: "2026-01-12",
        prob: 13
    },
    {
        date: "2026-01-17",
        prob: 2
    },
    {
        date: "2026-01-18",
        prob: 12
    },
    {
        date: "2026-01-20",
        prob: 15
    },
    {
        date: "2026-01-24",
        prob: 8
    },
    {
        date: "2026-01-25",
        prob: 7
    },
    {
        date: "2026-01-27",
        prob: 9
    },
    {
        date: "2026-01-28",
        prob: 12
    },
    {
        date: "2026-01-29",
        prob: 12
    },
    {
        date: "2026-01-30",
        prob: 12
    },
    {
        date: "2026-01-31",
        prob: 13
    },
    {
        date: "2026-02-01",
        prob: 13
    },
    {
        date: "2026-02-03",
        prob: 18
    },
    {
        date: "2026-02-04",
        prob: 23
    },
    {
        date: "2026-02-05",
        prob: 25
    },
    {
        date: "2026-02-06",
        prob: 23
    },
    {
        date: "2026-02-07",
        prob: 22
    },
    {
        date: "2026-02-08",
        prob: 21
    },
    {
        date: "2026-02-09",
        prob: 24
    },
    {
        date: "2026-02-10",
        prob: 22
    },
    {
        date: "2026-02-11",
        prob: 27
    },
    {
        date: "2026-02-12",
        prob: 17
    },
    {
        date: "2026-02-13",
        prob: 15
    },
    {
        date: "2026-02-14",
        prob: 24
    },
    {
        date: "2026-02-16",
        prob: 16
    },
    {
        date: "2026-02-17",
        prob: 13
    },
    {
        date: "2026-02-18",
        prob: 16
    },
    {
        date: "2026-02-19",
        prob: 12
    },
    {
        date: "2026-02-20",
        prob: 12
    },
    {
        date: "2026-02-21",
        prob: 13
    },
    {
        date: "2026-02-22",
        prob: 15
    },
    {
        date: "2026-02-23",
        prob: 16
    },
    {
        date: "2026-02-24",
        prob: 19
    },
    {
        date: "2026-02-25",
        prob: 17
    },
    {
        date: "2026-02-26",
        prob: 7
    },
    {
        date: "2026-02-27",
        prob: 9
    },
    {
        date: "2026-02-28",
        prob: 4
    },
    {
        date: "2026-03-01",
        prob: 6
    },
    {
        date: "2026-03-02",
        prob: 6
    },
    {
        date: "2026-03-03",
        prob: 6
    },
    {
        date: "2026-03-04",
        prob: 4
    },
    {
        date: "2026-03-05",
        prob: 6
    },
    {
        date: "2026-03-06",
        prob: 5
    },
    {
        date: "2026-03-07",
        prob: 3
    },
    {
        date: "2026-03-08",
        prob: 2
    },
    {
        date: "2026-03-09",
        prob: 4
    },
    {
        date: "2026-03-10",
        prob: 4
    },
    {
        date: "2026-03-11",
        prob: 2
    },
    {
        date: "2026-03-12",
        prob: 7
    },
    {
        date: "2026-03-13",
        prob: 4
    }
];
// ─── COLORS ──────────────────────────────────────────────────────────────────
const $681acae7fda8566f$var$COLORS = {
    "Kat Abughazaleh": "#E8453C",
    "Daniel Biss": "#4A6FA5",
    "Laura Fine": "#7B9E6B",
    "Mike Simmons": "#C47F17",
    "Bushra Amiwala": "#9B6B9E",
    "Hoan Huynh": "#5DADE2",
    "Phil Andrew": "#8D8D8D",
    Undecided: "#C0C0C0",
    "Progressive Coalition": "#E8453C"
};
const $681acae7fda8566f$var$PROGRESSIVE_CANDIDATES = [
    "Kat Abughazaleh",
    "Bushra Amiwala",
    "Mike Simmons",
    "Hoan Huynh"
];
const $681acae7fda8566f$var$ALL_DECIDED = [
    "Kat Abughazaleh",
    "Bushra Amiwala",
    "Daniel Biss",
    "Laura Fine",
    "Hoan Huynh",
    "Mike Simmons",
    "Phil Andrew"
];
// ─── COMPONENTS ──────────────────────────────────────────────────────────────
const $681acae7fda8566f$var$SectionHeader = ({ number: number, title: title, subtitle: subtitle })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            marginBottom: 28,
            marginTop: 48
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "baseline",
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontFamily: "'IBM Plex Mono', monospace",
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#E8453C",
                            letterSpacing: 2,
                            textTransform: "uppercase"
                        },
                        children: number
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            fontFamily: "'Playfair Display', serif",
                            fontSize: 28,
                            fontWeight: 700,
                            color: "#1a1a1a",
                            margin: 0,
                            lineHeight: 1.2
                        },
                        children: title
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontFamily: "'Source Sans 3', sans-serif",
                    fontSize: 15,
                    color: "#666",
                    margin: "6px 0 0 0",
                    paddingLeft: 42,
                    maxWidth: 650
                },
                children: subtitle
            })
        ]
    });
const $681acae7fda8566f$var$StatCard = ({ value: value, label: label, sublabel: sublabel, color: color = "#E8453C", large: large })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            background: "white",
            borderRadius: 10,
            padding: large ? "22px 26px" : "16px 20px",
            border: "1px solid #e8e8e8",
            flex: 1,
            minWidth: 140,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontFamily: "'IBM Plex Mono', monospace",
                    fontSize: large ? 36 : 28,
                    fontWeight: 700,
                    color: color,
                    lineHeight: 1.1
                },
                children: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontFamily: "'Source Sans 3', sans-serif",
                    fontSize: 13,
                    color: "#555",
                    marginTop: 4,
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: 0.5
                },
                children: label
            }),
            sublabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontFamily: "'Source Sans 3', sans-serif",
                    fontSize: 12,
                    color: "#999",
                    marginTop: 2
                },
                children: sublabel
            })
        ]
    });
const $681acae7fda8566f$var$CustomTooltip = ({ active: active, payload: payload, label: label })=>{
    if (!active || !payload?.length) return null;
    const source = payload[0]?.payload;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            background: "rgba(255,255,255,0.97)",
            border: "1px solid #ddd",
            borderRadius: 8,
            padding: "10px 14px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
            fontFamily: "'Source Sans 3', sans-serif",
            fontSize: 13
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontWeight: 700,
                    marginBottom: 6,
                    color: "#333"
                },
                children: label
            }),
            payload.map((p, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginBottom: 3
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                background: p.color
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            style: {
                                color: "#666"
                            },
                            children: [
                                p.name,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                fontWeight: 600,
                                color: "#222"
                            },
                            children: typeof p.value === "number" ? p.value.toFixed(1) + "%" : p.value
                        })
                    ]
                }, i)),
            source?.pollGrade && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 6,
                    paddingTop: 6,
                    borderTop: "1px solid #eee",
                    color: "#777",
                    fontSize: 11
                },
                children: [
                    "Pollster grade: ",
                    source.pollGrade,
                    " \xb7 weight:",
                    " ",
                    source.pollWeight.toFixed(2)
                ]
            })
        ]
    });
};
// ─── MAIN DASHBOARD ──────────────────────────────────────────────────────────
function $681acae7fda8566f$var$IL09Dashboard() {
    const [activeSection, setActiveSection] = (0, $acw62.useState)(0);
    const [scenarioDropouts, setScenarioDropouts] = (0, $acw62.useState)(new Set([
        "Bushra Amiwala",
        "Mike Simmons",
        "Hoan Huynh"
    ]));
    const [redistributionTarget, setRedistributionTarget] = (0, $acw62.useState)("Kat Abughazaleh");
    const [animatedPct, setAnimatedPct] = (0, $acw62.useState)(0);
    const [now, setNow] = (0, $acw62.useState)(()=>new Date());
    const [kalshiWindow, setKalshiWindow] = (0, $acw62.useState)("ALL");
    const latestPoll = $681acae7fda8566f$var$POLLS[$681acae7fda8566f$var$POLLS.length - 1];
    const primaryDate = (0, $acw62.useMemo)(()=>new Date("2026-03-17T00:00:00"), []);
    const msUntilPrimary = primaryDate.getTime() - now.getTime();
    const daysUntilPrimary = Math.max(0, Math.ceil(msUntilPrimary / 86400000));
    const untilPrimaryLabel = daysUntilPrimary === 0 ? "Today" : `${daysUntilPrimary} day${daysUntilPrimary === 1 ? "" : "s"}`;
    const untilPrimaryBodyText = daysUntilPrimary === 0 ? "With the primary happening today" : `With ${untilPrimaryLabel.toLowerCase()} until March 17`;
    // Animate the hero stat
    (0, $acw62.useEffect)(()=>{
        const target = 45;
        let current = 0;
        const interval = setInterval(()=>{
            current += 1;
            if (current >= target) {
                setAnimatedPct(target);
                clearInterval(interval);
            } else setAnimatedPct(current);
        }, 30);
        return ()=>clearInterval(interval);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>setNow(new Date()), 1000);
        return ()=>clearInterval(interval);
    }, []);
    // Build poll trend data
    const trendData = (0, $acw62.useMemo)(()=>{
        const weightedSums = Object.fromEntries($681acae7fda8566f$var$ALL_DECIDED.map((c)=>[
                c,
                0
            ]));
        let progressiveWeightedSum = 0;
        let totalWeight = 0;
        return $681acae7fda8566f$var$POLLS.map((p)=>{
            const decided = {};
            let total = 0;
            $681acae7fda8566f$var$ALL_DECIDED.forEach((c)=>{
                decided[c] = p.candidates[c] || 0;
                total += p.candidates[c] || 0;
            });
            const row = {
                date: new Date(p.date).toLocaleDateString("en-US", {
                    month: "short",
                    year: "2-digit"
                }),
                rawDate: p.date,
                poll: p.poll,
                pollGrade: p.grade,
                pollWeight: p.weight
            };
            $681acae7fda8566f$var$ALL_DECIDED.forEach((c)=>{
                const pct = decided[c] / total * 100;
                row[c] = +pct.toFixed(1);
                weightedSums[c] += pct * p.weight;
            });
            // progressive coalition
            let progTotal = 0;
            $681acae7fda8566f$var$PROGRESSIVE_CANDIDATES.forEach((c)=>progTotal += decided[c]);
            const progressivePct = progTotal / total * 100;
            row["Progressive Coalition"] = +progressivePct.toFixed(1);
            totalWeight += p.weight;
            progressiveWeightedSum += progressivePct * p.weight;
            $681acae7fda8566f$var$ALL_DECIDED.forEach((c)=>{
                row[`${c} (Grade-Weighted Avg)`] = +(weightedSums[c] / totalWeight).toFixed(1);
            });
            row["Progressive Coalition (Grade-Weighted Avg)"] = +(progressiveWeightedSum / totalWeight).toFixed(1);
            return row;
        });
    }, []);
    // Kalshi combined timeline
    const kalshiData = (0, $acw62.useMemo)(()=>{
        const dateMap = {};
        $681acae7fda8566f$var$KALSHI_BISS.forEach((d)=>{
            dateMap[d.date] = {
                ...dateMap[d.date] || {},
                date: d.date,
                "Daniel Biss": d.prob
            };
        });
        $681acae7fda8566f$var$KALSHI_KAT.forEach((d)=>{
            dateMap[d.date] = {
                ...dateMap[d.date] || {},
                date: d.date,
                "Kat Abughazaleh": d.prob
            };
        });
        $681acae7fda8566f$var$KALSHI_FINE.forEach((d)=>{
            dateMap[d.date] = {
                ...dateMap[d.date] || {},
                date: d.date,
                "Laura Fine": d.prob
            };
        });
        return Object.values(dateMap).sort((a, b)=>a.date.localeCompare(b.date)).map((d)=>({
                ...d,
                label: new Date(d.date).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric"
                })
            }));
    }, []);
    const filteredKalshiData = (0, $acw62.useMemo)(()=>{
        if (kalshiWindow === "ALL") return kalshiData;
        const months = kalshiWindow === "1M" ? 1 : 6;
        const cutoff = new Date();
        cutoff.setMonth(cutoff.getMonth() - months);
        const cutoffStr = cutoff.toISOString().slice(0, 10);
        return kalshiData.filter((d)=>d.date >= cutoffStr);
    }, [
        kalshiData,
        kalshiWindow
    ]);
    // Scenario builder
    const scenarioData = (0, $acw62.useMemo)(()=>{
        const latest = {
            ...latestPoll.candidates
        };
        delete latest["Undecided"];
        const other = latestPoll.candidates["Undecided"] || 0;
        const totalDecided = $681acae7fda8566f$var$ALL_DECIDED.reduce((s, c)=>s + (latest[c] || 0), 0);
        const redistributed = {};
        let pooledVotes = 0;
        $681acae7fda8566f$var$ALL_DECIDED.forEach((c)=>{
            if (scenarioDropouts.has(c)) {
                pooledVotes += latest[c] || 0;
                redistributed[c] = 0;
            } else redistributed[c] = latest[c] || 0;
        });
        redistributed[redistributionTarget] = (redistributed[redistributionTarget] || 0) + pooledVotes;
        const newTotal = $681acae7fda8566f$var$ALL_DECIDED.reduce((s, c)=>s + redistributed[c], 0);
        return $681acae7fda8566f$var$ALL_DECIDED.filter((c)=>redistributed[c] > 0).map((c)=>({
                name: c,
                original: +((latest[c] || 0) / totalDecided * 100).toFixed(1),
                scenario: +(redistributed[c] / newTotal * 100).toFixed(1),
                color: $681acae7fda8566f$var$COLORS[c],
                isTarget: c === redistributionTarget
            })).sort((a, b)=>b.scenario - a.scenario);
    }, [
        scenarioDropouts,
        redistributionTarget
    ]);
    // Progressive bloc comparison per poll
    const blocData = (0, $acw62.useMemo)(()=>{
        return $681acae7fda8566f$var$POLLS.map((p)=>{
            const all = {
                ...p.candidates
            };
            delete all["Undecided"];
            delete all["Other"];
            const total = Object.values(all).reduce((s, v)=>s + v, 0);
            let prog = 0;
            $681acae7fda8566f$var$PROGRESSIVE_CANDIDATES.forEach((c)=>prog += all[c] || 0);
            return {
                poll: p.poll.split("(")[0].trim(),
                pollGrade: p.grade,
                pollWeight: p.weight,
                date: new Date(p.date).toLocaleDateString("en-US", {
                    month: "short",
                    year: "2-digit"
                }),
                Biss: +((all["Daniel Biss"] || 0) / total * 100).toFixed(1),
                "Progressive Bloc": +(prog / total * 100).toFixed(1),
                "Fine + Andrew": +(((all["Laura Fine"] || 0) + (all["Phil Andrew"] || 0)) / total * 100).toFixed(1)
            };
        });
    }, []);
    const weightedBlocSummary = (0, $acw62.useMemo)(()=>{
        const totals = {
            prog: 0,
            biss: 0,
            fineAndrew: 0,
            weights: 0
        };
        $681acae7fda8566f$var$POLLS.forEach((p)=>{
            const all = {
                ...p.candidates
            };
            delete all["Undecided"];
            delete all["Other"];
            const total = Object.values(all).reduce((s, v)=>s + v, 0);
            const progressive = $681acae7fda8566f$var$PROGRESSIVE_CANDIDATES.reduce((s, c)=>s + (all[c] || 0), 0);
            const biss = all["Daniel Biss"] || 0;
            const fineAndrew = (all["Laura Fine"] || 0) + (all["Phil Andrew"] || 0);
            totals.weights += p.weight;
            totals.prog += progressive / total * 100 * p.weight;
            totals.biss += biss / total * 100 * p.weight;
            totals.fineAndrew += fineAndrew / total * 100 * p.weight;
        });
        return [
            {
                name: "Progressive Bloc",
                value: +(totals.prog / totals.weights).toFixed(1),
                color: "#E8453C"
            },
            {
                name: "Biss",
                value: +(totals.biss / totals.weights).toFixed(1),
                color: "#4A6FA5"
            },
            {
                name: "Fine + Andrew",
                value: +(totals.fineAndrew / totals.weights).toFixed(1),
                color: "#7B9E6B"
            }
        ];
    }, []);
    const toggleDropout = (c)=>{
        setScenarioDropouts((prev)=>{
            const next = new Set(prev);
            if (next.has(c)) next.delete(c);
            else next.add(c);
            if (next.has(redistributionTarget)) {
                const remaining = $681acae7fda8566f$var$ALL_DECIDED.filter((x)=>!next.has(x));
                if (remaining.length > 0) setRedistributionTarget(remaining[0]);
            }
            return next;
        });
    };
    // Latest poll decided-voter shares
    const latestDecided = (0, $acw62.useMemo)(()=>{
        const d = {
            ...latestPoll.candidates
        };
        delete d["Undecided"];
        delete d["Other"];
        const total = Object.values(d).reduce((s, v)=>s + v, 0);
        return $681acae7fda8566f$var$ALL_DECIDED.map((c)=>({
                name: c,
                pct: +((d[c] || 0) / total * 100).toFixed(1),
                color: $681acae7fda8566f$var$COLORS[c]
            })).sort((a, b)=>b.pct - a.pct);
    }, []);
    const progCoalitionPct = latestDecided.filter((d)=>$681acae7fda8566f$var$PROGRESSIVE_CANDIDATES.includes(d.name)).reduce((s, d)=>s + d.pct, 0);
    const bissPct = latestDecided.find((d)=>d.name === "Daniel Biss")?.pct || 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            minHeight: "100vh",
            background: "linear-gradient(175deg, #FAFAF8 0%, #F3F1ED 100%)",
            fontFamily: "'Source Sans 3', sans-serif"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("link", {
                href: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;900&family=Source+Sans+3:wght@300;400;600;700&family=IBM+Plex+Mono:wght@400;500;600;700&display=swap",
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    background: "linear-gradient(135deg, #1a1a1a 0%, #2d1f1f 50%, #1a1a1a 100%)",
                    padding: "52px 40px 44px",
                    position: "relative",
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: 400,
                            height: 400,
                            background: "radial-gradient(circle, rgba(232,69,60,0.12) 0%, transparent 70%)",
                            borderRadius: "50%",
                            transform: "translate(100px, -100px)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            maxWidth: 960,
                            margin: "0 auto",
                            position: "relative",
                            zIndex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    fontSize: 11,
                                    letterSpacing: 3,
                                    color: "#E8453C",
                                    textTransform: "uppercase",
                                    marginBottom: 12,
                                    fontWeight: 600
                                },
                                children: "IL-09 Democratic Primary \xb7 March 17, 2026"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                style: {
                                    fontFamily: "'Playfair Display', serif",
                                    fontSize: 42,
                                    fontWeight: 900,
                                    color: "white",
                                    margin: "0 0 10px 0",
                                    lineHeight: 1.15,
                                    maxWidth: 700
                                },
                                children: [
                                    "The Spoiler Problem:",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            color: "#E8453C"
                                        },
                                        children: "How a Fragmented Field Hands Biss the Win"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    fontSize: 16,
                                    color: "rgba(255,255,255,0.65)",
                                    maxWidth: 600,
                                    lineHeight: 1.6,
                                    margin: "0 0 28px 0"
                                },
                                children: "Progressive candidates collectively out-poll Daniel Biss \u2014 but only if they consolidate. This analysis makes the case for strategic coordination using polling data, prediction markets, and coalition modeling."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: 16,
                                    flexWrap: "wrap"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$StatCard, {
                                        value: `${animatedPct}%`,
                                        label: "Progressive bloc",
                                        sublabel: "Combined decided-voter share",
                                        color: "#E8453C",
                                        large: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$StatCard, {
                                        value: `${bissPct.toFixed(0)}%`,
                                        label: "Daniel Biss",
                                        sublabel: "Current frontrunner",
                                        color: "#4A6FA5",
                                        large: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$StatCard, {
                                        value: "7",
                                        label: "Candidates",
                                        sublabel: "Splitting the anti-Biss vote",
                                        color: "#C47F17",
                                        large: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$StatCard, {
                                        value: untilPrimaryLabel,
                                        label: "Until primary",
                                        sublabel: "March 17, 2026",
                                        color: "#888",
                                        large: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    maxWidth: 960,
                    margin: "0 auto",
                    padding: "0 24px 60px"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$SectionHeader, {
                        number: "01",
                        title: "The Current Standings Are Deceiving",
                        subtitle: "In the latest Public Policy Polling survey (Mar 9\u201310), Biss leads \u2014 but the progressive vote is shattered across four candidates."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: "white",
                            borderRadius: 12,
                            padding: 28,
                            border: "1px solid #e8e8e8",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.03)"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: "#999",
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    marginBottom: 16,
                                    textTransform: "uppercase",
                                    letterSpacing: 1
                                },
                                children: "Latest Poll \xb7 Decided Voters \xb7 Feb 2026"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10
                                },
                                children: latestDecided.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    width: 140,
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    color: "#333",
                                                    textAlign: "right",
                                                    flexShrink: 0,
                                                    fontStyle: $681acae7fda8566f$var$PROGRESSIVE_CANDIDATES.includes(d.name) ? "normal" : "normal"
                                                },
                                                children: [
                                                    $681acae7fda8566f$var$PROGRESSIVE_CANDIDATES.includes(d.name) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            color: "#E8453C",
                                                            fontSize: 10,
                                                            marginRight: 4
                                                        },
                                                        children: "\u25CF"
                                                    }),
                                                    d.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 28,
                                                    background: "#f5f5f3",
                                                    borderRadius: 6,
                                                    overflow: "hidden",
                                                    position: "relative"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        height: "100%",
                                                        width: `${d.pct / 40 * 100}%`,
                                                        background: $681acae7fda8566f$var$PROGRESSIVE_CANDIDATES.includes(d.name) ? `linear-gradient(90deg, ${d.color}, ${d.color}dd)` : d.color + "88",
                                                        borderRadius: 6,
                                                        transition: "width 0.8s cubic-bezier(0.22, 1, 0.36, 1)"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    width: 52,
                                                    fontSize: 15,
                                                    fontWeight: 700,
                                                    color: d.color,
                                                    fontFamily: "'IBM Plex Mono', monospace",
                                                    textAlign: "right"
                                                },
                                                children: [
                                                    d.pct.toFixed(1),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, d.name))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 18,
                                    paddingTop: 14,
                                    borderTop: "2px dashed #E8453C33",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    color: "#E8453C",
                                                    fontSize: 10
                                                },
                                                children: "\u25CF"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 13,
                                                    color: "#666"
                                                },
                                                children: "= Progressive-aligned candidate"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            fontFamily: "'IBM Plex Mono', monospace",
                                            fontSize: 15,
                                            fontWeight: 700,
                                            color: "#E8453C"
                                        },
                                        children: [
                                            "Combined: ",
                                            progCoalitionPct.toFixed(1),
                                            "% > Biss at",
                                            " ",
                                            bissPct.toFixed(1),
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$SectionHeader, {
                        number: "02",
                        title: "The Progressive Bloc Beats Biss in Every Poll",
                        subtitle: "When you sum the progressive-aligned candidates (Kat, Amiwala, Simmons, Huynh), they outperform Biss consistently. Grade-weighted average shown below uses FiveThirtyEight-style source quality weights."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: "white",
                            borderRadius: 12,
                            padding: "24px 20px",
                            border: "1px solid #e8e8e8"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                                width: "100%",
                                height: 340,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74d07378047db57c$export$94aefc399ef206a9), {
                                    data: blocData,
                                    margin: {
                                        left: 10,
                                        right: 10,
                                        top: 10,
                                        bottom: 10
                                    },
                                    barGap: 3,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                            strokeDasharray: "3 3",
                                            stroke: "#eee"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                            dataKey: "date",
                                            tick: {
                                                fontSize: 12,
                                                fill: "#888"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                            tick: {
                                                fontSize: 12,
                                                fill: "#888"
                                            },
                                            tickFormatter: (v)=>v + "%",
                                            domain: [
                                                0,
                                                50
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$CustomTooltip, {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f4bd73be8c7e839$export$ed247974535929c7), {
                                            wrapperStyle: {
                                                fontSize: 13
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                                            dataKey: "Progressive Bloc",
                                            fill: "#E8453C",
                                            radius: [
                                                4,
                                                4,
                                                0,
                                                0
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                                            dataKey: "Biss",
                                            fill: "#4A6FA5",
                                            radius: [
                                                4,
                                                4,
                                                0,
                                                0
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                                            dataKey: "Fine + Andrew",
                                            fill: "#7B9E6B",
                                            radius: [
                                                4,
                                                4,
                                                0,
                                                0
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    gap: 10,
                                    flexWrap: "wrap",
                                    marginTop: 10
                                },
                                children: weightedBlocSummary.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            background: "#fafafa",
                                            border: "1px solid #eee",
                                            borderRadius: 8,
                                            padding: "8px 10px",
                                            fontSize: 12,
                                            color: "#666"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    fontWeight: 700,
                                                    color: row.color
                                                },
                                                children: [
                                                    row.name,
                                                    ": ",
                                                    row.value.toFixed(1),
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: " (grade-weighted avg)"
                                            })
                                        ]
                                    }, row.name))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$SectionHeader, {
                        number: "03",
                        title: "Kat's Trajectory Is the Strongest Among Progressives",
                        subtitle: "Among the fragmented progressive candidates, Kat Abughazaleh has the highest and most consistent polling \u2014 she's the natural consolidation candidate. Dashed overlays show running grade-weighted averages."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            background: "white",
                            borderRadius: 12,
                            padding: "24px 20px",
                            border: "1px solid #e8e8e8"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                            width: "100%",
                            height: 360,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d1341a4ce4753cde$export$54d0e8420ac838ac), {
                                data: trendData,
                                margin: {
                                    left: 10,
                                    right: 20,
                                    top: 10,
                                    bottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                        strokeDasharray: "3 3",
                                        stroke: "#eee"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                        dataKey: "date",
                                        tick: {
                                            fontSize: 12,
                                            fill: "#888"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                        tick: {
                                            fontSize: 12,
                                            fill: "#888"
                                        },
                                        tickFormatter: (v)=>v + "%",
                                        domain: [
                                            0,
                                            45
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$CustomTooltip, {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f4bd73be8c7e839$export$ed247974535929c7), {
                                        wrapperStyle: {
                                            fontSize: 12
                                        }
                                    }),
                                    $681acae7fda8566f$var$ALL_DECIDED.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                            type: "monotone",
                                            dataKey: c,
                                            stroke: $681acae7fda8566f$var$COLORS[c],
                                            strokeWidth: 0,
                                            dot: {
                                                r: c === "Kat Abughazaleh" || c === "Daniel Biss" ? 6 : 4,
                                                fill: $681acae7fda8566f$var$COLORS[c],
                                                strokeWidth: 0
                                            },
                                            activeDot: {
                                                r: c === "Kat Abughazaleh" || c === "Daniel Biss" ? 8 : 6
                                            },
                                            opacity: c === "Kat Abughazaleh" || c === "Daniel Biss" ? 1 : 0.65
                                        }, c)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                        type: "monotone",
                                        dataKey: "Kat Abughazaleh (Grade-Weighted Avg)",
                                        name: "Kat (Grade-Weighted Avg)",
                                        stroke: "#E8453C",
                                        strokeWidth: 2,
                                        strokeDasharray: "6 4",
                                        dot: false
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                        type: "monotone",
                                        dataKey: "Daniel Biss (Grade-Weighted Avg)",
                                        name: "Biss (Grade-Weighted Avg)",
                                        stroke: "#4A6FA5",
                                        strokeWidth: 2,
                                        strokeDasharray: "6 4",
                                        dot: false
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8a3115883abd1dc$export$17d680238e50603e), {
                                        type: "monotone",
                                        dataKey: "Progressive Coalition (Grade-Weighted Avg)",
                                        stroke: "#B3201B",
                                        strokeWidth: 2,
                                        strokeDasharray: "2 3",
                                        dot: false
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$SectionHeader, {
                        number: "04",
                        title: "Prediction Markets: Biss's Dominance Is Fragile",
                        subtitle: "Kalshi data shows Biss's win probability has been declining while Kat's has been climbing \u2014 but the split field props him up."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: "white",
                            borderRadius: 12,
                            padding: "24px 20px",
                            border: "1px solid #e8e8e8"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 6,
                                    marginBottom: 12
                                },
                                children: [
                                    "1M",
                                    "6M",
                                    "ALL"
                                ].map((w)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>setKalshiWindow(w),
                                        style: {
                                            padding: "4px 12px",
                                            borderRadius: 6,
                                            border: "1px solid",
                                            borderColor: kalshiWindow === w ? "#4A6FA5" : "#ddd",
                                            background: kalshiWindow === w ? "#4A6FA5" : "white",
                                            color: kalshiWindow === w ? "white" : "#888",
                                            fontFamily: "'IBM Plex Mono', monospace",
                                            fontSize: 12,
                                            fontWeight: 600,
                                            cursor: "pointer"
                                        },
                                        children: w
                                    }, w))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0431397098acacbe$export$e60a4704009a0009), {
                                width: "100%",
                                height: 340,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $40df630ec903a4ea$export$f510429275d6f1a8), {
                                    data: filteredKalshiData,
                                    margin: {
                                        left: 10,
                                        right: 20,
                                        top: 10,
                                        bottom: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                                    id: "gradBiss",
                                                    x1: "0",
                                                    y1: "0",
                                                    x2: "0",
                                                    y2: "1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                            offset: "0%",
                                                            stopColor: "#4A6FA5",
                                                            stopOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                            offset: "100%",
                                                            stopColor: "#4A6FA5",
                                                            stopOpacity: 0.02
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                                                    id: "gradKat",
                                                    x1: "0",
                                                    y1: "0",
                                                    x2: "0",
                                                    y2: "1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                            offset: "0%",
                                                            stopColor: "#E8453C",
                                                            stopOpacity: 0.3
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                                            offset: "100%",
                                                            stopColor: "#E8453C",
                                                            stopOpacity: 0.02
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eae69ed53f30e7ce$export$6440e27b9f186856), {
                                            strokeDasharray: "3 3",
                                            stroke: "#eee"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f21953d5ea7d4fb8$export$ea77231de273b52d), {
                                            dataKey: "label",
                                            tick: {
                                                fontSize: 10,
                                                fill: "#888"
                                            },
                                            interval: kalshiWindow === "1M" ? 4 : kalshiWindow === "6M" ? 14 : 29
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e2dfd8b3bfb4506$export$f96c4024c52de8f4), {
                                            tick: {
                                                fontSize: 12,
                                                fill: "#888"
                                            },
                                            tickFormatter: (v)=>v + "%",
                                            domain: [
                                                0,
                                                90
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3258e2bab55a6a07$export$28c660c63b792dea), {
                                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$CustomTooltip, {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f4bd73be8c7e839$export$ed247974535929c7), {
                                            wrapperStyle: {
                                                fontSize: 13
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                            type: "stepAfter",
                                            dataKey: "Daniel Biss",
                                            stroke: "#4A6FA5",
                                            fill: "url(#gradBiss)",
                                            strokeWidth: 2.5,
                                            connectNulls: true,
                                            dot: false
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                            type: "stepAfter",
                                            dataKey: "Kat Abughazaleh",
                                            stroke: "#E8453C",
                                            fill: "url(#gradKat)",
                                            strokeWidth: 2.5,
                                            connectNulls: true,
                                            dot: false
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                            type: "stepAfter",
                                            dataKey: "Laura Fine",
                                            stroke: "#7B9E6B",
                                            fill: "transparent",
                                            strokeWidth: 1.5,
                                            strokeDasharray: "5 3",
                                            connectNulls: true,
                                            dot: false
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: 8,
                                    fontSize: 12,
                                    color: "#999",
                                    fontFamily: "'IBM Plex Mono', monospace",
                                    textAlign: "center"
                                },
                                children: "Source: Kalshi prediction market (KXIL9D-26) \xb7 Implied win probabilities"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$SectionHeader, {
                        number: "05",
                        title: "Build a Consolidation Scenario",
                        subtitle: "Toggle candidates out of the race and see how their vote share redistributes. The math speaks for itself."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: "white",
                            borderRadius: 12,
                            padding: 28,
                            border: "2px solid #E8453C33",
                            boxShadow: "0 4px 20px rgba(232,69,60,0.06)"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: 32,
                                    flexWrap: "wrap",
                                    marginBottom: 24
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 280
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    color: "#999",
                                                    fontFamily: "'IBM Plex Mono', monospace",
                                                    marginBottom: 10,
                                                    textTransform: "uppercase",
                                                    letterSpacing: 1
                                                },
                                                children: "Who drops out? (click to toggle)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 8
                                                },
                                                children: $681acae7fda8566f$var$ALL_DECIDED.filter((c)=>c !== "Daniel Biss").map((c)=>{
                                                    const isOut = scenarioDropouts.has(c);
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: ()=>toggleDropout(c),
                                                        style: {
                                                            padding: "8px 14px",
                                                            borderRadius: 8,
                                                            border: "2px solid",
                                                            borderColor: isOut ? "#E8453C" : "#ddd",
                                                            background: isOut ? "#E8453C0F" : "white",
                                                            color: isOut ? "#E8453C" : "#666",
                                                            fontFamily: "'Source Sans 3', sans-serif",
                                                            fontSize: 13,
                                                            fontWeight: 600,
                                                            cursor: "pointer",
                                                            transition: "all 0.2s",
                                                            textDecoration: isOut ? "line-through" : "none"
                                                        },
                                                        children: [
                                                            c,
                                                            " ",
                                                            isOut ? "\u2715" : ""
                                                        ]
                                                    }, c);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            minWidth: 220
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    color: "#999",
                                                    fontFamily: "'IBM Plex Mono', monospace",
                                                    marginBottom: 10,
                                                    textTransform: "uppercase",
                                                    letterSpacing: 1
                                                },
                                                children: "Votes go to:"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 6
                                                },
                                                children: $681acae7fda8566f$var$ALL_DECIDED.filter((c)=>!scenarioDropouts.has(c)).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>setRedistributionTarget(c),
                                                        style: {
                                                            padding: "7px 12px",
                                                            borderRadius: 8,
                                                            border: "2px solid",
                                                            borderColor: redistributionTarget === c ? $681acae7fda8566f$var$COLORS[c] : "#ddd",
                                                            background: redistributionTarget === c ? $681acae7fda8566f$var$COLORS[c] + "15" : "white",
                                                            color: redistributionTarget === c ? $681acae7fda8566f$var$COLORS[c] : "#888",
                                                            fontFamily: "'Source Sans 3', sans-serif",
                                                            fontSize: 13,
                                                            fontWeight: 600,
                                                            cursor: "pointer",
                                                            transition: "all 0.2s"
                                                        },
                                                        children: c.split(" ").pop()
                                                    }, c))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8
                                },
                                children: scenarioData.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    width: 130,
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    color: "#333",
                                                    textAlign: "right",
                                                    flexShrink: 0
                                                },
                                                children: [
                                                    d.name,
                                                    d.isTarget && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            color: "#E8453C",
                                                            fontSize: 10,
                                                            marginLeft: 4
                                                        },
                                                        children: "\u2605"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 32,
                                                    background: "#f5f5f3",
                                                    borderRadius: 6,
                                                    overflow: "hidden",
                                                    position: "relative"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            position: "absolute",
                                                            height: "100%",
                                                            width: `${d.original / 55 * 100}%`,
                                                            background: d.color + "20",
                                                            borderRadius: 6,
                                                            borderRight: `2px dashed ${d.color}44`
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            position: "relative",
                                                            height: "100%",
                                                            width: `${d.scenario / 55 * 100}%`,
                                                            background: d.isTarget ? `linear-gradient(90deg, ${d.color}cc, ${d.color})` : d.color + "77",
                                                            borderRadius: 6,
                                                            transition: "width 0.6s cubic-bezier(0.22, 1, 0.36, 1)"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    width: 95,
                                                    display: "flex",
                                                    gap: 6,
                                                    alignItems: "baseline"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        style: {
                                                            fontSize: 15,
                                                            fontWeight: 700,
                                                            color: d.color,
                                                            fontFamily: "'IBM Plex Mono', monospace"
                                                        },
                                                        children: [
                                                            d.scenario.toFixed(1),
                                                            "%"
                                                        ]
                                                    }),
                                                    d.scenario !== d.original && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        style: {
                                                            fontSize: 11,
                                                            color: d.scenario > d.original ? "#2ecc71" : "#999",
                                                            fontWeight: 600
                                                        },
                                                        children: [
                                                            d.scenario > d.original ? "+" : "",
                                                            (d.scenario - d.original).toFixed(1)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, d.name))
                            }),
                            scenarioData[0]?.isTarget && scenarioData[0]?.scenario > (scenarioData[1]?.scenario || 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 20,
                                    padding: "14px 18px",
                                    borderRadius: 8,
                                    background: "linear-gradient(90deg, #E8453C0A, #E8453C15)",
                                    border: "1px solid #E8453C33"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        style: {
                                            fontWeight: 700,
                                            color: "#E8453C",
                                            fontSize: 14
                                        },
                                        children: [
                                            "\u2726 ",
                                            scenarioData[0].name,
                                            " wins this scenario"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        style: {
                                            color: "#666",
                                            fontSize: 13,
                                            marginLeft: 8
                                        },
                                        children: [
                                            "with a",
                                            " ",
                                            (scenarioData[0].scenario - (scenarioData[1]?.scenario || 0)).toFixed(1),
                                            " ",
                                            "point lead over ",
                                            scenarioData[1]?.name
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$SectionHeader, {
                        number: "06",
                        title: "The Case for Consolidation",
                        subtitle: ""
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                            gap: 16
                        },
                        children: [
                            {
                                icon: "\uD83D\uDCCA",
                                title: "The Math Is Clear",
                                body: `Progressive candidates (Kat, Amiwala, Simmons, Huynh) combine for ~${progCoalitionPct.toFixed(0)}% of decided voters \u{2014} more than Biss's ${bissPct.toFixed(0)}%. But fragmentation turns a majority into a loss.`
                            },
                            {
                                icon: "\uD83D\uDCC8",
                                title: "Kat Has the Momentum",
                                body: "Kat has polled as high as 18% consistently \u2014 the highest of any progressive. Her Kalshi odds peaked at 63% and she maintains the strongest trajectory in the field."
                            },
                            {
                                icon: "\u23F0",
                                title: "The Clock Is Ticking",
                                body: `${untilPrimaryBodyText}, every day without consolidation is another day Biss's plurality holds. Early voting has already begun.`
                            },
                            {
                                icon: "\uD83C\uDFAF",
                                title: "Precedent Is Clear",
                                body: "Spoiler effects have decided primaries for decades. Progressives lose when they split \u2014 consolidation behind the strongest candidate is the only viable counter-strategy."
                            }
                        ].map((card, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    background: "white",
                                    borderRadius: 12,
                                    padding: "22px 24px",
                                    border: "1px solid #e8e8e8",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.03)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 28,
                                            marginBottom: 10
                                        },
                                        children: card.icon
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontFamily: "'Playfair Display', serif",
                                            fontSize: 17,
                                            fontWeight: 700,
                                            color: "#1a1a1a",
                                            marginBottom: 8
                                        },
                                        children: card.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 14,
                                            color: "#555",
                                            lineHeight: 1.6
                                        },
                                        children: card.body
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 48,
                            paddingTop: 24,
                            borderTop: "1px solid #ddd",
                            textAlign: "center",
                            color: "#999",
                            fontSize: 12,
                            fontFamily: "'IBM Plex Mono', monospace"
                        },
                        children: [
                            "Data: Impact Research, GBAO Strategies, Data for Progress, MDW Communications, Kalshi prediction markets",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "Bayesian model: Dirichlet-Multinomial GP (Mat\xe9rn 5/2 HSGP) \xb7 6 polls \xb7 n=500\u2013917",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "Analysis as of Mar 15, 2026. This is a persuasive analytical tool, not a neutral forecast."
                        ]
                    })
                ]
            })
        ]
    });
}
const $681acae7fda8566f$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.querySelector("#root"));
$681acae7fda8566f$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($681acae7fda8566f$var$IL09Dashboard, {}));


//# sourceMappingURL=80069votes.fa32df1b.js.map
